webpackJsonp([8],{

/***/ "+AJo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REG_IS_QINIU = exports.JIANSHU_EDITOR = exports.PN_ITEM_MASK_CLASSNAME = exports.MAX_VIDEO_COUNT = exports.NOTE_HISTORY_NOT_FOUND = exports.NOTES_NOT_FOUND = exports.CONTENT_NOT_FOUND = undefined;

var _symbol = __webpack_require__("5QVw");

var _symbol2 = _interopRequireDefault(_symbol);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by zad on 17/10/26.
 */
var CONTENT_NOT_FOUND = exports.CONTENT_NOT_FOUND = (0, _symbol2.default)('content_not_found');
var NOTES_NOT_FOUND = exports.NOTES_NOT_FOUND = (0, _symbol2.default)('notes_not_found');
var NOTE_HISTORY_NOT_FOUND = exports.NOTE_HISTORY_NOT_FOUND = (0, _symbol2.default)('notes_not_found');

var MAX_VIDEO_COUNT = exports.MAX_VIDEO_COUNT = 10;
var PN_ITEM_MASK_CLASSNAME = exports.PN_ITEM_MASK_CLASSNAME = 'pn-item-mask';

var JIANSHU_EDITOR = exports.JIANSHU_EDITOR = (0, _symbol2.default)('jianshu_editor');

var REG_IS_QINIU = exports.REG_IS_QINIU = /^(http(s?):)?\/\/(upload-images\.jianshu\.io\/upload_images\/|jianshu-(dev\.u|staging)\.qiniudn\.com\/|upload\.jianshu\.io\/users\/upload_avatars\/)/i;

/***/ }),

/***/ "+cSM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */
module.exports = {
  bind: {
    bindwb: '綁定微博',
    binddb: '綁定豆瓣',
    bindqq: '綁定qq',
    hasbind: '已綁定',
    yjbdwx: '一键綁定微信',
    bindway: '綁定以下一種登錄方式'
  },
  "global": {
    "timeout": "請求超時",
    "content-loading": "內容加載中",
    "to-home": "返回首頁",
    "setting": "設定",
    "quit": "按 Esc 退出",
    "note-loading": "文章加載中",
    "forbidden-desc": "很抱歉，網頁版寫文章功能暫不支持手機/平板電腦，你可以在簡書App中使用",
    "cancel": "取消",
    "commit": "提交",
    "download": "下載簡書App"
  },
  "not-found": {
    "title": "您要找的頁面不見了",
    "desc": "因為您的連結位址有誤，連結位址為",
    "to-home": "返回「簡書」首頁"
  },
  "note-action": {
    'time-publish': '定時發佈',
    "publicize": "直接發佈",
    "publicize-paid-note": "發佈為付費文章",
    "publicized": "已發佈",
    "compile-paid-note": "發佈更新和設定",
    'set-publicize-style': '設置發布樣式',
    'topping-note': '置頂文章',
    'untopping-note': '取消置頂文章',
    'topping-success': '置頂文章成功',
    'untopping-success': '取消置頂文章成功',
    "move-note": "移動文章",
    "private-note": "設為私密",
    "open-in-new-window": "在新窗口打開",
    "to-history": "歷史版本",
    "share": "分享文章",
    "del-note": "删除文章",
    'set-unreprintable': '設置禁止轉載',
    'cancel-unreprintable': '取消禁止轉載'
  },
  "settings": {
    "change-locale": "顯示語言已切換成功",
    "change-read-mode": "閱讀模式已切換成功",
    "change-font": "顯示字體已切換成功",
    "change-to-simple": "切換至簡體",
    "change-to-traditional": "切換至繁體",
    "open-night-mode": "打開夜間模式",
    "change-to-song": "切換至宋體",
    "close-night-mode": "關閉夜間模式",
    "change-editor": "默認編輯器已切換成功",
    "editor": "默認編輯器",
    "rich-editor": "富文字編輯器",
    "feedback": "幫助與迴響",
    "md-editor": "MarkDown編輯器",
    "recycle": "回收站",
    "need-help": "遇到問題",
    "common-issue": "常見問題",
    "change-to-black": "切換至黑體",
    "display": "設定顯示模式",
    'on': '開',
    'off': '關',
    'sync-scroll': '同步滾動',
    'switch-sync-scroll': '同步滾動狀態切換成功',
    'author-verfy': '簡書作者實名認證'
  },
  grammar: {
    'grammar': 'Markdown語法參考',
    'h1': '# 一級標題',
    'h2': '## 二級標題',
    'h5': '##### 五級標題',
    'ul1': '- 列表第一項',
    'ul2': '- 列表第二項',
    'ol1': '1. 有序列表第一項',
    'ol2': '2. 有序列表第二項',
    'link': '[標題](鏈接地址)',
    'image': '![圖片描述](圖片鏈接地址)',
    'italic': '*斜體*',
    'bold': '**粗體**',
    'code-block': '> 引用段落',
    'blockquote': '```\n代碼塊\n```'
  },
  "notebooks": {
    "new-notebook-ing": "新建文集中…",
    "del-notebook-tip": "確認删除文集《{name}》，文章將被移動到回收站。",
    "new-notebook-empty": "文集名不能為空",
    "new-notebook": "新建文集",
    "rename-notebook-tip": "請輸入新文集名",
    "to-homepage": "回首頁"
  },
  "notes": {
    'audio': '音頻',
    "new-note-ing": "新建文章中…",
    "new-note": "新建文章",
    "new-note-bottom": "在下方新建文章",
    "save-word": "{wordNum}字",
    "default-note-title": "無標題文章",
    "word-num": "字數：",
    "move-note-success": "文章已移動至新文集",
    "del-note-confirm-tip": "確認删除文章《{title}》，文章將被移動到回收站，您可以在那裡恢復它。60天后將被徹底删除。",
    "topping": '置頂'
  },
  "pay-note": {
    "step-title": "付費文章設置",
    "agree-title": "付費文章協定",
    "step-two": "輸入定價",
    "cancelbtn": "不同意",
    "okbtn": "同意",
    "step-one": "設定試讀範圍",
    "step-one-des": "請你在右側選擇免費可讀的部分",
    "i-agree": "我同意",
    "confirming-btn": "發佈中…",
    "cancel-btn": "取消",
    "wrong-price": "請輸入正確的金額({minnum}-{maxnum}元)",
    "confirm-btn": "確認並發佈",
    "yuan": "元",
    'step-three': '設置音頻',
    'pay-for-audio': '購買文章後才能播放',
    'free-for-audio': '免費播放',
    "price-tip": "您可自由設置文章定價，最低1元，最高2000元。",
    'mask-item-des': '該分割線以上免費可讀',
    'publish-paid-notes': '發表付費文章',
    'publish-explain-1': '付費文章即讀者付費後才可解鎖閱讀的文章，擁有付費文章發表權限的作者可以發表付費文章。',
    'publish-explain-2': '該功能僅針對「簡書會員」或「簡書鑽大於 {minJSD}」或「被邀請」的用戶開放，您可以通過購買簡書會員快速獲得該資格。',
    'about-jsd': '了解簡書鑽特權',
    'open-js-member': '開通簡書會員'
  },
  'publish-setting': {
    'set-cover-img': '設置封面圖，優化文章的顯示效果',
    'set-note': '未設置則自動按默認樣式顯示',
    'choose-img-count': '選擇圖片數量',
    'one-img': '一圖',
    'three-img': '三圖（無摘要）',
    'upload-cover-img': '上傳封面圖',
    'click-to-upload': '點擊上傳',
    'upload-note1': '尺寸大于 360×360，格式 png/jpg',
    'upload-note2': '單張圖片大于 440×320，格式 png/jpg',
    'change': '更換',
    'input-abstract': '輸入摘要',
    'input-placeholder': '選填，30字內，如不填寫會默認抓取首段內容',
    'confirm-btn': '保存',
    'confirming-btn': '保存中...',
    'cancel-btn': '取消',
    'preview': '效果預覽',
    'preview-note': '僅供參考，具體效果會根據不同手機型號而變化',
    'save': '保存',
    'saving': '保存中...',
    'confirmed': '發布樣式已更新',
    'notes-over-limit': '摘要字數超出限制！'
  },
  "share": {
    "to-douban": "豆瓣",
    "to-wechat": "微信",
    "more": "更多分享",
    "to-weibo": "微博",
    "copy-link": "複製連結",
    "wechat-des": "打開微信“掃一掃”，打開網頁後點擊荧幕右上角分享按鈕",
    "trailing-jianshushe": "-簡書社",
    "to-googleplus": "Google+",
    "to-qzone": "QQ空間",
    "to-twitter": "Twitter",
    "to-facebook": "Facebook"
  },
  "error": {
    "try-again": "操作失敗，請再試一次",
    "save-again": "有內容未保存成功，確定要離開？",
    "text-no-empty": "文字不能為空",
    "link-no-empty": "連結不能為空",
    "file-size-over": "文件大小超過{size}M",
    "file-type-error": "圖片格式錯誤，請使用jpg/jpeg/png/gif檔案",
    "video-max-over": "視頻不能超過{num}個",
    "content-no-empty": "內容不能為空",
    "uploading-img": "正在上傳圖片，請稍等…",
    "file-not-exit": "檔案不存在",
    "fail-refresh": "操作失敗，可以刷新頁面嘗試",
    "need-bind-phone": "需要綁定手機號後才能發佈文章喲~",
    "upload-fail": "有圖片未上傳成功，請删除或重新上傳圖片。如需幫助，請",
    "save-again-soft": "上一篇文章有內容未保存成功，需要手動保存",
    "content-not-enough": "內容少於{num}段，不能發表為付費文章",
    "click": "點擊",
    'no-nb': '文集不存在',
    "data-empty": "暫無數據"
  },
  "tooltip": {
    "bold": "粗體",
    "link": "插入連結",
    "h3": "標題3",
    "video": "插入視頻",
    "audio": "插入音頻",
    'math-formula': '數學公式',
    "audioExist": "已有音頻",
    "h4": "標題4",
    "undo": "撤銷",
    "h1": "標題1",
    "redo": "重做",
    "expand": "全屏",
    "save": "保存",
    "to-normal-mode": "返回",
    "preview": "切換到預覽模式",
    "compress": "退出全屏",
    "quote": "引用",
    "italic": "斜體",
    "strikethrough": "删除線",
    "hr": "分割線",
    "h2": "標題2",
    "history": "歷史版本",
    "picture": "插入圖片",
    'grammar': 'Markdown語法參考',
    jianchuang: '簡創',
    film: '電影'
  },
  "pubbtn": {
    "publish-update": "發佈更新",
    "publishing": "發佈中…",
    "compile-paid-note": "發佈更新和設定",
    "cancel-publish": "取消發佈",
    "publicize": "發佈文章",
    "publicize-paid-note": "發佈為付費文章",
    "save-fail": "保存失敗，請手動保存",
    "publicized": "已發佈",
    "saving": "保存中…",
    "saved": "已保存",
    'audio-transcoding': '音頻轉碼中，請稍後發布'
  },
  "modal": {
    "insertlink": "插入連結",
    "confirm": "確認",
    "wrong-video-source": "暫不支持此視頻地址",
    "cancel": "取消",
    "tc": "騰訊",
    "video-url-des": "請輸入視頻地址",
    "imglinkdes": "請輸入網絡圖片連結",
    "linktxtdes": "連結文字",
    "insertimgdes": "點擊上傳（可多張）",
    "chooseurlimg": "或選擇網絡圖片",
    "imgpolicy": "圖片私密性",
    "only-support": "現時只支持",
    "getting-linkinfo": "正在獲取連結標題…",
    "choosesysimg": "或上傳本地圖片",
    "video-loading": "正在加載視頻，請稍等…",
    "video": "視頻",
    "removeLink": "删除連結",
    "insertimg": "插入圖片",
    "urldes": "連結位址",
    "insertvideo": "插入視頻",
    "insertfilm": "插入電影",
    "film-placeholder": "請輸入電影名稱",
    "film-select-tip": "請先選擇一部電影",
    "film-search-fail": "電影搜索失敗",
    "film-score": "評分",
    "film-score-unit": "分",
    "film-score-bad": "很差",
    "film-score-poor": "較差",
    "film-score-ok": "還行",
    "film-score-good": "推薦",
    "film-score-great": "力薦",
    "yk": "優酷",
    "getting-linkinfo-fail": "無法獲取連結標題，請手動輸入連結文字",
    "fetch-video-info-failed": "抱歉，您輸入的地址無法識別！",
    'insert-audio': '插入音頻',
    'upload-audio': '點擊上傳',
    'audio-support': '支持 {format} 格式，大小不超過 {size} M',
    'audio-cancle': '取消上傳',
    'audio-upload-unfinished': '音頻上傳尚未完成',
    'reupload-audio': '重新上傳',
    'retry': '重試',
    'audio-upload-failed': '上傳失敗',
    'audio-uploading-failed': '音頻未上傳成功',
    'audio-upload-complete': '上傳完成',
    'audio-upload-error': '網路異常，請稍後再試',
    'audio-name': '音頻名稱',
    'audio-author': '音頻作者',
    'insert-audio-name': '輸入音頻名稱',
    'insert-audio-author': '輸入音頻的創作者',
    'delete-audio': '刪除音頻',
    'audio-confirm': '確定',
    'audio-overlarge': '文件大小超過限制！',
    'audio-delete': '確認刪除音頻嗎？',
    'no-name': '佚名',
    'close-audio-warning': '確認關閉嗎？',
    'close-audio-warning2': '關閉後，當前的更改或上傳將丟失',
    'audio-transcoding': '音頻正在轉碼，請稍候',
    'audio-edit': '編輯',
    'insert-math-formula': '插入數學公式',
    'common-expression': '常用表達式',
    'common-function': '常用函數',
    'common-symbol': '常用符號',
    'greek-alphabet': '希臘字母',
    'special-symbol': '特殊符號',
    'math-formula-grammar': '數學公式語法',
    'insert-empty': '輸入內容為空，請重新輸入！',
    'insert-audio-modal': '插入音頻',
    'insert-audio-explain': '插入音頻功能，僅對簡書鑽大于 {minJSD} 或被邀請的用戶開放，你可以通過購買簡書會員，或者積極參與簡書社區互動（喜歡優質文章/喜歡自己的文章）等方式，增加你的簡書鑽'
  },
  "history": {
    "publicize": "公開發表文章",
    "recovery-to": "恢復到這個版本",
    "timeago": "剛剛_秒以前_分鐘以前_小時以前_天以前_周以前_月以前_年以前",
    "android": "簡書Android App",
    "ios-night": "簡書iPhone App黑夜版",
    "total-items": "共{num}條歷史版本",
    "ios": "簡書iPhone App",
    "update": "發佈更新",
    "web": "簡書網站",
    "auto-save": "自動保存",
    "recovery": "版本恢復",
    "filter": "篩選"
  },
  "trash": {
    "del-time2": "{time}天后清除",
    "recovery": "恢復文章",
    "delete": "徹底删除",
    "del-time": "將於{time}清除",
    "trash": "回收站（{num}）",
    "recovering": "恢復文章中…",
    "deleting": "徹底删除中…"
  },
  "verifymodal": {
    "resend-captcha": "重新發送驗證碼",
    "loading": "正在加載驗證資訊…",
    "send-captcha": "發送驗證碼",
    "by-phone": "用手機短信驗證",
    "send-captcha-error": "驗證碼發送失敗，可刷新頁面重試",
    "confirming": "確認中…",
    "confirm": "確認",
    "empty-captcha": "驗證碼為空",
    "sending-captcha": "{num}秒後重新發送",
    "email-prefix": "用郵箱",
    "captcha": "驗證碼",
    "title": "安全驗證",
    "by-email": "用郵箱驗證",
    "verify": "驗證",
    "verify-captcha-error": "驗證碼錯誤，請重試",
    "des": "為了保證你的帳號安全，請先驗證身份，驗證成功後進行下一步操作，驗證碼{minute}分鐘內有效",
    "sms-prefix": "用手機"
  },
  "app": {
    "name": "簡書"
  },
  "phoneModal": {
    "tip": "綁定遇到問題",
    "yjjb": "一鍵綁定",
    "cancel": "取消",
    "wxoccupy": "微信被佔用",
    "clickbind": "點擊綁定",
    "bindwx": "綁定微信",
    "bindwxtip": "請使用微信掃描二維碼進行綁定",
    "bindtitle": "綁定手機號和微信",
    "nobind": "未綁定",
    "bindtip": "發佈公開文章需要同時綁定手機號和微信",
    "href": "點擊查看幫助",
    "bindwxphone": "綁定手機號和微信",
    "phone-error": "輸入的手機號碼有誤，請重新輸入",
    "captcha-regex-error": "驗證碼格式不對，請重新輸入",
    "get-otp-info-error": "獲取國家區號失敗，請刷新頁面重試",
    "hot-countries": "熱門國家和地區",
    "captcha": "簡訊驗證碼",
    "phone-num": "手機號",
    "all": "全部",
    "title": "綁定手機"
  },
  "publishSuccessModal": {
    "lastest-collections": "最近投稿",
    "post-des": "向專題投稿，讓文章被更多人發現",
    "success-des": "發佈成功，點擊查看文章",
    "new-collection": "新建",
    "including-note": "收錄中",
    "copy-success": "已複製到剪貼板中",
    "posted-note": "等待稽核",
    "post-note": "投稿",
    "copy-fail": "此瀏覽器不支持，複製失敗，建議用Chrome",
    "my-collections": "我管理的專題",
    "include-note": "收錄",
    "included-note": "已收錄",
    "no-more-data": "沒有更多了",
    "posting-note": "投稿中",
    "get-more-data": "點擊加載更多",
    "search-collection": "搜索專題",
    "recomend-collections": "推薦專題"
  },
  "collections": {
    "suber-num": "{num}人關注",
    "note-num": "{num}篇文章"
  },
  'upload-img': {
    'upload-success': '上傳成功',
    'upload-fail': '上傳失敗',
    'upload-size-error': '上傳圖片尺寸錯誤',
    'upload-net-error': '網絡錯誤，請重試'
  },
  tips: {
    'set-reprintable-success': '設置轉載狀態成功',
    'set-reprintable-fail': '設置轉載狀態失敗'
  }
};

/***/ }),

/***/ "+qiL":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("EDcJ");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../node_modules/css-loader/index.js??ref--3-1!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/lib/loader.js!./index.scss", function() {
		var newContent = require("!!../../node_modules/css-loader/index.js??ref--3-1!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/lib/loader.js!./index.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "/MvA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = __webpack_require__("Xpbu");

var _Modal2 = _interopRequireDefault(_Modal);

var _ModalConfirm = __webpack_require__("1nMn");

var _ModalConfirm2 = _interopRequireDefault(_ModalConfirm);

var _ModalButton = __webpack_require__("83nq");

var _ModalButton2 = _interopRequireDefault(_ModalButton);

var _ModalPrompt = __webpack_require__("sAuu");

var _ModalPrompt2 = _interopRequireDefault(_ModalPrompt);

var _ModalAlert = __webpack_require__("PREo");

var _ModalAlert2 = _interopRequireDefault(_ModalAlert);

var _ModalOpen = __webpack_require__("2dDR");

var _ModalOpen2 = _interopRequireDefault(_ModalOpen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by zad on 17/11/15.
 */
_Modal2.default.Prompt = _ModalPrompt2.default;
_Modal2.default.Confirm = _ModalConfirm2.default;
_Modal2.default.Alert = _ModalAlert2.default;
_Modal2.default.Button = _ModalButton2.default;
_Modal2.default.open = _ModalOpen2.default;

exports.default = _Modal2.default;

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0BBt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactIntlUniversal = __webpack_require__("cl+9");

var _reactIntlUniversal2 = _interopRequireDefault(_reactIntlUniversal);

var _step = __webpack_require__("5ym/");

var _step2 = _interopRequireDefault(_step);

var _IconFont = __webpack_require__("z69G");

var _IconFont2 = _interopRequireDefault(_IconFont);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by mac on 2018/8/25.
 */
var StepTwo = function (_Component) {
  (0, _inherits3.default)(StepTwo, _Component);

  function StepTwo() {
    (0, _classCallCheck3.default)(this, StepTwo);
    return (0, _possibleConstructorReturn3.default)(this, (StepTwo.__proto__ || (0, _getPrototypeOf2.default)(StepTwo)).apply(this, arguments));
  }

  (0, _createClass3.default)(StepTwo, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          username = _props.username,
          onModalCancelClick = _props.onModalCancelClick;

      return _react2.default.createElement(
        'div',
        { className: _step2.default.container },
        _react2.default.createElement(
          'div',
          { className: _step2.default.title },
          _react2.default.createElement(
            'div',
            { className: _step2.default.index },
            '2'
          ),
          _react2.default.createElement(
            'p',
            null,
            '\u89E3\u7ED1\u300C',
            username,
            '\u300D\u7684\u5FAE\u4FE1\uFF0C\u5E76\u4E00\u952E\u7ED1\u5B9A\u5230\u5F53\u524D\u8D26\u6237'
          )
        ),
        _react2.default.createElement(
          'button',
          { className: _step2.default.btn, onClick: function onClick() {
              StepTwo.goUrl();
            } },
          _reactIntlUniversal2.default.get('bind.yjbdwx')
        ),
        _react2.default.createElement(
          'span',
          { className: _step2.default['cancel'], onClick: onModalCancelClick },
          _reactIntlUniversal2.default.get('phoneModal.cancel')
        )
      );
    }
  }], [{
    key: 'goUrl',
    value: function goUrl() {
      var url = window.location.href;
      window.location.href = '/users/auth/wechat?transfer=true&redirect_url=' + encodeURIComponent(url);
    }
  }]);
  return StepTwo;
}(_react.Component);

exports.default = StepTwo;

/***/ }),

/***/ "0PXr":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3+cj",
	"./af.js": "3+cj",
	"./ar": "gwdE",
	"./ar-dz": "Zj87",
	"./ar-dz.js": "Zj87",
	"./ar-kw": "Hq//",
	"./ar-kw.js": "Hq//",
	"./ar-ly": "Yt+k",
	"./ar-ly.js": "Yt+k",
	"./ar-ma": "f3I/",
	"./ar-ma.js": "f3I/",
	"./ar-sa": "Vva3",
	"./ar-sa.js": "Vva3",
	"./ar-tn": "0/L7",
	"./ar-tn.js": "0/L7",
	"./ar.js": "gwdE",
	"./az": "L0Jm",
	"./az.js": "L0Jm",
	"./be": "zoyG",
	"./be.js": "zoyG",
	"./bg": "ZOhF",
	"./bg.js": "ZOhF",
	"./bm": "l/yJ",
	"./bm.js": "l/yJ",
	"./bn": "bKVG",
	"./bn.js": "bKVG",
	"./bo": "1nci",
	"./bo.js": "1nci",
	"./br": "DjjZ",
	"./br.js": "DjjZ",
	"./bs": "aGQg",
	"./bs.js": "aGQg",
	"./ca": "18Sw",
	"./ca.js": "18Sw",
	"./cs": "Z0bR",
	"./cs.js": "Z0bR",
	"./cv": "hUuh",
	"./cv.js": "hUuh",
	"./cy": "yp9d",
	"./cy.js": "yp9d",
	"./da": "rb49",
	"./da.js": "rb49",
	"./de": "AApy",
	"./de-at": "pqcM",
	"./de-at.js": "pqcM",
	"./de-ch": "0bCN",
	"./de-ch.js": "0bCN",
	"./de.js": "AApy",
	"./dv": "uwE4",
	"./dv.js": "uwE4",
	"./el": "zDKb",
	"./el.js": "zDKb",
	"./en-SG": "TSHU",
	"./en-SG.js": "TSHU",
	"./en-au": "kI07",
	"./en-au.js": "kI07",
	"./en-ca": "r9L2",
	"./en-ca.js": "r9L2",
	"./en-gb": "G2Jj",
	"./en-gb.js": "G2Jj",
	"./en-ie": "fW3T",
	"./en-ie.js": "fW3T",
	"./en-il": "GS7I",
	"./en-il.js": "GS7I",
	"./en-nz": "+MOH",
	"./en-nz.js": "+MOH",
	"./eo": "dHoV",
	"./eo.js": "dHoV",
	"./es": "Vnb8",
	"./es-do": "/zKl",
	"./es-do.js": "/zKl",
	"./es-us": "SfFD",
	"./es-us.js": "SfFD",
	"./es.js": "Vnb8",
	"./et": "VnLk",
	"./et.js": "VnLk",
	"./eu": "WB/1",
	"./eu.js": "WB/1",
	"./fa": "YWp/",
	"./fa.js": "YWp/",
	"./fi": "BcOZ",
	"./fi.js": "BcOZ",
	"./fo": "I4ST",
	"./fo.js": "I4ST",
	"./fr": "KYpt",
	"./fr-ca": "JNcU",
	"./fr-ca.js": "JNcU",
	"./fr-ch": "khdO",
	"./fr-ch.js": "khdO",
	"./fr.js": "KYpt",
	"./fy": "1Ltb",
	"./fy.js": "1Ltb",
	"./ga": "3a9g",
	"./ga.js": "3a9g",
	"./gd": "5SH9",
	"./gd.js": "5SH9",
	"./gl": "e4fh",
	"./gl.js": "e4fh",
	"./gom-latn": "Dv4+",
	"./gom-latn.js": "Dv4+",
	"./gu": "NMF5",
	"./gu.js": "NMF5",
	"./he": "i7j8",
	"./he.js": "i7j8",
	"./hi": "3+Ci",
	"./hi.js": "3+Ci",
	"./hr": "xQLz",
	"./hr.js": "xQLz",
	"./hu": "0TxH",
	"./hu.js": "0TxH",
	"./hy-am": "MhGK",
	"./hy-am.js": "MhGK",
	"./id": "VLGm",
	"./id.js": "VLGm",
	"./is": "atCy",
	"./is.js": "atCy",
	"./it": "NLs2",
	"./it-ch": "oNF7",
	"./it-ch.js": "oNF7",
	"./it.js": "NLs2",
	"./ja": "kPus",
	"./ja.js": "kPus",
	"./jv": "NbcM",
	"./jv.js": "NbcM",
	"./ka": "Rke8",
	"./ka.js": "Rke8",
	"./kk": "4tz5",
	"./kk.js": "4tz5",
	"./km": "nQRU",
	"./km.js": "nQRU",
	"./kn": "crw6",
	"./kn.js": "crw6",
	"./ko": "srrC",
	"./ko.js": "srrC",
	"./ku": "Ibtz",
	"./ku.js": "Ibtz",
	"./ky": "D3qQ",
	"./ky.js": "D3qQ",
	"./lb": "Oc34",
	"./lb.js": "Oc34",
	"./lo": "NG6E",
	"./lo.js": "NG6E",
	"./lt": "VH6b",
	"./lt.js": "VH6b",
	"./lv": "s3gM",
	"./lv.js": "s3gM",
	"./me": "crH3",
	"./me.js": "crH3",
	"./mi": "4MLK",
	"./mi.js": "4MLK",
	"./mk": "OOAP",
	"./mk.js": "OOAP",
	"./ml": "kni4",
	"./ml.js": "kni4",
	"./mn": "OytY",
	"./mn.js": "OytY",
	"./mr": "hun5",
	"./mr.js": "hun5",
	"./ms": "oRRj",
	"./ms-my": "taHH",
	"./ms-my.js": "taHH",
	"./ms.js": "oRRj",
	"./mt": "d+NK",
	"./mt.js": "d+NK",
	"./my": "vYxR",
	"./my.js": "vYxR",
	"./nb": "NPFl",
	"./nb.js": "NPFl",
	"./ne": "RqPg",
	"./ne.js": "RqPg",
	"./nl": "SKWH",
	"./nl-be": "qaUT",
	"./nl-be.js": "qaUT",
	"./nl.js": "SKWH",
	"./nn": "W5ed",
	"./nn.js": "W5ed",
	"./pa-in": "2CDf",
	"./pa-in.js": "2CDf",
	"./pl": "1Qu0",
	"./pl.js": "1Qu0",
	"./pt": "IFwP",
	"./pt-br": "qSpG",
	"./pt-br.js": "qSpG",
	"./pt.js": "IFwP",
	"./ro": "61xJ",
	"./ro.js": "61xJ",
	"./ru": "8evC",
	"./ru.js": "8evC",
	"./sd": "YaZ2",
	"./sd.js": "YaZ2",
	"./se": "W33H",
	"./se.js": "W33H",
	"./si": "gjfK",
	"./si.js": "gjfK",
	"./sk": "LFem",
	"./sk.js": "LFem",
	"./sl": "D3ov",
	"./sl.js": "D3ov",
	"./sq": "Jx5p",
	"./sq.js": "Jx5p",
	"./sr": "NC8w",
	"./sr-cyrl": "4s4W",
	"./sr-cyrl.js": "4s4W",
	"./sr.js": "NC8w",
	"./ss": "2/Pz",
	"./ss.js": "2/Pz",
	"./sv": "8Cjv",
	"./sv.js": "8Cjv",
	"./sw": "6U4l",
	"./sw.js": "6U4l",
	"./ta": "V08a",
	"./ta.js": "V08a",
	"./te": "aTm7",
	"./te.js": "aTm7",
	"./tet": "YUVt",
	"./tet.js": "YUVt",
	"./tg": "qiX1",
	"./tg.js": "qiX1",
	"./th": "4ibK",
	"./th.js": "4ibK",
	"./tl-ph": "Iw4U",
	"./tl-ph.js": "Iw4U",
	"./tlh": "4piq",
	"./tlh.js": "4piq",
	"./tr": "Lbwn",
	"./tr.js": "Lbwn",
	"./tzl": "jKHx",
	"./tzl.js": "jKHx",
	"./tzm": "fa8f",
	"./tzm-latn": "6zxo",
	"./tzm-latn.js": "6zxo",
	"./tzm.js": "fa8f",
	"./ug-cn": "JBfE",
	"./ug-cn.js": "JBfE",
	"./uk": "hupV",
	"./uk.js": "hupV",
	"./ur": "pSsn",
	"./ur.js": "pSsn",
	"./uz": "KWx0",
	"./uz-latn": "7kbE",
	"./uz-latn.js": "7kbE",
	"./uz.js": "KWx0",
	"./vi": "dToJ",
	"./vi.js": "dToJ",
	"./x-pseudo": "5zzP",
	"./x-pseudo.js": "5zzP",
	"./yo": "M9h0",
	"./yo.js": "M9h0",
	"./zh-cn": "0b5e",
	"./zh-cn.js": "0b5e",
	"./zh-hk": "cSot",
	"./zh-hk.js": "cSot",
	"./zh-tw": "UU12",
	"./zh-tw.js": "UU12"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0PXr";

/***/ }),

/***/ "0Ze7":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("cjYq");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./QrcodeModal.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./QrcodeModal.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "1nMn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _isFunction2 = __webpack_require__("gGqR");

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _class, _temp; /**
                    * Created by zad on 17/11/17.
                    */


exports.default = confirm;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("O27J");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _reactIntlUniversal = __webpack_require__("cl+9");

var _reactIntlUniversal2 = _interopRequireDefault(_reactIntlUniversal);

var _Modal = __webpack_require__("Xpbu");

var _Modal2 = _interopRequireDefault(_Modal);

var _Modal3 = __webpack_require__("UsL9");

var _Modal4 = _interopRequireDefault(_Modal3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Confirm = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Confirm, _Component);

  function Confirm(props) {
    (0, _classCallCheck3.default)(this, Confirm);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Confirm.__proto__ || (0, _getPrototypeOf2.default)(Confirm)).call(this, props));

    _this.showModal = function () {
      _this.setState(function (prevState) {
        if (prevState.visible) {
          return null;
        }
        return {
          visible: true
        };
      });
    };

    _this.hideModal = function () {
      _this.setState({ visible: false });
    };

    _this.handleOk = function (e) {
      _this.hideModal();
      var onOk = _this.props.onOk;

      if ((0, _isFunction3.default)(onOk)) {
        onOk(e);
      }
    };

    _this.handleCancel = function (e) {
      _this.hideModal();
      var onCancel = _this.props.onCancel;

      if ((0, _isFunction3.default)(onCancel)) {
        onCancel(e);
      }
    };

    _this.getButtonText = function () {
      var _this$props = _this.props,
          okText = _this$props.okText,
          cancelText = _this$props.cancelText;

      return {
        ok: okText || _reactIntlUniversal2.default.get('modal.confirm'),
        cancel: cancelText || _reactIntlUniversal2.default.get('modal.cancel')
      };
    };

    _this.state = {
      visible: false
    };
    return _this;
  }

  (0, _createClass3.default)(Confirm, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.destroy();
    }
  }, {
    key: 'render',
    value: function render() {
      // eslint-disable-next-line max-len
      var _props = this.props,
          content = _props.content,
          showCancelBtn = _props.showCancelBtn,
          modalClassName = _props.modalClassName,
          confirmBodyClassName = _props.confirmBodyClassName,
          confirmBodyStyle = _props.confirmBodyStyle,
          destroy = _props.destroy;

      var btnText = this.getButtonText();
      var modalClass = (0, _classnames2.default)(modalClassName, (0, _defineProperty3.default)({}, '' + _Modal4.default['confirm'], true));
      var bodyClass = (0, _classnames2.default)(confirmBodyClassName, (0, _defineProperty3.default)({}, '' + _Modal4.default['confirm-body'], true));

      var body = _react2.default.createElement(
        'div',
        { className: bodyClass, style: confirmBodyStyle },
        content
      );

      var footer = _react2.default.createElement(
        'div',
        { className: _Modal4.default['confirm-footer'] },
        showCancelBtn && _react2.default.createElement(
          _Modal2.default.Button,
          { onClick: this.handleCancel },
          btnText.cancel
        ),
        _react2.default.createElement(
          _Modal2.default.Button,
          { onClick: this.handleOk, type: 'primary' },
          btnText.ok
        )
      );

      return _react2.default.createElement(
        _Modal2.default,
        (0, _extends3.default)({}, this.props, {
          modalClassName: modalClass,
          visible: this.state.visible,
          onOk: this.handleOk,
          onCancel: this.handleCancel,
          afterClose: destroy
        }),
        _react2.default.createElement(
          'div',
          { className: _Modal4.default['confirm-wrapper'] },
          body,
          footer
        )
      );
    }
  }]);
  return Confirm;
}(_react.Component), _class.displayName = 'Modal.Confirm', _class.propTypes = {
  content: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  modalClassName: _propTypes2.default.string,
  confirmBodyClassName: _propTypes2.default.string,
  confirmBodyStyle: _propTypes2.default.object,
  destroy: _propTypes2.default.func,
  showCancelBtn: _propTypes2.default.bool
}, _temp);
function confirm(content, options) {
  return new _promise2.default(function (resolve) {
    var called = false;
    var div = document.createElement('div');
    document.body.appendChild(div);

    // 在关闭动画结束时，触发destroy方法
    function destroy() {
      var isRemoved = _reactDom2.default.unmountComponentAtNode(div);
      if (isRemoved && div.parentNode) {
        div.parentNode.removeChild(div);
      }
    }

    var confirmProps = (0, _extends3.default)({
      isMiddle: true,
      showMask: true,
      maskClosable: true,
      width: 312,
      okText: '确认',
      cancelText: '取消',
      onOk: function onOk() {
        return undefined;
      },
      onCancel: function onCancel() {
        return undefined;
      },
      modalClassName: '',
      confirmBodyClassName: '',
      confirmBodyStyle: {},
      showCancelBtn: true
    }, options, {
      title: '',
      showFooter: false,
      closable: false,
      content: content,
      destroy: destroy
    });

    function ref(instance) {
      if (called) {
        return;
      }
      called = true;
      instance.showModal();
      resolve({
        destroy: destroy,
        instance: instance,
        target: div
      });
    }

    _reactDom2.default.render(_react2.default.createElement(Confirm, (0, _extends3.default)({}, confirmProps, { ref: ref })), div);
  });
}

/***/ }),

/***/ "1uUF":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("4xFE");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./PNAgreeModal.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./PNAgreeModal.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "2Jz7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _getComponentName = __webpack_require__("pNOl");

var _getComponentName2 = _interopRequireDefault(_getComponentName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by zad on 17/9/28.
 */
exports.default = function (getComponent) {
  var _class, _temp;

  return _temp = _class = function (_React$Component) {
    (0, _inherits3.default)(AsyncRoute, _React$Component);

    function AsyncRoute(props) {
      (0, _classCallCheck3.default)(this, AsyncRoute);

      var _this = (0, _possibleConstructorReturn3.default)(this, (AsyncRoute.__proto__ || (0, _getPrototypeOf2.default)(AsyncRoute)).call(this, props));

      _this.state = {
        Component: AsyncRoute.Component,
        error: null
      };
      return _this;
    }

    (0, _createClass3.default)(AsyncRoute, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        if (!this.state.Component) {
          getComponent().then(function (module) {
            // 确保模块和默认导出都存在
            if (module && module.default) {
              AsyncRoute.Component = module.default;
              AsyncRoute.displayName = 'AsyncRoute(' + (0, _getComponentName2.default)(module.default) + ')';
              _this2.setState({
                Component: module.default,
                error: null
              });
            } else {
              // 如果模块导入失败，设置一个错误组件
              console.error('Failed to load component:', module);
              _this2.setState({
                Component: null,
                error: new Error('Failed to load component')
              });
            }
          }).catch(function (error) {
            // 捕获导入错误
            console.error('Error importing component:', error);
            _this2.setState({
              Component: null,
              error: error
            });
          });
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _state = this.state,
            Component = _state.Component,
            error = _state.error;

        // 如果有错误，显示错误信息

        if (error) {
          console.error('AsyncRoute error:', error);
          return _react2.default.createElement(
            'div',
            null,
            'Error loading component: ',
            error.message
          );
        }

        // 确保返回有效的React元素
        if (Component) {
          try {
            return _react2.default.createElement(Component, this.props);
          } catch (renderError) {
            console.error('Error rendering component:', renderError);
            return _react2.default.createElement(
              'div',
              null,
              'Error rendering component: ',
              renderError.message
            );
          }
        }

        // 加载状态
        return _react2.default.createElement(
          'div',
          null,
          'Loading...'
        );
      }
    }]);
    return AsyncRoute;
  }(_react2.default.Component), _class.Component = null, _class.displayName = 'AsyncRoute()', _temp;
};

/***/ }),

/***/ "2PWF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.watchGetNotebooks = watchGetNotebooks;
exports.watchSortNotebooks = watchSortNotebooks;
exports.watchNewNoteBook = watchNewNoteBook;
exports.watchDelNoteBookSoft = watchDelNoteBookSoft;
exports.watchRenameNoteBook = watchRenameNoteBook;

var _effects = __webpack_require__("egdi");

var _actionTypes = __webpack_require__("4HHy");

var _TrashNotesReducer = __webpack_require__("mXnL");

var _NotebooksReducer = __webpack_require__("gmmG");

var _ajax = __webpack_require__("Z1y9");

var _ajax2 = _interopRequireDefault(_ajax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(getNotebooksAsync),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(sortNotebooksAsync),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(newNoteBook),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(deleteNoteBookSoft),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(renameNoteBook),
    _marked6 = /*#__PURE__*/_regenerator2.default.mark(watchGetNotebooks),
    _marked7 = /*#__PURE__*/_regenerator2.default.mark(watchSortNotebooks),
    _marked8 = /*#__PURE__*/_regenerator2.default.mark(watchNewNoteBook),
    _marked9 = /*#__PURE__*/_regenerator2.default.mark(watchDelNoteBookSoft),
    _marked10 = /*#__PURE__*/_regenerator2.default.mark(watchRenameNoteBook); /**
                                                                               * Created by zad on 17/4/26.
                                                                               */


function getNotebooksAsync(action) {
  var isForce, notebooks, _ref, data;

  return _regenerator2.default.wrap(function getNotebooksAsync$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          isForce = action.isForce;
          _context.next = 3;
          return (0, _effects.select)(_NotebooksReducer.getState);

        case 3:
          notebooks = _context.sent;
          _context.prev = 4;

          if (!(notebooks.get('seq').size === 0 || isForce)) {
            _context.next = 14;
            break;
          }

          _context.next = 8;
          return (0, _effects.call)(_ajax2.default.getNotebooks);

        case 8:
          _ref = _context.sent;
          data = _ref.data;
          _context.next = 12;
          return (0, _effects.put)({ type: _actionTypes.Notebooks.GET_NOTEBOOKS_SUCCESS, data: data });

        case 12:
          _context.next = 16;
          break;

        case 14:
          _context.next = 16;
          return (0, _effects.put)({ type: _actionTypes.Notebooks.GET_NOTEBOOKS_SUCCESS, isCache: true });

        case 16:
          _context.next = 22;
          break;

        case 18:
          _context.prev = 18;
          _context.t0 = _context['catch'](4);
          _context.next = 22;
          return (0, _effects.put)({ type: _actionTypes.Notebooks.GET_NOTEBOOKS_FAIL });

        case 22:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[4, 18]]);
}

function sortNotebooksAsync(action) {
  var newSeq, oldSeq, _ref2, data;

  return _regenerator2.default.wrap(function sortNotebooksAsync$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          newSeq = action.newSeq, oldSeq = action.oldSeq;
          _context2.prev = 1;
          _context2.next = 4;
          return (0, _effects.call)(_ajax2.default.sortNotebooks, newSeq);

        case 4:
          _ref2 = _context2.sent;
          data = _ref2.data;
          _context2.next = 8;
          return (0, _effects.put)({ type: _actionTypes.Notebooks.SORT_NOTEBOOKS_SUCCESS });

        case 8:
          _context2.next = 14;
          break;

        case 10:
          _context2.prev = 10;
          _context2.t0 = _context2['catch'](1);
          _context2.next = 14;
          return (0, _effects.put)({ type: _actionTypes.Notebooks.SORT_NOTEBOOKS_FAIL, oldSeq: oldSeq });

        case 14:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[1, 10]]);
}

function newNoteBook(action) {
  var name, resolve, reject, _ref3, data;

  return _regenerator2.default.wrap(function newNoteBook$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          name = action.name, resolve = action.resolve, reject = action.reject;
          _context3.prev = 1;
          _context3.next = 4;
          return (0, _effects.call)(_ajax2.default.newNoteBook, name);

        case 4:
          _ref3 = _context3.sent;
          data = _ref3.data;
          _context3.next = 8;
          return (0, _effects.put)({ type: _actionTypes.Notebooks.NEW_NOTEBOOK_SUCCESS, data: data });

        case 8:
          resolve(data);
          _context3.next = 16;
          break;

        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3['catch'](1);
          _context3.next = 15;
          return (0, _effects.put)({ type: _actionTypes.Notebooks.NEW_NOTEBOOK_FAIL });

        case 15:
          reject(_context3.t0);

        case 16:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this, [[1, 11]]);
}

function deleteNoteBookSoft(action) {
  var nbId, resolve, reject, trashList, _ref4, data;

  return _regenerator2.default.wrap(function deleteNoteBookSoft$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          nbId = action.nbId, resolve = action.resolve, reject = action.reject;
          _context4.next = 3;
          return (0, _effects.select)(_TrashNotesReducer.getTrashNotesListState);

        case 3:
          trashList = _context4.sent;
          _context4.prev = 4;
          _context4.next = 7;
          return (0, _effects.call)(_ajax2.default.deleteNoteBookSoft, nbId);

        case 7:
          _ref4 = _context4.sent;
          data = _ref4.data;
          _context4.next = 11;
          return (0, _effects.put)({ type: _actionTypes.Notebooks.DEL_NOTEBOOK_SOFT_SUCCESS, data: data, nbId: nbId });

        case 11:
          if (!trashList.get('seq')) {
            _context4.next = 14;
            break;
          }

          _context4.next = 14;
          return (0, _effects.put)({ type: _actionTypes.Trash.GET_TRASH_NOTES_LIST, isForce: true });

        case 14:
          resolve(data);
          _context4.next = 22;
          break;

        case 17:
          _context4.prev = 17;
          _context4.t0 = _context4['catch'](4);
          _context4.next = 21;
          return (0, _effects.put)({ type: _actionTypes.Notebooks.DEL_NOTEBOOK_SOFT_FAIL, nbId: nbId });

        case 21:
          reject(_context4.t0);

        case 22:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this, [[4, 17]]);
}

// 重命名文集
function renameNoteBook(action) {
  var nbId, name, _ref5, data;

  return _regenerator2.default.wrap(function renameNoteBook$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          nbId = action.nbId, name = action.name;
          _context5.prev = 1;
          _context5.next = 4;
          return (0, _effects.call)(_ajax2.default.updateBookName, nbId, name);

        case 4:
          _ref5 = _context5.sent;
          data = _ref5.data;
          _context5.next = 8;
          return (0, _effects.put)({ type: _actionTypes.Notebooks.RENAME_NOTEBOOK_SUCCESS, data: data, nbId: nbId, name: name });

        case 8:
          _context5.next = 14;
          break;

        case 10:
          _context5.prev = 10;
          _context5.t0 = _context5['catch'](1);
          _context5.next = 14;
          return (0, _effects.put)({ type: _actionTypes.Notebooks.RENAME_NOTEBOOK_FAIL, nbId: nbId, name: name });

        case 14:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this, [[1, 10]]);
}

// eslint-disable-next-line import/prefer-default-export
function watchGetNotebooks() {
  return _regenerator2.default.wrap(function watchGetNotebooks$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.takeEvery)(_actionTypes.Notebooks.GET_NOTEBOOKS, getNotebooksAsync);

        case 2:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function watchSortNotebooks() {
  return _regenerator2.default.wrap(function watchSortNotebooks$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.takeLatest)(_actionTypes.Notebooks.SORT_NOTEBOOKS, sortNotebooksAsync);

        case 2:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

function watchNewNoteBook() {
  return _regenerator2.default.wrap(function watchNewNoteBook$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.takeEvery)(_actionTypes.Notebooks.NEW_NOTEBOOK, newNoteBook);

        case 2:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

function watchDelNoteBookSoft() {
  return _regenerator2.default.wrap(function watchDelNoteBookSoft$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.takeLatest)(_actionTypes.Notebooks.DEL_NOTEBOOK_SOFT, deleteNoteBookSoft);

        case 2:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this);
}

function watchRenameNoteBook() {
  return _regenerator2.default.wrap(function watchRenameNoteBook$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.takeLatest)(_actionTypes.Notebooks.RENAME_NOTEBOOK, renameNoteBook);

        case 2:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked10, this);
}

/***/ }),

/***/ "2dDR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _isFunction2 = __webpack_require__("gGqR");

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _class, _temp;

exports.default = open;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("O27J");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactIntlUniversal = __webpack_require__("cl+9");

var _reactIntlUniversal2 = _interopRequireDefault(_reactIntlUniversal);

var _Modal = __webpack_require__("Xpbu");

var _Modal2 = _interopRequireDefault(_Modal);

var _Modal3 = __webpack_require__("UsL9");

var _Modal4 = _interopRequireDefault(_Modal3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Open = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Open, _Component);

  function Open(props) {
    (0, _classCallCheck3.default)(this, Open);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Open.__proto__ || (0, _getPrototypeOf2.default)(Open)).call(this, props));

    _this.showModal = function () {
      _this.setState(function (prevState) {
        if (prevState.visible) {
          return null;
        }
        return {
          visible: true
        };
      });
    };

    _this.hideModal = function () {
      _this.setState({ visible: false });
    };

    _this.handleOk = function (e) {
      _this.hideModal();
      var onOk = _this.props.onOk;

      if ((0, _isFunction3.default)(onOk)) {
        onOk(e);
      }
    };

    _this.handleCancel = function (e) {
      _this.hideModal();
      var onCancel = _this.props.onCancel;

      if ((0, _isFunction3.default)(onCancel)) {
        onCancel(e);
      }
    };

    _this.state = {
      visible: false
    };
    return _this;
  }

  (0, _createClass3.default)(Open, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.destroy();
    }
  }, {
    key: 'render',
    value: function render() {
      var content = this.props.content;


      return _react2.default.createElement(
        _Modal2.default,
        (0, _extends3.default)({}, this.props, {
          visible: this.state.visible,
          onOk: this.handleOk,
          onCancel: this.handleCancel
        }),
        _react2.default.createElement(
          'div',
          { className: _Modal4.default['confirm-wrapper'] },
          content
        )
      );
    }
  }]);
  return Open;
}(_react.Component), _class.displayName = 'Modal.open', _temp);
function open(content, options) {
  return new _promise2.default(function (resolve) {
    var called = false;
    var div = document.createElement('div');
    document.body.appendChild(div);

    // 在关闭动画结束时，触发destroy方法
    function destroy() {
      var isRemoved = _reactDom2.default.unmountComponentAtNode(div);
      if (isRemoved && div.parentNode) {
        div.parentNode.removeChild(div);
      }
    }

    var openProps = (0, _extends3.default)({}, options, {
      content: content,
      destroy: destroy
    });

    function ref(instance) {
      if (called) {
        return;
      }
      called = true;
      instance.showModal();
      resolve({
        destroy: destroy,
        instance: instance,
        target: div
      });
    }

    _reactDom2.default.render(_react2.default.createElement(Open, (0, _extends3.default)({}, openProps, { ref: ref })), div);
  });
}

/***/ }),

/***/ "38jt":
/***/ (function(module, exports) {

module.exports = "data:application/x-font-ttf;base64,AAEAAAALAIAAAwAwR1NVQrD+s+0AAAE4AAAAQk9TLzI8d0jtAAABfAAAAFZjbWFw/gPSewAAAhAAAAJ+Z2x5Zl+ynJoAAASwAAAJPGhlYWQU5b4mAAAA4AAAADZoaGVhCEUEHgAAALwAAAAkaG10eDyV//wAAAHUAAAAPGxvY2EQDBIyAAAEkAAAACBtYXhwASAAkAAAARgAAAAgbmFtZT5U/n0AAA3sAAACbXBvc3TBGtVvAAAQXAAAALkAAQAAA4D/gABcBJP//P/7BGoAAQAAAAAAAAAAAAAAAAAAAA8AAQAAAAEAAPMxtVVfDzz1AAsEAAAAAADYsD0UAAAAANiwPRT//P+ABGoDgQAAAAgAAgAAAAAAAAABAAAADwCEAAcAAAAAAAIAAAAKAAoAAAD/AAAAAAAAAAEAAAAKAB4ALAABREZMVAAIAAQAAAAAAAAAAQAAAAFsaWdhAAgAAAABAAAAAQAEAAQAAAABAAgAAQAGAAAAAQAAAAAAAQQKAZAABQAIAokCzAAAAI8CiQLMAAAB6wAyAQgAAAIABQMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUGZFZABA5gHm8AOA/4AAXAOBAIAAAAABAAAAAAAABAAAAAQAAAAEAAAABJMAAAQAAAAEAAAABAAAAAQAAAAEAAAABAL//AQAAAAEAAAABAAAAAQAAAAEAAAAAAAABQAAAAMAAAAsAAAABAAAAcYAAQAAAAAAwAADAAEAAAAsAAMACgAAAcYABACUAAAAGgAQAAMACuYC5gTmEOYS5hvmKOYz5lHmkeaZ5qHm8P//AADmAeYE5hDmEuYa5ijmM+ZR5pHmmeah5vD//wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABABoAHAAcABwAHAAeAB4AHgAeAB4AHgAeAAAADgABAAMACgALAAwADQAFAAIABAAGAAgABwAJAAABBgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAC4AAAAAAAAAA4AAOYBAADmAQAAAA4AAOYCAADmAgAAAAEAAOYEAADmBAAAAAMAAOYQAADmEAAAAAoAAOYSAADmEgAAAAsAAOYaAADmGgAAAAwAAOYbAADmGwAAAA0AAOYoAADmKAAAAAUAAOYzAADmMwAAAAIAAOZRAADmUQAAAAQAAOaRAADmkQAAAAYAAOaZAADmmQAAAAgAAOahAADmoQAAAAcAAObwAADm8AAAAAkAAAAAAAAASABqAOoBNgFcAZYB+gLKAyYDYgPwBDIEbgSeAAQAAP+AAx0DgAARABoAIAAsAAAFIisBLgEnET4BNyEeARcRDgEnMjY0JiIGFBYTIisBFTMXBiMhIicRNjchFhcCqxaVqzBAAQFAMAFWMEABAUDbGCAgMCAgbQpLVaqPBwj+VggHDRABjhANgAFAMQMcMUABAUAx/OQxQDghMCAgMCEDjhw3AgL9aAcBAQcAAAEAAAAAA5sCnQARAAAlIi8BJjQ2Mh8BATYyFhQHAQYBoRkU/RImMhTQAY0UMiYS/kYUYhL+FDInE9EBjxMmMxP+QxIABgAA/8EEagM/AAgAEwAcACcARABWAAABNCYiBhQWMjYFNCYjIgYUFjMyNgM0JiIGFBYyNgU0JiMiBhQWMzI2JyYjIg4BFRQXBiMiJi8BJi8BBzcmNTQ+ATMyHgEBFAYHFycGIyIuATQ+ATMyHgEBVxstIyMtGwGOHBUOGRkOFRx/Gi0jIy0aAVUcFQ8YGA8VHI8RFFuYVwwTEg4ZERgHFhuHJptos2lfp3EBTkk/HmtQJVqZV1eZWlaZWwJpFhscKhsa+g8YGB4YGAEfFhscKhsa+g8YGB4YGOQCUo1UKSgCAgMDAQUGRHRtmlqYWEd9/oc/ci9hOxRLgpmCS0uCAAMAAP+4A8gDSAAMABAAKwAAAQYABxYAFzYANyYAJxMjNTMTBw4BFSM1PgE/ATY0JiIGByM+ATceARcUBgcCAMH+/wUFAQHBwQEBBQX+/8EuXFxeKRkcXAEcGTgaM04zAVsCZ01NZwIXEwNHBf7/wcH+/wUFAQHBwQEBBfz6WwEGKhc4MhcmQhk5Gk00NCZNZwICZ00fNBQAAQAAAAAC3gK5ABIAAAE0MQEmIgYUFwkBBhQWMjcBNjQC0v7UCx4VCgET/u0KFR4LASwLAYEBASwKFR4L/u3+7gwdFgsBLQsdAAAAAAQAAP/eA8MDMgAGAAoAGwAfAAABIR4BFzM2NzUhFQEhNSEmJzcjESERIxcGByEVAyE1IQLM/nQgOxmiSlr+GgKs/IgBCjE1RXgCo35EMjIBBBb8tgNKARw1czxwy6mp/mxWbE0sAVv+pSxrTlYC/FcAAAAAAQAA/7sDkANAAEAAAAE0Jic+ASc2JicOARcGFhcOARUGFjcyPgI3Mh8BHgEXDgEVDgEXFjY3Mx4BNzYmJzQmJz4BPwE2Mx4DMxY2A4EmJAMKHghizMxiCB4KAyQmDyMJBRIJDAIDAgIQKAIeJAgCXGR1AhQCdWRcAggkHgIoEAICAwIMCRIFCSMBDQRoMAFAMxL/EhL/EjNAATBoBFY4ARIPGgMGCC44AQ0dAgRHDwgkAwMkCA9HBAIdDQE4LggGAxoPEgE4AAAHAAAAAAOWAssAJAAwAEoAZQBxAHoAgwAAAS4BNz4BJyYGBwYmNzYmJyYGBw4BFzMeARc+ATc1Njc+AScuAQEuASc+ATceARcOARMWMzY3NjUuASciBw4BHgE3NjMeARcUBwYWAyIHDgEeATc2Mx4BFxQHBhYXFjMyNjc2NS4BAQ4BBx4BFz4BNy4BByImNDYyFhQGNw4BLgE+AR4BAsQKDAYICBYYUyYhDAIFATdQoSYxDQMBCcGPebQgBwMEAgcQPP7fZocCAodmZYcDA4fgAwQMBggBNikTEggFBg4ICwsYIAEFAwY4IR8MCwcVDBcYRl4CBwQLDAQFCQ8ECQJ//oY2SAICSDY2SAEBSGATGRkmGRlBBQ0MAwgODAMBhwELCw00GBUGEA4KCw9NDAOCPFRjAU9oAgFPPwENDhEtGCkk/t8CWUNDWgEBWkNDWQFdAgELEhMpNgEIAw4QBgMFASAYCwsIDgEDCQQUGAsDBwJeRhkXDBUEAQsKHyJff/6gAT8wLz8BAT8vMD+3GSYaGiYZUAcFBw4PBQcPAAAAAAT//P+mBAcDPAAIACYALwAzAAABJzMWHwEWBgcXAQ4BLgE3EyMDDgEiJicDIxMWDgEmJwEmNjchHgElNzY3MwcjLgElMxchAu97oCMYoAwOESL+gwYTEggDrjmqAw4TDgOrOa8DCBITBv6DCQ8QA8wRD/wLoRgjn3rtEg0Bv3Z7/pQCTe8BGacNIAFw/fEIBQkSCgIj/bEJCgoJAk/93goSCQQJAg4OHQEBHZCnGQHvASDO7wAAAAACAAAAAAM6AukAEAAhAAABJy4BPgEXBRYGByEuATQ2MxMXHgEOASclJjY3ITIWFAYjApasDgQSHw0BDRYQHP3mEBYWEHetDQQSHw3+8xYQHAIaEBYWEAIegAsfGwUJyBMzAgEWIRf+xIALHxsFCcgTMwIXIRcAAAAEAAD/pAPbA1wAFwAiAFIAWwAAARYdASYGBwYWFyEiJicRPgEzITIzFRQXNxcWBisBJic1PgETDgEHJyYGDwEGIi8BLgEPAS4BJzc2NC8BPgE3FxY2PwE2Mh8BHgE/AR4BFwcGFBcHPgE0JiIGFBYDtgFh5VFNEln+VB8pAQEqHgIiAQIHKsIEBAXCBwEBCPYHJR0kCRADCCRMIggCEQkkHSUHGwcHGwclHSQJEAMIJEwiCAIRCSQdJQcbBwe+JTIySjIyAlsBAvRLF1xf5VMqHwMkHiv4BwH0wwMJAQbDBQP9BCU+GAsDCgkkDAwkCQoDCxg+JRgHEwYZJD8YCwMJCiQLCyQKCQMLGD8kGQYTB0YBMUkxMUkxAAAAAAIAAP+ABAEDgQANACMAAAE0LgIjBgAHFgAXNgAlJj8BPgEfARYyNwE2HwEWFAcBBiInBABNlL1o1f7hBgYBH9XeASP9CgYFEgIIBHoHEgYBPwgHDwMD/qIGEQYBemi9lE0F/t3e1f7hBgYBH7YHCBgDAgNdBQYBCQYGDwMJA/6oBgYAAAEAAP//A0oDAQAlAAAbARYUBwMhNjc2NxUUBiMhIiY9ARM2NCcDNTQ2MyEyFh0BJicmJ+b0Bgb0AYJJHjhCDwr9gwsO9AUF9A8KAn0KD0I4HkwCzf7DCBAI/sMDCxQ5dQoPDwsZAT0IEAgBPRkLDw8LdDkUCwMAAAIAAP+ABAADgAADABsAABEhNSEBJyYiDwEGBx4BFzMxMxEhETM1Fz4BNyYEAPwAAybsGEQY7BMBASwhAmoBAGcFISwBAQMJd/4V+BkZ+BUcICoB/mcBmQEBASogHQAAAAAAEgDeAAEAAAAAAAAAFQAAAAEAAAAAAAEACAAVAAEAAAAAAAIABwAdAAEAAAAAAAMACAAkAAEAAAAAAAQACAAsAAEAAAAAAAUACwA0AAEAAAAAAAYACAA/AAEAAAAAAAoAKwBHAAEAAAAAAAsAEwByAAMAAQQJAAAAKgCFAAMAAQQJAAEAEACvAAMAAQQJAAIADgC/AAMAAQQJAAMAEADNAAMAAQQJAAQAEADdAAMAAQQJAAUAFgDtAAMAAQQJAAYAEAEDAAMAAQQJAAoAVgETAAMAAQQJAAsAJgFpCkNyZWF0ZWQgYnkgaWNvbmZvbnQKaWNvbmZvbnRSZWd1bGFyaWNvbmZvbnRpY29uZm9udFZlcnNpb24gMS4waWNvbmZvbnRHZW5lcmF0ZWQgYnkgc3ZnMnR0ZiBmcm9tIEZvbnRlbGxvIHByb2plY3QuaHR0cDovL2ZvbnRlbGxvLmNvbQAKAEMAcgBlAGEAdABlAGQAIABiAHkAIABpAGMAbwBuAGYAbwBuAHQACgBpAGMAbwBuAGYAbwBuAHQAUgBlAGcAdQBsAGEAcgBpAGMAbwBuAGYAbwBuAHQAaQBjAG8AbgBmAG8AbgB0AFYAZQByAHMAaQBvAG4AIAAxAC4AMABpAGMAbwBuAGYAbwBuAHQARwBlAG4AZQByAGEAdABlAGQAIABiAHkAIABzAHYAZwAyAHQAdABmACAAZgByAG8AbQAgAEYAbwBuAHQAZQBsAGwAbwAgAHAAcgBvAGoAZQBjAHQALgBoAHQAdABwADoALwAvAGYAbwBuAHQAZQBsAGwAbwAuAGMAbwBtAAAAAAIAAAAAAAAACgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADwECAQMBBAEFAQYBBwEIAQkBCgELAQwBDQEOAQ8BEAAFcGhvbmUGZHVpaGFvBndlY2hhdA9uYXZpZ2F0aW9uLWhlbHALeW91amlhbnRvdTEGZG91YmFuAnFxBXdlaWJvBHBhaWQGY2hhbmdlA3NldBJpY29uX3Njcm9sbF9hY3RpdmUHZ29uZ3NoaQppY29uX3N0aWNrAAAAAAA="

/***/ }),

/***/ "3SFg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.watchChangeLocale = watchChangeLocale;
exports.watchChangeReadMode = watchChangeReadMode;
exports.watchChangeFontType = watchChangeFontType;

var _reactIntlUniversal = __webpack_require__("cl+9");

var _reactIntlUniversal2 = _interopRequireDefault(_reactIntlUniversal);

var _effects = __webpack_require__("egdi");

var _actionTypes = __webpack_require__("4HHy");

var _Message = __webpack_require__("mzOA");

var _Message2 = _interopRequireDefault(_Message);

var _ajax = __webpack_require__("Z1y9");

var _ajax2 = _interopRequireDefault(_ajax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(changeLocaleAsync),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(changeReadModeAsync),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(changeFontTypeAsync),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(watchChangeLocale),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(watchChangeReadMode),
    _marked6 = /*#__PURE__*/_regenerator2.default.mark(watchChangeFontType); /**
                                                                              * Created by zad on 17/4/26.
                                                                              */


function changeLocaleAsync(action) {
  var locales, locale;
  return _regenerator2.default.wrap(function changeLocaleAsync$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          locales = _reactIntlUniversal2.default.options.locales;
          locale = action.locale;
          _context.next = 5;
          return (0, _effects.call)(_ajax2.default.changeLocale, locale);

        case 5:
          _context.next = 7;
          return (0, _effects.call)(_reactIntlUniversal2.default.init.bind(_reactIntlUniversal2.default), {
            locales: locales,
            currentLocale: action.locale
          });

        case 7:
          _Message2.default.info(_reactIntlUniversal2.default.get('settings.change-locale'));
          _context.next = 10;
          return (0, _effects.put)({ type: _actionTypes.Global.CHANGE_LOCALE_SUCCESS, locale: locale });

        case 10:
          _context.next = 16;
          break;

        case 12:
          _context.prev = 12;
          _context.t0 = _context['catch'](0);
          _context.next = 16;
          return (0, _effects.put)({ type: _actionTypes.Global.CHANGE_LOCALE_FAIL });

        case 16:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[0, 12]]);
}

function changeReadModeAsync(action) {
  var readMode;
  return _regenerator2.default.wrap(function changeReadModeAsync$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          readMode = action.readMode;
          _context2.next = 4;
          return (0, _effects.call)(_ajax2.default.changeReadMode, readMode);

        case 4:
          _context2.next = 6;
          return (0, _effects.put)({ type: _actionTypes.Global.CHANGE_READ_MODE_SUCCESS, readMode: readMode });

        case 6:
          _Message2.default.info(_reactIntlUniversal2.default.get('settings.change-read-mode'));
          _context2.next = 13;
          break;

        case 9:
          _context2.prev = 9;
          _context2.t0 = _context2['catch'](0);
          _context2.next = 13;
          return (0, _effects.put)({ type: _actionTypes.Global.CHANGE_READ_MODE_FAIL });

        case 13:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[0, 9]]);
}

function changeFontTypeAsync(action) {
  var fontType;
  return _regenerator2.default.wrap(function changeFontTypeAsync$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          fontType = action.fontType;
          _context3.next = 4;
          return (0, _effects.call)(_ajax2.default.changeFontType, fontType);

        case 4:
          _context3.next = 6;
          return (0, _effects.put)({ type: _actionTypes.Global.CHANGE_FONT_TYPE_SUCCESS, fontType: fontType });

        case 6:
          _Message2.default.info(_reactIntlUniversal2.default.get('settings.change-font'));
          _context3.next = 13;
          break;

        case 9:
          _context3.prev = 9;
          _context3.t0 = _context3['catch'](0);
          _context3.next = 13;
          return (0, _effects.put)({ type: _actionTypes.Global.CHANGE_FONT_TYPE_FAIL });

        case 13:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this, [[0, 9]]);
}

function watchChangeLocale() {
  return _regenerator2.default.wrap(function watchChangeLocale$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.takeLatest)(_actionTypes.Global.CHANGE_LOCALE, changeLocaleAsync);

        case 2:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function watchChangeReadMode() {
  return _regenerator2.default.wrap(function watchChangeReadMode$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.takeLatest)(_actionTypes.Global.CHANGE_READ_MODE, changeReadModeAsync);

        case 2:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function watchChangeFontType() {
  return _regenerator2.default.wrap(function watchChangeFontType$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.takeLatest)(_actionTypes.Global.CHANGE_FONT_TYPE, changeFontTypeAsync);

        case 2:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

/***/ }),

/***/ "3vUK":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "@font-face{font-family:iconfont;src:url(" + escape(__webpack_require__("Gbmw")) + ");src:url(" + escape(__webpack_require__("Gbmw")) + "#iefix) format(\"embedded-opentype\"),url(\"data:application/x-font-woff2;charset=utf-8;base64,d09GMgABAAAAAAnoAAsAAAAAERgAAAmYAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHEIGVgCEfgqSPI5NATYCJAM8CyAABCAFhG0HgTkbPg4jETaUk8Il++dhDG7Tqnh/Pf8gIhThkL/rNUFkO3bQF/lt0UTjfc+np017fwXZBY/oxoTUqIiR1LJLG+JOTaB10jpSVVL1c4ucKecZzhQUYNuOeUiRy6mmcwMiQDxhaBefNFqv4aFXpLdzPl6Gi1ABLICdz+7tb6q82UCzExCvhzqjNGcDfVSLSC696BLftdee///9XB1qoekschYSh1om9mznX9Q8Q2mEtPn7iFr6CxVqoZQOhIRXnfSFbOUchNOBAOAgIAdkyjRLPhRgoJjQq7GupgyKWhaYPgkECpvM2JXhyG6wUFDbqFcB7Ep/n3wPM1EAFFgaeqa51VMrMSFAAkHaEcIopJ1wTK8AwNteAA0gBwADkOfNoidB5ygnJZw1mIEbQAx0rSsFqAAT0AUMgdhAZmBwYF5gT+BA4EQgGArBfIx2BjHT0RaCGMS59EIToAGZ/795PFRQgwUFBjIoIIcSIDIIURFyt1kDBEhoKCkFRpsyAGioDgAHNQDgoTEAVNBYAGpoJgAWOhiM6dJ5YED3AJBBDwBQQE8AkEODDIESAKCNdxEAZAPU2wB9CsoaU8KcAQG0Pi+Sg9n7iPqtpwxKmSq08o4fb1AzsUY5o2cmpqliYlVKfUJByej1UfxApSYinYlqqncX4G4/Jssnn4artx+SZGP3UscqvdA7h5cbuq8OUnQDlYtieKRmYYXLXfLTp0o3saZTeYxdK88XDDZwD+8rF3OdC2AEYZ4slkprc5POApfQBWx1GrhmnNO9wRnzrT2EU+7lO8TuKodgEaUu4JJ6fp5+VddnfveX2Pvd2vNNWsER3jbm/JoCkGOyaUEn/ei6j+PkXmu3KDrWXO1Ooto7C2nAqko3nleiGh9dobomDuJlK1GhTEd0eyQrR2spTuxKUCNLRwxXOaVxvkn/Q5LUJURfHYcPBQjnkR2L/GD0CDD8yHn46T0FI4jdciTPitZeKcJ54Oy7TIj0kZ5+dt5zeGn3csg36e4XhtzMBkrTeoQJXUI4vzC79cqDCY8OjZofva3skaQlbOgSbB7ScEAcfRzmcnQzLDuZAWfmzRwmbjat0djXP43OjTnIYeruhx6yYzgt/l75rBB3RJz6gpxwVMp3LdCLynk8l+xmOI7nWbZG4m+5iZ4+R7HWPTUzgEq4QjfTy1HFXJGnb2qGqvcOIv2Z/nprZwifwJ0dyOdF1TLJO7A4C8sujDlquIk5JxeJnv65KarcP+minfJlwSqPQiEJ+V2iqHKdmMsHT0ltBwkMraKHAZz3TYTnMw+fZQ7zMiZxN3uDBe+MyRD/hWDy0VT2sUvTUA+PEu4og+I902j4hfP4TDeG+Xeedhc4Hja5Vm3cbh3c7EUmHw9Fj+8IhnuwSaW7lypZlIkuVPdmvJIMzACNiyOIbcIVBcTJL4Z+yV415myS3EiMVkj+Xtf886YHjoN4gqfUNE/C75xaHFxoifAs/gixFApKaYf3Q6KCA0PukYKyp51gthjn1wSXKfzaZftvgprg88Zyowf9+5/RLJnNb9xv18Q3Fwcb7h35QaqN8HuZsrP7XVD/1O5CTZf1Fr3wO81CxEEj8kBCorZGWKb9RM0HCbP5YqXtCVl37AwaWqu9NP9MZ2ia/WDhwbQa30ZyXcnZiFbnWJ27fPyMtr740vpRc4xpBftnSc4DgTaBAim050QiPf1JBmCedABE48vLUl/ICm2FRey2zXfMhZFs7MStyw/kpuSlsDZiqa62YCWvWrgJFSl4y0FgMl0QpggHDSoV/aH4qYLflOOPxyux238d1d5xcmbLopcvBC507lsucQMbhlimmJbbTtnWTjYNqh+Uy0jh/8yyzsIIvZpJqxmfeOzttrL/X9E7rV/f9vaxxPHtyzIaMcPB6nfeM9Dhkf8t0304hrKTaTZNhXxxiiHMEAkV8oq0yDQ7NeZD3bL/IsNpw72detaRgWc2775fsNpuXTyfLVHfi8mDpWEOddxpG7hAVZ5IFHlP1uwky3Ej73/S2G9gXM2fNxITq8jmhWSSa7d5URUqEQvUJLQtKXxSmMRcLWgzKkSHMbI9t6S7/TTfGpLzszKKhlNJ39w4VTPrenXUVFJURKZGV48+fWMgq/xu5M5kUrx27YqSudPHJQghmpuGa7QdSm4bt6Zv8/+QrRPmTHv2dr+1Xbf7o8+ysu944vJjZx9+gqSW1RpralRb1qXkkRfyMt8zvpfpzxt5OSmrLSpl4Wr1jh+Cr+KH8XN3Hz+7PPHYir4fdW88fm3pyr5GeOI7170/LubLF1UvzP/5WkxQTJJ0S0dfXPdyO0In+RFGl9tA/Vo668uIuTZLsf7LhfMvJmzTpKoPCsmE+lNemvXLU0+bR7BPl7LPMO2//aNzXxi1/q9M+2hLrD1KuX7UC7mV56qNVecr8qy0f2bZR1li7NEKx3kV56uM1Y+mTtDN1M0Kj4oJZGWt5eG+fQ8ttV2MkMx+xHYJQlfyKMnCb7ek6ZGGNvOKwkqDOE6xpKovWZlcZBX1Ir569ZcxVp014q6fQb1vnzhiCdfHreE/5qNb+dN104Fo/qec6+MXd/Pt78+moMQymMu+//6P5VOWy1Ol8tp7oFB/AAdqyATc06qw7l8AQpiOpx0AQB+ijkjDOVNPj08d79Ev0jMAgPqYukfDM/0MbabpkN5NTxjWlZd6JfQndJaR02PE2SjqWyA0RX9AF06zgiG0k5b/9CyaPDa6wxeDbokl2jG/Kfiny9p3r44NS3XTQY75EucNmVC9ignwSAjMvi/ZP5Zfs2ZrmW9jOH9fOYFNqdAfyzClFC02Qt5AAeDcOuAxsMyAj+fHwoc2Pviy8FJOQY54RFshqWgPDCE5chZvCJIRMl7OMXl1xTNKDpBpf9Rg3yIndH7kFI0nEC0hv4gh5E/OivBvlRHTgZwj9XBIXnr+/DGBINBMLswrDCbIpfOs9xvYaRBJzC/eviBlj4E1Zf3f+goB0jRE8mxbIsNMwpG9eBwYBmQxYQeKSkdLXFeV+RAtFY6rc5MlQKBYXWOkRdNTUGA2Juetn38DrMlASH0m/dH8ApLMb51plOohAl5JGGrSZRmYzawWSYHBwpEJGjEvUgAG14SYaLvqAIWU3BgN0Voli5lhSTl/Nh7uBAfflPr42obGpuaW1rb2js6u7p7ePke/wwDHevJO4PEOVDKQboKYvRW0vziFgyFeLDh1XgQivznW0RGkCPvb7dEOvMTDKLw+HmNQsHCQge737mk3WSUcho1Q5Gc4sRhsdv6820pJYb9aAQAAAA==\") format(\"woff2\"),url(" + escape(__webpack_require__("XB7B")) + ") format(\"woff\"),url(" + escape(__webpack_require__("38jt")) + ") format(\"truetype\"),url(" + escape(__webpack_require__("PayV")) + "#iconfont) format(\"svg\")}.iconfont{font-family:iconfont!important;font-size:16px;font-style:normal;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.ic-phone:before{content:\"\\E602\"}.ic-duihao:before{content:\"\\E633\"}.ic-wechat:before{content:\"\\E604\"}.ic-navigation-help:before{content:\"\\E651\"}.ic-youjiantou1:before{content:\"\\E628\"}.ic-douban:before{content:\"\\E691\"}.ic-qq:before{content:\"\\E6A1\"}.ic-weibo:before{content:\"\\E699\"}.ic-paid:before{content:\"\\E6F0\"}.ic-change:before{content:\"\\E610\"}.ic-set:before{content:\"\\E612\"}.ic-icon_scroll_active:before{content:\"\\E61A\"}.ic-gongshi:before{content:\"\\E61B\"}.ic-icon_stick:before{content:\"\\E601\"}", ""]);

// exports


/***/ }),

/***/ "3zmX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.watchGetTrashNotesList = watchGetTrashNotesList;
exports.watchGetTrashNote = watchGetTrashNote;
exports.watchDelTrashNote = watchDelTrashNote;
exports.watchRecoveryTrashNote = watchRecoveryTrashNote;

var _TrashNotesReducer = __webpack_require__("mXnL");

var _effects = __webpack_require__("egdi");

var _variables = __webpack_require__("+AJo");

var _actionTypes = __webpack_require__("4HHy");

var _ajax = __webpack_require__("Z1y9");

var _ajax2 = _interopRequireDefault(_ajax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(getTrashNotesListAsync),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(getTrashNoteContentAsync),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(delTrashNote),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(recoveryTrashNote),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(watchGetTrashNotesList),
    _marked6 = /*#__PURE__*/_regenerator2.default.mark(watchGetTrashNote),
    _marked7 = /*#__PURE__*/_regenerator2.default.mark(watchDelTrashNote),
    _marked8 = /*#__PURE__*/_regenerator2.default.mark(watchRecoveryTrashNote);

function getTrashNotesListAsync(action) {
  var isForce, trashNotesListState, seq, newData, _ref, data;

  return _regenerator2.default.wrap(function getTrashNotesListAsync$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          isForce = action.isForce;
          _context.next = 3;
          return (0, _effects.select)(_TrashNotesReducer.getTrashNotesListState);

        case 3:
          trashNotesListState = _context.sent;
          seq = trashNotesListState.get('seq');
          newData = void 0;
          _context.prev = 6;

          if (!(!seq || isForce)) {
            _context.next = 13;
            break;
          }

          _context.next = 10;
          return (0, _effects.call)(_ajax2.default.getTrashNotesList);

        case 10:
          _ref = _context.sent;
          data = _ref.data;

          newData = data;

        case 13:
          _context.next = 15;
          return (0, _effects.put)({ type: _actionTypes.Trash.GET_TRASH_NOTES_LIST_SUCCESS, data: newData });

        case 15:
          _context.next = 21;
          break;

        case 17:
          _context.prev = 17;
          _context.t0 = _context['catch'](6);
          _context.next = 21;
          return (0, _effects.put)({ type: _actionTypes.Trash.GET_TRASH_NOTES_LIST_FAIL });

        case 21:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[6, 17]]);
}

function getTrashNoteContentAsync(action) {
  var isForce, noteId, trashNotes, note, noteContent, _ref2, data;

  return _regenerator2.default.wrap(function getTrashNoteContentAsync$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          isForce = action.isForce, noteId = action.noteId;
          _context2.next = 3;
          return (0, _effects.select)(_TrashNotesReducer.getTrashNotesState);

        case 3:
          trashNotes = _context2.sent;

          // 必须获取content字段，只获取noteId一级在reducer里GET_TRASH_NOTE_CONTENT时已经设置了
          note = void 0;
          noteContent = trashNotes.getIn([noteId, 'content'], _variables.CONTENT_NOT_FOUND);
          _context2.prev = 6;

          if (!(noteContent === _variables.CONTENT_NOT_FOUND || isForce)) {
            _context2.next = 13;
            break;
          }

          _context2.next = 10;
          return (0, _effects.call)(_ajax2.default.getNoteContent, noteId);

        case 10:
          _ref2 = _context2.sent;
          data = _ref2.data;

          note = data;

        case 13:
          _context2.next = 15;
          return (0, _effects.put)({ type: _actionTypes.Trash.GET_TRASH_NOTE_CONTENT_SUCCESS, data: note, noteId: noteId });

        case 15:
          _context2.next = 21;
          break;

        case 17:
          _context2.prev = 17;
          _context2.t0 = _context2['catch'](6);
          _context2.next = 21;
          return (0, _effects.put)({ type: _actionTypes.Trash.GET_TRASH_NOTE_CONTENT_FAIL, noteId: noteId });

        case 21:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[6, 17]]);
}

function delTrashNote(action) {
  var noteId, doneCallback, _ref3, data;

  return _regenerator2.default.wrap(function delTrashNote$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          noteId = action.noteId, doneCallback = action.doneCallback;
          _context3.prev = 1;
          _context3.next = 4;
          return (0, _effects.call)(_ajax2.default.deleteNote, noteId);

        case 4:
          _ref3 = _context3.sent;
          data = _ref3.data;

          doneCallback(null, { noteId: noteId });
          _context3.next = 9;
          return (0, _effects.put)({ type: _actionTypes.Trash.DEL_TRASH_NOTE_SUCCESS, data: data, noteId: noteId });

        case 9:
          _context3.next = 16;
          break;

        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3['catch'](1);
          _context3.next = 15;
          return (0, _effects.put)({ type: _actionTypes.Trash.DEL_TRASH_NOTE_FAIL, noteId: noteId });

        case 15:
          doneCallback(_context3.t0.error);

        case 16:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this, [[1, 11]]);
}

// 恢复文章
function recoveryTrashNote(action) {
  var noteId, doneCallback, _ref4, data, nbId;

  return _regenerator2.default.wrap(function recoveryTrashNote$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          noteId = action.noteId, doneCallback = action.doneCallback;
          _context4.prev = 1;
          _context4.next = 4;
          return (0, _effects.call)(_ajax2.default.recoveryNote, noteId);

        case 4:
          _ref4 = _context4.sent;
          data = _ref4.data;
          nbId = data.notebook_id;
          // 恢复文章后需要强制更新文集数据，其实应该只需要更新文章所在的文集的数据，但目前还木有这种接口
          // 更新文章数据

          _context4.next = 9;
          return (0, _effects.put)({ type: _actionTypes.Trash.RECOVERY_TRASH_NOTE_SUCCESS, data: data, noteId: noteId });

        case 9:
          doneCallback(null, { nbId: nbId, noteId: noteId });
          _context4.next = 12;
          return (0, _effects.put)({ type: _actionTypes.Notebooks.GET_NOTEBOOKS, isForce: true });

        case 12:
          _context4.next = 14;
          return (0, _effects.put)({ type: _actionTypes.Notes.GET_NOTES, isForce: true, nbId: nbId });

        case 14:
          _context4.next = 21;
          break;

        case 16:
          _context4.prev = 16;
          _context4.t0 = _context4['catch'](1);
          _context4.next = 20;
          return (0, _effects.put)({ type: _actionTypes.Trash.RECOVERY_TRASH_NOTE_FAIL, noteId: noteId });

        case 20:
          doneCallback(_context4.t0);

        case 21:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this, [[1, 16]]);
}

// eslint-disable-next-line import/prefer-default-export
function watchGetTrashNotesList() {
  return _regenerator2.default.wrap(function watchGetTrashNotesList$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.takeLatest)(_actionTypes.Trash.GET_TRASH_NOTES_LIST, getTrashNotesListAsync);

        case 2:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function watchGetTrashNote() {
  return _regenerator2.default.wrap(function watchGetTrashNote$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.takeLatest)(_actionTypes.Trash.GET_TRASH_NOTE_CONTENT, getTrashNoteContentAsync);

        case 2:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function watchDelTrashNote() {
  return _regenerator2.default.wrap(function watchDelTrashNote$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.takeLatest)(_actionTypes.Trash.DEL_TRASH_NOTE, delTrashNote);

        case 2:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

function watchRecoveryTrashNote() {
  return _regenerator2.default.wrap(function watchRecoveryTrashNote$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.takeLatest)(_actionTypes.Trash.RECOVERY_TRASH_NOTE, recoveryTrashNote);

        case 2:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

/***/ }),

/***/ "4/F/":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "._2w9pn{font-size:14px;-webkit-box-shadow:0 5px 10px rgba(0,0,0,.2);box-shadow:0 5px 10px rgba(0,0,0,.2);list-style:none;background-color:#fff;color:#595959;border-radius:6px}body.reader-night-mode ._2w9pn{color:#b3b3b3;background-color:#3d3d3d}", ""]);

// exports
exports.locals = {
	"menu": "_2w9pn"
};

/***/ }),

/***/ "4HHy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Trash = exports.NoteHistory = exports.Global = exports.NoteContent = exports.User = exports.Notes = exports.Notebooks = undefined;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _symbol = __webpack_require__("5QVw");

var _symbol2 = _interopRequireDefault(_symbol);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by zad on 17/10/17.
 */

// 自动创建三种action，typename， typename_success, typename_fail
var createTypes = function createTypes(typename) {
  var _ref;

  var typenameSuccess = typename + '_SUCCESS';
  var typenameFail = typename + '_FAIL';
  return _ref = {}, (0, _defineProperty3.default)(_ref, typename, (0, _symbol2.default)(typename.toLowerCase())), (0, _defineProperty3.default)(_ref, typenameSuccess, (0, _symbol2.default)(typenameSuccess.toLowerCase())), (0, _defineProperty3.default)(_ref, typenameFail, (0, _symbol2.default)(typenameFail.toLowerCase())), _ref;
};

// notebooks
var NOTEBOOKS_INIT = (0, _symbol2.default)('notebooks_init');
var GET_NOTEBOOKS = (0, _symbol2.default)('get_notebooks');
var GET_NOTEBOOKS_SUCCESS = (0, _symbol2.default)('get_notebooks_success');
var GET_NOTEBOOKS_FAIL = (0, _symbol2.default)('get_notebooks_fail');
var SORT_NOTEBOOKS = (0, _symbol2.default)('sort_notebooks');
var SORT_NOTEBOOKS_SUCCESS = (0, _symbol2.default)('sort_notebooks_success');
var SORT_NOTEBOOKS_FAIL = (0, _symbol2.default)('sort_notebooks_fail');

// notes
var NOTES_INIT = (0, _symbol2.default)('notes_init');
var GET_NOTES = (0, _symbol2.default)('get_notes');
var GET_NOTES_SUCCESS = (0, _symbol2.default)('get_notes_success');
var GET_NOTES_FAIL = (0, _symbol2.default)('get_notes_fail');
var SORT_NOTES = (0, _symbol2.default)('sort_notes');
var SORT_NOTES_SUCCESS = (0, _symbol2.default)('sort_notes_success');
var SORT_NOTES_FAIL = (0, _symbol2.default)('sort_notes_fail');
var GET_COVER_IMG = (0, _symbol2.default)('get_cover_img');
var GET_COVER_IMG_SUCCESS = (0, _symbol2.default)('get_cover_img_success');
var GET_COVER_IMG_FAIL = (0, _symbol2.default)('get_cover_img_fail');
var POST_COVER_IMG = (0, _symbol2.default)('post_cover_img');
var POST_COVER_IMG_SUCCESS = (0, _symbol2.default)('post_cover_img_success');
var POST_COVER_IMG_FAIL = (0, _symbol2.default)('post_cover_img_fail');
var POST_SET_NOTE_TOP = (0, _symbol2.default)('post_set_note_top');
var POST_SET_NOTE_TOP_SUCCESS = (0, _symbol2.default)('post_set_note_top_success');
var POST_SET_NOTE_TOP_FAIL = (0, _symbol2.default)('post_set_note_top_fail');
var POST_UNSET_NOTE_TOP = (0, _symbol2.default)('post_unset_note_top');
var POST_UNSET_NOTE_TOP_SUCCESS = (0, _symbol2.default)('post_unset_note_top_success');
var POST_UNSET_NOTE_TOP_FAIL = (0, _symbol2.default)('post_unset_note_top_fail');
var SET_NOTE_REPRINTABLE = (0, _symbol2.default)('set_note_reprintable');
var SET_NOTE_REPRINTABLE_SUCCESS = (0, _symbol2.default)('set_note_reprintable_success');
var SET_NOTE_REPRINTABLE_FAIL = (0, _symbol2.default)('set_note_reprintable_fail');
var SET_NOTE_PUBLISH_TIME = (0, _symbol2.default)('set_note_publish_time');
var SET_NOTE_PUBLISH_TIME_SUCCESS = (0, _symbol2.default)('set_note_publish_time_success');

// user
var USER_INIT = (0, _symbol2.default)('user_init');
var USER_OTP_CHANNEL_INIT = (0, _symbol2.default)('user_opt_chanel_init');
var GET_USER = (0, _symbol2.default)('get_user');
var GET_USER_SUCCESS = (0, _symbol2.default)('get_user_success');
var GET_USER_FAIL = (0, _symbol2.default)('get_user_fail');
var SET_USER = (0, _symbol2.default)('set_user');
var CHANGE_EDITOR_TYPE = (0, _symbol2.default)('change_editor_type');
var CHANGE_EDITOR_TYPE_SUCCESS = (0, _symbol2.default)('change_editor_type_success');
var CHANGE_EDITOR_TYPE_FAIL = (0, _symbol2.default)('change_editor_type_fail');
var SET_BIND_STATUS = (0, _symbol2.default)('set_bind_status');
var SWITCH_SYNC_SCROLL = (0, _symbol2.default)('switch_sync_scroll');
var SWITCH_SYNC_SCROLL_FAIL = (0, _symbol2.default)('switch_sync_scroll_fail');

// note-content
var NOTE_CONTENT_INIT = (0, _symbol2.default)('note_content_init');
var GET_NOTE_CONTENT = (0, _symbol2.default)('get_note_content');
var GET_NOTE_CONTENT_SUCCESS = (0, _symbol2.default)('get_note_content_success');
var GET_NOTE_CONTENT_FAIL = (0, _symbol2.default)('get_note_content_fail');
var UPDATE_NOTE_CONTENT_ABBR = (0, _symbol2.default)('update_note_content_abbr');
var POST_AUDIO = (0, _symbol2.default)('post_audio');
var PUT_AUDIO_MESSAGE = (0, _symbol2.default)('put_audio_message');
var PUT_AUDIO_MESSAGE_SUCCESS = (0, _symbol2.default)('put_audio_message_success');
var PUT_AUDIO_MESSAGE_FAIL = (0, _symbol2.default)('put_audio_message_fail');
var GET_AUDIO_URL = (0, _symbol2.default)('get_audio_url');
var GET_AUDIO_URL_SUCCESS = (0, _symbol2.default)('get_audio_url_success');
var GET_AUDIO_URL_FAIL = (0, _symbol2.default)('get_audio_url_fail');

// note-history
var NOTE_HISTORY_INIT = (0, _symbol2.default)('note_history_init');
var NOTE_HISTORY_CONTENT_INIT = (0, _symbol2.default)('note_history_content_init');
var NOTE_HISTORY_RESTORE_INIT = (0, _symbol2.default)('note_history_restore_init');

// trash
var TRASH_NOTES_LIST_INIT = (0, _symbol2.default)('trash_noteslist_init');
var TRASH_NOTE_CONTENT_INIT = (0, _symbol2.default)('trash_notescontent_init');

// global
var CHANGE_LOCALE = (0, _symbol2.default)('change_locale');
var CHANGE_LOCALE_SUCCESS = (0, _symbol2.default)('change_locale_success');
var CHANGE_LOCALE_FAIL = (0, _symbol2.default)('change_locale_fail');
var SWITCH_DEV = (0, _symbol2.default)('switch_dev');
var SET_BIND_PHONE_STATUS = (0, _symbol2.default)('set_bind_phone_status');
var SET_PUBLISH_SUCCESS_MODAL_DATA = (0, _symbol2.default)('set_publish_success_modal_data');
var SET_QRCODE_MODAL_DATA = (0, _symbol2.default)('set_qrcode_modal_data');
var SET_PNAGREE_MODAL_DATA = (0, _symbol2.default)('set_pnagree_modal_data');
var CHANGE_READ_MODE = (0, _symbol2.default)('change_read_mode');
var CHANGE_READ_MODE_SUCCESS = (0, _symbol2.default)('change_read_mode_success');
var CHANGE_READ_MODE_FAIL = (0, _symbol2.default)('change_read_mode_fail');
var CHANGE_FONT_TYPE = (0, _symbol2.default)('change_font_type');
var CHANGE_FONT_TYPE_SUCCESS = (0, _symbol2.default)('change_font_type_success');
var CHANGE_FONT_TYPE_FAIL = (0, _symbol2.default)('change_font_type_fail');
var SET_NOTE_DATA = (0, _symbol2.default)('set_note_data');
var SET_SORTED_NOTE_DATA = (0, _symbol2.default)('set_sorted_note_data');
var SET_BIND_WX_STATUS = (0, _symbol2.default)('set_bind_wx_status');
var SET_OCCUPY_HASOTHER = (0, _symbol2.default)('set_occupy_hasother');
var SET_OCCUPY_NOOTHER = (0, _symbol2.default)('set_occupy_noother');
var OPEN_TIME_PUBLISH_BUY_MODAL = (0, _symbol2.default)('open_time_publish_buy_modal');
var CLOSE_TIME_PUBLISH_BUY_MODAL = (0, _symbol2.default)('close_time_publish_buy_modal');

var Notebooks = exports.Notebooks = (0, _extends3.default)({
  NOTEBOOKS_INIT: NOTEBOOKS_INIT,
  GET_NOTEBOOKS: GET_NOTEBOOKS,
  GET_NOTEBOOKS_SUCCESS: GET_NOTEBOOKS_SUCCESS,
  GET_NOTEBOOKS_FAIL: GET_NOTEBOOKS_FAIL,
  SORT_NOTEBOOKS: SORT_NOTEBOOKS,
  SORT_NOTEBOOKS_SUCCESS: SORT_NOTEBOOKS_SUCCESS,
  SORT_NOTEBOOKS_FAIL: SORT_NOTEBOOKS_FAIL
}, createTypes('NEW_NOTEBOOK'), createTypes('DEL_NOTEBOOK_SOFT'), createTypes('RENAME_NOTEBOOK'));

var Notes = exports.Notes = (0, _extends3.default)({
  NOTES_INIT: NOTES_INIT,
  GET_NOTES: GET_NOTES,
  GET_NOTES_SUCCESS: GET_NOTES_SUCCESS,
  GET_NOTES_FAIL: GET_NOTES_FAIL,
  SORT_NOTES: SORT_NOTES,
  SORT_NOTES_SUCCESS: SORT_NOTES_SUCCESS,
  SORT_NOTES_FAIL: SORT_NOTES_FAIL
}, createTypes('NEW_NOTE'), createTypes('PUBLISH_NOTE'), createTypes('UPDATE_NOTE'), createTypes('PRIVATE_NOTE'), createTypes('DEL_NOTE_SOFT'), createTypes('MOVE_NOTE'), createTypes('PUBLISH_PAID_NOTE'), {
  GET_COVER_IMG: GET_COVER_IMG,
  GET_COVER_IMG_SUCCESS: GET_COVER_IMG_SUCCESS,
  GET_COVER_IMG_FAIL: GET_COVER_IMG_FAIL,
  POST_COVER_IMG: POST_COVER_IMG,
  POST_COVER_IMG_SUCCESS: POST_COVER_IMG_SUCCESS,
  POST_COVER_IMG_FAIL: POST_COVER_IMG_FAIL,
  POST_SET_NOTE_TOP: POST_SET_NOTE_TOP,
  POST_SET_NOTE_TOP_SUCCESS: POST_SET_NOTE_TOP_SUCCESS,
  POST_SET_NOTE_TOP_FAIL: POST_SET_NOTE_TOP_FAIL,
  POST_UNSET_NOTE_TOP: POST_UNSET_NOTE_TOP,
  POST_UNSET_NOTE_TOP_SUCCESS: POST_UNSET_NOTE_TOP_SUCCESS,
  POST_UNSET_NOTE_TOP_FAIL: POST_UNSET_NOTE_TOP_FAIL,
  SET_NOTE_REPRINTABLE: SET_NOTE_REPRINTABLE,
  SET_NOTE_REPRINTABLE_SUCCESS: SET_NOTE_REPRINTABLE_SUCCESS,
  SET_NOTE_REPRINTABLE_FAIL: SET_NOTE_REPRINTABLE_FAIL,
  SET_NOTE_PUBLISH_TIME: SET_NOTE_PUBLISH_TIME,
  SET_NOTE_PUBLISH_TIME_SUCCESS: SET_NOTE_PUBLISH_TIME_SUCCESS
});

var User = exports.User = (0, _extends3.default)({
  USER_INIT: USER_INIT,
  GET_USER: GET_USER,
  GET_USER_SUCCESS: GET_USER_SUCCESS,
  GET_USER_FAIL: GET_USER_FAIL,
  SET_USER: SET_USER,
  USER_OTP_CHANNEL_INIT: USER_OTP_CHANNEL_INIT
}, createTypes('GET_USER_OTP_CHANNEL'), {
  CHANGE_EDITOR_TYPE: CHANGE_EDITOR_TYPE,
  CHANGE_EDITOR_TYPE_SUCCESS: CHANGE_EDITOR_TYPE_SUCCESS,
  CHANGE_EDITOR_TYPE_FAIL: CHANGE_EDITOR_TYPE_FAIL,
  SWITCH_SYNC_SCROLL: SWITCH_SYNC_SCROLL,
  SWITCH_SYNC_SCROLL_FAIL: SWITCH_SYNC_SCROLL_FAIL
});

var NoteContent = exports.NoteContent = (0, _extends3.default)({
  NOTE_CONTENT_INIT: NOTE_CONTENT_INIT,
  GET_NOTE_CONTENT: GET_NOTE_CONTENT,
  GET_NOTE_CONTENT_SUCCESS: GET_NOTE_CONTENT_SUCCESS,
  GET_NOTE_CONTENT_FAIL: GET_NOTE_CONTENT_FAIL,
  UPDATE_NOTE_CONTENT_ABBR: UPDATE_NOTE_CONTENT_ABBR,
  POST_AUDIO: POST_AUDIO,
  PUT_AUDIO_MESSAGE: PUT_AUDIO_MESSAGE,
  PUT_AUDIO_MESSAGE_SUCCESS: PUT_AUDIO_MESSAGE_SUCCESS,
  PUT_AUDIO_MESSAGE_FAIL: PUT_AUDIO_MESSAGE_FAIL,
  GET_AUDIO_URL: GET_AUDIO_URL,
  GET_AUDIO_URL_SUCCESS: GET_AUDIO_URL_SUCCESS,
  GET_AUDIO_URL_FAIL: GET_AUDIO_URL_FAIL
}, createTypes('DELETE_AUDIO'));

var Global = exports.Global = {
  CHANGE_LOCALE: CHANGE_LOCALE,
  CHANGE_LOCALE_SUCCESS: CHANGE_LOCALE_SUCCESS,
  CHANGE_LOCALE_FAIL: CHANGE_LOCALE_FAIL,
  SWITCH_DEV: SWITCH_DEV,
  SET_BIND_PHONE_STATUS: SET_BIND_PHONE_STATUS, // 控制绑定手机的modal的显示隐藏
  SET_PUBLISH_SUCCESS_MODAL_DATA: SET_PUBLISH_SUCCESS_MODAL_DATA,
  SET_QRCODE_MODAL_DATA: SET_QRCODE_MODAL_DATA,
  SET_BIND_WX_STATUS: SET_BIND_WX_STATUS,
  SET_PNAGREE_MODAL_DATA: SET_PNAGREE_MODAL_DATA, // 设置付费协议弹窗数据
  CHANGE_READ_MODE: CHANGE_READ_MODE,
  CHANGE_READ_MODE_FAIL: CHANGE_READ_MODE_FAIL,
  CHANGE_READ_MODE_SUCCESS: CHANGE_READ_MODE_SUCCESS,
  CHANGE_FONT_TYPE: CHANGE_FONT_TYPE,
  CHANGE_FONT_TYPE_SUCCESS: CHANGE_FONT_TYPE_SUCCESS,
  CHANGE_FONT_TYPE_FAIL: CHANGE_FONT_TYPE_FAIL,
  SET_NOTE_DATA: SET_NOTE_DATA, // 发布文章的数据
  SET_BIND_STATUS: SET_BIND_STATUS,
  SET_SORTED_NOTE_DATA: SET_SORTED_NOTE_DATA, // 移动文章的数据
  SET_OCCUPY_HASOTHER: SET_OCCUPY_HASOTHER,
  SET_OCCUPY_NOOTHER: SET_OCCUPY_NOOTHER,
  OPEN_TIME_PUBLISH_BUY_MODAL: OPEN_TIME_PUBLISH_BUY_MODAL,
  CLOSE_TIME_PUBLISH_BUY_MODAL: CLOSE_TIME_PUBLISH_BUY_MODAL
};

var NoteHistory = exports.NoteHistory = (0, _extends3.default)({
  NOTE_HISTORY_INIT: NOTE_HISTORY_INIT
}, createTypes('GET_NOTE_HISTORY_LIST'), {
  NOTE_HISTORY_CONTENT_INIT: NOTE_HISTORY_CONTENT_INIT
}, createTypes('GET_NOTE_HISTORY_CONTENT'), {
  NOTE_HISTORY_RESTORE_INIT: NOTE_HISTORY_RESTORE_INIT
}, createTypes('RESTORE_NOTE_HISTORY_CONTENT'));

var Trash = exports.Trash = (0, _extends3.default)({
  TRASH_NOTES_LIST_INIT: TRASH_NOTES_LIST_INIT,
  TRASH_NOTE_CONTENT_INIT: TRASH_NOTE_CONTENT_INIT
}, createTypes('GET_TRASH_NOTES_LIST'), createTypes('GET_TRASH_NOTE_CONTENT'), createTypes('DEL_TRASH_NOTE'), createTypes('RECOVERY_TRASH_NOTE'));

/***/ }),

/***/ "4J7M":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactIntlUniversal = __webpack_require__("cl+9");

var _reactIntlUniversal2 = _interopRequireDefault(_reactIntlUniversal);

var _reactRedux = __webpack_require__("RH2O");

var _Modal = __webpack_require__("/MvA");

var _Modal2 = _interopRequireDefault(_Modal);

var _PNAgreeModal = __webpack_require__("1uUF");

var _PNAgreeModal2 = _interopRequireDefault(_PNAgreeModal);

var _ajax = __webpack_require__("Z1y9");

var _ajax2 = _interopRequireDefault(_ajax);

var _Message = __webpack_require__("hGJ7");

var _Message2 = _interopRequireDefault(_Message);

var _NestLoading = __webpack_require__("66rn");

var _NestLoading2 = _interopRequireDefault(_NestLoading);

var _UserAction = __webpack_require__("XaZM");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PNAgreeModal = (_dec = (0, _reactRedux.connect)(function (state) {
  return {};
}, function (dispatch) {
  return {
    setUser: function setUser(data) {
      return dispatch((0, _UserAction.setUser)(data));
    }
  };
}), _dec(_class = function (_Component) {
  (0, _inherits3.default)(PNAgreeModal, _Component);

  function PNAgreeModal(props) {
    (0, _classCallCheck3.default)(this, PNAgreeModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PNAgreeModal.__proto__ || (0, _getPrototypeOf2.default)(PNAgreeModal)).call(this, props));

    _this.onModalCancelBtnClick = function () {
      var onModalCancelBtnClick = _this.props.onModalCancelBtnClick;

      onModalCancelBtnClick();
    };

    _this.state = {
      content: '',
      // isSubmitting: false,
      contentLoading: true
    };
    _ajax2.default.getPayNoteAgreement().then(function (_ref) {
      var _ref$data = _ref.data,
          data = _ref$data === undefined ? '' : _ref$data;

      var content = void 0;
      data.replace(/\n/g, '').replace(/<\/head>(.*)<\/html>/ig, function (match, $1) {
        content = $1 || '';
      });
      _this.setState({
        content: content,
        contentLoading: false
      });
    }).catch(function (res) {});
    return _this;
  }

  (0, _createClass3.default)(PNAgreeModal, [{
    key: 'render',
    value: function render() {
      var visible = this.props.visible;
      var _state = this.state,
          content = _state.content,
          contentLoading = _state.contentLoading;

      return _react2.default.createElement(
        _Modal2.default,
        {
          visible: visible,
          modalClassName: _PNAgreeModal2.default['modal'],
          width: 580,
          showFooter: false,
          isMiddle: true,
          title: _reactIntlUniversal2.default.get('pay-note.agree-title'),
          onCancel: this.onModalCancelBtnClick
        },
        contentLoading && _react2.default.createElement(_NestLoading2.default, null),
        _react2.default.createElement('div', {
          className: _PNAgreeModal2.default['modal-body'],
          dangerouslySetInnerHTML: { __html: content }
        })
      );
    }
  }]);
  return PNAgreeModal;
}(_react.Component)) || _class);
exports.default = PNAgreeModal;

/***/ }),

/***/ "4r03":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp; /*
                                   * 绑定手机的modal
                                   */


var _Menu = __webpack_require__("l8jW");

var _Menu2 = _interopRequireDefault(_Menu);

var _Dropdown = __webpack_require__("Q9EA");

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _Message = __webpack_require__("mzOA");

var _Message2 = _interopRequireDefault(_Message);

var _Icon = __webpack_require__("9JgI");

var _Icon2 = _interopRequireDefault(_Icon);

var _Modal = __webpack_require__("/MvA");

var _Modal2 = _interopRequireDefault(_Modal);

var _util = __webpack_require__("oFuF");

var _ajax = __webpack_require__("Z1y9");

var _ajax2 = _interopRequireDefault(_ajax);

var _tiny = __webpack_require__("UpxA");

var _tiny2 = _interopRequireDefault(_tiny);

var _actionTypes = __webpack_require__("4HHy");

var _NestLoading = __webpack_require__("66rn");

var _NestLoading2 = _interopRequireDefault(_NestLoading);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__("RH2O");

var _reactRouterDom = __webpack_require__("F8kA");

var _immutable = __webpack_require__("BYKG");

var _immutable2 = _interopRequireDefault(_immutable);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _reactIntlUniversal = __webpack_require__("cl+9");

var _reactIntlUniversal2 = _interopRequireDefault(_reactIntlUniversal);

var _PhoneModal = __webpack_require__("jgCU");

var _PhoneModal2 = _interopRequireDefault(_PhoneModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var countryOtpInfos = []; // 国家区号信息

var PhoneModal = (_dec = (0, _reactRedux.connect)(function (state) {
  return {};
}, function (dispatch) {
  return {};
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PhoneModal, _Component);

  function PhoneModal(props) {
    (0, _classCallCheck3.default)(this, PhoneModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PhoneModal.__proto__ || (0, _getPrototypeOf2.default)(PhoneModal)).call(this, props));

    _this.startConutDown = function (total) {
      clearInterval(_this.captchaTimer);
      _this.setState({
        curSecond: total
      });
      _this.captchaTimer = setInterval(function () {
        var _this$state = _this.state,
            curSecond = _this$state.curSecond,
            isResendCaptcha = _this$state.isResendCaptcha;

        curSecond -= 1;
        if (curSecond <= 0) {
          clearInterval(_this.captchaTimer);
          curSecond = 0;
          isResendCaptcha = true;
        }
        _this.setState({ curSecond: curSecond, isResendCaptcha: isResendCaptcha });
      }, 1000);
    };

    _this.onCountryDropdownItemClick = function (e) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (data.index) {
        var _data$index = data.index,
            isoCode = _data$index.isoCode,
            callingCode = _data$index.callingCode;

        _this.setState({
          isoCode: isoCode,
          callingCode: callingCode
        });
        document.body.click(); // close the drop menu
      }
    };

    _this.sendCaptchaBtnClick = function () {
      var _this$state2 = _this.state,
          isoCode = _this$state2.isoCode,
          curSecond = _this$state2.curSecond,
          sending = _this$state2.sending;

      var phoneNum = _this.getPhoneNum();
      if (!phoneNum) {
        return;
      }
      if (curSecond || sending) {
        return;
      }
      _this.setState({ sending: true });
      _ajax2.default.sendCaptchaWhenBindPhone({
        iso_code: isoCode,
        mobile_number: phoneNum
      }).then(function () {
        _this.startConutDown(60);
        _this.setState({ sending: false });
      }).catch(function () {
        _Message2.default.error(_reactIntlUniversal2.default.get('verifymodal.send-captcha-error'));
        _this.setState({ sending: false });
      });
    };

    _this.getCountryDropItems = function () {
      var countryPhoneData = _this.state.countryPhoneData;

      var allCountries = countryPhoneData.all_countries;
      var importantCountries = countryPhoneData.important_countries;
      if (!importantCountries || !allCountries) {
        return null;
      }
      var data = ['divider-hot'].concat(importantCountries).concat('divider-all', allCountries);
      return data.map(function (v, k) {
        if (v === 'divider-hot') {
          return _react2.default.createElement(
            'div',
            { key: k, className: _PhoneModal2.default['divider'] },
            _reactIntlUniversal2.default.get('phoneModal.hot-countries')
          );
        }
        if (v === 'divider-all') {
          return _react2.default.createElement(
            'div',
            { key: k, className: _PhoneModal2.default['divider'] },
            _reactIntlUniversal2.default.get('phoneModal.all')
          );
        }
        return _react2.default.createElement(
          _Menu.MenuItem,
          { key: k, index: { isoCode: v.iso_code, callingCode: v.calling_code } },
          _react2.default.createElement(
            'span',
            null,
            '+',
            v.calling_code
          ),
          v.name
        );
      });
    };

    _this.getPhoneNum = function () {
      var phoneNum = (_this.phoneInput.value || '').trim();
      if (!/^\d{11}$/.test(phoneNum)) {
        _Message2.default.error(_reactIntlUniversal2.default.get('phoneModal.phone-error'));
        return '';
      }
      return phoneNum;
    };

    _this.onModalConfirmBtnClick = function () {
      var onModalConfirmBtnClick = _this.props.onModalConfirmBtnClick;
      var _this$state3 = _this.state,
          isoCode = _this$state3.isoCode,
          callingCode = _this$state3.callingCode,
          confirming = _this$state3.confirming;

      var code = (_this.codeInput.value || '').trim();
      var phoneNum = _this.getPhoneNum();
      if (!phoneNum) {
        return;
      }
      if (!/^\d{6}$/.test(code)) {
        _Message2.default.error(_reactIntlUniversal2.default.get('phoneModal.captcha-regex-error'));
        return;
      }
      if (confirming) {
        return;
      }
      _this.setState({
        confirming: true
      });
      _ajax2.default.bindPhone({
        mobile_number: phoneNum,
        iso_code: isoCode,
        code: code
      }).then(function () {
        _this.setState({
          confirming: false
        });
        onModalConfirmBtnClick({ phone: phoneNum });
      }).catch(function () {
        var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _this.setState({
          confirming: false
        });
        _Message2.default.error(res.error && res.error[0].message || _reactIntlUniversal2.default.get('error.try-again'));
      });
    };

    _this.state = {
      error: '',
      confirming: false, // 正在验证验证码
      sending: false, // 正在请求发送验证吗
      callingCode: '86', // 手机号码国家区号代码
      isoCode: 'CN', // 手机号码国家区号代码
      curChannel: 'sms',
      curSecond: 0, // 倒计时秒数
      isResendCaptcha: false, // 是否是重发验证码
      countryPhoneData: {} // 国家区号
    };
    // console.log('getCountyOtpInfo::', countryOtpInfos);

    if (countryOtpInfos.length < 1) {
      _ajax2.default.getCountyOtpInfo().then(function (_ref) {
        var data = _ref.data;

        _this.setState({
          countryPhoneData: data
        });
      }).catch(function () {
        _Message2.default.error(_reactIntlUniversal2.default.get('phoneModal.get-otp-info-error'));
      });
    }
    return _this;
  }

  (0, _createClass3.default)(PhoneModal, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          countryPhoneData = _state.countryPhoneData,
          isResendCaptcha = _state.isResendCaptcha,
          curSecond = _state.curSecond,
          callingCode = _state.callingCode,
          confirming = _state.confirming;
      var _props = this.props,
          onModalCancelClick = _props.onModalCancelClick,
          visible = _props.visible;

      var sendBtnClass = (0, _classnames2.default)(_PhoneModal2.default['btn-in-resend'], (0, _defineProperty3.default)({}, _PhoneModal2.default['disable'], !!curSecond));
      var captchaBtnTip = 'verifymodal.send-captcha';
      if (curSecond) {
        captchaBtnTip = 'verifymodal.sending-captcha';
      } else if (isResendCaptcha) {
        captchaBtnTip = 'verifymodal.resend-captcha';
      }
      return _react2.default.createElement(
        _Modal2.default,
        {
          width: 420,
          visible: visible,
          showFooter: false,
          maskClassName: _PhoneModal2.default['mask'],
          modalClassName: _PhoneModal2.default['modal'],
          closable: true,
          isMiddle: true,
          title: _reactIntlUniversal2.default.get('phoneModal.title'),
          onCancel: onModalCancelClick
        },
        _react2.default.createElement(
          'form',
          { className: _PhoneModal2.default['form'] },
          _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)(_PhoneModal2.default['input-prepend'], _PhoneModal2.default['phone-input-prepend']) },
            _react2.default.createElement('input', {
              type: 'text',
              pattern: '\\d*',
              maxLength: '11',
              placeholder: _reactIntlUniversal2.default.get('phoneModal.phone-num'),
              ref: function ref(v) {
                _this2.phoneInput = v;
              }
            })
          ),
          _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)(_PhoneModal2.default['input-prepend'], _PhoneModal2.default['captcha-input-prepend']) },
            _react2.default.createElement(_Icon2.default, { name: 'shield', size: 'lg' }),
            _react2.default.createElement('input', {
              type: 'text',
              placeholder: _reactIntlUniversal2.default.get('phoneModal.captcha'),
              maxLength: '6',
              ref: function ref(v) {
                _this2.codeInput = v;
              }
            }),
            _react2.default.createElement(
              'a',
              { className: sendBtnClass, onClick: this.sendCaptchaBtnClick },
              _reactIntlUniversal2.default.get(captchaBtnTip, { num: curSecond })
            )
          ),
          _react2.default.createElement(
            'div',
            {
              className: _PhoneModal2.default['confirm-btn'],
              onClick: this.onModalConfirmBtnClick
            },
            confirming ? _reactIntlUniversal2.default.get('verifymodal.confirming') : _reactIntlUniversal2.default.get('verifymodal.confirm')
          )
        )
      );
    }
  }]);
  return PhoneModal;
}(_react.Component), _class2.defaultProps = {
  onModalCancelClick: _util.noop,
  onModalConfirmBtnClick: _util.noop
}, _temp)) || _class);
exports.default = PhoneModal;

/***/ }),

/***/ "4xFE":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "._3kZbo ._1DjYz{height:560px;overflow-y:auto;font-size:14px}._3kZbo ._1DjYz p{margin-bottom:20px;line-height:1.7}._3kZbo ._1DjYz ul{margin-top:10px}._3kZbo ._1DjYz ul li{list-style:none;margin-bottom:10px}._3kZbo ._1DjYz>ul>li{padding-left:5px}._3kZbo ._1DjYz>ul>li ul{padding-left:10px}._3kZbo button{height:36px;line-height:26px;width:120px;border-radius:18px}._3kZbo button:first-child{margin-right:100px;border:1px solid #f50;color:#f50}._3kZbo button:last-child{margin:0}", ""]);

// exports
exports.locals = {
	"modal": "_3kZbo",
	"modal-body": "_1DjYz"
};

/***/ }),

/***/ "5Ara":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "._3FrjS ul{position:absolute;top:0;right:100%}._3FrjS ul ._1CHYP{padding:7px 12px;line-height:20px}._3FrjS ul ._1CHYP img{margin-right:6px;width:16px;height:16px;display:inline-block;vertical-align:middle}", ""]);

// exports
exports.locals = {
	"sharemenu": "_3FrjS",
	"shareitem": "_1CHYP"
};

/***/ }),

/***/ "5Q8M":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closeTimePublishBuyModalAction = exports.openTimePublishBuyModalAction = exports.setOccupyNoother = exports.setOccupyHasOther = exports.setBindWxStatus = exports.setBindStatus = exports.setSortedNoteData = exports.setPnAgreeModalData = exports.changeFontType = exports.changeReadMode = exports.changeLocale = exports.switchDev = exports.setNoteData = exports.setQrCodeModalData = exports.setPublishSuccessData = exports.setBindPhoneStatus = undefined;

var _actionTypes = __webpack_require__("4HHy");

var _createAction = __webpack_require__("lTDY");

var _createAction2 = _interopRequireDefault(_createAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by zad on 17/10/25.
 */
var setBindPhoneStatus = exports.setBindPhoneStatus = (0, _createAction2.default)(_actionTypes.Global.SET_BIND_PHONE_STATUS, 'hasBind');

var setPublishSuccessData = exports.setPublishSuccessData = (0, _createAction2.default)(_actionTypes.Global.SET_PUBLISH_SUCCESS_MODAL_DATA, 'show', 'data');

var setQrCodeModalData = exports.setQrCodeModalData = (0, _createAction2.default)(_actionTypes.Global.SET_QRCODE_MODAL_DATA, 'show', 'data');

var setNoteData = exports.setNoteData = (0, _createAction2.default)(_actionTypes.Global.SET_NOTE_DATA, 'data');

var switchDev = exports.switchDev = (0, _createAction2.default)(_actionTypes.Global.SWITCH_DEV);

var changeLocale = exports.changeLocale = (0, _createAction2.default)(_actionTypes.Global.CHANGE_LOCALE, 'locale');

var changeReadMode = exports.changeReadMode = (0, _createAction2.default)(_actionTypes.Global.CHANGE_READ_MODE, 'readMode');

var changeFontType = exports.changeFontType = (0, _createAction2.default)(_actionTypes.Global.CHANGE_FONT_TYPE, 'fontType');

var setPnAgreeModalData = exports.setPnAgreeModalData = (0, _createAction2.default)(_actionTypes.Global.SET_PNAGREE_MODAL_DATA, 'show', 'data');

var setSortedNoteData = exports.setSortedNoteData = (0, _createAction2.default)(_actionTypes.Global.SET_SORTED_NOTE_DATA, 'data');
var setBindStatus = exports.setBindStatus = (0, _createAction2.default)(_actionTypes.Global.SET_BIND_STATUS, 'status', 'data');
var setBindWxStatus = exports.setBindWxStatus = (0, _createAction2.default)(_actionTypes.Global.SET_BIND_WX_STATUS, 'status');
var setOccupyHasOther = exports.setOccupyHasOther = (0, _createAction2.default)(_actionTypes.Global.SET_OCCUPY_HASOTHER, 'status', 'msg');
var setOccupyNoother = exports.setOccupyNoother = (0, _createAction2.default)(_actionTypes.Global.SET_OCCUPY_NOOTHER, 'status', 'msg', 'step', 'data');

var openTimePublishBuyModalAction = exports.openTimePublishBuyModalAction = (0, _createAction2.default)(_actionTypes.Global.OPEN_TIME_PUBLISH_BUY_MODAL, 'data');
var closeTimePublishBuyModalAction = exports.closeTimePublishBuyModalAction = (0, _createAction2.default)(_actionTypes.Global.CLOSE_TIME_PUBLISH_BUY_MODAL);

/***/ }),

/***/ "5ym/":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("v1l9");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./step.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./step.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "63ug":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "._33JKm{height:1px;overflow:hidden;background-color:#e5e5e5}", ""]);

// exports
exports.locals = {
	"divider": "_33JKm"
};

/***/ }),

/***/ "66rn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _isNan = __webpack_require__("MICi");

var _isNan2 = _interopRequireDefault(_isNan);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by zad on 17/1/12.
                    */


var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _rcAnimate = __webpack_require__("8aSS");

var _rcAnimate2 = _interopRequireDefault(_rcAnimate);

var _Loader = __webpack_require__("TRCE");

var _Loader2 = _interopRequireDefault(_Loader);

var _NestLoading = __webpack_require__("A0uo");

var _NestLoading2 = _interopRequireDefault(_NestLoading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loadingPrefix = 'loading';

var Loading = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Loading, _Component);

  function Loading(props) {
    (0, _classCallCheck3.default)(this, Loading);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Loading.__proto__ || (0, _getPrototypeOf2.default)(Loading)).call(this, props));

    _this.state = {
      loading: _this.props.loading
    };
    _this.debounceLoading = _this.debounceLoading.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Loading, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.debounceLoading(nextProps);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = null;
      }
    }

    // 对改变loading状态进行去抖

  }, {
    key: 'debounceLoading',
    value: function debounceLoading(nextProps) {
      var _this2 = this;

      var prevLoading = this.props.loading;
      var nextLoading = nextProps.loading;
      var delay = this.props.delay;


      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      // 如果设定了delay且前后状态不一致
      if (delay && !(0, _isNan2.default)(+delay) && prevLoading !== nextLoading) {
        this.debounceTimer = setTimeout(function () {
          return _this2.setState({ loading: nextLoading });
        }, delay);
      } else {
        this.setState({ loading: nextLoading });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          size = _props.size,
          hasMask = _props.hasMask,
          tip = _props.tip,
          wrapperClassName = _props.wrapperClassName;
      var loading = this.state.loading;


      var wrapperClass = (0, _classnames2.default)(wrapperClassName, _NestLoading2.default['loading-panel'], (_classNames = {}, (0, _defineProperty3.default)(_classNames, _NestLoading2.default['loading-panel__none'], !loading), (0, _defineProperty3.default)(_classNames, _NestLoading2.default['loading-panel-has-mask'], hasMask), _classNames));
      // const skClasses = classNames(styles['sk-circle'], {
      //   [styles['sk-circle-small']]: size === 'small',
      //   [styles['sk-circle-large']]: size === 'large',
      // });

      return _react2.default.createElement(
        _rcAnimate2.default,
        {
          className: wrapperClass,
          transitionName: 'fade',
          component: 'div'
        },
        _react2.default.createElement(_Loader2.default, { key: 'bb', size: size, tip: tip, loading: loading, loaderClassName: _NestLoading2.default['center'] })
      );
    }
  }]);
  return Loading;
}(_react.Component), _class.propTypes = {
  size: _propTypes2.default.oneOf(['small', 'default', 'large']),
  loading: _propTypes2.default.bool,
  tip: _propTypes2.default.string,
  delay: _propTypes2.default.number,
  hasMask: _propTypes2.default.bool,
  wrapperClassName: _propTypes2.default.string
}, _class.defaultProps = {
  loading: true,
  delay: undefined,
  hasMask: false
}, _temp);
exports.default = Loading;

/***/ }),

/***/ "72M+":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("QgNW");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./NoAccount.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./NoAccount.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "7ITh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__("2KeS");

var _GlobalReducer = __webpack_require__("boom");

var _GlobalReducer2 = _interopRequireDefault(_GlobalReducer);

var _NotebooksReducer = __webpack_require__("gmmG");

var _NotebooksReducer2 = _interopRequireDefault(_NotebooksReducer);

var _NotesReducer = __webpack_require__("R2Qq");

var _NotesReducer2 = _interopRequireDefault(_NotesReducer);

var _UserReducer = __webpack_require__("i0Fb");

var _UserReducer2 = _interopRequireDefault(_UserReducer);

var _NoteContentReducer = __webpack_require__("THqP");

var _NoteContentReducer2 = _interopRequireDefault(_NoteContentReducer);

var _NoteHistoryReducer = __webpack_require__("qiO7");

var _NoteHistoryReducer2 = _interopRequireDefault(_NoteHistoryReducer);

var _TrashNotesReducer = __webpack_require__("mXnL");

var _TrashNotesReducer2 = _interopRequireDefault(_TrashNotesReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import Api from './Api/ApiReducer';
var RootReducer = (0, _redux.combineReducers)({
  Global: _GlobalReducer2.default,
  // Api, // 已废弃
  Notebooks: _NotebooksReducer2.default,
  Notes: _NotesReducer2.default,
  User: _UserReducer2.default,
  NoteContent: _NoteContentReducer2.default,
  NoteHistory: _NoteHistoryReducer2.default,
  TrashNotes: _TrashNotesReducer2.default
});

exports.default = RootReducer;

/***/ }),

/***/ "7XSB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactIntlUniversal = __webpack_require__("cl+9");

var _reactIntlUniversal2 = _interopRequireDefault(_reactIntlUniversal);

var _step = __webpack_require__("5ym/");

var _step2 = _interopRequireDefault(_step);

var _IconFont = __webpack_require__("z69G");

var _IconFont2 = _interopRequireDefault(_IconFont);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by mac on 2018/8/25.
 */
var StepOne = function (_Component) {
  (0, _inherits3.default)(StepOne, _Component);

  function StepOne() {
    (0, _classCallCheck3.default)(this, StepOne);
    return (0, _possibleConstructorReturn3.default)(this, (StepOne.__proto__ || (0, _getPrototypeOf2.default)(StepOne)).apply(this, arguments));
  }

  (0, _createClass3.default)(StepOne, [{
    key: 'goUrl',
    value: function goUrl(channel) {
      var _props = this.props,
          token = _props.token,
          id = _props.id;

      var url = window.location.href;
      console.log('steponeUrl', '/users/auth/' + channel + '?bind_token=' + token + '&target_user_id=' + id + '&redirect_url=' + encodeURIComponent(url));
      window.location.href = '/users/auth/' + channel + '?bind_token=' + token + '&target_user_id=' + id + '&redirect_url=' + encodeURIComponent(url);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          username = _props2.username,
          token = _props2.token,
          id = _props2.id;

      return _react2.default.createElement(
        'div',
        { className: _step2.default.container },
        _react2.default.createElement(
          'div',
          { className: _step2.default.title },
          _react2.default.createElement(
            'div',
            { className: _step2.default.index },
            '1'
          ),
          _react2.default.createElement(
            'p',
            null,
            '\u4E3A\u8D26\u53F7\u300C',
            username,
            '\u300D',
            _reactIntlUniversal2.default.get('bind.bindway')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _step2.default.ways },
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(_IconFont2.default, { name: 'weibo', className: _step2.default.webo }),
            _react2.default.createElement(
              'span',
              {
                className: _step2.default.channel,
                onClick: function onClick() {
                  _this2.goUrl('weibo');
                }
              },
              _reactIntlUniversal2.default.get('bind.bindwb'),
              _react2.default.createElement(_IconFont2.default, { name: 'youjiantou1' })
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(_IconFont2.default, { name: 'qq', className: _step2.default.qq }),
            _react2.default.createElement(
              'span',
              {
                className: _step2.default.channel,
                onClick: function onClick() {
                  _this2.goUrl('qq_connect');
                }
              },
              _reactIntlUniversal2.default.get('bind.bindqq'),
              _react2.default.createElement(_IconFont2.default, { name: 'youjiantou1' })
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(_IconFont2.default, { name: 'douban', className: _step2.default.douban }),
            _react2.default.createElement(
              'span',
              {
                className: _step2.default.channel,
                onClick: function onClick() {
                  _this2.goUrl('douban');
                }
              },
              _reactIntlUniversal2.default.get('bind.binddb'),
              _react2.default.createElement(_IconFont2.default, { name: 'youjiantou1' })
            )
          )
        )
      );
    }
  }]);
  return StepOne;
}(_react.Component);

exports.default = StepOne;

/***/ }),

/***/ "83nq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ModalButton;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = __webpack_require__("KluA");

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ModalButton(props) {
  return _react2.default.createElement(_Button2.default, props);
} /**
   * Created by zad on 17/11/20.
   */


ModalButton.displayName = 'Modal.Button';
ModalButton.propTypes = {
  type: _propTypes2.default.string,
  className: _propTypes2.default.string
};

/***/ }),

/***/ "8CP6":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("YCVJ");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../css-loader/index.js!../../../../postcss-loader/lib/index.js!../../../../sass-loader/lib/loader.js!./index.css", function() {
		var newContent = require("!!../../../../css-loader/index.js!../../../../postcss-loader/lib/index.js!../../../../sass-loader/lib/loader.js!./index.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "8Pl5":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("FWRk");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./Dropdown.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./Dropdown.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "91PG":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("IkM0");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--3-1!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/lib/loader.js!./SubMenu.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--3-1!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/lib/loader.js!./SubMenu.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "9JgI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__("+6Bu");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by zad on 17/10/11.
                    */


var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line no-underscore-dangle
var _type = {
  size: ['lg', '2x', '3x', '4x', '5x'],
  rotate: [90, 180, 270]
};

var Icon = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(Icon, _PureComponent);

  function Icon() {
    (0, _classCallCheck3.default)(this, Icon);
    return (0, _possibleConstructorReturn3.default)(this, (Icon.__proto__ || (0, _getPrototypeOf2.default)(Icon)).apply(this, arguments));
  }

  (0, _createClass3.default)(Icon, [{
    key: 'render',
    value: function render() {
      var _classNames;

      // eslint-disable-next-line object-curly-newline
      var _props = this.props,
          name = _props.name,
          size = _props.size,
          fixedWidth = _props.fixedWidth,
          spin = _props.spin,
          pulse = _props.pulse,
          rotate = _props.rotate,
          className = _props.className,
          props = (0, _objectWithoutProperties3.default)(_props, ['name', 'size', 'fixedWidth', 'spin', 'pulse', 'rotate', 'className']);

      var iconClass = (0, _classnames2.default)('fa', 'fa-' + name, className, (_classNames = {}, (0, _defineProperty3.default)(_classNames, 'fa-' + size, size && _type.size.includes(size)), (0, _defineProperty3.default)(_classNames, 'fa-rotate-' + rotate, rotate && _type.rotate.includes(rotate)), (0, _defineProperty3.default)(_classNames, 'fa-fw', fixedWidth), (0, _defineProperty3.default)(_classNames, 'fa-spin', spin), (0, _defineProperty3.default)(_classNames, 'fa-pulse', pulse), _classNames));
      return _react2.default.createElement('i', (0, _extends3.default)({}, props, { className: iconClass }));
    }
  }]);
  return Icon;
}(_react.PureComponent), _class.propTypes = {
  name: _propTypes2.default.string.isRequired,
  size: _propTypes2.default.string,
  fixedWidth: _propTypes2.default.bool,
  spin: _propTypes2.default.bool,
  pulse: _propTypes2.default.bool,
  rotate: _propTypes2.default.number
}, _temp);
exports.default = Icon;

/***/ }),

/***/ "9Q5t":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _isIterable2 = __webpack_require__("us/S");

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__("BO1k");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _setPrototypeOf = __webpack_require__("kiBT");

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__("OvRC");

var _create2 = _interopRequireDefault(_create);

var _defineProperty = __webpack_require__("C4MV");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _iterator = __webpack_require__("Zzip");

var _iterator2 = _interopRequireDefault(_iterator);

var _typeof3 = __webpack_require__("pFYg");

var _typeof4 = _interopRequireDefault(_typeof3);

var _symbol = __webpack_require__("5QVw");

var _symbol2 = _interopRequireDefault(_symbol);

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

var _escape = __webpack_require__("l4he");

var _escape2 = _interopRequireDefault(_escape);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable */
/** 
 * dante.js 
 * version: 1.0.14 
 * author: liudecai 
 * email: liudecai@jianshu.com 
**/
function __$styleInject(css, returnValue) {
  if (typeof document === 'undefined') {
    return returnValue;
  }
  css = css || '';
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
  return returnValue;
}

/*
    poly-fill
*/
/* eslint-disable */

!function () {
  // Object.assign
  if (typeof _assign2.default !== 'function') {
    Object.assign = function (target) {
      if (target == null) {
        throw new TypeError('Cannot convert undefined or null to object');
      }

      target = Object(target);

      for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        rest[_key - 1] = arguments[_key];
      }

      for (var index = 0; index < rest.length; index++) {
        var source = rest[index];
        if (source != null) {
          /* eslint-disable no-restricted-syntax */
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
          /* eslint-disable no-restricted-syntax */
        }
      }
      return target;
    };
  }

  // IE 中兼容 Element.prototype.matches
  // if (!Element.prototype.matches) {
  //   Element.prototype.matches =
  //     Element.prototype.matchesSelector ||
  //     Element.prototype.mozMatchesSelector ||
  //     Element.prototype.msMatchesSelector ||
  //     Element.prototype.oMatchesSelector ||
  //     Element.prototype.webkitMatchesSelector ||
  //     function(s) {
  //       const matches = (this.document || this.ownerDocument).querySelectorAll(s);
  //       let i = matches.length;
  //       /* eslint-disable no-empty */
  //       while (--i >= 0 && matches.item(i) !== this) {}
  //       /* eslint-disable no-empty */
  //       return i > -1;
  //     };
  // }

  if (!Array.prototype.filter) {
    /* eslint-disable no-extend-native */
    Array.prototype.filter = function (func, thisArg) {
      /* eslint-disable valid-typeof */
      if (!(typeof func === 'Function' && this)) {
        throw new TypeError();
      }
      /* eslint-disable valid-typeof */

      var len = this.length >>> 0;
      var res = new Array(len); // preallocate array
      var c = 0;
      var i = -1;
      if (thisArg === undefined) {
        while (++i !== len) {
          // checks to see if the key was set
          if (i in this) {
            if (func(t[i], i, t)) {
              res[c++] = t[i];
            } else {
              while (++i !== len) {
                // checks to see if the key was set
                if (i in this) {
                  if (func.call(thisArg, t[i], i, t)) {
                    res[c++] = t[i];
                  }
                }
              }
            }
          }
        }
      }

      res.length = c; // shrink down array to proper size
      return res;
    };
    /* eslint-disable no-extend-native */
  }
}();

var _typeof = typeof _symbol2.default === "function" && (0, _typeof4.default)(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === 'undefined' ? 'undefined' : (0, _typeof4.default)(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : (0, _typeof4.default)(obj);
};

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : (0, _typeof4.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === 'undefined' ? 'undefined' : (0, _typeof4.default)(call)) === "object" || typeof call === "function") ? call : self;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/*
    DOM 操作 API
*/

// 根据 html 代码片段创建 dom 对象
function createElemByHTML(html) {
  var div = document.createElement('div');
  div.innerHTML = html;
  return div.children;
}

// 是否是 DOM List
function isDOMList(domList) {
  if (!domList) {
    return false;
  }
  if (domList instanceof HTMLCollection || domList instanceof NodeList) {
    return true;
  }
  return false;
}

// 封装 document.querySelectorAll
function querySelectorAll(selector) {
  var result = document.querySelectorAll(selector);
  if (isDOMList(result)) {
    return result;
  }
  return [result];
}

// function isWindow(obj) {
//   return obj != null && obj == obj.window;
// }

function isDocument(obj) {
  return obj !== null && obj.nodeType === obj.DOCUMENT_NODE;
}
function matches(element, selector) {
  if (!selector || !element || element.nodeType !== 1) return false;
  var matchesSelector = element.matches || element.webkitMatchesSelector || element.mozMatchesSelector || element.oMatchesSelector || element.matchesSelector;
  if (matchesSelector) return matchesSelector.call(element, selector);
  // fall back to performing a selector:
  var match = false;
  var parent = element.parentNode;
  var temp = !parent;
  var tempParent = document.createElement('div');
  if (temp) (parent = tempParent).appendChild(element);
  /* eslint-disable no-use-before-define */
  $(parent.querySelectorAll(selector)).forEach(function (node) {
    if (node === element) {
      match = true;
    }
  });
  /* eslint-disable no-use-before-define */
  if (temp) {
    tempParent.removeChild(element);
  }
  return match;
}

// 创建构造函数
function DomElement(selector) {
  if (!selector) {
    this.length = 0;
    return this;
  }

  // selector 本来就是 DomElement 对象，直接返回
  if (selector instanceof DomElement) {
    return selector;
  }

  this.selector = selector;

  // 根据 selector 得出的结果（如 DOM，DOM List）
  var selectorResult = [];
  if (selector.nodeType) {
    // if (selector.nodeType === 1) {
    // 单个 DOM 节点
    selectorResult = [selector];
  } else if (isDOMList(selector)) {
    // DOM List
    selectorResult = selector;
    // 如果是个数组节点
  } else if (selector instanceof Array) {
    // 过滤null undefined等无效数据
    selectorResult = selector.filter(function (v) {
      return !!v;
    });
  } else if (typeof selector === 'string') {
    // 字符串
    selector = selector.replace('/\n/mg', '').trim();
    if (selector.indexOf('<') === 0) {
      // 如 <div>
      selectorResult = createElemByHTML(selector);
    } else {
      // 如 #id .class
      selectorResult = querySelectorAll(selector);
    }
  }

  var length = selectorResult.length;
  if (!length) {
    // 空数组
    this.length = 0;
    return this;
  }

  // 加入 DOM 节点
  var i = void 0;
  for (i = 0; i < length; i++) {
    this[i] = selectorResult[i];
  }
  this.length = length;
}

// 修改原型
/* eslint-disable object-shorthand, func-names, no-param-reassign */
DomElement.prototype = {
  constructor: DomElement,

  // 类数组，forEach
  forEach: function forEach(fn) {
    var i = void 0;
    for (i = 0; i < this.length; i++) {
      var elem = this[i];
      var result = fn.call(elem, elem, i);
      if (result === false) {
        break;
      }
    }
    return this;
  },
  closest: function closest(selector, context) {
    var nodes = [];
    var collection = (typeof selector === 'undefined' ? 'undefined' : _typeof(selector)) === 'object' && $(selector);
    this.forEach(function (node) {
      while (node && !(collection ? collection.indexOf($(node)) >= 0 : matches(node, selector))) {
        node = node !== context && !isDocument(node) && node.parentNode;
      }
      if (node && nodes.indexOf(node) < 0) nodes.push(node);
    });
    return $(nodes);
  },
  // 获取第几个元素
  get: function get$$1(index) {
    var length = this.length;
    if (index >= length) {
      index %= length;
    }
    return $(this[index]);
  },

  // 第一个
  first: function first() {
    return this.get(0);
  },

  // 最后一个
  last: function last() {
    var length = this.length;
    return this.get(length - 1);
  },
  pre: function pre() {
    var elems = [];
    this.forEach(function (node) {
      elems.push(node.previousElementSibling);
    });
    return $(elems);
  },
  preNode: function preNode() {
    var elems = [];
    this.forEach(function (node) {
      if (node.previousSibling) {
        elems.push(node.previousSibling);
      }
    });
    return $(elems);
  },
  next: function next() {
    var elems = [];
    this.forEach(function (node) {
      elems.push(node.nextElementSibling);
    });
    return $(elems);
  },
  nextNode: function nextNode() {
    var elems = [];
    this.forEach(function (node) {
      elems.push(node.nextSibling);
    });
    return $(elems);
  },
  // 绑定事件
  on: function on(eventType, selector, fn) {
    // selector 不为空，证明绑定事件要加代理
    if (!fn) {
      fn = selector;
      selector = null;
    }

    // type 是否有多个
    var types = [];
    types = eventType.split(/\s+/);

    return this.forEach(function (elem) {
      types.forEach(function (type) {
        if (!type) {
          return;
        }

        if (!selector) {
          // 无代理
          elem.addEventListener(type, fn, false);
          return;
        }

        // 有代理
        elem.addEventListener(type, function (e) {
          var match = $(e.target).closest(selector, elem).get(0);
          // console.log('delegate event',e,selector,match)
          if (match.length && match !== elem) {
            fn.call(match, e);
          }
        }, false);
      });
    });
  },

  // 取消事件绑定
  off: function off(type, fn) {
    return this.forEach(function (elem) {
      elem.removeEventListener(type, fn, false);
    });
  },
  /* eslint-disable prefer-rest-params */
  data: function data(name, value) {
    var attrName = 'data-' + name.replace(/([A-Z])/, '-$1').toLowerCase();

    var data = 1 in arguments ? this.attr(attrName, value) : this.attr(attrName);

    return data !== null ? data : undefined;
  },
  /* eslint-disable prefer-rest-params */
  // 获取/设置 属性
  attr: function attr(key, val) {
    if (val == null) {
      // 获取值
      return this[0].getAttribute(key);
    }
    // 设置值
    return this.forEach(function (elem) {
      elem.setAttribute(key, val);
    });
  },
  // 支持多个className,只需要包含其中一个即可
  hasClass: function hasClass(className) {
    var result = false;
    if (!className) {
      return result;
    }
    this.forEach(function (elem) {
      var arr = void 0;
      if (elem.className) {
        // 解析当前 className 转换为数组
        arr = elem.className.split(/\s/);
        className = className.split(/\s/);
        arr = arr.filter(function (item) {
          item = item.trim();
          if (item && className.indexOf(item) > -1) {
            return item;
          }
          return false;
        });
        if (arr.length) {
          result = true;
        }
      }
    });
    return result;
  },
  // 添加 class
  addClass: function addClass(className) {
    if (!className) {
      return this;
    }
    return this.forEach(function (elem) {
      var arr = void 0;
      if (elem.className) {
        // 解析当前 className 转换为数组
        arr = elem.className.split(/\s/);
        arr = arr.filter(function (item) {
          return !!item.trim();
        });
        // 添加 class
        if (arr.indexOf(className) < 0) {
          arr.push(className);
        }
        // 修改 elem.class
        elem.className = arr.join(' ');
      } else {
        elem.className = className;
      }
    });
  },

  // 删除 class
  removeClass: function removeClass(className) {
    if (!className) {
      return this;
    }
    return this.forEach(function (elem) {
      var arr = void 0;
      if (elem.className) {
        // 解析当前 className 转换为数组
        arr = elem.className.split(/\s/);
        arr = arr.filter(function (item) {
          item = item.trim();
          // 删除 class
          if (!item || item === className) {
            return false;
          }
          return true;
        });
        // 修改 elem.class
        elem.className = arr.join(' ');
      }
    });
  },

  // 修改 css
  css: function css(key, val) {
    var currentStyle = key + ':' + val + ';';
    return this.forEach(function (elem) {
      var style = (elem.getAttribute('style') || '').trim();
      var styleArr = void 0;
      var resultArr = [];
      if (style) {
        // 将 style 按照 ; 拆分为数组
        styleArr = style.split(';');
        styleArr.forEach(function (item) {
          // 对每项样式，按照 : 拆分为 key 和 value
          var arr = item.split(':').map(function (i) {
            return i.trim();
          });
          if (arr.length === 2) {
            resultArr.push(arr[0] + ':' + arr[1]);
          }
        });
        // 替换或者新增
        resultArr = resultArr.map(function (item) {
          if (item.indexOf(key) === 0) {
            return currentStyle;
          }
          return item;
        });
        if (resultArr.indexOf(currentStyle) < 0) {
          resultArr.push(currentStyle);
        }
        // 结果
        elem.setAttribute('style', resultArr.join('; '));
      } else {
        // style 无值
        elem.setAttribute('style', currentStyle);
      }
    });
  },
  removeAttr: function removeAttr(name) {
    return this.forEach(function (node) {
      node.removeAttribute(name);
    });
  },
  // 显示
  show: function show() {
    return this.css('display', 'block');
  },

  // 隐藏
  hide: function hide() {
    return this.css('display', 'none');
  },

  // 获取子节点
  children: function children() {
    var elem = this[0];
    if (!elem) {
      return $([]);
    }

    return $(elem.children);
  },

  // 增加子节点
  append: function append($children) {
    return this.forEach(function (elem) {
      $children.forEach(function (child) {
        elem.appendChild(child);
      });
    });
  },
  prepend: function prepend($children) {
    return this.forEach(function (elem) {
      $children.forEach(function (child) {
        elem.insertBefore(child, elem.firstChild);
      });
    });
  },
  // 移除当前节点
  remove: function remove() {
    return this.forEach(function (elem) {
      if (elem.remove) {
        elem.remove();
      } else {
        var parent = elem.parentElement;
        if (parent) {
          parent.removeChild(elem);
        }
      }
    });
  },
  replace: function replace($elem) {
    return this.forEach(function (elem) {
      $elem.insertBefore($(elem));
      $(elem).remove();
    });
  },
  // 是否包含某个子节点
  isContain: function isContain($child) {
    var elem = this[0];
    var child = $child[0];
    if (!elem || !child) {
      return false;
    }
    return elem.contains(child);
  },

  // 尺寸数据
  getBoundingClientRect: function getBoundingClientRect() {
    var elem = this[0];
    return elem.getBoundingClientRect(); // 可得到 bottom height left right top width 的数据
  },

  // 封装 nodeName
  getNodeName: function getNodeName() {
    var elem = this[0];
    if (!elem) {
      return '';
    }
    return elem.nodeName && elem.nodeName.toUpperCase();
  },
  // 向parent查找，直到遇到utilElem, 没查到返回false
  findReverse: function findReverse(classNames) {
    var utilElem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $(document);

    var result = false;
    var elem = this;
    while (!utilElem.equal(elem) && !utilElem.equal($(document))) {
      if (elem.hasClass(classNames)) {
        result = elem;
        break;
      }
      elem = elem.parent();
    }
    return result;
  },
  // 从当前元素查找
  find: function find(selector) {
    var elem = this[0];
    return $(elem.querySelectorAll(selector));
  },
  clone: function clone() {
    var elem = this[0];
    return $(elem.cloneNode(true));
  },
  // 获取当前元素的 text
  text: function text(val) {
    if (!val) {
      // 获取 text
      var elem = this[0];
      if (elem) {
        return (0, _escape2.default)(elem.innerText) || elem.textContent || '';
      }
      return '';
      // return elem.innerHTML.replace(/<.*?>/g, () => '')
    }
    // 设置 text
    return this.forEach(function (elem) {
      elem.textContent = val;
    });
  },

  // 获取 html
  html: function html(value) {
    var elem = this[0];
    if (!elem) {
      return '';
    }
    if (value == null) {
      return elem.innerHTML || '';
    }
    elem.innerHTML = value;
    return this;
  },
  contents: function contents() {
    var elem = this[0];
    if (!elem) {
      return $();
    }
    return $(elem.contentDocument || Array.prototype.slice.call(elem.childNodes));
  },
  // 获取 value
  val: function val() {
    var elem = this[0];
    return elem.value.trim();
  },

  // focus
  focus: function focus() {
    return this.forEach(function (elem) {
      elem.focus();
    });
  },

  // parent
  parent: function parent() {
    var elem = this[0];
    if (elem) {
      return $(elem.parentElement);
    }
    return $(elem);
  },

  // 判断两个 elem 是否相等
  equal: function equal($elem) {
    if ($elem.nodeType === 1) {
      return this[0] === $elem;
    }
    return this[0] === $elem[0];
  },
  before: function before(elem) {
    return elem.insertBefore(this);
  },
  after: function after(elem) {
    return elem.insertAfter(this);
  },
  // 将该元素插入到某个元素前面
  insertBefore: function insertBefore(selector) {
    var $referenceNode = $(selector);
    var referenceNode = $referenceNode[0];
    if (!referenceNode) {
      return this;
    }
    return this.forEach(function (elem) {
      var parent = referenceNode.parentNode;
      if (parent) {
        parent.insertBefore(elem, referenceNode);
      }
    });
  },

  // 将该元素插入到某个元素后面
  insertAfter: function insertAfter(selector) {
    var $referenceNode = $(selector);
    var referenceNode = $referenceNode[0];
    if (!referenceNode) {
      return this;
    }
    return this.forEach(function (elem) {
      var parent = referenceNode.parentNode;
      if (!parent) {
        return;
      }
      // console.log("insertAfter:::===",parent,referenceNode,elem)
      if (parent.lastChild === referenceNode) {
        // 最后一个元素
        parent.appendChild(elem);
      } else {
        // 不是最后一个元素
        parent.insertBefore(elem, referenceNode.nextSibling);
      }
    });
  },
  is: function is(selector) {
    return typeof selector === 'string' ? this.length > 0 && matches(this[0], selector) : selector && this.selector === selector.selector;
  },
  wrap: function wrap(structure) {
    return this.forEach(function (elem) {
      if (typeof structure === 'string') {
        $(elem).before(structure = $(structure));
      } else {
        $(elem).before(structure);
      }
      structure.append($(elem));
    });
  },
  unwrap: function unwrap() {
    return this.forEach(function (elem) {
      $(elem).parent().replace($(elem));
    });
  },
  // 把所有的childnodes放到外面
  unpack: function unpack() {
    return this.forEach(function (elem) {
      elem = $(elem);
      elem.contents().forEach(function (child) {
        elem.before($(child));
      });
      elem.remove();
    });
  }
};

// new 一个对象
function $(selector) {
  return new DomElement(selector);
}

var CSS = {
  PLACE_HOLDER: 'PLACE_HOLDER',

  UPLOADING: 'img-uploading-status', // 上传中
  UPLOADING_PANEL: 'image-upload-status-panel', // 上传状态栏
  // UPLOAD_ERROR: 'img-uploading-error-status', // 上传失败
  // UPLOAD_ERROR_TIP: 'img-uploading-error-tip', // 上传失败提示
  UPLOADING_ICON: 'uploading-icon', // 上传loding icon
  UPLOAD_CANCER_BTN: 'upload-btn-cancel', // 取消上传按键
  UPLOAD_RETRY_BTN: 'upload-btn-retry', // 重新上传按键
  UPLOADING_MSG: 'upload-error-msg', // 重新上传按键

  IMG_CONTAINER: 'image-package',
  IMG_TITLE: 'image-caption',
  VIDEO_CONTAINER: 'video-package',
  VIDEO_DESCRIPTION: 'video-description'

  // 为了兼容原来的文章能继续编写，所以只能区别对待，不能统一一个Class名字
  // MEDIA_CONTAINER: 'dante-media-or-img-package', // img or media common class
  // MEDIA_SELF: 'dante-media-or-img', // img or media caption common class
  // MEDIA_CAPTION: 'dante-media-or-img-caption'// img or media caption common class
};

var EVENT = {
  ERROR: 'error',

  // capture event
  CAPTRUE: 'CAPTRUE',

  // drag event
  DRAG_ENTER: 'dragenter',
  DRAG_LEAVE: 'dragleave',
  DROP: 'drop',

  // onchang event
  HTML_CONTENT_CHANGE: 'contentChange',

  // upload img event
  IMG_UPLOAD: 'imageUpload',
  ALLIMG_UPLOADED: 'AllImgUploaded',

  // keybord event
  KEY_DOWN: 'KEY_DOWN',
  KEY_UP: 'KEY_UP',
  TAB_KEY_DOWN: 'TAB_KEY_DOWN',
  TAB_KEY_UP: 'TAB_KEY_UP',
  DEL_KEY_DOWN: 'DEL_KEY_DOWN',
  DEL_KEY_UP: 'DEL_KEY_UP',
  ENTER_KEY_DOWN: 'ENTER_KEY_DOWN',
  ENTER_KEY_UP: 'ENTER_KEY_UP'

};

// eslint-disable-next-line import/no-mutable-exports
var Logger = function Logger() {
  return function () {};
};

var Log = Logger;

/*
    工具
*/
// import EVENT from '@enum/eventname';
// import ERROR from '@enum/error';

var blockTags = ['address', 'article', 'aside', 'audio', 'blockquote', 'canvas', 'dd', 'div', 'dl', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'noscript', 'ol', 'output', 'p', 'pre', 'section', 'table', 'thead', 'tfoot', 'tbody', 'tr', 'ul', 'video', 'li', 'legend'];
var allowTags = ['blockquote', 'pre', 'code', 'p', 'div', 'ul', 'ol', 'li', 'br', 'hr', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'img', 'a', 'b', 'i', 'u', 'del', 'strike', 'strong', 'em'];

// 和 UA 相关的属性
var UA = {
  ua: navigator.userAgent,

  // 是否 webkit
  isWebkit: function isWebkit() {
    var reg = /webkit/i;
    return reg.test(this.ua);
  },

  // 是否 IE
  isIE: function isIE() {
    return 'ActiveXObject' in window;
  }
};

function videoMaker(_ref) {
  var url = _ref.url,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 400 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 400 : _ref$height,
      provider = _ref.provider,
      flash = _ref.flash;

  url = url.replace(/http:|https:/, '');
  var player = '';
  if (provider === 'bilibili') {
    player = '<div class="video-player player">';
    player += '<video width="' + width + '" height="' + height + '" preload="auto" controls="true">';
    player += '<source src="' + url + '" type="video/mp4">';
    player += '<object type="application/x-shockwave-flash" data="http://static.hdslb.com/play.swf" class="flash" style="width:' + width + 'px; height:' + height + 'px;">';
    player += '<param name="bgcolor" value="#ffffff">';
    player += '<param name="allowfullscreeninteractive" value="true">';
    player += '<param name="allowfullscreen" value="true">';
    player += '<param name="quality" value="high">';
    player += '<param name="allowscriptaccess" value="always">';
    player += '<param name="wmode" value="direct">';
    player += '<param name="flashvars" value="' + flash + '">';
    player += '</object>';
    player += '</video>';
    player += '</div>';
  } else {
    player = '<iframe class="player" src="' + url + '" height="' + height + '" width="' + width + '" frameborder=0 allowfullscreen style="width:' + width + 'px; height:' + height + 'px;"></iframe>';
  }

  return player;
}

// 获取当前node所在的p元素,如果没有，返回自身
function getPElemByNode(node) {
  while (node && $(node).getNodeName() !== 'P') {
    node = node.parentNode;
  }
  return $(node);
}

// 编辑区域顶级元素只允许这些 + GapNode(媒体标签和分割线)
function isContainer(node) {
  var tag = $(node).getNodeName();
  var containerTagArray = ['P', 'BLOCKQUOTE', 'PRE', 'H1', 'H2', 'H3', 'H4'];
  /* eslint-disable no-restricted-syntax */
  for (var i in containerTagArray) {
    if (tag === containerTagArray[i]) {
      return true;
    }
  }
  /* eslint-disable no-restricted-syntax */
  return false;
}
// 媒体标签和hr分割线
function isGapNode(node) {
  return $(node).hasClass(CSS.IMG_CONTAINER) || $(node).hasClass(CSS.VIDEO_CONTAINER) || $(node).getNodeName() === 'HR';
}
/* eslint-disable no-prototype-builtins */
function urlParse(url) {
  if (url.indexOf('//') === 0) {
    url = location.protocol + url;
    return url;
  }
  if (/^((https?|ftp):)\/\//i.test(url)) {
    return url;
  }
  url = location.protocol + '//' + url;
  return url;
}

function getImgTitle() {
  return $('<div class=\'' + CSS.IMG_TITLE + '\'></div>');
}
function getImgPanel(url) {
  var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var uploadId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
  var width = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'auto';
  var height = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'auto';
  var minWidth = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
  var minHeight = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
  var needLoading = arguments[7];

  var elem = $('\n            <div class=\'' + CSS.IMG_CONTAINER + ' ' + (needLoading ? CSS.UPLOADING : '') + ' ' + (needLoading ? CSS.IMG_CONTAINER + '-' + uploadId : '') + '\'  data-index=\'' + uploadId + '\'>\n              <img class=\'uploaded-img\' src=' + url + ' style="min-height:' + minHeight + ';min-width:' + minWidth + ';" width=' + width + ' height=' + height + ' />\n              <br>\n            </div>\n         ');
  elem.append(getImgTitle(title));
  return elem;
}

function getVideoTitle() {
  var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return $('<div class="' + CSS.VIDEO_DESCRIPTION + '">' + title + '</div>');
}
function getVideoPanel() {
  var videoInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var elem = $('<div\n              class="' + CSS.VIDEO_CONTAINER + ' "\n              data-video-id="' + videoInfo.id + '"\n              data-video-url="' + videoInfo.url + '"\n              data-flash-url="' + videoInfo.flash + '"\n              data-provider="' + videoInfo.provider + '"\n              data-cover-uuid="' + videoInfo.cover_id + '"\n          >\n          ' + videoMaker(videoInfo) + '\n          <br>\n          </div>');
  elem.append(getVideoTitle(videoInfo.description));
  return elem;
}
function getLoadingPanel(url, loadingId) {
  return $('<div class="' + CSS.UPLOADING_PANEL + '" contenteditable="false">\n              <img class="preview" src="' + url + '">\n              <div class="status-bar">\n                <span class="' + CSS.UPLOADING_ICON + '"></span>\n                <div class="status-area">\n                  <span class="' + CSS.UPLOADING_MSG + '">\u6B63\u5728\u4E0A\u4F20...</span>\n                  <a class="' + CSS.UPLOAD_CANCER_BTN + '" data-index="' + loadingId + '" href="javascript:void(0)">\u53D6\u6D88</a>\n                  <a class="' + CSS.UPLOAD_RETRY_BTN + '" data-index="' + loadingId + '" href="javascript:void(0)">\u91CD\u65B0\u4E0A\u4F20</a>\n                </div>\n              </div>\n            </div>');
}

function dataURI2Blob(data) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var _data$split = data.split(','),
      _data$split2 = slicedToArray(_data$split, 2),
      bra = _data$split2[0],
      ket = _data$split2[1];

  var byteString = void 0;
  // # convert base64/URLEncoded data component to raw binary data held in a string
  if (bra.indexOf('base64') > -1) {
    byteString = atob(ket);
  } else {
    byteString = unescape(ket);
  }
  // # separate out the mime component
  var mimeString = bra.split(':')[1].split(';')[0];

  // # write the bytes of the string to a typed array
  var ia = new Uint8Array(byteString.length);
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  var file = new Blob([ia], { type: mimeString });
  file.name = name + '.' + mimeString.replace('image/', '');
  return file;
}

function formatTheTag(container, tag, action) {
  container.find(tag).forEach(function (item) {
    item = $(item);
    item.find(tag).forEach(function (subItem) {
      action(item, $(subItem));
    });
  });
}
/*
* 清除嵌套标签，如<p><p></p></p>
*/
// eslint-disable-next-line class-methods-use-this
function clearDuplicateTag(html) {
  var container = $('<div>');
  container.html(html);
  var inlineTagArray = ['b', 'strong', 'i', 'em', 'del', 'strike'];
  var blockTagArray = ['p'];
  // 把嵌套的标签提出来
  inlineTagArray.map(function (v) {
    formatTheTag(container, v, function (item, subItem) {
      subItem.unpack();
    });
    return null;
  });
  blockTagArray.map(function (v) {
    formatTheTag(container, v, function (item, subItem) {
      item.after(subItem);
    });
    return null;
  });
  // 移除空标签
  inlineTagArray.map(function (v) {
    container.find(v).forEach(function (item) {
      item = $(item);
      if (item.text() === '') {
        item.remove();
      }
    });
    return null;
  });
  return container.html();
}

var Logger$1 = Log('Command');

var command = function () {
  function command(editor) {
    classCallCheck(this, command);

    this.editor = editor;
    // 这些操作是不需要拍照保存history的
    this.donotCaptureCommandList = ['undo', 'redo'];
    this.bindEvent();
  }
  // 绑定一些代理事件，例如图片上传状态的取消和重试按键


  createClass(command, [{
    key: 'bindEvent',
    value: function bindEvent() {
      var editor = this.editor;
      var selection = editor.selection;
      var $editElem = editor.$editElem;
      var imgUploader = editor.imgUploader;

      // 取消按键
      $editElem.on('click', '.' + CSS.UPLOAD_CANCER_BTN, function (e) {
        var index = $(e.target || e.srcElement).data('index');

        var imgContainerElem = $('.' + CSS.IMG_CONTAINER + '-' + index);
        imgUploader.uploadDataCache[index] = null; // clear cache
        imgContainerElem.remove();
      });

      // 重试按键
      $editElem.on('click', '.' + CSS.UPLOAD_RETRY_BTN, function (e) {
        var index = $(e.target || e.srcElement).data('index');

        var imgContainerElem = $('.' + CSS.IMG_CONTAINER + '-' + index);
        var imgCaptionElem = imgContainerElem.find('.' + CSS.IMG_TITLE);
        selection.setCursorInElem(imgCaptionElem);
        // const uploaddata = JSON.parse(imgContainerElem.data('uploaddata'));
        imgUploader.beginUpload({ id: index });
      });
    }
  }, {
    key: 'exec',
    value: function exec(name, value) {
      var editor = this.editor;
      var selection = editor.selection;
      var isDonotCaptureCommand = this.donotCaptureCommandList.indexOf(name) >= 0;
      if (!isDonotCaptureCommand && !selection.isValidEditSelection()) {
        return null;
      }
      // 如果无选区，忽略
      if (!selection.getRange()) {
        return null;
      }
      // 执行
      var result = void 0;
      var customerName = '_' + name;
      // console.time('commandTIME')
      if (this[customerName]) {

        // 有自定义事件
        result = this[customerName](value);

        // 自定义的command有可能改变选区，所以需要重新保存,恢复光标
        selection.saveRange();
        selection.restoreSelection();
      } else if (!selection.isInsideMediaBox()) {

        selection.restoreSelection();
        // 默认 command
        result = this.execCommand(name, value);
        selection.saveRange();
        // editor.focusNative();
      } else {

        selection.restoreSelection();
      }

      // 触发 onchange
      editor.handleHtmlChange(false);
      if (!isDonotCaptureCommand) {
        // 强制保存快照
        editor.emit(EVENT.CAPTRUE);
      }
      // console.timeEnd('commandTIME')

      return result;
    }

    // 自定义 insertHTML 事件

  }, {
    key: '_insertHTML',
    value: function _insertHTML(html) {
      var editor = this.editor;
      var range = editor.selection.getRange();

      // 保证传入的参数是 html 代码
      var test = /^<.+>$/.test(html);
      if (!test && !UA.isWebkit()) {
        // webkit 可以插入非 html 格式的文字
        // html = `<span>${html}</span>`;
        return;
        // throw new Error('执行 insertHTML 命令时传入的参数必须是 html 格式');
      }

      if (this.queryCommandSupported('insertHTML')) {
        // W3C
        this.execCommand('insertHTML', html);
      } else if (range.insertNode) {
        // IE
        range.deleteContents();
        range.insertNode($(html)[0]);
      } else if (range.pasteHTML) {
        // IE <= 10
        range.pasteHTML(html);
      }
    }

    // 插入 elem

  }, {
    key: '_insertElem',
    value: function _insertElem($elem) {
      var editor = this.editor;
      editor.selection.insertElem($elem);
    }

    // 批量插入

  }, {
    key: '_insertImgs',
    value: function _insertImgs(_ref) {
      var images = _ref.images;

      // console.log('_insertImgs::',images)
      var owner = this;
      var editor = this.editor;
      var imgUploader = editor.imgUploader;
      // 使用for保证照片顺序
      for (var i = 0; i < images.length; i++) {
        var _images$i = images[i],
            url = _images$i.url,
            file = _images$i.file;

        if (file && imgUploader.checkImgFile(file)) {
          // 检查文件是否合法
          owner.exec('insertImg', { file: file, title: file.name, islast: i == images.length - 1 });
        } else if (url) {
          owner.exec('insertImg', { url: url, islast: i == images.length - 1 });
        }
      }
    }

    // 单张插入,可以指定插入位置$imgPlaceHolderElem(插入后的图片会替换$imgPlaceHolderElem)
    // file参数可选，如果有说明不是一个网络图片，上传应使用file对象

  }, {
    key: '_insertImg',
    value: function _insertImg(_ref2) {
      var _ref2$url = _ref2.url,
          url = _ref2$url === undefined ? '' : _ref2$url,
          file = _ref2.file,
          _ref2$title = _ref2.title,
          title = _ref2$title === undefined ? 'image.png' : _ref2$title,
          _ref2$width = _ref2.width,
          width = _ref2$width === undefined ? 'auto' : _ref2$width,
          _ref2$height = _ref2.height,
          height = _ref2$height === undefined ? 'auto' : _ref2$height,
          _ref2$minWidth = _ref2.minWidth,
          minWidth = _ref2$minWidth === undefined ? 0 : _ref2$minWidth,
          _ref2$minHeight = _ref2.minHeight,
          minHeight = _ref2$minHeight === undefined ? 0 : _ref2$minHeight,
          _ref2$$imgPlaceHolder = _ref2.$imgPlaceHolderElem,
          $imgPlaceHolderElem = _ref2$$imgPlaceHolder === undefined ? null : _ref2$$imgPlaceHolder,
          islast = _ref2.islast;

      var editor = this.editor;
      var config = editor.config;
      var selection = editor.selection;
      var imgUploader = editor.imgUploader;

      // 必选参数合法判定
      if (!file && !url) {

        return;
      }
      // 检查文件是否合法
      if (file && !imgUploader.checkImgFile(file)) {
        return;
      }
      // 如果图片本身是简书的，就不需要上传了
      var isJianshuImg = config.jianshuImgUrlRegex.test(url);

      // 如果是简书图片需要改成https
      if (isJianshuImg) {
        url = url.replace(/^http:/, window.location.protocol);
      }
      // 如果是网路图片，需要设置宽高
      if (!file) {
        minHeight = '200px';
        minWidth = '200px';
      }

      var uploadId = imgUploader.getNewUploadId();
      var imgContainerElem = getImgPanel(url, title, uploadId, width, height, minWidth, minHeight, !isJianshuImg);
      var imgCaptionElem = imgContainerElem.find('.' + CSS.IMG_TITLE);

      // 构造上传参数
      var uploaddata = { id: uploadId };
      if (file) {
        uploaddata.file = file;
      } else {
        uploaddata.url = url;
      }

      if (!isJianshuImg) {
        // add loading
        var loadingPanel = getLoadingPanel(url, uploadId);
        // const $cancelBtn = loadingPanel.find(`.${CSS.UPLOAD_CANCER_BTN}`);
        // const $comfirBtn = loadingPanel.find(`.${CSS.UPLOAD_RETRY_BTN}`);

        imgContainerElem.append(loadingPanel);
      }

      if ($imgPlaceHolderElem) {
        $imgPlaceHolderElem.replace(imgContainerElem);
      } else {
        var rangEndTopElem = selection.getSelectionEndTopContainerElem();
        if (rangEndTopElem.getNodeName() === 'P') {
          selection.breakOnePtoTwoP(null, false, false);
        }
        imgContainerElem.insertAfter(rangEndTopElem);
      }
      // 最后调用beginUpload，确保dom已插入文档
      if (!isJianshuImg) {
        // 如果是file的，需要做好预览功能
        if (file) {
          var reader = new FileReader();
          reader.readAsDataURL(file);
          // eslint-disable-next-line func-names
          reader.onload = function (evt) {
            var base64Image = evt.target.result;
            var imgElem = imgContainerElem.find('img');
            imgElem.attr('src', base64Image);
            return imgUploader.beginUpload(uploaddata, islast);
          };
        } else {
          return imgUploader.beginUpload(uploaddata, islast);
        }
      } else {
        if (islast) {
          editor.emit(EVENT.ALLIMG_UPLOADED);
        }
      }
    }
  }, {
    key: '_insertFormula',
    value: function _insertFormula(_ref3) {
      var _ref3$formula = _ref3.formula,
          formula = _ref3$formula === undefined ? '' : _ref3$formula;

      var editor = this.editor;
      var selection = editor.selection;
      var rangElem = selection.getSelectionContainerElem();

      var urlElem = $('<img class=\'math-inline\' src=\'https://math.jianshu.com/math?formula=' + encodeURIComponent(formula) + '\' alt=\'' + formula + '\' mathimg=\'1\'>');
      if (rangElem.getNodeName() === 'A') {
        rangElem.replace(urlElem);
      } else {
        this._insertElem(urlElem); // eslint-disable-line no-underscore-dangle
      }
      selection.setCursorAfterElem(urlElem);
    }
  }, {
    key: '_changeFormula',
    value: function _changeFormula(e) {
      var editor = this.editor;
      var selection = editor.selection;
      selection.selectElem($(e.target));
    }
  }, {
    key: '_removeLink',
    value: function _removeLink() {
      var editor = this.editor;
      var selection = editor.selection;
      var linkElem = selection.getCurrentLinkElem();
      if (!linkElem.data('fake')) {
        linkElem.unpack();
      }
    }
  }, {
    key: '_insertLink',
    value: function _insertLink(_ref4) {
      var url = _ref4.url,
          text = _ref4.text;

      var editor = this.editor;
      var selection = editor.selection;
      var rangElem = selection.getSelectionContainerElem();

      url = urlParse(url);

      var urlElem = $('<a href=\'' + url + '\' target=\'_blank\'>' + (text || url) + '</a>');
      if (rangElem.getNodeName() === 'A') {
        rangElem.replace(urlElem);
      } else {
        this._insertElem(urlElem); // eslint-disable-line no-underscore-dangle
      }
      selection.setCursorAfterElem(urlElem);
    }
  }, {
    key: '_insertTitle',
    value: function _insertTitle(level) {
      var editor = this.editor;
      // const $editElem = editor.$editElem;

      var selection = editor.selection;

      selection.toggleBlockTag('H' + level);
    }
  }, {
    key: '_insertBlockquote',
    value: function _insertBlockquote() {
      var editor = this.editor;
      var selection = editor.selection;
      if (selection.isInsideMediaBox()) {
        return null;
      }
      selection.toggleBlockTag('BLOCKQUOTE');
      return null;
    }
  }, {
    key: '_insertHRule',
    value: function _insertHRule() {
      var editor = this.editor;
      var selection = editor.selection;

      var rangEndTopElem = selection.getSelectionEndTopContainerElem();
      var gaplineElem = $('<hr>');
      var $p = $('<p><br></p>');
      gaplineElem.insertAfter(rangEndTopElem);
      // console.log('_insertHRule::', rangEndTopElem, gaplineElem.next());
      if (gaplineElem[0].nextElementSibling) {
        selection.setCursorInElem(gaplineElem.next());
      } else {
        $p.insertAfter(gaplineElem);
        selection.setCursorInElem($p);
      }
      // const $children = $editElem.children()
      // $editElem.append($p)
    }
  }, {
    key: '_insertVideo',
    value: function _insertVideo() {
      var videoInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var editor = this.editor;
      var selection = editor.selection;
      var rangEndTopElem = selection.getSelectionEndTopContainerElem();
      var videoElem = getVideoPanel(videoInfo);
      videoElem.insertAfter(rangEndTopElem);
      selection.setCursorInElem(videoElem.find('.' + CSS.VIDEO_DESCRIPTION));
    }

    // 接管了undo命令

  }, {
    key: '_undo',
    value: function _undo() {
      this.editor.history.undo();
    }

    // 接管了redo命令

  }, {
    key: '_redo',
    value: function _redo() {
      this.editor.history.redo();
    }

    // 获取当前选区中的链接信息，插入链接用
    // _getCurrentLinkInfo(){
    //   return this.editor.selection.getCurrentLinkInfo()
    // }

    // 重新聚焦到编辑器, 注意此方法会重新应用选区
    // _focus(){
    //   this.editor.selection.restoreSelection()
    // }

    /* eslint-disable class-methods-use-this */
    // 封装 execCommand

  }, {
    key: 'execCommand',
    value: function execCommand(name, value) {
      // console.log('execCommand1::',name,value)
      document.execCommand(name, false, value);
    }

    // 封装 document.queryCommandValue

  }, {
    key: 'queryCommandValue',
    value: function queryCommandValue(name) {
      return document.queryCommandValue(name);
    }

    // 封装 document.queryCommandState

  }, {
    key: 'queryCommandState',
    value: function queryCommandState(name) {
      return document.queryCommandState(name);
    }

    // 封装 document.queryCommandSupported

  }, {
    key: 'queryCommandSupported',
    value: function queryCommandSupported(name) {
      return document.queryCommandSupported(name);
    }

    /* eslint-disable class-methods-use-this */

  }]);
  return command;
}();

var NODETYPE = {
  ELEMENT_NODE: 1,
  TEXT_NODE: 3,
  CDataSection: 4,
  Comment: 8
};

var domselection = function () {
  function domselection(editor) {
    classCallCheck(this, domselection);

    this.editor = editor;
  }
  /* eslint-disable class-methods-use-this */

  createClass(domselection, [{
    key: 'newPlaceHolder',
    value: function newPlaceHolder() {
      return $('<span>').addClass(CSS.PLACE_HOLDER);
    }
    /* eslint-disable class-methods-use-this */

  }, {
    key: 'getSelectionContainerElem',
    value: function getSelectionContainerElem(range) {
      var elem = void 0;
      if (range) {
        elem = range.commonAncestorContainer;
        return $(elem.nodeType === NODETYPE.ELEMENT_NODE ? elem : elem.parentNode);
      }
      return null;
    }
  }, {
    key: 'getSelectionStartElem',
    value: function getSelectionStartElem(range) {
      // range = range || this._currentRange
      var elem = void 0;
      if (range) {
        elem = range.startContainer;
        return $(elem.nodeType === NODETYPE.ELEMENT_NODE ? elem : elem.parentNode);
      }
      return null;
    }
  }, {
    key: 'getSelectionEndElem',
    value: function getSelectionEndElem(range) {
      // range = range || this._currentRange
      var elem = void 0;
      if (range) {
        elem = range.endContainer;
        // console.log('getSelectionEndElem::',elem)
        return $(elem.nodeType === NODETYPE.ELEMENT_NODE ? elem : elem.parentNode);
      }
      return null;
    }
    // 获取当前选区endContainer所在的最顶层的元素, 这个函数用的挺多，主要用来判定光标所在位置，如是在引用，标题，还是普通段落，
    // 不过我发现有个原生的API可以获取这个(不知道好不好用),queryCommandState

  }, {
    key: 'getSelectionEndTopContainerElem',
    value: function getSelectionEndTopContainerElem(range) {
      var editor = this.editor;
      var $editElem = editor.$editElem;
      // let elem = range.commonAncestorContainer;
      var elem = range.endContainer;
      while (!$(elem).equal($editElem) && !$(elem.parentNode).equal($editElem) && elem.parentNode) {
        // console.log('getSelectionEndTopContainerElem::parentNode::',elem)
        elem = elem.parentNode;
      }
      return $(elem);
    }
  }, {
    key: 'getTopContainerByNode',
    value: function getTopContainerByNode(node) {
      var editor = this.editor;
      var $editElem = editor.$editElem;
      var elem = node;
      while (!$(elem.parentNode).equal($editElem) && elem.parentNode) {
        elem = elem.parentNode;
      }
      return $(elem);
    }
  }, {
    key: 'isCharacterDataNode',
    value: function isCharacterDataNode(node) {
      var t = node.nodeType;
      // Text, CDataSection or Comment
      return t === NODETYPE.TEXT_NODE || t === NODETYPE.CDataSection || t === NODETYPE.Comment;
    }
  }, {
    key: 'getTextNodes',
    value: function getTextNodes(node) {
      var textNodes = [];
      if (!node) return textNodes;

      if (node.nodeType === 3) {
        textNodes.push(node);
      }
      var childNodes = node.childNodes;
      /* eslint-disable no-restricted-syntax */
      for (var k in childNodes) {
        if (childNodes[k].nodeType === 3) {
          textNodes.push(childNodes[k]);
        } else {
          textNodes = textNodes.concat(this.getTextNodes(childNodes[k]));
        }
      }
      /* eslint-disable no-restricted-syntax */
      return textNodes;
    }
  }, {
    key: 'getReverseTextNodes',
    value: function getReverseTextNodes(node) {
      var textNodes = [];
      if (!node) return textNodes;

      if (node.nodeType === 3) {
        textNodes.push(node);
      }
      for (var i = node.childNodes.length - 1; i >= 0; i--) {
        var child = node.childNodes[i];
        if (child.nodeType === 3) {
          textNodes.push(child);
        } else {
          textNodes = textNodes.concat(this.getReverseTextNodes(child));
        }
      }
      return textNodes;
    }
    // 用于从backupRange中从新找出textNode

  }, {
    key: 'getStartNodeFromNodes',
    value: function getStartNodeFromNodes(node, textNode) {
      var textNodes = this.getTextNodes(node);
      var result = null;
      textNodes.map(function (item) {
        if (textNode.isEqualNode(item)) {
          result = item;
        }
        return null;
      });
      return result;
    }
    // 用于findNewRange中

  }, {
    key: 'getEndNodeFromNodes',
    value: function getEndNodeFromNodes(node, textNode) {
      var textNodes = this.getReverseTextNodes(node);
      var result = void 0;
      textNodes.map(function (item) {
        if (textNode.isEqualNode(item)) {
          result = item;
        }
        return null;
      });
      return result;
    }
    // 用于从backupRange中恢复光标位置

  }, {
    key: 'findNewRange',
    value: function findNewRange(node, oldRange) {
      var _oldRange = slicedToArray(oldRange, 2),
          oldStart = _oldRange[0],
          oldEnd = _oldRange[1];

      var newStart = this.getStartNodeFromNodes(node, oldStart);
      var newEnd = this.getEndNodeFromNodes(node, oldEnd);
      return [newStart, newEnd];
    }

    /* eslint-disable class-methods-use-this */
    // 获取光标当前所在的段落

  }, {
    key: 'getCurrentParagraph',
    value: function getCurrentParagraph(range) {
      return getPElemByNode(range.commonAncestorContainer);
    }
    /* eslint-disable class-methods-use-this */
    // 获取选区的顶级node集合

  }, {
    key: 'getSelectedTopNodes',
    value: function getSelectedTopNodes(range) {
      var startTopContainer = this.getTopContainerByNode(range.startContainer);
      var endTopContainer = this.getTopContainerByNode(range.endContainer);
      var selectedNodes = [];

      while (!startTopContainer.equal(endTopContainer)) {
        selectedNodes.push(startTopContainer[0]);
        startTopContainer = startTopContainer.next();
      }
      selectedNodes.push(endTopContainer[0]);
      return selectedNodes;
    }
    // 检查nodes里是否含有tag，如果有说明是需要取消tag，没有就是需要加上tag

  }, {
    key: 'detectHasSurrounded',
    value: function detectHasSurrounded(nodes, tagName) {
      var result = true;
      nodes.map(function (node) {
        if (isContainer(node) && !($(node).getNodeName() === tagName)) {
          result = false;
        }
        return null;
      });
      return result;
    }
    // 切换tag，如blockquote h3等

  }, {
    key: 'toggleBlockTag',
    value: function toggleBlockTag(tagName, range) {
      // 获取选区的顶级元素集合
      var selectedNodes = this.getSelectedTopNodes(range);
      if (selectedNodes.length === 0) {
        return;
      }
      if (this.detectHasSurrounded(selectedNodes, tagName)) {
        this.removeSurroundBlockTag(selectedNodes, tagName, range);
      } else {
        this.surroundBlockTag(selectedNodes, tagName, range);
      }
    }
    // 取消顶级的tag，如取消引用和标题

  }, {
    key: 'removeSurroundBlockTag',
    value: function removeSurroundBlockTag(nodes, tagName) {
      var editor = this.editor;
      var selection = editor.selection;
      var placeHolder = this.newPlaceHolder();
      $(nodes[0]).before(placeHolder);
      var firstNode = void 0;
      var lastNode = void 0;

      var newContent = void 0;
      if (['PRE', 'BLOCKQUOTE'].indexOf(tagName) > -1) {
        // 引用的处理

        // 遍历每一个top container
        nodes.map(function (node) {
          node = $(node);
          if (node.getNodeName() === 'BLOCKQUOTE') {
            var children = node.children();
            children.forEach(function (child) {
              node.before($(child));
              // 因为dom变化了，所以需要保存新的起止点，用于applyRange
              if (!firstNode) {
                firstNode = child;
              }
              lastNode = child;
            });
            // dom删除
            node.remove();
          }
          return null;
        });
        // selection.applyRange(range);
        selection.applyRange({
          startContainer: firstNode,
          endContainer: lastNode,
          startOffset: 0,
          endOffset: $(lastNode).contents().length
        });
      } else if (/H\d/i.test(tagName)) {
        // 标题的处理

        // 遍历每一个top container
        nodes.map(function (node) {
          node = $(node);
          if (node.getNodeName() === tagName) {
            newContent = $('<p>');
            newContent.append(node.contents());
            node.replace(newContent);
            if (!firstNode) {
              firstNode = newContent[0];
            }
            lastNode = newContent[0];
          } else {
            if (!firstNode) {
              firstNode = node[0];
            }
            lastNode = node[0];
          }
          return null; // array-callback-return
        });

        selection.applyRange({
          startContainer: firstNode,
          startOffset: 0,
          endContainer: lastNode,
          endOffset: $(lastNode).contents().length
        });
      }
      placeHolder.remove();
    }

    // 用tag包含nodes

  }, {
    key: 'surroundBlockTag',
    value: function surroundBlockTag(nodes, tagName) {
      var editor = this.editor;
      var selection = editor.selection;
      var placeHolder = this.newPlaceHolder();
      $(nodes[0]).before(placeHolder);
      var firstNode = void 0;
      var lastNode = void 0;

      // const lastNode = nodes[nodes.length - 1]
      var len = nodes.length;
      var restart = false;
      var newContent = $('<' + tagName + '>');

      // 引用的处理
      if (['PRE', 'BLOCKQUOTE'].indexOf(tagName) > -1) {
        // 遍历每一个top container
        for (var i = 0; i < len; i++) {
          var node = $(nodes[i]);
          // 默认就是最后一个，后面如果修改了dom，需要更改lastNode
          lastNode = node[0];

          if (isGapNode(node[0])) {
            // 如果不是一个空的newContent才插入，比如第一个selected node就是isGapNode的话，此时插入的就是一个空newContent
            if (newContent.html()) {
              placeHolder.replace(newContent);
            }
            newContent = $('<' + tagName + '>');
            restart = true;
          } else if (node.getNodeName() === 'BLOCKQUOTE') {
            // 如果本省就是引用，需要合并到新引用中
            if (restart) {
              node.before(placeHolder);
            }
            restart = false;

            var children = node.children();
            // eslint-disable-next-line no-loop-func
            children.forEach(function (child) {
              // 因为dom变化了，所以需要保存新的起止点，用于applyRange
              if (!firstNode) {
                firstNode = child;
              }
              lastNode = child;
              newContent.append($(child));
            });
            node.remove();
          } else {
            if (restart) {
              node.before(placeHolder);
            }
            restart = false;
            if (node.getNodeName() !== 'P') {
              // 此处有dom变化，所以需要记录range的范围
              var newNode = $('<p>').html(node.html());
              if (!firstNode) {
                firstNode = newNode[0];
              }
              lastNode = newNode[0];
              newContent.append(newNode);
              node.remove();
            } else {
              newContent.append(node);
            }
          }
          if (!firstNode) {
            firstNode = node[0];
          }
        }
        placeHolder.replace(newContent);

        selection.applyRange({
          startContainer: firstNode,
          startOffset: 0,
          endContainer: lastNode,
          endOffset: $(lastNode).contents().length
        });
      } else if (/H\d/i.test(tagName)) {
        // 标题的处理
        nodes.map(function (node) {
          if (isGapNode(node)) {
            restart = true;
            return null;
          }
          if (restart) {
            $(node).before(placeHolder);
          }
          if (['PRE', 'BLOCKQUOTE'].indexOf($(node).getNodeName()) > -1) {
            var contents = $(node).contents();
            contents.forEach(function (cnode) {
              newContent = $('<' + tagName + '>');
              newContent.html($(cnode).html() || $(cnode).text());
              placeHolder.before(newContent);
              // save range
              if (!firstNode) {
                firstNode = newContent[0];
              }
            });
          } else {
            newContent = $('<' + tagName + '>');
            newContent.html($(node).html() || $(node).text());
            placeHolder.before(newContent);
          }
          // remove self
          $(node).remove();

          // save range
          if (!firstNode) {
            firstNode = newContent[0];
          }
          lastNode = newContent[0];
          return null;
        });

        placeHolder.remove();
        selection.applyRange({
          startContainer: firstNode,
          startOffset: 0,
          endContainer: lastNode,
          endOffset: $(lastNode).contents().length
        });
      }
    }
  }]);
  return domselection;
}();

var UA$1 = navigator.userAgent;
var Detector = {
  isMozilla: function isMozilla() {
    return $('body').hasClass('mozilla') || UA$1.match(/(?:firefox|fxios)\/(\d+)/);
  },
  lessThanIE8: function lessThanIE8() {},
  isEdge: function isEdge() {
    var reg = /Edge/;
    return reg.test(UA$1);
  },
  // 是否 webkit
  isWebkit: function isWebkit() {
    var reg = /webkit/i;
    return reg.test(UA$1);
  },
  // 是否 IE
  isIE: function isIE() {
    return $('body').hasClass('ie') || 'ActiveXObject' in window;
  },
  canPasteImage: function canPasteImage() {
    return window.navigator.userAgent.toLowerCase().indexOf('chrome') > 0 || window.navigator.userAgent.toLowerCase().indexOf('chromium');
  },
  canUseSelection: function canUseSelection() {},
  canInsertHTML: function canInsertHTML() {},
  isMac: function isMac() {
    return (/(MacPPC|MacIntel|Mac_PowerPC|Macintosh|(Mac\sOS\sX))/.test(UA$1)
    );
  }
};

var Logger$2 = Log('Selection');

var Selection = function () {
  function Selection(editor) {
    classCallCheck(this, Selection);

    this.editor = editor;
    this.currentRange = null;
    this.doms = new domselection(editor);
  }
  // 获取 当前range 对象


  createClass(Selection, [{
    key: 'getRange',
    value: function getRange() {
      return this.currentRange;
    }
  }, {
    key: 'isCollapsed',
    value: function isCollapsed() {
      return this.currentRange.collapsed;
    }

    // 获取选取长度

  }, {
    key: 'getSelectionLength',
    value: function getSelectionLength() {
      return this.currentRange.endOffset - this.currentRange.startOffset;
    }
  }, {
    key: 'isSelectionInEditor',
    value: function isSelectionInEditor() {
      var _range = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getRange();

      var editor = this.editor;
      var $editElem = editor.$editElem;

      // 判断选区内容是否在编辑内容之内
      var $containerElem = this.getSelectionContainerElem(_range);

      if (!$containerElem) {
        return false;
      }
      if ($editElem.isContain($containerElem)) {
        return true;
      }
      return false;
    }

    /*
       * 设置rang对象或者保存当前range对象
       * */

  }, {
    key: 'saveRange',
    value: function saveRange(_range) {

      if (_range) {
        // 保存已有选区
        this.currentRange = _range;
        return;
      }

      // 获取当前的选区
      var selection = window.getSelection();
      // const selection = rangy.getSelection($editElem[0]);
      if (selection.rangeCount === 0) {
        return;
      }
      _range = selection.getRangeAt(0);
      // 判断选区内容是否在编辑内容之内
      if (this.isSelectionInEditor(_range)) {

        this.currentRange = _range;
      }
    }
    // 备份选区

  }, {
    key: 'backupRange',
    value: function backupRange(range) {

      if (!range) {
        range = this.currentRange;
      }

      var editor = this.editor;
      var $editElem = editor.$editElem;

      var doms = this.doms;

      var startContainer = range.startContainer;
      var startOffset = range.startOffset;

      var endContainer = range.endContainer;
      var endOffset = range.endOffset;
      if (startContainer === endContainer && startOffset === endOffset) ;else {
        // insert placeholder
        $(startContainer).before(doms.newPlaceHolder());
        $(endContainer).after(doms.newPlaceHolder());
      }
      var backupElemTmp = editor.$editElem.clone();
      // clear the placeholder
      $editElem.find('.' + CSS.PLACE_HOLDER).remove();

      return {
        collapsed: range.collapsed,
        backupElem: backupElemTmp,
        startOffset: range.startOffset,
        endOffset: range.endOffset,
        startContainer: $(range.startContainer).clone(),
        endContainer: $(range.endContainer).clone()
      };
    }
  }, {
    key: 'applyRange',
    value: function applyRange(rangeBackup) {

      var editor = this.editor;
      var $editElem = editor.$editElem;
      var newRange = document.createRange();
      // const newRange = rangy.createRange();
      if (!rangeBackup || !rangeBackup.startContainer && !rangeBackup.endContainer) {
        newRange.selectNodeContents($editElem[0]);
        return;
      }
      /* eslint-disable no-empty */
      try {
        if (rangeBackup.startContainer) {
          newRange.setStart(rangeBackup.startContainer, rangeBackup.startOffset || 0);
        } else {
          newRange.setStart(rangeBackup.endContainer, 0);
        }
      } catch (e1) {}

      try {
        if (rangeBackup.endContainer) {
          newRange.setEnd(rangeBackup.endContainer, rangeBackup.endOffset || 0);
        } else {
          newRange.setEnd(rangeBackup.startContainer, $(rangeBackup.startContainer).contents().length);
        }
      } catch (e2) {}

      // try {
      //   rangy.getSelection(window).setSingleRange(newRange);
      // } catch (e3) {}
      /* eslint-disable no-empty */
      this.saveRange(newRange);
      this.restoreSelection();
    }

    // 选区的 $Elem

  }, {
    key: 'getSelectionContainerElem',
    value: function getSelectionContainerElem() {
      var range = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.currentRange;

      return this.doms.getSelectionContainerElem(range);
    }
  }, {
    key: 'getSelectionStartElem',
    value: function getSelectionStartElem() {
      var range = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.currentRange;

      return this.doms.getSelectionStartElem(range);
    }

    // 获取选区所在的最后一个元素

  }, {
    key: 'getSelectionEndElem',
    value: function getSelectionEndElem() {
      var range = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.currentRange;

      return this.doms.getSelectionEndElem(range);
    }

    // 获取当前选区所在的最顶层的元素

  }, {
    key: 'getSelectionEndTopContainerElem',
    value: function getSelectionEndTopContainerElem() {
      return this.doms.getSelectionEndTopContainerElem(this.currentRange);
    }

    // 选中当前光标所在的P标签

  }, {
    key: 'getCurrentParagraph',
    value: function getCurrentParagraph() {
      var range = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.currentRange;

      return this.doms.getCurrentParagraph(range);
    }
  }, {
    key: 'getTopContainerByNode',
    value: function getTopContainerByNode(node) {
      return this.doms.getTopContainerByNode(node);
    }
    // 获取选中的所有顶部元素

  }, {
    key: 'getSelectedTopElems',
    value: function getSelectedTopElems() {
      var range = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.currentRange;

      return this.doms.getSelectedTopElems(range);
    }

    // 选中区域是否合法可编辑
    // 有些区域可以点击，但是编辑了会出现不可控的效果，这些区域一律禁止编辑好了

  }, {
    key: 'isValidEditSelection',
    value: function isValidEditSelection() {
      var editor = this.editor;
      var range = this.currentRange;
      var elem = range.endContainer;

      if ($(elem).equal(editor.$editElem) || !elem.parentNode) {

        return false;
      }

      return true;
    }
    // 选区是否为空

  }, {
    key: 'isSelectionEmpty',
    value: function isSelectionEmpty() {
      var range = this.currentRange;
      if (range && range.startContainer) {
        if (range.startContainer === range.endContainer) {
          if (range.startOffset === range.endOffset) {
            return true;
          }
        }
      }
      return false;
    }
    // 删除选区内容

  }, {
    key: 'clearRange',
    value: function clearRange() {
      var range = this.getRange();
      if (!range.collapsed) {
        var placeholder = this.doms.newPlaceHolder();
        this.insertElem(placeholder, true);
        this.saveRange();
      }
    }
    // 恢复选区,显示光标

  }, {
    key: 'restoreSelection',
    value: function restoreSelection() {
      var currentRange = this.currentRange;

      var selection = window.getSelection();
      var range = void 0;
      if (selection.rangeCount > 0) {
        range = selection.getRangeAt(0);
      }
      if (range && range.startContainer === currentRange.startContainer && range.endContainer === currentRange.endContainer && range.startOffset === currentRange.startOffset && range.endOffset === currentRange.endOffset) {
        this.saveRange(range);
      } else {
        selection.removeAllRanges();
        selection.addRange(currentRange);
      }

      // 自动滚动到选区位置
      this.scrollToRange();

      // fire fox cannot auto focus
      this.editor.focusNative();
    }
    // 根据 $Elem 设置选区

  }, {
    key: 'createRangeByElem',
    value: function createRangeByElem($elem, toStart, isContent) {
      // $elem - 经过封装的 elem
      // toStart - true 开始位置，false 结束位置
      // isContent - 是否选中Elem的内容
      if (!$elem.length) {
        return;
      }
      var elem = $elem[0];
      // const range = rangy.createRange();
      var range = document.createRange();
      if (isContent) {
        range.selectNodeContents(elem);
      } else {
        range.selectNode(elem);
      }
      // range.collapseBefore(elem)
      if (typeof toStart === 'boolean') {
        range.collapse(toStart);
      }

      // 存储 range
      this.saveRange(range);
    }
    // eslint-disable-next-line class-methods-use-this,no-unused-vars

  }, {
    key: 'scrollToRange',
    value: function scrollToRange(range) {}
    // if (!range) {
    //   range = this.currentRange;
    // }
    // const editor = this.editor;
    // let start = range.startContainer;
    // let end = range.endContainer;
    // // console.log('scrollTop::start::end',start,end)
    // if (start.nodeType === NODETYPE.TEXT_NODE) {
    //   start = start.parentNode;
    // }
    // if (end.nodeType === NODETYPE.TEXT_NODE) {
    //   end = end.parentNode;
    // }
    // if (!start.getBoundingClientRect || !end.getBoundingClientRect) return;
    // // 注意如果元素本身是display:none的话，getBoundingClientRect方法获取到的结果是0，所以不能准确获取display:none的元素的数据
    // let isVisible = false;
    // try {
    //   const style = window.getComputedStyle(this.getSelectionContainerElem()[0]);
    //   isVisible = !(style.display === 'none');
    // } catch (e) {}
    // if (!isVisible) { return; }
    // const startRect = start.getBoundingClientRect();
    // const endRect = end.getBoundingClientRect();
    // const top = startRect.top < endRect.top ? startRect.top : endRect.top;
    // const bottom = startRect.bottom > endRect.bottom ? startRect.bottom : endRect.bottom;

    // const editElem = editor.$editElem[0];
    // const clientH = editElem.clientHeight;
    // const rect = editElem.getBoundingClientRect();
    // let verticalDiff = 0;

    // // 不在可视范围内
    // if ((top + 100) > rect.bottom) {
    //   // 给一个元素设置超过本身scrollH的scrollTop，会默认滚动到底部
    //   verticalDiff = (bottom - rect.bottom) + (clientH / 2);
    // } else if ((bottom - 100) < rect.top) {
    //   // 给一个元素设置一个负值的scrollTop，会默认滚动到顶部
    //   verticalDiff = -((rect.top - bottom) + (clientH / 2));
    // }

    // if (verticalDiff !== 0) {
    //   Logger('scrollToRange::', top, bottom, rect, editElem.scrollTop, verticalDiff);
    //   editElem.scrollTop += verticalDiff;
    // }

    // TODO delete

  }, {
    key: 'insertNode',
    value: function insertNode(node) {
      var range = this.currentRange;
      range.insertNode(node);
    }
  }, {
    key: 'getTextNodes',
    value: function getTextNodes(elem) {
      return this.doms.getTextNodes(elem[0]);
    }
  }, {
    key: 'selectNodeContents',
    value: function selectNodeContents(node) {
      var range = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.createRange();
      var collapse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (range) {
        range.selectNodeContents(node);
        if (typeof collapse === 'boolean') {
          range.collapse(collapse);
        }
        this.saveRange(range);
        this.restoreSelection();
        // @getSelection()?.setSingleRange(range)
      }
    }

    // 选中全部节点

  }, {
    key: 'selectElem',
    value: function selectElem($elem) {
      var range = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.createRange();

      if (range) {
        range.selectNode($elem[0]);
        this.saveRange(range);
        this.restoreSelection();
        // @getSelection()?.setSingleRange(range)
      }
    }

    // 设置光标

  }, {
    key: 'setCursorInElem',
    value: function setCursorInElem($elm) {
      this.createRangeByElem($elm, false, true);
      this.restoreSelection();
    }
  }, {
    key: 'setCursorBeforeElem',
    value: function setCursorBeforeElem($elem) {
      this.createRangeByElem($elem, true, true);
      this.restoreSelection();
    }
  }, {
    key: 'setCursorAfterElem',
    value: function setCursorAfterElem($elem) {
      this.createRangeByElem($elem, false, false);
      this.restoreSelection();
    }
    // 光标是否在图片或者视屏里

  }, {
    key: 'isInsideMediaBox',
    value: function isInsideMediaBox() {
      if (!this.currentRange) return false; // 如果没有光标，返回false
      var $rangEndTopElem = this.getSelectionEndTopContainerElem();
      // 为了兼容原来的文章能继续编写，所以只能区别对待，不能统一一个Class名字
      return $rangEndTopElem.hasClass(CSS.IMG_CONTAINER) || $rangEndTopElem.hasClass(CSS.VIDEO_CONTAINER);
    }
    // 光标是否在图片或者视屏的标题里

  }, {
    key: 'isInMediaCaption',
    value: function isInMediaCaption() {
      var $editElem = this.editor.$editElem;
      var $rangContainer = this.getSelectionContainerElem();
      var classNames = CSS.IMG_TITLE + ' ' + CSS.VIDEO_DESCRIPTION;
      var result = !!$rangContainer.findReverse(classNames, $editElem);
      return result;
    }
    // 跳至上一行

  }, {
    key: 'jumpToPreLine',
    value: function jumpToPreLine(elem) {
      var preElem = elem.pre();
      if (preElem.getNodeName() !== 'P') {
        preElem = $('<p><br></p>');
        elem.before(preElem);
      } else if (preElem.text() === '') {
        preElem.html('<br>');
      }
      this.setCursorInElem(preElem);
    }
    // 跳至下一行

  }, {
    key: 'jumpToNextLine',
    value: function jumpToNextLine(elem) {
      var nextElem = elem.next();
      // 后面没有元素或者不是P，均新增一行
      if (nextElem.getNodeName() !== 'P') {
        nextElem = $('<p><br></p>');
        elem.after(nextElem);
      } else if (nextElem.text() === '') {
        nextElem.html('<br>');
      }
      this.setCursorInElem(nextElem);
    }
  }, {
    key: 'toggleBlockTag',
    value: function toggleBlockTag(tagName) {
      var range = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.currentRange;

      this.doms.toggleBlockTag(tagName, range);
    }
    // 当前选区是否包含了link元素

  }, {
    key: 'hasSelectLinkElem',
    value: function hasSelectLinkElem() {
      var linkElem = this.getCurrentLinkElem();
      if (linkElem.data('fake')) {
        return false;
      }
      return true;
    }
  }, {
    key: 'getCurrentLinkElem',
    value: function getCurrentLinkElem() {
      var rangContainer = this.getSelectionContainerElem();
      var range = this.getRange();
      var docFrag = range.cloneContents() || document.createDocumentFragment();
      var linkElem = $(docFrag).find('a');
      if (rangContainer.getNodeName() === 'A') {
        return rangContainer;
      } else if (linkElem.length > 0) {
        return linkElem;
      }
      // 使用data-fake属性表明这是一个虚构的linkElem，选区目前并没有包含a标签
      return $('<a>').attr('href', '').data('fake', 'true').html($(docFrag).text());
    }
    // 获取当前选区中的链接信息

  }, {
    key: 'getCurrentLinkInfo',
    value: function getCurrentLinkInfo() {
      var linkElem = this.getCurrentLinkElem();
      var linkInfo = {
        url: linkElem.attr('href'),
        text: linkElem.text()
      };

      return linkInfo;
    }

    // 插入 elem

  }, {
    key: 'insertElem',
    value: function insertElem($elem, isCollapsed) {
      var range = this.getRange();
      if (range.insertNode) {
        range.deleteContents();
        range.insertNode($elem[0]);
        // eslint-disable-next-line no-unused-expressions
        isCollapsed && this.setCursorInElem($elem);
      }
    }
    /* 调用这个方法前须确保光标是在p标签中
     * needNewBlankLine 是否需要新空白行（
     * 回车键是需要增加，但是复制和黏贴不需要）
    */

  }, {
    key: 'breakOnePtoTwoP',
    value: function breakOnePtoTwoP(range) {
      var autoFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var needNewBlankLine = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (!range) {
        range = this.getRange();
      }

      if (!range.collapsed) {
        range.deleteContents();
      }
      var curPElem = this.getCurrentParagraph();
      if (curPElem.length === 0) {
        return;
      }

      // 空行不需要截断
      if (curPElem.text().trim() === '') {
        return;
      }
      var lastElement = curPElem.contents().last();
      var textNodes = this.getTextNodes(lastElement);
      if (textNodes && textNodes.length) {
        var textNode = textNodes[textNodes.length - 1];
        range.setEnd(textNode, textNode.length);
      }
      var contents = $(range.cloneContents());
      var newParagraph = $('<p>');
      if (contents.length > 0) {
        newParagraph.append(contents);
      }
      // 如果不需要增加新的空白行，直接return
      if (!needNewBlankLine && newParagraph.html() === '') {
        return;
      }
      range.deleteContents();
      if (curPElem.html() === '') {
        // eslint-disable-next-line no-unused-expressions
        Detector.isIE() ? curPElem.html('') : curPElem.html('<br>');
      }
      if (newParagraph.html() === '') {
        // eslint-disable-next-line no-unused-expressions
        Detector.isIE() ? newParagraph.html('') : newParagraph.html('<br>');
      }
      curPElem.after(newParagraph);
      // eslint-disable-next-line no-unused-expressions
      autoFocus && this.setCursorBeforeElem(newParagraph);
    }
    // 插入html或者text

  }, {
    key: 'insertHtml',
    value: function insertHtml(html) {
      var next = $('<span>').html(html);
      var lastChild = $(next[0].lastChild);
      this.insertElem(next);
      next.unpack();
      this.setCursorAfterElem(lastChild);
    }
  }, {
    key: 'isInHeader',
    value: function isInHeader() {
      var range = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getRange();

      if (!range.collapsed) {
        return false;
      }
      if (range.startOffset === 0) {
        return true;
      }
      return false;
    }
  }, {
    key: 'isInMediaCaptionHeader',
    value: function isInMediaCaptionHeader() {
      var range = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getRange();

      if (!this.isInHeader(range)) {
        return false;
      }
      if (!this.isInMediaCaption()) {
        return false;
      }
      return true;
    }
  }]);
  return Selection;
}();

var KEYCODE = {

  LEFT_KEY: 37,
  UP_KEY: 38,
  RIGHT_KEY: 39,
  DOWN_KEY: 40,
  ESC_KEY: 27,

  C_KEY: 67,
  R_KEY: 82,
  T_KEY: 84,
  Y_KEY: 89, // Y
  Z_KEY: 90, // Z
  S_KEY: 83, // S
  ENTER_KEY: 13, // 回车
  TAB_KEY: 9, // TAB
  BACK_KEY: 8, // 退格
  DEL_KEY: 46 // delete按键
};

// import KeyCode from '@enum/keycode';

function enterKeyHandle(editor) {
  var $editElem = editor.$editElem;
  var selection = editor.selection;

  // 将回车之后生成的非 <p> 的顶级标签，改为 <p>
  function pHandle() {
    // console.log('pHandle:::')
    var $selectionElem = editor.selection.getSelectionContainerElem();
    var $parentElem = $selectionElem.parent();
    if (!$parentElem.equal($editElem)) {
      // 不是顶级标签
      return;
    }
    var nodeName = $selectionElem.getNodeName();
    if (nodeName === 'P') {
      // 当前的标签是 P ，不用做处理
      return;
    }
    if ($selectionElem.text()) {
      // 有内容，不做处理
      return;
    }
    // 插入 <p> ，并将选取定位到 <p>，删除当前标签
    var $p = $('<p>a</p>');
    $p.insertBefore($selectionElem);
    $selectionElem.remove();
    editor.selection.createRangeByElem($p, true, true);
    editor.selection.restoreSelection();
    $p.html('<br>');
  }
  editor.on(EVENT.ENTER_KEY_UP, function (e) {
    pHandle(e);
  });

  // 多媒体元素（图片或者视频）特殊处理
  function mediaHandle(e) {
    // const $rangEndElem = selection.getSelectionEndElem();
    // console.log('mediaHandle:::',$rangEndElem)
    // 图片后面不允许回车
    // 如果是在标题按回车键，在后面新增p标签
    var $rangTopElem = editor.selection.getSelectionEndTopContainerElem();
    if (selection.isInMediaCaption()) {
      // console.log('mediaHandle:::',$rangTopElem)
      selection.jumpToNextLine($rangTopElem);
      e.preventDefault();
    }
    // 如果编辑器第一个元素是一张图片，这时候回车在顶部增加一个p
    if ($rangTopElem.equal($editElem.children().get(0)) && selection.isInsideMediaBox()) {
      var newP = $('<p><br></p>');
      $rangTopElem.before(newP);
      selection.setCursorInElem(newP);
      e.preventDefault();
    }
  }

  // 引用处理
  function blockquoteHandle(e) {
    // shift+enter的话，不做处理
    if (e.shiftKey) {
      return true;
    }
    var $rangEndTopElem = selection.getSelectionEndTopContainerElem();
    if ($rangEndTopElem.getNodeName() === 'BLOCKQUOTE') {
      var paragraphs = $rangEndTopElem.children();
      var curPElem = selection.getCurrentParagraph();
      // 最后一个空P标签，就跳出到新一行
      if (curPElem.equal(paragraphs.last()) && curPElem.text().trim() === '') {
        selection.jumpToNextLine($rangEndTopElem);
        curPElem.remove();
        // 如果是空引用直接删除
        if ($rangEndTopElem.children().length === 0) {
          $rangEndTopElem.remove();
        }
      } else {
        selection.breakOnePtoTwoP(null, true);
      }
      e.preventDefault();
      return false;
    }
    return true;
  }
  // 标题处理,标题回车默认产生div，不能忍
  // function hTitlehandle(e) {
  //   const $selectionElem = selection.getSelectionContainerElem();
  //   if (/H\d/i.test($selectionElem.getNodeName())) {
  //     e.preventDefault();
  //     const newP = $('<p><br></p>');
  //     $selectionElem.after(newP);
  //     selection.setCursorInElem(newP);
  //   }
  // }
  editor.on(EVENT.ENTER_KEY_DOWN, function (e) {
    mediaHandle(e);
    blockquoteHandle(e);
    // hTitlehandle(e);
    // codeHandle(e)
  });
}

// import KeyCode from '@enum/keycode';

var Logger$3 = Log('DeletekeyHandle');
function deleteKeyHandle(editor) {
  var $editElem = editor.$editElem;
  var selection = editor.selection;

  var emptyHtml = ['', '<br>', '<p><br></p>', '<p></p><br>'];
  // 确保不会被删除过头，保证有个<p><br></p>
  function ensureLastElem() {
    var $p = void 0;
    // const text = $editElem.text().toLowerCase().trim()
    var html = $editElem.html().toLowerCase().trim();
    // console.log('ensureLastElem::',html)
    // firefox 时用 html === '<br>' 判断，其他用 !html 判断
    if (emptyHtml.indexOf(html) > -1) {
      // 内容空了
      $p = $('<p><br></p>');
      $editElem.html(''); // 一定要先清空，否则在 firefox 下有问题
      $editElem.append($p);
      editor.selection.setCursorInElem($p);
    }
  }
  editor.on(EVENT.DEL_KEY_DOWN, function (e) {
    selection.saveRange(); // force save for getting the precise selection

    var targetElem = selection.getSelectionEndElem();
    var topElem = selection.getSelectionEndTopContainerElem();
    // 光标在标题头部的话，不允许删除
    if (selection.isInMediaCaptionHeader()) {
      e.preventDefault();
      return;
    }
    // 多媒体元素（图片或者视频）标题不能单独删除
    if (selection.isInMediaCaption()) {
      var text = targetElem.html();
      var selectionLen = selection.getSelectionLength();
      if (text.length <= 1 || selectionLen === text.length) {
        targetElem.html('');
        e.preventDefault();
      }
      return;
    }

    // 开头在标题内，却又选中了其他元素的情况，咔嚓，只选中标题
    var $rangeStartElem = selection.getSelectionStartElem();
    var classNames = CSS.IMG_TITLE + ' ' + CSS.VIDEO_DESCRIPTION;
    var captionElem = $rangeStartElem.findReverse(classNames, $editElem);
    if (captionElem) {
      // const placeHolder = selection.doms.newPlaceHolder();
      // captionElem.append(placeHolder);
      var range = selection.getRange();
      // const lastElm = placeHolder.preNode();
      range.setEnd(captionElem[0], captionElem.contents().length);
      range.deleteContents();
      // placeHolder.remove();
      // eslint-disable-next-line
      captionElem.html(captionElem.html().trim().replace('\"', ''));

      setTimeout(function () {
        selection.setCursorInElem(captionElem);
      }, 0);
      e.preventDefault();
      return;
    }

    // 删除多媒体元素（图片或者视频）的同时删除标题
    // Logger('DEL_KEY_DOWN::', selection.getSelectionEndTopContainerElem())
    if (selection.isInsideMediaBox()) {
      var $mediaElem = topElem;
      var index = $mediaElem.data('index');
      var imgUploader = editor.imgUploader;
      imgUploader.uploadDataCache[index] = null; // clear cache
      $mediaElem.remove();
      e.preventDefault();
      return;
    }

    // 最后处理这种情况
    var txtHtml = $editElem.html().toLowerCase().trim();
    if (emptyHtml.indexOf(txtHtml) > -1) {
      // 最后剩下一个空行，就不再删除了
      e.preventDefault();
    }
  });

  editor.on(EVENT.DEL_KEY_UP, ensureLastElem);
}

// import $ from '@util/dom';
// import KeyCode from '@enum/keycode';

function tabKeyHandle(editor) {
  // const $editElem = editor.$editElem;

  editor.on(EVENT.TAB_KEY_DOWN, function (e) {
    if (!editor.cmd.queryCommandSupported('insertHTML')) {
      // 必须原生支持 insertHTML 命令
      e.preventDefault();
      return;
    }
    var $selectionElem = editor.selection.getSelectionContainerElem();
    if (!$selectionElem) {
      return;
    }
    var $parentElem = $selectionElem.parent();
    var selectionNodeName = $selectionElem.getNodeName();
    var parentNodeName = $parentElem.getNodeName();

    if (selectionNodeName === 'CODE' && parentNodeName === 'PRE') {
      // <pre><code> 里面
      editor.cmd.exec('insertHTML', '    ');
    } else {
      // 普通文字
      editor.cmd.exec('insertHTML', '&nbsp;&nbsp;&nbsp;&nbsp;');
    }

    e.preventDefault();
  });
}

/*
    粘贴信息的处理
*/

function checkPastedImage(editor) {
  var $editElem = editor.$editElem;
  var selection = editor.selection;
  var cmd = editor.cmd;

  var needToUploadingImgs = $editElem.find('.need-to-insert-img');
  needToUploadingImgs.forEach(function (node) {
    var $elem = $(node);
    var $topContainer = selection.getTopContainerByNode(node);
    if (!$elem.parent().equal($editElem)) {
      $topContainer.after($elem);
    }
    var dataUrl = $elem.data('src');
    // console.log('checkPastedImage::', dataUrl);
    if (dataUrl.substring(0, 5) === 'data:') {
      cmd.exec('insertImg', { url: dataUrl, file: dataURI2Blob(dataUrl), $imgPlaceHolderElem: $elem });
    } else {
      cmd.exec('insertImg', { url: dataUrl, $imgPlaceHolderElem: $elem });
    }
  });
}

function changeNBSPSpace(html) {
  if (!html) {
    return '';
  }
  // Use new replace rule, old replace rule here for removing html tag is useless now.
  html = html.replace(/&nbsp;/g, ' ').replace(/[ ]{2}/gi, '&nbsp; ');
  return html;
}

/**
 * 这个函数主要是清洗用户复制过来的内容
 *
 * @param {*} container
 */
function getContents(container) {
  var result = [];
  // 如果复制过来的不是html，就当纯文字处理
  if (!container.html().match(/<\w+.*?>/)) {
    // support Array map func since ie9
    result = container.text().split('\n')
    // .map(text => text.trim()) // 空格处理掉会有问题
    .filter(function (text) {
      return text.length > 0;
    });
  } else {
    // 获取container的所有子节点
    var nodes = container.contents();
    var text = ''; // 段落内容
    var needNewLine = false; // 是否需要重新开始一个段落
    nodes.forEach(function (node) {
      var tag = node.tagName || '#text';
      tag = tag.toLowerCase();
      // for block level tags 块级元素直接单独成段
      if (blockTags.indexOf(tag) >= 0) {
        if (text.length > 0) {
          result.push(text);
        }
        getContents($(node)).map(function (content) {
          return result.push(content);
        });
        text = '';
        needNewLine = true;
      } else if (tag === 'br' || tag === 'hr') {
        // for line-level tags
        if (text.length > 0) {
          result.push(text);
        }
        result.push('');
        text = '';
        needNewLine = true;
      } else if (tag === '#text') {
        // for text-nodes
        if (!node.nodeType) {
          node = document.createTextNode(node);
        }
        text += $(node).text().replace(/[\n\t]*/g, '').trim();
      } else if (tag === 'img') {
        // insert image directly
        if (text.length > 0) {
          result.push(text);
        }
        // 用占位符方式处理图片，后续会遍历这个上传以及整理
        text = '<div class="need-to-insert-img" data-src=' + node.src + '>need-to-insert-img</div>';
      } else if (['a', 'b', 'strong', 'i', 'em', 'del', 'strike'].indexOf(tag) > -1) {
        // 需要保留的一些标签，比如链接加粗等
        var isLink = tag === 'a';
        var isBold = ['b', 'strong'].indexOf(tag) > -1;
        var isItalic = ['i', 'em'].indexOf(tag) > -1;
        var isDel = ['del', 'strike'].indexOf(tag) > -1;
        var endTag = '';
        if (isLink) {
          text += '<a href="' + node.href + '" target="_blank">';
          endTag = '</a>';
        } else if (isBold) {
          text += '<b>';
          endTag = '</b>';
        } else if (isItalic) {
          text += '<i>';
          endTag = '</i>';
        } else if (isDel) {
          text += '<del>';
          endTag = '</del>';
        }
        // 标签里还会有标签，比如<a><b></b></a>
        var rest = getContents($(node));
        if (rest.length === 1) {
          text = text + rest[0] + endTag;
        } else if (rest.length > 1) {
          rest[0] = text + rest[0];
          text = rest.pop() + endTag;
          rest.map(function (_text) {
            return result.push(_text);
          });
        }
      } else {
        // for the inline tags contains block tags 其他的一些标签处理
        var _rest = getContents($(node));
        if (_rest.length === 1) {
          text += _rest[0];
        } else if (_rest.length > 1) {
          _rest[0] = text + _rest[0];
          text = _rest.pop();
          _rest.map(function (_text) {
            return result.push(_text);
          });
        }
      }
    });
    if (text.length > 0) {
      result.push(text);
    }
    if (result.length > 1 && needNewLine) {
      result.push('');
    }
  }
  return result;
}

var Logger$4 = Log('PasteHandle');

function createHiddenEditable() {
  return $('<div>').attr('contenteditable', true).attr('aria-hidden', true).attr('tabindex', -1).css('position', 'fixed').css('overflow', 'hidden').css('left', '-10000px');
}

function dataURLtoBlob(dataURL, sliceSize) {
  // eslint-disable-next-line
  var b64Data, byteArray, byteArrays, byteCharacters, byteNumbers, contentType, i, m, offset, ref, slice;
  if (sliceSize == null) {
    sliceSize = 512;
  }
  // eslint-disable-next-line
  m = dataURL.match(/^data\:([^\;]+)\;base64\,(.+)$/);
  if (!m) {
    return null;
  }
  // eslint-disable-next-line
  ref = m, m = ref[0], contentType = ref[1], b64Data = ref[2];
  byteCharacters = atob(b64Data);
  byteArrays = [];
  offset = 0;
  while (offset < byteCharacters.length) {
    slice = byteCharacters.slice(offset, offset + sliceSize);
    byteNumbers = new Array(slice.length);
    i = 0;
    while (i < slice.length) {
      byteNumbers[i] = slice.charCodeAt(i);
      i++;
    }
    byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
    offset += sliceSize;
  }
  return new Blob(byteArrays, {
    type: contentType
  });
}

function pasteHandle(editor) {
  var $editElem = editor.$editElem,
      selection = editor.selection;

  function insertPasteContents(clipContent) {
    if (clipContent) {
      var _ret = function () {
        // 清空选区
        selection.clearRange();
        var needCheckForDataURI = false; // 是否有图片
        var container = $('<div>').html(clipContent);

        var imgs = container.find('img');
        if (imgs.length) {
          needCheckForDataURI = true;
        }
        // 获取格式化后的html/text
        var contents = getContents(container);

        var currentContainer = selection.getSelectionEndTopContainerElem();
        var newParagraph = $('<p><br></p>');
        var nodeName = currentContainer.getNodeName();

        // 如果是在blockquote和h1/2/3上复制，简单处理，只取文字 TODO: 需要优化
        if (nodeName === 'BLOCKQUOTE' || /H\d/i.test(nodeName)) {
          clipContent = $('<div>').html(clipContent).text();
          selection.insertHtml(clipContent);
          return {
            v: void 0
          };
        }
        // 异常情况
        if (currentContainer.equal(editor.$editElem)) {
          currentContainer.append(newParagraph);
          currentContainer = newParagraph;
          selection.setCursorInElem(newParagraph);
        } else if (isGapNode(currentContainer) || nodeName !== 'P') {
          currentContainer.after(newParagraph);
          currentContainer = newParagraph;
          selection.setCursorInElem(currentContainer);
        }

        var firstNode = contents.shift();

        /* 复制的首行处理，首行是需要插入到光标处的 begin */
        selection.insertHtml(firstNode);
        /* 复制的首行处理，首行是需要插入到光标处的 end */

        var restNodes = [];

        var lastNode = currentContainer;
        var node = void 0;
        for (var i = contents.length - 1; i >= 0; i--) {
          node = contents[i];
          if (node && node.length > 0) {
            node = $('<p>').html(changeNBSPSpace(node));
            if (lastNode === currentContainer) {
              // 第一次进入循环，也是除了首行外第一次添加复制内容
              selection.breakOnePtoTwoP(null, false, false); // 这时候需要把一段P切成两段，在两端之间插入黏贴内容
              lastNode = node;
            }
            if (node.html().trim() !== '') {
              currentContainer.after(node);
              /* eslint-disable no-loop-func */
              node.find('.need-to-insert-img').forEach(function (div) {
                div = $(div);
                node.after(div);
              });
              /* eslint-disable no-loop-func */
            }
          }
        }
        /* eslint-disable arrow-body-style */

        if (restNodes.length) {
          restNodes.map(function (item) {
            return lastNode.append($(item));
          });
          node = restNodes[0];

          selection.selectNodeContents(node, null, true);
          /* eslint-disable arrow-body-style */
        } else if (lastNode !== currentContainer) {
          // 复制的内容多余一个节点时需要定位到最后一个元素
          // move the cursor to the bottom of pasted contents
          // node = document.createTextNode('');

          // lastNode.append($(node));
          // selection.selectNodeContents(node, null, true);
          selection.setCursorInElem(lastNode);
          // DONE
        }

        if (needCheckForDataURI) {
          checkPastedImage(editor);
        }

        if (currentContainer.text() === '') currentContainer.remove();
      }();

      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
    }
  }

  // 使用canvas获取图片blob
  function handleImage(src, callback) {
    var loader = void 0;
    var blob = void 0;
    // eslint-disable-next-line
    if (src.match(/^webkit\-fake\-url\:\/\//)) {
      // You are trying to paste an image in Safari, however we are unable to retieve its data.
      callback(null);
      return null;
    }
    loader = new Image(); // eslint-disable-line
    loader.crossOrigin = 'anonymous';
    loader.onload = function () {
      var dataURL = void 0;
      var canvas = document.createElement('canvas');
      canvas.width = loader.width;
      canvas.height = loader.height;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(loader, 0, 0, canvas.width, canvas.height);
      dataURL = null;
      try {
        dataURL = canvas.toDataURL('image/png');
        blob = dataURLtoBlob(dataURL);
      } catch (error) {} // eslint-disable-line

      callback(blob);
    };
    loader.onerror = function () {

      callback(null);
    };
    loader.src = src;
    return null;
  }
  // 粘贴文字
  $editElem.on('paste', function (e) {
    // force getting the right selection
    selection.saveRange();
    if (e.clipboardData && e.clipboardData.getData || window.clipboardData) {
      var clipboard = e.clipboardData || window.clipboardData;
      var clipboardTypes = [];
      if (clipboard.types) {
        // clipboard.types are not array in IE.
        clipboardTypes = [].map.call(clipboard.types, function (type) {
          return type;
        });
      }
      // Logger('paste::', clipboardTypes, clipboard);
      // 优先选择文件上传会导致从word、excel等office来源 paste 过来的东西变成图片, 所以需要排除clipboardTypes中会有text/rtf类型
      if (clipboardTypes.indexOf('Files') >= 0 && clipboardTypes.indexOf('text/rtf') < 0) {
        // eslint-disable-next-line
        var files = [],
            cFiles = clipboard.files,
            cItems = clipboard.items;
        if (cFiles && cFiles.length) {
          files = [].map.call(cFiles, function (file) {
            return { file: file };
          });
        } else if (cItems && cItems.length) {
          files = [].filter.call(cItems, function (item) {
            return item.kind === 'file';
          }).map(function (item) {
            return { file: item.getAsFile() };
          });
        }
        // Logger('cFiles::', files);
        editor.cmd.exec('insertImgs', { images: files });
      } else if (clipboardTypes.indexOf('image/tiff') > -1) {
        // Get pasted image in Safari.
        // In Safari you will be informed that
        // the pasted content is an image but no access to get it.
        // But we can use Canvas to read the unreadable webkit-fake-url resource HAHAHA.
        // It is magical.
        var hiddenEditor = createHiddenEditable();
        $editElem.after(hiddenEditor);
        hiddenEditor.focus();
        setTimeout(function () {
          var loader = hiddenEditor.find('img')[0];
          if (!loader) {
            $editElem.focus();
            hiddenEditor.remove();
            return;
          }
          // 重新新建Image是为了获取宽高, 因为直接使用loader画，获取宽高有问题
          handleImage(loader.src, function (blob) {
            // 重新获取焦点
            $editElem.focus();
            if (blob) {
              editor.cmd.exec('insertImgs', { images: [{ file: blob }] });
            }
            hiddenEditor.remove();
          });
        }, 0);
        // 这种情况下不要接管paste事件，让系统在hiddenEditor插入一张img
        return true;
      } else {
        var clipContent = void 0;
        if (window.clipboardData) {
          clipContent = clipboard.getData('text');
        } else if (clipboardTypes.indexOf('text/html') > -1) {
          clipContent = clipboard.getData('text/html');
        } else if (clipboardTypes.indexOf('text/plain') > -1) {
          clipContent = (0, _escape2.default)(clipboard.getData('text/plain'));
        }
        if (!clipContent) {
          return false;
        }
        // Remove useless html tags |
        // Improved 20141230 for more body and html tag's attributions and comment tags.
        clipContent = clipContent.replace(/<!DOCTYPE.*?>\n?/gi, '').replace(/\n?<head[ >][\w\W]*?<\/head>\n?/gi, '').replace(/\n?<\/?(body|html|meta)[\w\W]*?>\n?/gi, '').replace(/<!--[\w\W]*?-->/gi, '');

        // 如果是在图片或者视频标题，复制的话就只复制一行文本
        if (selection.isInMediaCaption()) {
          clipContent = $('<div>').html(clipContent).text();
          selection.insertHtml(clipContent);
        } else {
          // DONE 复制的是多行html
          // insertPasteContents(clipContent);
          insertPasteContents(clearDuplicateTag(clipContent));
        }
        // 需要触发变化
        editor.handleHtmlChange(true);
      }
    }
    // 接管paste 事件
    e.preventDefault();
    return false;
  });
}

var Logger$5 = Log('DragHandle');

var dragHandle = function () {
  function dragHandle(editor) {
    classCallCheck(this, dragHandle);

    this.editor = editor;
    this.bindEvent();
  }

  createClass(dragHandle, [{
    key: 'bindEvent',
    value: function bindEvent() {
      var editor = this.editor;
      var $editElem = editor.$editElem;

      $editElem.on('drop', function (ev) {

        $editElem.removeClass('dragging-over');
        var dataTransfer = ev.dataTransfer;
        var dataTransferTypes = [];
        if (dataTransfer.types) {
          // dataTransfer.types are not array in IE.
          dataTransferTypes = [].map.call(dataTransfer.types, function (type) {
            return type;
          });
        }
        if (dataTransfer && dataTransferTypes.indexOf('Files') > -1) {
          var files = [];
          var tFiles = dataTransfer.files || [];
          var len = tFiles.length;
          // tFiles is not a array but a obj has length attr
          for (var i = 0; i < len; i++) {
            var file = tFiles[i];
            if (file) {
              files.push({ file: file });
            }
          }
          editor.cmd.exec('insertImgs', { images: files });
        }
        editor.emit(EVENT.DROP, ev);
        ev.preventDefault();
        $editElem.focus();
      });

      var lastenter = null;
      // 在有子元素的元素dragenter，
      // 会存在多次触发的情况 https://stackoverflow.com/questions/10867506/dragleave-of-parent-element-fires-when-dragging-over-children-elements
      $editElem.on('dragenter', function (ev) {
        lastenter = $(ev.target || ev.srcElement);

        $editElem.addClass('dragging-over');
        editor.emit(EVENT.DRAG_ENTER, ev);
      });
      // dragover也需要阻止默认行为，否则在IE下不会触发drop事件
      // http://www.zhangxinxu.com/wordpress/2011/02/html5-drag-drop-%E6%8B%96%E6%8B%BD%E4%B8%8E%E6%8B%96%E6%94%BE%E7%AE%80%E4%BB%8B/
      $editElem.on('dragover', function (ev) {
        ev.preventDefault();
        return false;
      });
      $editElem.on('dragleave', function (ev) {
        var target = $(ev.target || ev.srcElement);

        if (target.equal(lastenter)) {

          $editElem.removeClass('dragging-over');
          editor.emit(EVENT.DRAG_LEAVE, ev);
          ev.stopPropagation();
          ev.preventDefault();
          return false;
        }
        return true;
      });
    }
  }]);
  return dragHandle;
}();

var Logger$6 = Log('Text');
var DonotHandleKeys = [KEYCODE.DOWN_KEY, // up
KEYCODE.UP_KEY, // down
KEYCODE.LEFT_KEY, // left
KEYCODE.RIGHT_KEY];
// ctr组合件
var DonotHandleKeyCtrl = [KEYCODE.T_KEY, // c+t 新开tab
KEYCODE.R_KEY];

var Text = function () {
  function Text(editor) {
    classCallCheck(this, Text);

    this.editor = editor;
    this.bindEvent();
  }

  createClass(Text, [{
    key: 'bindEvent',
    value: function bindEvent() {
      // 鼠标事件总处理
      this.mouseHandle();
      // 按键总处理
      this.keyHandle();
      // 点击事件处理
      this.clickhande();
      // drag事件处理
      this.dragHandle = new dragHandle(this.editor);
    }
  }, {
    key: 'clickhande',
    value: function clickhande() {
      var editor = this.editor;
      var $editElem = editor.$editElem;
      var selection = editor.selection;

      // 图片整体选择的处理
      // eslint-disable-next-line func-names
      $editElem.on('click', '.' + CSS.IMG_CONTAINER, function (e) {
        var targetElem = $(e.target || e.srcElement);
        // 事件代理的实现上帮this指向了imgContainer
        var imgContainerCaption = this.find('.' + CSS.IMG_TITLE);
        // Logger('图片整体选择的处理::clickhande', targetElem);
        // 不是标题，取消/确认按键 就自动选中整张图片
        if (!imgContainerCaption.equal(targetElem) && !imgContainerCaption.isContain(targetElem)) {

          selection.selectElem($(this).children().first());
        }
      });

      // 视屏整体选择的处理
      // eslint-disable-next-line func-names
      $editElem.on('click', '.' + CSS.VIDEO_CONTAINER, function (e) {
        var targetElem = $(e.target || e.srcElement);
        // 事件代理的实现上帮this指向了videoContainer
        var videoContainerCaption = this.find('.' + CSS.VIDEO_DESCRIPTION);
        // 不是标题，取消/确认按键 就自动选中整张图片
        if (!videoContainerCaption.equal(targetElem) && !videoContainerCaption.isContain(targetElem)) {

          selection.selectElem($(this));
        }
      });
    }

    // 多媒体元素（图片或者视频）两边不允许编辑

  }, {
    key: 'mouseHandle',
    value: function mouseHandle() {
      var _this = this;

      var editor = this.editor;
      var $editElem = editor.$editElem;

      var wrapSave = function wrapSave() {

        _this.saveRangeRealTime();
      };

      $editElem.on('mousedown', function () {
        // mousedown 状态下，鼠标滑动到编辑区域外面，也需要保存选区
        $editElem.on('mouseleave', wrapSave);
      });
      $editElem.on('mouseup', function () {
        // 此处使用异步是保证获取到的range是mouseup之后的range, 不然取到的是上一次的range, 浏览器还没有执行完成默认操作
        setTimeout(function () {
          _this.saveRangeRealTime();
        }, 0);
        // 在编辑器区域之内完成点击，取消鼠标滑动到编辑区外面的事件
        $editElem.off('mouseleave', wrapSave);
      });
    }
  }, {
    key: 'keyHandle',
    value: function keyHandle() {
      var _this2 = this;

      var editor = this.editor;
      var selection = editor.selection;
      var $editElem = editor.$editElem;

      // 按回车建时的特殊处理
      enterKeyHandle(editor);

      // 清空时保留 <p><br></p>
      deleteKeyHandle(editor);

      // 粘贴事件（粘贴文字，粘贴图片）
      pasteHandle(editor);

      // tab 特殊处理
      tabKeyHandle(editor);

      var isRedo = false;
      var isUndo = false;
      var isMac = Detector.isMac();
      // 微软的中文输入法在edge下也是奇葩，正在输入的时候backupRange会有问题
      editor.isCompositionOn = false; // 标识用户是否正在输入
      // let shouldEscape = false;
      $editElem.on('compositionstart', function () {
        editor.isCompositionOn = true;
      });
      $editElem.on('compositionend', function () {
        editor.isCompositionOn = false;
        _this2.triggerHtmlChangeEvent(isRedo, isUndo); // edge下compositionend事件晚于keyup事件，蛋疼
      });

      $editElem.on('keydown', function (e) {

        var keyCode = e.keyCode;
        var ctrKey = isMac ? e.metaKey : e.ctrlKey;
        // // 一些不需处理的按键，已提供给外部绑定事件
        if (DonotHandleKeys.indexOf(keyCode) >= 0) {
          return true;
        }
        // ctr+的按键
        if (ctrKey && DonotHandleKeyCtrl.indexOf(keyCode) >= 0) {
          return true;
        }

        // undo redo
        isUndo = keyCode === KEYCODE.Z_KEY && ctrKey;
        isRedo = keyCode === KEYCODE.Y_KEY && ctrKey;
        if (isUndo) {
          e.preventDefault();
          editor.cmd.exec('undo');
          return false;
        }

        if (isRedo) {
          // Logger('isRedo::', isRedo);
          e.preventDefault();
          editor.cmd.exec('redo');
          return false;
        }

        // DEL_KEY and BACK_KEY aways can do
        if (e.keyCode === KEYCODE.DEL_KEY || e.keyCode === KEYCODE.BACK_KEY) {
          editor.emit(EVENT.DEL_KEY_DOWN, e);
          return true;
        }

        // 图片只允许标记标题
        if (selection.isInsideMediaBox() && !selection.isInMediaCaption()) {
          // 允许复制黏贴
          if (keyCode === KEYCODE.C_KEY && ctrKey) {
            return true;
          }
          // 图片在最顶部时允许entey key
          if (keyCode === KEYCODE.ENTER_KEY) {
            editor.emit(EVENT.ENTER_KEY_DOWN, e);
          }
          e.preventDefault();
          return false;
        }

        if (e.keyCode === KEYCODE.ENTER_KEY) {
          editor.emit(EVENT.ENTER_KEY_DOWN, e);
          return true;
        }
        if (e.keyCode === KEYCODE.TAB_KEY) {
          editor.emit(EVENT.TAB_KEY_DOWN, e);
        }
        return true;
      });

      $editElem.on('keyup', function (e) {
        var keyCode = e.keyCode;

        // 告知外界内部有keyup事件
        editor.emit(EVENT.KEY_UP, e);

        if (keyCode === KEYCODE.DEL_KEY || e.keyCode === KEYCODE.BACK_KEY) {
          editor.emit(EVENT.DEL_KEY_UP, e);
        }

        if (keyCode === KEYCODE.ENTER_KEY) {
          editor.selection.scrollToRange(); // 保证如果光标在最后一行的话，不会被淹没
          editor.emit(EVENT.ENTER_KEY_UP, e);
          // 强制保存快照
          editor.emit(EVENT.CAPTRUE);
        }
        // 按键后保存, 实时保存选取
        _this2.saveRangeRealTime();

        _this2.triggerHtmlChangeEvent(isRedo, isUndo);
      });
    }
  }, {
    key: 'triggerHtmlChangeEvent',
    value: function triggerHtmlChangeEvent(isRedo, isUndo) {
      var editor = this.editor;
      // 触发HTML_CONTENT_CHANGE事件
      if (!editor.isCompositionOn && !isRedo && !isUndo) {
        editor.handleHtmlChange(true);
      }
    }
  }, {
    key: 'saveRangeRealTime',
    value: function saveRangeRealTime() {
      var editor = this.editor;
      editor.selection.saveRange();
    }
  }]);
  return Text;
}();

/* eslint-disable object-shorthand */

var Logger$7 = Log('History');

var history = function () {
  function history(editor) {
    var _this = this;

    classCallCheck(this, history);

    this.editor = editor;
    this.curPos = -1; // 当前快照位置
    this.snapshootArray = []; // 快照数组
    this.MAX_HISTORY_LENGTH = 25;
    // 保存最原始记录, range有可能会初始化错误
    if (editor.selection.getRange()) {
      this.capture();
    }
    // 强制保存快照
    editor.on(EVENT.CAPTRUE, function () {
      _this.capture();
    });
    // 有变化就尝试拍照
    // editor.on(EVENT.HTML_CONTENT_CHANGE,()=>{
    //  this.capture()
    // })
  }

  // 拍照


  createClass(history, [{
    key: 'capture',
    value: function capture() {

      var editor = this.editor;
      var selection = editor.selection;
      var snapshootArray = this.snapshootArray;
      var curHtml = editor.getHtml();
      var backupRange = void 0;
      // 非首次拍照
      if (this.curPos >= 0) {
        backupRange = snapshootArray[this.curPos].backupRange;
        // 先要移除placeholder, 才能比较
        var backupElem = backupRange.backupElem.clone();
        backupElem.find('.' + CSS.PLACE_HOLDER).remove();
        var snapHtml = backupElem.html();
        // 如果存照里的HTML和现在的HTML无差别，就不要拍了
        if (snapHtml === curHtml) {
          return;
        }
      }
      // 如果用户正在输入，就不要拍照保存了，不然在edge下有问题
      if (editor.isCompositionOn) {
        return;
      }
      backupRange = selection.backupRange();

      // 裁剪snapshootArray，始终保持拍照时curPos为最后一个
      snapshootArray.length = this.curPos + 1;
      var length = snapshootArray.length;

      if (length >= this.MAX_HISTORY_LENGTH) {
        snapshootArray.shift();
        this.curPos--;
      }
      this.curPos++;
      // let curRangeElm = selection.getSelectionContainerElem()
      // curRangeElm.addClass('dante_cur_range')
      this.snapshootArray.push({
        backupRange: backupRange
      });

      // curRangeElm.removeClass('dante_cur_range')
      // console.log('capture==============', this.curPos, this.snapshootArray)
    }
  }, {
    key: 'undo',
    value: function undo() {
      // console.log('history::undo:::', this.canUndo(), this.curPos, this.snapshootArray);
      if (!this.canUndo()) {
        return;
      }
      this.setEditorContent(this.snapshootArray[--this.curPos]);
    }
  }, {
    key: 'redo',
    value: function redo() {
      // console.log('history::redo:::', this.canRedo(), this.curPos, this.snapshootArray);
      if (!this.canRedo()) {
        return;
      }
      this.setEditorContent(this.snapshootArray[++this.curPos]);
    }
  }, {
    key: 'canUndo',
    value: function canUndo() {
      return this.curPos > 0;
    }
  }, {
    key: 'canRedo',
    value: function canRedo() {
      return this.curPos < this.snapshootArray.length - 1;
    }

    // 绘制编辑区

  }, {
    key: 'setEditorContent',
    value: function setEditorContent(_ref) {
      var backupRange = _ref.backupRange;

      var editor = this.editor;
      var selection = editor.selection;
      var $editElem = editor.$editElem;
      // const doms = selection.doms;
      $editElem.html('');
      var backupElem = backupRange.backupElem;
      $editElem.append(backupElem.clone().children());

      // 查找光标占位符
      var cursorPlaceHolders = $editElem.find('.' + CSS.PLACE_HOLDER);
      var startContainer = void 0;
      var endContainer = void 0;
      var startOffset = 0;
      var endOffset = void 0;
      // 双光标的情况,就是选中了一块区域的情况
      if (cursorPlaceHolders.length > 1) {
        startContainer = cursorPlaceHolders[0].nextSibling;
        endContainer = cursorPlaceHolders[1].previousSibling;
        endOffset = $(endContainer).contents().length;
        // 单光标的情况
      } else if (cursorPlaceHolders.length === 1) {
        startContainer = cursorPlaceHolders[0].previousSibling;
        endContainer = cursorPlaceHolders[0].previousSibling;
        startOffset = backupRange.startOffset;
        endOffset = backupRange.endOffset;
      }

      cursorPlaceHolders.remove();
      // 恢复光标,关于光标range的API https://developer.mozilla.org/zh-CN/docs/Web/API/Range
      selection.applyRange({
        collapsed: backupRange.collapsed, // 判断 Range 起始位置和终止位置是否相同的布尔值
        startContainer: startContainer,
        startOffset: startOffset,
        endContainer: endContainer,
        endOffset: endOffset
      });
    }
  }]);
  return history;
}();

var ERROR = {
  FILE_NOT_EXIST: 1, // 文件不存在
  FILE_NOT_SUPPORT: 2, // 不支持该协议
  FILE_TYPE_ERROR: 3, // 文件类型不对
  FILE_TOO_LARGE: 4, // 文件过大
  NET_WORK_ERROR: 5, // 网络错误
  VIDEO_URL_INVALID: 6, // 视屏链接非法
  OTHER_ERROR: 99 // 其他错误
};

/**
 * 本处不做具体上传工作
 * 仅用于对接外部上传组件
 */

var Logger$8 = Log('ImagUpload');

var ImagUpload = function () {
  function ImagUpload(editor) {
    classCallCheck(this, ImagUpload);

    this.editor = editor;

    this.upLoadId = 0; // 每次从0开始
    this.uploadDataCache = {}; // cache上传的图片，以保证可以重新上传
    // export the success and error api
    editor.imageUploadSuccess = this.imageUploadSuccess.bind(this);
    editor.imageUploadFail = this.imageUploadFail.bind(this);
    editor.on(EVENT.ALLIMG_UPLOADED, function (opts) {
      var imgs = editor.$editElem.find('.' + CSS.IMG_CONTAINER);
      if (imgs.length) {
        editor.selection.setCursorInElem(imgs[imgs.length - 1].querySelectorAll('.' + CSS.IMG_TITLE), true);
      }
      // console.log('IMG_UPLOAD event capture',type,success,error)
    });
  }

  createClass(ImagUpload, [{
    key: 'checkImgFile',
    value: function checkImgFile(file) {
      var editor = this.editor;
      var config = editor.config;
      if (!file) {
        editor.emit(EVENT.ERROR, { code: ERROR.FILE_NOT_EXIST, file: file });
        return false;
      }
      // 文件类型不对
      if (!config.imageTypeReg.test(file.type)) {

        editor.emit(EVENT.ERROR, { code: ERROR.FILE_TYPE_ERROR, file: file });
        return false;
      }

      // 图片过大
      if (file.size > config.fileLimitSize) {

        editor.emit(EVENT.ERROR, { code: ERROR.FILE_TOO_LARGE, file: file });
        return false;
      }
      return true;
    }
  }, {
    key: 'replaceImgUrl',
    value: function replaceImgUrl(elem, url, onloadCb) {
      var editor = this.editor;
      var img = new Image();
      img.onload = function () {
        elem.attr('src', url);
        onloadCb();
        // 触发html变化事件
        editor.handleHtmlChange(true);
      };
      img.src = url;
    }

    // 获取一个新的uploadId

  }, {
    key: 'getNewUploadId',
    value: function getNewUploadId() {
      this.upLoadId = this.upLoadId + 1;
      return this.upLoadId;
    }
  }, {
    key: 'beginUpload',
    value: function beginUpload(_ref, islast) {
      var id = _ref.id,
          file = _ref.file,
          url = _ref.url;

      // console.log('beginUpload::', id);

      // 优先从cache里找数据
      var cache = this.uploadDataCache[id];
      if (cache) {
        file = cache.file;
        url = cache.url;
      } else {
        this.uploadDataCache[id] = {
          id: id,
          file: file,
          url: url
        };
      }
      var editor = this.editor;
      var $editElem = editor.$editElem;
      var $imgContainerElem = $editElem.find('.' + CSS.IMG_CONTAINER + '-' + id);
      if ($imgContainerElem.length) {
        var $loadingPanel = $imgContainerElem.find('.' + CSS.UPLOADING_PANEL);
        var $loadingIcon = $loadingPanel.find('.' + CSS.UPLOADING_ICON);
        var $comfirBtn = $loadingPanel.find('.' + CSS.UPLOAD_RETRY_BTN);
        var $loadingMsg = $loadingPanel.find('.' + CSS.UPLOADING_MSG);
        // console.log($loadingIcon.html())
        $loadingMsg.html('正在上传...');
        $loadingIcon.show();
        $comfirBtn.hide();
        $loadingPanel.show();

        var evenData = {
          id: id,
          file: file,
          url: url,
          islast: islast
        };
        editor.emit(EVENT.IMG_UPLOAD, evenData);
      }
    }
  }, {
    key: 'imageUploadSuccess',
    value: function imageUploadSuccess(_ref2) {
      var id = _ref2.id,
          data = _ref2.data,
          islast = _ref2.islast;

      var editor = this.editor;
      var $editElem = editor.$editElem;
      var $imgContainerElem = $editElem.find('.' + CSS.IMG_CONTAINER + '-' + id);
      if ($imgContainerElem.length) {
        // console.log('imageUploadSuccess::',id,data)
        this.uploadDataCache[id] = null; // clear cache
        var $imgElem = $imgContainerElem.find('.uploaded-img');
        var $loadingPanel = $imgContainerElem.find('.' + CSS.UPLOADING_PANEL);
        this.replaceImgUrl($imgElem, data.url, function () {
          $imgContainerElem.removeAttr('data-index');
          $imgContainerElem.removeAttr('data-uploaddata');
          $imgContainerElem.removeClass(CSS.IMG_CONTAINER + '-' + id);
          $loadingPanel.remove();
          $imgContainerElem.removeClass(CSS.UPLOADING);

          if (islast) {
            editor.emit(EVENT.ALLIMG_UPLOADED);
          }
        });
      }
    }
  }, {
    key: 'imageUploadFail',
    value: function imageUploadFail(_ref3) {
      var id = _ref3.id,
          data = _ref3.data;

      if (data.msg && data.msg.length > 13) {
        data.msg = data.msg.substring(0, 13) + '...'; // 限制显示的信息长度
      }
      var editor = this.editor;
      var $editElem = editor.$editElem;
      var code = data.code;
      var $imgContainerElem = $editElem.find('.' + CSS.IMG_CONTAINER + '-' + id);
      if ($imgContainerElem.length) {
        var $loadingPanel = $imgContainerElem.find('.' + CSS.UPLOADING_PANEL);
        // const $loadingIcon = $loadingPanel.find(`.${CSS.UPLOADING_ICON}`);
        var $comfirBtn = $loadingPanel.find('.' + CSS.UPLOAD_RETRY_BTN);
        var $loadingMsg = $loadingPanel.find('.' + CSS.UPLOADING_MSG);

        $comfirBtn.show();
        // $loadingIcon.hide();
        switch (code) {
          case ERROR.FILE_TOO_LARGE:
            $loadingMsg.html(data.msg || '文件过大');
            $comfirBtn.hide();
            break;
          case ERROR.FILE_TYPE_ERROR:
            $loadingMsg.html(data.msg || '文件类型不对');
            $comfirBtn.hide();
            break;
          case ERROR.NET_WORK_ERROR:
            $loadingMsg.html(data.msg || '网络错误');
            break;
          default:
            $loadingMsg.html(data.msg || '未知错误');
            break;
        }
        // console.log('upload error-----', id);
      }
    }
  }]);
  return ImagUpload;
}();

var event = function () {
  function event() {
    classCallCheck(this, event);

    this.events = {};
  }

  createClass(event, [{
    key: 'on',
    value: function on(eventname, listener) {
      var listeners = this.events[eventname];
      if (!listeners) {
        listeners = [];
        this.events[eventname] = listeners;
      }
      if (listeners.indexOf(listener) < 0) {
        listeners.push(listener);
      }
    }
  }, {
    key: 'off',
    value: function off(eventname, listener) {
      var listeners = this.events[eventname] || [];
      var pos = listeners.indexOf(listener);
      var start = pos > -1 ? pos : 0;
      var end = listener ? 1 : listeners.length;
      listeners.splice(start, end);
    }
  }, {
    key: 'offAll',
    value: function offAll() {
      this.events = {};
    }
  }, {
    key: 'emit',
    value: function emit(eventname) {
      var listeners = this.events[eventname];
      if (listeners) {
        for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          rest[_key - 1] = arguments[_key];
        }

        for (var i = 0; i < listeners.length; i += 1) {
          if (typeof listeners[i] === 'function') {
            listeners[i].apply(null, rest);
          }
        }
      }
    }
  }]);
  return event;
}();

/* 无法完全控制用户的编辑行为，所以需要定期整理dom，使之保持我们所需要的结构 */

var Logger$9 = Log('Clear');

var Clear = function () {
  function Clear(editor) {
    classCallCheck(this, Clear);

    this.editor = editor;
  }
  /**
   * 清除不合理标签，整顿dom，
   * 这个是直接在$editElem上操作的，所以会影响当前用户看到的dom
   * 设置isInit参数，是因为，文章第一次加载在editor的时候也需要清洗dom，这时候还没有初始化光标, range为undefined
   */

  createClass(Clear, [{
    key: 'clearTmpElement',
    value: function clearTmpElement() {
      var isInit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var editor = this.editor;
      var selection = editor.selection;
      var range = selection.getRange();
      var $editElem = editor.$editElem;
      var children = $editElem.contents();
      var changed = false; // 如果有dom变化，需要重新应用range
      children.forEach(function (child) {
        if ($(child).getNodeName() === 'BR') {
          $(child).remove();
          changed = true;
          return;
        }
        if (child.nodeType === 3 || ['B', 'A', 'I', 'STRIKE'].indexOf((child.tagName || '').toUpperCase()) > 0) {
          $(child).wrap($('<p>'));
          changed = true;
        } else if (!isContainer(child) && !isGapNode(child)) {
          // for all others that not a container 不是所允许的标签一律转化成p标签
          if (!isInit && range && range.startContainer === range.endContainer && range.startContainer === child) {
            var content = $(child).contents().unwrap().wrap('<p></p>');
            selection.setCursorInElem(content.parent());
            range = selection.getRange(); // 重新获取
          } else {
            // console.log('clearTmpElement::', child, $(child).contents())
            $('<p></p>').html($(child).html()).insertAfter($(child));
            $(child).remove();
          }
          changed = true;
        }
      });

      // 粗体命令，对于H标签内的内容，浏览器会直接用span包裹并在上style="font-weight: normal;", 要做的好不容易啊，事无巨细的处理
      $editElem.find('[style]').forEach(function (node) {
        var topContainer = selection.getTopContainerByNode(node);
        node = $(node);
        // console.log('clearTmpElement::', node,topContainer)
        if (!topContainer.hasClass(CSS.IMG_CONTAINER) && !topContainer.hasClass(CSS.VIDEO_CONTAINER)) {
          node.removeAttr('style');
        }
        if (node.is('span') && !node.attr('class')) {
          // const content = node.contents()
          // if ( !isInit && range ) {
          //   if (range.startContainer === ) {
          //     range.startContainer = content.first()[0];
          //     range.startOffset = 0
          //   }
          //   if (range.endContainer === content.last()[0]) {

          //   }
          // }
          node.unpack();
          changed = true;
        }
      });
      // eslint-disable-next-line quotes
      $editElem.find("br[type='_moz']").removeAttr('type');

      var pElems = $editElem.find('p');

      pElems.forEach(function (node) {
        node = $(node);

        // Empty Line, remove it.
        if (node.html().length === 0) {
          if (!Detector.isIE()) {
            node.remove();
          }
        } else if (/^\s*$/.test(node.text())) {
          // Line with enters
          if (node.children().length < 1) {
            //  Enters are not BR-node
            if (Detector.isIE()) {
              node.html('');
            } else {
              node.html('<br>');
            }
          }
        }
        // 删除有文字的段落中头部和尾部br
        // const html = node.html();
        // if (html !== '' && html !== '<br>') {
        //   const contents = node.contents();
        //   if (contents.length) {
        //     if (contents.last().getNodeName() === 'BR') {
        //       contents.last().remove();
        //     } else if (contents.first().getNodeName() === 'BR') {
        //       contents.first().remove();
        //     }
        //   }
        // }
      });

      // 初始化时处理链接
      if (isInit) {
        $editElem.find('a').forEach(function (link) {
          link = $(link);
          // 移除空连接
          if (link.text().trim() === '') {
            link.remove();
            return;
          }
          var target = link.attr('target');
          if (target !== '_blank') {
            link.attr('target', '_blank');
          }
        });
      }
      // remove from block elements 需要在p标签处理之后处理，因为block元素里也是p标签
      var blockquoteElems = $editElem.find('blockquote');
      blockquoteElems.forEach(function (blockquote) {
        blockquote = $(blockquote);
        blockquote.contents().forEach(function (child) {
          child = $(child);
          if (child.getNodeName() !== 'P') {
            if (child.text().length < 1 && child.contents() < 1) {
              child.remove();
            } else {
              child.wrap('<p></p>');
            }
          }
        });
        // remove the empty blockquote
        if (blockquote.children().length === 0) {
          blockquote.remove();
        }
      });

      this.clearMediaElement();

      if (!isInit && changed) {
        selection.applyRange(range);
        // selection.scrollToRange(range)
      }
    }
  }, {
    key: 'clearMediaElement',
    value: function clearMediaElement() {

      var editor = this.editor;
      var selection = editor.selection;
      // const selection = editor.selection;
      var $editElem = editor.$editElem;
      $editElem.find('.' + CSS.IMG_CONTAINER).forEach(function (node) {
        var $rangEndElem = selection.getSelectionContainerElem();
        node = $(node);
        var isInBox = $rangEndElem === node; // 如果光标在标签里，定位到标题

        // 图片标签必须要在最顶级元素
        var topContainer = selection.getTopContainerByNode(node[0]);
        if (!topContainer.equal(node)) {
          topContainer.after(node);
        }

        // 如果是没有图片就直接移除掉
        if (node.find('img').length === 0) {
          node.remove();
          return;
        }
        var textCache = []; // 保留里面的不合规的文字信息，并插入到标题中
        // 清洗里面无关的dom
        node.contents().forEach(function (content) {
          content = $(content);
          var tagName = content.getNodeName();
          // 删除br,最后加一个保证只有一个
          if (tagName === 'BR') {
            content.remove();
          } else if (['IMG', 'DIV'].indexOf(tagName) < 0) {
            // <div class="image-caption">﻿﻿﻿﻿﻿﻿</div> 有这种不明字符存在，服了，所以必须trim()
            // eslint-disable-next-line no-unused-expressions
            content.text().length && textCache.push(content.text().trim());
            content.remove();
          }
        });
        // 如果没有图片标题就添加标题
        var captionElem = node.find('.' + CSS.IMG_TITLE);
        if (captionElem.length === 0) {
          captionElem = getImgTitle();
          node.append(captionElem);
        }
        captionElem.before($('<br>'));
        // 恢复不合规的文字
        if (textCache.length) {
          captionElem.html('' + captionElem.html() + textCache.join(''));
        }

        if (isInBox) {
          selection.setCursorInElem(captionElem);
        }
      });

      $editElem.find('.' + CSS.VIDEO_CONTAINER).forEach(function (node) {
        var $rangEndElem = selection.getSelectionContainerElem();
        node = $(node);
        var isInBox = $rangEndElem === node; // 如果光标在标签里，定位到标题

        // 视屏标签必须要在最顶级元素
        var topContainer = selection.getTopContainerByNode(node[0]);
        if (!topContainer.equal(node)) {
          topContainer.after(node);
        }

        // 如果没有播放器的视屏元素直接删除
        if (node.find('.player').length === 0) {
          node.remove();
          return;
        }
        var textCache = []; // 保留里面的不合规的文字信息，并插入到标题中
        // 清洗里面无关的dom
        node.contents().forEach(function (content) {
          content = $(content);
          var tagName = content.getNodeName();
          // 删除br,最后加一个保证只有一个
          if (tagName === 'BR') {
            content.remove();
          } else if (['IMG', 'DIV', 'IFRAME'].indexOf(tagName) < 0) {
            if (content.text().length) {
              textCache.push(content.text().trim());
            }
            content.remove();
          }
        });
        // 如果没有视屏标题就添加标题
        var captionElem = node.find('.' + CSS.VIDEO_DESCRIPTION);
        if (captionElem.length === 0) {
          captionElem = getVideoTitle();
          node.append(captionElem);
        }
        captionElem.before($('<br>'));

        if (textCache.length) {
          captionElem.html('' + captionElem.html() + textCache.join(''));
        }

        if (isInBox) {
          selection.setCursorInElem(captionElem);
        }
      });
    }
    // 清洗html,删除正在上传的图片dom

  }, {
    key: 'getContent',
    value: function getContent() {
      var isInit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var editor = this.editor;
      var $editElem = editor.$editElem;
      if (this.preHtml === editor.getHtml()) {
        return this.editorContent;
      }

      // remove placeholder
      var placeholder = $('.' + CSS.PLACE_HOLDER);
      placeholder.forEach(function (node) {
        node = $(node);
        if (node.html() !== '') {
          node.unpack();
        } else {
          node.remove();
        }
      });

      this.clearTmpElement(isInit);

      // Logger('getContent::after::clearTmpElement',this.getHtml())
      var container = $editElem.clone(true);

      // let contents = container.contents();
      var contents = void 0;

      // Remove Empty Chars in end of paragraphs
      container.find('p').forEach(function (p) {
        var html = p.innerHTML;
        html = html.replace(/\s+$/, '');
        // 如果是有内容的话 删除烦人的 头部和尾部br标签
        if (html !== '<br>') {
          html = html.replace(/^<br>|<br>$/g, '');
        }
        p.innerHTML = html;
      });
      // 处理图片
      container.find('img').forEach(function (image) {
        if (image.src.indexOf('https://math.jianshu.com/math?formula=') !== -1) {
          return;
        }
        var $image = $(image);
        // $image.removeAttr('height').removeAttr('width')
        var src = $image.attr('src') || '';
        var parent = $image.parent();
        // Remove local image and blob file
        if (src.indexOf('file://') > -1 || src.indexOf('blob:') > -1 || src.indexOf('data:') > -1) {
          if ($editElem.equal(parent)) {
            $image.remove();
          } else {
            parent.remove();
          }
          return;
        } else if (src.match(/^http:\/\/(\w+\.)?qpic\.cn/)) {
          var newSrc = src.split('?');
          if (newSrc.length > 1) {
            newSrc[2] = [];
            newSrc[1].split('&').map(function (p) {
              if (p !== 'tp=webp') {
                newSrc[2].push(p);
              }
              return null;
            });
            if (newSrc[2].length > 0) {
              newSrc[1] = newSrc[2].join('&');
              newSrc = newSrc[0] + '?' + newSrc[1];
              $image.attr('src', newSrc);
            }
          }
        }
        // get again
        src = $image.attr('src');

        if (parent.hasClass(CSS.UPLOADING)) {
          // 正在上传的img不需要保存
          parent.remove();
        } else if (!parent.hasClass(CSS.IMG_CONTAINER)) {
          // 一些意外的img全部包裹到正确的img container中
          var $newImgPanel = getImgPanel(src, '', null, null, null, null, null, false);
          if ($editElem.equal(parent)) {
            $image.replace($newImgPanel);
          } else {
            parent.replace($newImgPanel);
          }
        }
      });
      // 处理链接
      container.find('a').forEach(function (link) {
        link = $(link);
        // 移除空连接
        if (link.text().trim() === '') {
          link.remove();
          return;
        }
        var target = link.attr('target');
        if (target !== '_blank') {
          link.attr('target', '_blank');
        }
      });
      // 整理图片
      container.find('.' + CSS.IMG_CONTAINER).forEach(function (imgContainer) {
        var imgCaption = $(imgContainer).find('.' + CSS.IMG_TITLE);
        // 如果图片标题没有文字，直接清空，有可能存在没有标题的情况
        if (imgCaption.length && imgCaption.text().trim() === '') {
          imgCaption.html('');
        }
      });
      // 整理视频
      container.find('.' + CSS.VIDEO_CONTAINER).forEach(function (video) {
        video = $(video);
        video.removeAttr('contenteditable');
        video.removeAttr('flag-generated');
        video.find('.player').remove(); // 视频播放器和视频截图都移除
      });
      // Logger('getContent::after::处理链接',container.html());

      // get again
      contents = container.contents();

      // 去除结尾空行
      for (var i = contents.length - 1; i >= 0; i--) {
        var elem = $(contents[i]);
        if (elem.getNodeName() === 'P' && elem.text().replace(/[\n ]/gi, '').length === 0) {
          elem.remove();
        } else {
          break;
        }
      }

      // 去除开头空行
      for (var _i = 0; _i < contents.length; _i++) {
        var _elem = $(contents[_i]);
        if (_elem.getNodeName() === 'P' && _elem.text().replace(/[\n ]/gi, '').length === 0) {
          _elem.remove();
        } else {
          break;
        }
      }
      // Remove invalid tags inside paragraphs
      contents = container.html();
      // Logger('getContent::after::去除开头空行',container.html());

      // 这里会把非allowTags里的标签去除，比如iframe
      contents = contents.replace(/<(\/?)(.*?)>/gi, function (match, isEnd, tag) {
        tag = tag.trim();
        if (tag.indexOf(' ') > 0) {
          tag = tag.split(' ')[0];
        }
        tag = tag.toLowerCase();
        if (allowTags.indexOf(tag) < 0) {
          return '';
        }
        return match;
      });
      container.html(contents);
      // Logger('getContent::after::去除开头空行',container.html());

      this.preHtml = editor.getHtml();
      this.editorContent = container.html();

      // console.timeEnd('GetContent')

      return this.editorContent;
    }
  }]);
  return Clear;
}();

/* eslint-disable no-useless-escape */

var Config = {
  imageTypeReg: /(.|\/)(jpe?g|png|gif)$/i, // 允许的imgtype
  contentChangeDelay: 500, // contentChange事件触发延时ms 200的话太快了
  content: '<p><br></p>', // editor的初始化content
  autoFillParentSize: true, // 自动撑满父元素
  videoFetchUrl: 'http://www.jianshu.com/videos.json',
  // 长宽大小，前端判断
  fileLimitSize: 2 * 1024 * 1024, // M
  jianshuImgUrlRegex: /^(https?:)?\/\/(([\w-]+\.jianshu\.(io|com))|(jianshu\-(dev\.u|staging)\.qiniudn\.com))\//,
  availableVideoUrlRegex: /^https?:\/\/(?:[\w\.]*?\.(?:youku|tudou|qq|bilibili)\.com|[\w\.-]*?\.acgvideo\.com)\//i
};

var Logger$a = Log('Editor');

var Editor = function (_EventEmitter) {
  inherits(Editor, _EventEmitter);

  function Editor(selector, customConfig) {
    classCallCheck(this, Editor);

    var _this = possibleConstructorReturn(this, (Editor.__proto__ || (0, _getPrototypeOf2.default)(Editor)).call(this));

    if (!selector) {
      throw new Error('please give a valid selector when create Dante Editor');
    }

    _this.selector = selector;
    _this.config = (0, _assign2.default)({}, Config, customConfig || {});
    // 延迟触发onchange事件
    _this.curOnChangeTimeoutId = 0;
    // this._beforeChangeHtml = '';

    // 初始化 DOM
    _this.initDom();

    _this.initSelectionAPI();

    _this.initClear();

    // this.bindEvent();
    _this.initUploaders();

    // 封装 API
    _this.initCommand();
    _this.initText();

    // 初始化选区，将光标定位到内容尾部
    _this.initSelection();

    // 在初始化之后确保存在有效range
    _this.initHistory();

    // 初始化curContent，并且顺便规整下dom
    _this.curContent = _this.clear.getContent(true);

    _this.focusNative();

    return _this;
  }

  createClass(Editor, [{
    key: 'initClear',
    value: function initClear() {
      this.clear = new Clear(this);
    }
  }, {
    key: 'setConfig',
    value: function setConfig(customConfig) {
      this.config = (0, _assign2.default)({}, this.config, customConfig);
    }

    // 由于保存的文章中视频dom没有了iframe元素，初始化时需要修复，html()方法是获取不到iframe的内容的

  }, {
    key: 'rebuildVideo',
    value: function rebuildVideo() {
      var $editElem = this.$editElem;
      $editElem.find('.' + CSS.VIDEO_CONTAINER).forEach(function (node) {
        node = $(node);
        var videoInfo = {};
        videoInfo.id = node.data('video-id') || '';
        videoInfo.url = node.data('video-url') || '';
        videoInfo.provider = node.data('video-provider') || '';
        videoInfo.cover_id = node.data('cover-uuid') || '';
        var playerElem = $(videoMaker(videoInfo));
        node.prepend(playerElem);
      });
    }
  }, {
    key: 'initDom',
    value: function initDom() {
      var config = this.config;
      var selector = this.selector;
      var $editContainerElem = $(selector);
      this.$editContainerElem = $editContainerElem;
      var initContent = clearDuplicateTag(config.content);
      // 编辑区域
      var $editElem = $('<div>' + initContent + '</div>');
      this.$editElem = $editElem;
      this.rebuildVideo();

      $editElem.attr('contenteditable', 'true');

      if (config.autoFillParentSize) {
        $editElem.css('width', '100%').css('height', '100%').css('box-sizing', 'border-box');
      }
      // clear the container
      $editContainerElem.html('');
      $editContainerElem.append($editElem);

      // 是否使用Dante的默认主题，如果你需要使用黑夜模式，估计就不能使默认主题了
      if (config.defaultTheme) {
        $editContainerElem.addClass('dante-editor-container');
        $editElem.addClass('dante-editor');
      }
      // 设置配置的 class
      if (config.editorClass) {
        $editElem.addClass(config.editorClass);
      }
    }
    // 参数needCapture 是否需要发出保存快照事件，因为redo和undo指令是不需要的

  }, {
    key: 'handleHtmlChange',
    value: function handleHtmlChange(needCapture) {
      var _this2 = this;

      // trigger onchange event
      if (this.curOnChangeTimeoutId) {
        clearTimeout(this.curOnChangeTimeoutId);
      }
      this.curOnChangeTimeoutId = setTimeout(function () {
        // 用户正在输入的话，就skip这次保存
        if (_this2.isCompositionOn) {
          return;
        }
        // 出去的内容也保证没有duplicate tag
        var curContent = clearDuplicateTag(_this2.clear.getContent());
        var preContent = _this2.curContent;
        if (curContent === preContent) {
          return;
        }
        // 触发HTML_CONTENT_CHANGE事件

        _this2.curContent = curContent;
        _this2.emit(EVENT.HTML_CONTENT_CHANGE, preContent, curContent);
        if (needCapture) {
          _this2.emit(EVENT.CAPTRUE);
        }
      }, this.config.contentChangeDelay);
    }
    // 封装 command

  }, {
    key: 'initCommand',
    value: function initCommand() {
      this.cmd = new command(this);
    }
    // 封装 selection range API

  }, {
    key: 'initSelectionAPI',
    value: function initSelectionAPI() {
      this.selection = new Selection(this);
    }
  }, {
    key: 'initText',
    value: function initText() {
      this.txt = new Text(this);
    }
  }, {
    key: 'initHistory',
    value: function initHistory() {
      this.history = new history(this);
    }
  }, {
    key: 'initUploaders',
    value: function initUploaders() {
      this.imgUploader = new ImagUpload(this);
    }
    // 初始化选区，将光标定位到内容尾部

  }, {
    key: 'initSelection',
    value: function initSelection() {
      var $editElem = this.$editElem;
      var $children = $editElem.children();
      var selection = this.selection;
      if (!$children.length) {
        // 如果编辑器区域无内容，添加一个空行，重新设置选区
        $editElem.append($('<p><br></p>'));
        this.initSelection();
        return;
      }

      var $first = $children.first();

      try {
        // 如果是图片或者视屏，定位到标题
        if ($first.hasClass(CSS.IMG_CONTAINER)) {
          selection.setCursorInElem($first.find('.' + CSS.IMG_TITLE));
        } else if ($first.hasClass(CSS.VIDEO_CONTAINER)) {
          selection.setCursorInElem($first.find('.' + CSS.VIDEO_DESCRIPTION));
        } else if ($first.getNodeName() === 'P') {
          selection.setCursorInElem($first);
        } else {
          var $newP = $('<p><br></p>');
          $editElem.append($newP);
          selection.setCursorInElem($newP);
        }
      } catch (e) {
        var _$newP = $('<p><br></p>');
        $editElem.append(_$newP);
        selection.setCursorInElem(_$newP);
      }
    }
  }, {
    key: 'getVideoCount',
    value: function getVideoCount() {
      return this.$editElem.find('.' + CSS.VIDEO_CONTAINER).length;
    }
  }, {
    key: 'isUploadingImage',
    value: function isUploadingImage() {

      return this.$editElem.find('.' + CSS.UPLOADING).length > 0;
    }
  }, {
    key: 'getContent',
    value: function getContent() {

      return this.curContent || '';
    }
    // 获取当前选区中的链接信息，插入链接用

  }, {
    key: 'getCurrentLinkInfo',
    value: function getCurrentLinkInfo() {
      return this.selection.getCurrentLinkInfo();
    }
    // 重新聚焦到编辑器, 注意此方法不会重新应用选区

  }, {
    key: 'focusNative',
    value: function focusNative() {
      this.$editElem.focus();
    }
    // 重新聚焦到编辑器, 注意此方法会重新应用选区

  }, {
    key: 'focus',
    value: function focus() {
      this.selection.restoreSelection();
    }
    // 为了和markdown的编辑器统一对外接口

  }, {
    key: 'onEvent',
    value: function onEvent(name, func) {
      this.on(name, func);
    }
  }, {
    key: 'offEvent',
    value: function offEvent(name, func) {
      this.off(name, func);
    }
  }, {
    key: 'exec',
    value: function exec(name, value) {
      return this.cmd.exec(name, value);
    }
  }, {
    key: 'getHtml',
    value: function getHtml() {
      return this.$editElem.html() || '';
    }
  }, {
    key: 'getText',
    value: function getText() {
      return this.$editElem.text() || '';
    }
  }, {
    key: 'getWordNum',
    value: function getWordNum() {
      return this.getText().length;
    }
  }, {
    key: 'hasSelectLink',
    value: function hasSelectLink() {
      return this.selection.hasSelectLinkElem();
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      clearTimeout(this.curOnChangeTimeoutId);
      this.offAll(); // 移除所有事件监听
      this.$editContainerElem = null;
      // this.$editElem.remove();
    }
  }]);
  return Editor;
}(event);

Editor.Events = EVENT;
Editor.Errors = ERROR;
Editor.$ = $; // expose the $

// import 'babel-polyfill'

exports.default = Editor;
//# sourceMappingURL=dante.no.css.js.map

/***/ }),

/***/ "A0uo":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("C871");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./NestLoading.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./NestLoading.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "A6CO":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("iiQK");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./Message.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./Message.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "AW9g":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAWlBMVEUAAAAwiB4wiB4xiB0xjB4xhx4yhx4zjx8xhx0xiR0whx0whx0wiB0xiB1JmyRCiisxiB0wiB4xhx0wiB0xiCE3iSSA/4Awhx0wiB4xhx4wiR4yiSAyih0whx2miU+GAAAAHXRSTlMA85qtKaCAGOxOyPvgwQcL0sWCeC8cAtnOu4phV1lham4AAACRSURBVDjL1c3rCoMwDIbhaKu11jmdhx2/+7/NOdKCoRY2GBs+fxroS0J7YZFg3w3GPGGk75nUhmkVaGzQMnCV4KKgJuHwj+BihDoKIp8FplycShZGQ2uzVecjeW2jbEvS3AM38u5AtdSSzuDC1Q4YKDIAOU8PoBELwmE44wdY8VWwDuhf7xXICkYMScSyJPqJJydOGY+9PtjNAAAAAElFTkSuQmCC"

/***/ }),

/***/ "C871":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "._3ZWln{display:none}._2y-qc{position:absolute;top:0;left:0;height:100%;width:100%;z-index:999}._2y-qc ._25kuI{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}._1aPDY{background-color:#f2f2f2}body.reader-night-mode ._1aPDY{background-color:#3d3d3d}", ""]);

// exports
exports.locals = {
	"loading-panel__none": "_3ZWln",
	"loading-panel": "_2y-qc",
	"center": "_25kuI",
	"loading-panel-has-mask": "_1aPDY"
};

/***/ }),

/***/ "CGNb":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "CW2v":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; /**
                   * Created by mac on 2018/8/14.
                   */


var _Modal = __webpack_require__("/MvA");

var _Modal2 = _interopRequireDefault(_Modal);

var _img_binding_pic = __webpack_require__("S+hs");

var _img_binding_pic2 = _interopRequireDefault(_img_binding_pic);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _reactIntlUniversal = __webpack_require__("cl+9");

var _reactIntlUniversal2 = _interopRequireDefault(_reactIntlUniversal);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__("RH2O");

var _reactRouterDom = __webpack_require__("F8kA");

var _immutable = __webpack_require__("BYKG");

var _immutable2 = _interopRequireDefault(_immutable);

var _actionTypes = __webpack_require__("4HHy");

var _NoAccount = __webpack_require__("72M+");

var _NoAccount2 = _interopRequireDefault(_NoAccount);

var _GlobalAction = __webpack_require__("5Q8M");

var _IconFont = __webpack_require__("z69G");

var _IconFont2 = _interopRequireDefault(_IconFont);

var _GlobalReducer = __webpack_require__("boom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoAccount = (_dec = (0, _reactRedux.connect)(function (state) {
  var globalState = (0, _GlobalReducer.getState)(state);
  return {
    data: globalState.get('account')
  };
}, function (dispatch) {
  return {
    setBindPhoneStatus: function setBindPhoneStatus(status) {
      return dispatch((0, _GlobalAction.setBindPhoneStatus)(status));
    }
  };
}), _dec(_class = function (_Component) {
  (0, _inherits3.default)(NoAccount, _Component);

  function NoAccount() {
    (0, _classCallCheck3.default)(this, NoAccount);
    return (0, _possibleConstructorReturn3.default)(this, (NoAccount.__proto__ || (0, _getPrototypeOf2.default)(NoAccount)).apply(this, arguments));
  }

  (0, _createClass3.default)(NoAccount, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          onModalCancelClick = _props.onModalCancelClick,
          visible = _props.visible,
          data = _props.data;

      return _react2.default.createElement(
        _Modal2.default,
        {
          width: 520,
          visible: visible,
          showFooter: false,
          maskClassName: _NoAccount2.default['mask'],
          modalClassName: _NoAccount2.default['modal'],
          closable: true,
          isMiddle: true,
          title: _reactIntlUniversal2.default.get('phoneModal.bindtitle'),
          onCancel: onModalCancelClick
        },
        _react2.default.createElement(
          'div',
          { className: _NoAccount2.default['content'] },
          _react2.default.createElement(
            'div',
            { className: _NoAccount2.default['left'] },
            _react2.default.createElement('img', { src: _img_binding_pic2.default }),
            _react2.default.createElement(
              'p',
              { className: _NoAccount2.default['content'] },
              _reactIntlUniversal2.default.get('phoneModal.bindtip')
            )
          ),
          _react2.default.createElement(
            'div',
            { className: _NoAccount2.default['right'] },
            _react2.default.createElement(
              'div',
              { className: _NoAccount2.default['item'] },
              _react2.default.createElement(
                'div',
                { className: _NoAccount2.default['item-left'], style: { color: data.mobile_number ? '#2f2f2f' : '' } },
                _react2.default.createElement(_IconFont2.default, { name: 'phone', className: _NoAccount2.default['icon'] + ' ' + (data.mobile_number ? _NoAccount2.default['active'] : '') }),
                data.mobile_number || _reactIntlUniversal2.default.get('phoneModal.nobind')
              ),
              !data.mobile_number && _react2.default.createElement(
                'button',
                {
                  className: _NoAccount2.default['btn'],
                  onClick: function onClick() {
                    _this2.props.setBindPhoneStatus();
                  }
                },
                _reactIntlUniversal2.default.get('phoneModal.clickbind')
              )
            ),
            _react2.default.createElement(
              'div',
              { className: _NoAccount2.default['item'], style: { color: data.mobile_number ? '#2f2f2f' : '' } },
              _react2.default.createElement(
                'div',
                { className: _NoAccount2.default['item-left'] },
                _react2.default.createElement(_IconFont2.default, { name: 'wechat', className: _NoAccount2.default['icon'] + ' ' + (data.wechat ? _NoAccount2.default['active'] : '') }),
                data.wechat || _reactIntlUniversal2.default.get('phoneModal.nobind')
              ),
              !data.wechat && _react2.default.createElement(
                'button',
                {
                  className: _NoAccount2.default['btn'],
                  onClick: function onClick() {
                    var url = window.location.href + '?callback=true';
                    window.location.href = '/users/auth/wechat?can_transfer=true&redirect_url=' + encodeURIComponent(url);
                  }
                },
                ' ',
                _reactIntlUniversal2.default.get('phoneModal.clickbind')
              )
            )
          )
        )
      );
    }
  }]);
  return NoAccount;
}(_react.Component)) || _class);
exports.default = NoAccount;

/***/ }),

/***/ "CyHg":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAABL1BMVEUAAAD/yAD/ygD/yAD/yQD/yQD/0QD/yQD/yQD/yQD/yQD/yQD/yQD/ywD/zAD/ywD/zgD+yQT/yQD/yAD/yQD/yAD/yQD/yQD/yQD/yQD/ygD/yQD/yAD/yAD/yQD/ygD/zQD/yAD/2wD00U//4XT/yQD////YuFz/zQD////uwBn/1QD/yAD////gtiL+/fjnuhrxwA/+/vv9+/LqvBf7xgT++u79+Oj99dP26sL+4nf+zh3uvxL++/D+99v479H+8cH87LPz5K776KH+6Zr+5o7r03v+2lTjwUHlvzf+0jDkuB71wwv3wwn6xgX++eT58tr+88n27Mj67L3+8Lz+7Kvv25X54Ijs1YP+44H223npz3P+4HD+3WXpzGPnxU3+10rmvjLmvCT4yRz+ygqQhZLkAAAALHRSTlMA/Fu7gTkS+PXxuaSIOzcdGjP67uHJtKmbkotvZlRLQyQOB/zm1WNILikYBsDBVmAAAAFrSURBVDjLhdPlcsJQEAXgTZpSrMXdqbd7i7t70bq7vP8z9F7CQALTy/cHMmf3zGRnAkvMZuDT6/n5JuImvwBRv6aAX7GB1Aa/gFXwCrgV2zizzSn4t0KzI3pxzivuaBSJZHDYcIXNYZDYHK4BPn7uA/AL9Lf0WWzV8xfZWDIWq1SvGp23AYsFP1AinciMyunv/sd7975ZSxGq8cNyEaYCVpzKjEeJcvqrQEjqJZ5BtAZgJriFc70sIYV+gv7bCsJcSDuLf9t0vcvWURtSXVmHzKBKyPU5W0fd0r0lpIpJEnuMT5CRQM2FWKoTUqPrMheo7WOvQghJ5vK3d+3OU/F17+BYmZ8KpYdm4TLHLpXK5W9az7uHJ8qBI5yU0/HhmWwYTyfGFlAScYWoGjCiTCdJOpQZVQNOZLRGDYDGKF/NqRqws9N6zLPv08NOb1fmEUTBbVo8m9wCYgQWLIIhDCphg6B8jehie9ESBeYPieVTx9PUohAAAAAASUVORK5CYII="

/***/ }),

/***/ "DM98":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("eQpn");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./TimePublishBuyModal.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./TimePublishBuyModal.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "DUrC":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("Z9oK");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./Loading.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./Loading.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "DYhM":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*!\n *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */@font-face{font-family:FontAwesome;src:url(" + escape(__webpack_require__("cEaC")) + ");src:url(" + escape(__webpack_require__("cmUn")) + "?#iefix&v=4.7.0) format(\"embedded-opentype\"),url(" + escape(__webpack_require__("of+2")) + ") format(\"woff2\"),url(" + escape(__webpack_require__("jNsU")) + ") format(\"woff\"),url(" + escape(__webpack_require__("IMLV")) + ") format(\"truetype\"),url(" + escape(__webpack_require__("Fqd/")) + "#fontawesomeregular) format(\"svg\");font-weight:400;font-style:normal}.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fa-lg{font-size:1.33333em;line-height:.75em;vertical-align:-15%}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-fw{width:1.28571em;text-align:center}.fa-ul{padding-left:0;margin-left:2.14286em;list-style-type:none}.fa-ul>li{position:relative}.fa-li{position:absolute;left:-2.14286em;width:2.14286em;top:.14286em;text-align:center}.fa-li.fa-lg{left:-1.85714em}.fa-border{padding:.2em .25em .15em;border:.08em solid #eee;border-radius:.1em}.fa-pull-left{float:left}.fa-pull-right{float:right}.fa.fa-pull-left{margin-right:.3em}.fa.fa-pull-right{margin-left:.3em}.pull-right{float:right}.pull-left{float:left}.fa.pull-left{margin-right:.3em}.fa.pull-right{margin-left:.3em}.fa-spin{-webkit-animation:fa-spin 2s infinite linear;animation:fa-spin 2s infinite linear}.fa-pulse{-webkit-animation:fa-spin 1s infinite steps(8);animation:fa-spin 1s infinite steps(8)}@-webkit-keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}.fa-rotate-90{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg)}.fa-rotate-180{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";-webkit-transform:rotate(180deg);-ms-transform:rotate(180deg);transform:rotate(180deg)}.fa-rotate-270{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";-webkit-transform:rotate(270deg);-ms-transform:rotate(270deg);transform:rotate(270deg)}.fa-flip-horizontal{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";-webkit-transform:scaleX(-1);-ms-transform:scaleX(-1);transform:scaleX(-1)}.fa-flip-vertical{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";-webkit-transform:scaleY(-1);-ms-transform:scaleY(-1);transform:scaleY(-1)}:root .fa-flip-horizontal,:root .fa-flip-vertical,:root .fa-rotate-90,:root .fa-rotate-180,:root .fa-rotate-270{-webkit-filter:none;filter:none}.fa-stack{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.fa-stack-1x,.fa-stack-2x{position:absolute;left:0;width:100%;text-align:center}.fa-stack-1x{line-height:inherit}.fa-stack-2x{font-size:2em}.fa-inverse{color:#fff}.fa-glass:before{content:\"\\F000\"}.fa-music:before{content:\"\\F001\"}.fa-search:before{content:\"\\F002\"}.fa-envelope-o:before{content:\"\\F003\"}.fa-heart:before{content:\"\\F004\"}.fa-star:before{content:\"\\F005\"}.fa-star-o:before{content:\"\\F006\"}.fa-user:before{content:\"\\F007\"}.fa-film:before{content:\"\\F008\"}.fa-th-large:before{content:\"\\F009\"}.fa-th:before{content:\"\\F00A\"}.fa-th-list:before{content:\"\\F00B\"}.fa-check:before{content:\"\\F00C\"}.fa-close:before,.fa-remove:before,.fa-times:before{content:\"\\F00D\"}.fa-search-plus:before{content:\"\\F00E\"}.fa-search-minus:before{content:\"\\F010\"}.fa-power-off:before{content:\"\\F011\"}.fa-signal:before{content:\"\\F012\"}.fa-cog:before,.fa-gear:before{content:\"\\F013\"}.fa-trash-o:before{content:\"\\F014\"}.fa-home:before{content:\"\\F015\"}.fa-file-o:before{content:\"\\F016\"}.fa-clock-o:before{content:\"\\F017\"}.fa-road:before{content:\"\\F018\"}.fa-download:before{content:\"\\F019\"}.fa-arrow-circle-o-down:before{content:\"\\F01A\"}.fa-arrow-circle-o-up:before{content:\"\\F01B\"}.fa-inbox:before{content:\"\\F01C\"}.fa-play-circle-o:before{content:\"\\F01D\"}.fa-repeat:before,.fa-rotate-right:before{content:\"\\F01E\"}.fa-refresh:before{content:\"\\F021\"}.fa-list-alt:before{content:\"\\F022\"}.fa-lock:before{content:\"\\F023\"}.fa-flag:before{content:\"\\F024\"}.fa-headphones:before{content:\"\\F025\"}.fa-volume-off:before{content:\"\\F026\"}.fa-volume-down:before{content:\"\\F027\"}.fa-volume-up:before{content:\"\\F028\"}.fa-qrcode:before{content:\"\\F029\"}.fa-barcode:before{content:\"\\F02A\"}.fa-tag:before{content:\"\\F02B\"}.fa-tags:before{content:\"\\F02C\"}.fa-book:before{content:\"\\F02D\"}.fa-bookmark:before{content:\"\\F02E\"}.fa-print:before{content:\"\\F02F\"}.fa-camera:before{content:\"\\F030\"}.fa-font:before{content:\"\\F031\"}.fa-bold:before{content:\"\\F032\"}.fa-italic:before{content:\"\\F033\"}.fa-text-height:before{content:\"\\F034\"}.fa-text-width:before{content:\"\\F035\"}.fa-align-left:before{content:\"\\F036\"}.fa-align-center:before{content:\"\\F037\"}.fa-align-right:before{content:\"\\F038\"}.fa-align-justify:before{content:\"\\F039\"}.fa-list:before{content:\"\\F03A\"}.fa-dedent:before,.fa-outdent:before{content:\"\\F03B\"}.fa-indent:before{content:\"\\F03C\"}.fa-video-camera:before{content:\"\\F03D\"}.fa-image:before,.fa-photo:before,.fa-picture-o:before{content:\"\\F03E\"}.fa-pencil:before{content:\"\\F040\"}.fa-map-marker:before{content:\"\\F041\"}.fa-adjust:before{content:\"\\F042\"}.fa-tint:before{content:\"\\F043\"}.fa-edit:before,.fa-pencil-square-o:before{content:\"\\F044\"}.fa-share-square-o:before{content:\"\\F045\"}.fa-check-square-o:before{content:\"\\F046\"}.fa-arrows:before{content:\"\\F047\"}.fa-step-backward:before{content:\"\\F048\"}.fa-fast-backward:before{content:\"\\F049\"}.fa-backward:before{content:\"\\F04A\"}.fa-play:before{content:\"\\F04B\"}.fa-pause:before{content:\"\\F04C\"}.fa-stop:before{content:\"\\F04D\"}.fa-forward:before{content:\"\\F04E\"}.fa-fast-forward:before{content:\"\\F050\"}.fa-step-forward:before{content:\"\\F051\"}.fa-eject:before{content:\"\\F052\"}.fa-chevron-left:before{content:\"\\F053\"}.fa-chevron-right:before{content:\"\\F054\"}.fa-plus-circle:before{content:\"\\F055\"}.fa-minus-circle:before{content:\"\\F056\"}.fa-times-circle:before{content:\"\\F057\"}.fa-check-circle:before{content:\"\\F058\"}.fa-question-circle:before{content:\"\\F059\"}.fa-info-circle:before{content:\"\\F05A\"}.fa-crosshairs:before{content:\"\\F05B\"}.fa-times-circle-o:before{content:\"\\F05C\"}.fa-check-circle-o:before{content:\"\\F05D\"}.fa-ban:before{content:\"\\F05E\"}.fa-arrow-left:before{content:\"\\F060\"}.fa-arrow-right:before{content:\"\\F061\"}.fa-arrow-up:before{content:\"\\F062\"}.fa-arrow-down:before{content:\"\\F063\"}.fa-mail-forward:before,.fa-share:before{content:\"\\F064\"}.fa-expand:before{content:\"\\F065\"}.fa-compress:before{content:\"\\F066\"}.fa-plus:before{content:\"\\F067\"}.fa-minus:before{content:\"\\F068\"}.fa-asterisk:before{content:\"\\F069\"}.fa-exclamation-circle:before{content:\"\\F06A\"}.fa-gift:before{content:\"\\F06B\"}.fa-leaf:before{content:\"\\F06C\"}.fa-fire:before{content:\"\\F06D\"}.fa-eye:before{content:\"\\F06E\"}.fa-eye-slash:before{content:\"\\F070\"}.fa-exclamation-triangle:before,.fa-warning:before{content:\"\\F071\"}.fa-plane:before{content:\"\\F072\"}.fa-calendar:before{content:\"\\F073\"}.fa-random:before{content:\"\\F074\"}.fa-comment:before{content:\"\\F075\"}.fa-magnet:before{content:\"\\F076\"}.fa-chevron-up:before{content:\"\\F077\"}.fa-chevron-down:before{content:\"\\F078\"}.fa-retweet:before{content:\"\\F079\"}.fa-shopping-cart:before{content:\"\\F07A\"}.fa-folder:before{content:\"\\F07B\"}.fa-folder-open:before{content:\"\\F07C\"}.fa-arrows-v:before{content:\"\\F07D\"}.fa-arrows-h:before{content:\"\\F07E\"}.fa-bar-chart-o:before,.fa-bar-chart:before{content:\"\\F080\"}.fa-twitter-square:before{content:\"\\F081\"}.fa-facebook-square:before{content:\"\\F082\"}.fa-camera-retro:before{content:\"\\F083\"}.fa-key:before{content:\"\\F084\"}.fa-cogs:before,.fa-gears:before{content:\"\\F085\"}.fa-comments:before{content:\"\\F086\"}.fa-thumbs-o-up:before{content:\"\\F087\"}.fa-thumbs-o-down:before{content:\"\\F088\"}.fa-star-half:before{content:\"\\F089\"}.fa-heart-o:before{content:\"\\F08A\"}.fa-sign-out:before{content:\"\\F08B\"}.fa-linkedin-square:before{content:\"\\F08C\"}.fa-thumb-tack:before{content:\"\\F08D\"}.fa-external-link:before{content:\"\\F08E\"}.fa-sign-in:before{content:\"\\F090\"}.fa-trophy:before{content:\"\\F091\"}.fa-github-square:before{content:\"\\F092\"}.fa-upload:before{content:\"\\F093\"}.fa-lemon-o:before{content:\"\\F094\"}.fa-phone:before{content:\"\\F095\"}.fa-square-o:before{content:\"\\F096\"}.fa-bookmark-o:before{content:\"\\F097\"}.fa-phone-square:before{content:\"\\F098\"}.fa-twitter:before{content:\"\\F099\"}.fa-facebook-f:before,.fa-facebook:before{content:\"\\F09A\"}.fa-github:before{content:\"\\F09B\"}.fa-unlock:before{content:\"\\F09C\"}.fa-credit-card:before{content:\"\\F09D\"}.fa-feed:before,.fa-rss:before{content:\"\\F09E\"}.fa-hdd-o:before{content:\"\\F0A0\"}.fa-bullhorn:before{content:\"\\F0A1\"}.fa-bell:before{content:\"\\F0F3\"}.fa-certificate:before{content:\"\\F0A3\"}.fa-hand-o-right:before{content:\"\\F0A4\"}.fa-hand-o-left:before{content:\"\\F0A5\"}.fa-hand-o-up:before{content:\"\\F0A6\"}.fa-hand-o-down:before{content:\"\\F0A7\"}.fa-arrow-circle-left:before{content:\"\\F0A8\"}.fa-arrow-circle-right:before{content:\"\\F0A9\"}.fa-arrow-circle-up:before{content:\"\\F0AA\"}.fa-arrow-circle-down:before{content:\"\\F0AB\"}.fa-globe:before{content:\"\\F0AC\"}.fa-wrench:before{content:\"\\F0AD\"}.fa-tasks:before{content:\"\\F0AE\"}.fa-filter:before{content:\"\\F0B0\"}.fa-briefcase:before{content:\"\\F0B1\"}.fa-arrows-alt:before{content:\"\\F0B2\"}.fa-group:before,.fa-users:before{content:\"\\F0C0\"}.fa-chain:before,.fa-link:before{content:\"\\F0C1\"}.fa-cloud:before{content:\"\\F0C2\"}.fa-flask:before{content:\"\\F0C3\"}.fa-cut:before,.fa-scissors:before{content:\"\\F0C4\"}.fa-copy:before,.fa-files-o:before{content:\"\\F0C5\"}.fa-paperclip:before{content:\"\\F0C6\"}.fa-floppy-o:before,.fa-save:before{content:\"\\F0C7\"}.fa-square:before{content:\"\\F0C8\"}.fa-bars:before,.fa-navicon:before,.fa-reorder:before{content:\"\\F0C9\"}.fa-list-ul:before{content:\"\\F0CA\"}.fa-list-ol:before{content:\"\\F0CB\"}.fa-strikethrough:before{content:\"\\F0CC\"}.fa-underline:before{content:\"\\F0CD\"}.fa-table:before{content:\"\\F0CE\"}.fa-magic:before{content:\"\\F0D0\"}.fa-truck:before{content:\"\\F0D1\"}.fa-pinterest:before{content:\"\\F0D2\"}.fa-pinterest-square:before{content:\"\\F0D3\"}.fa-google-plus-square:before{content:\"\\F0D4\"}.fa-google-plus:before{content:\"\\F0D5\"}.fa-money:before{content:\"\\F0D6\"}.fa-caret-down:before{content:\"\\F0D7\"}.fa-caret-up:before{content:\"\\F0D8\"}.fa-caret-left:before{content:\"\\F0D9\"}.fa-caret-right:before{content:\"\\F0DA\"}.fa-columns:before{content:\"\\F0DB\"}.fa-sort:before,.fa-unsorted:before{content:\"\\F0DC\"}.fa-sort-desc:before,.fa-sort-down:before{content:\"\\F0DD\"}.fa-sort-asc:before,.fa-sort-up:before{content:\"\\F0DE\"}.fa-envelope:before{content:\"\\F0E0\"}.fa-linkedin:before{content:\"\\F0E1\"}.fa-rotate-left:before,.fa-undo:before{content:\"\\F0E2\"}.fa-gavel:before,.fa-legal:before{content:\"\\F0E3\"}.fa-dashboard:before,.fa-tachometer:before{content:\"\\F0E4\"}.fa-comment-o:before{content:\"\\F0E5\"}.fa-comments-o:before{content:\"\\F0E6\"}.fa-bolt:before,.fa-flash:before{content:\"\\F0E7\"}.fa-sitemap:before{content:\"\\F0E8\"}.fa-umbrella:before{content:\"\\F0E9\"}.fa-clipboard:before,.fa-paste:before{content:\"\\F0EA\"}.fa-lightbulb-o:before{content:\"\\F0EB\"}.fa-exchange:before{content:\"\\F0EC\"}.fa-cloud-download:before{content:\"\\F0ED\"}.fa-cloud-upload:before{content:\"\\F0EE\"}.fa-user-md:before{content:\"\\F0F0\"}.fa-stethoscope:before{content:\"\\F0F1\"}.fa-suitcase:before{content:\"\\F0F2\"}.fa-bell-o:before{content:\"\\F0A2\"}.fa-coffee:before{content:\"\\F0F4\"}.fa-cutlery:before{content:\"\\F0F5\"}.fa-file-text-o:before{content:\"\\F0F6\"}.fa-building-o:before{content:\"\\F0F7\"}.fa-hospital-o:before{content:\"\\F0F8\"}.fa-ambulance:before{content:\"\\F0F9\"}.fa-medkit:before{content:\"\\F0FA\"}.fa-fighter-jet:before{content:\"\\F0FB\"}.fa-beer:before{content:\"\\F0FC\"}.fa-h-square:before{content:\"\\F0FD\"}.fa-plus-square:before{content:\"\\F0FE\"}.fa-angle-double-left:before{content:\"\\F100\"}.fa-angle-double-right:before{content:\"\\F101\"}.fa-angle-double-up:before{content:\"\\F102\"}.fa-angle-double-down:before{content:\"\\F103\"}.fa-angle-left:before{content:\"\\F104\"}.fa-angle-right:before{content:\"\\F105\"}.fa-angle-up:before{content:\"\\F106\"}.fa-angle-down:before{content:\"\\F107\"}.fa-desktop:before{content:\"\\F108\"}.fa-laptop:before{content:\"\\F109\"}.fa-tablet:before{content:\"\\F10A\"}.fa-mobile-phone:before,.fa-mobile:before{content:\"\\F10B\"}.fa-circle-o:before{content:\"\\F10C\"}.fa-quote-left:before{content:\"\\F10D\"}.fa-quote-right:before{content:\"\\F10E\"}.fa-spinner:before{content:\"\\F110\"}.fa-circle:before{content:\"\\F111\"}.fa-mail-reply:before,.fa-reply:before{content:\"\\F112\"}.fa-github-alt:before{content:\"\\F113\"}.fa-folder-o:before{content:\"\\F114\"}.fa-folder-open-o:before{content:\"\\F115\"}.fa-smile-o:before{content:\"\\F118\"}.fa-frown-o:before{content:\"\\F119\"}.fa-meh-o:before{content:\"\\F11A\"}.fa-gamepad:before{content:\"\\F11B\"}.fa-keyboard-o:before{content:\"\\F11C\"}.fa-flag-o:before{content:\"\\F11D\"}.fa-flag-checkered:before{content:\"\\F11E\"}.fa-terminal:before{content:\"\\F120\"}.fa-code:before{content:\"\\F121\"}.fa-mail-reply-all:before,.fa-reply-all:before{content:\"\\F122\"}.fa-star-half-empty:before,.fa-star-half-full:before,.fa-star-half-o:before{content:\"\\F123\"}.fa-location-arrow:before{content:\"\\F124\"}.fa-crop:before{content:\"\\F125\"}.fa-code-fork:before{content:\"\\F126\"}.fa-chain-broken:before,.fa-unlink:before{content:\"\\F127\"}.fa-question:before{content:\"\\F128\"}.fa-info:before{content:\"\\F129\"}.fa-exclamation:before{content:\"\\F12A\"}.fa-superscript:before{content:\"\\F12B\"}.fa-subscript:before{content:\"\\F12C\"}.fa-eraser:before{content:\"\\F12D\"}.fa-puzzle-piece:before{content:\"\\F12E\"}.fa-microphone:before{content:\"\\F130\"}.fa-microphone-slash:before{content:\"\\F131\"}.fa-shield:before{content:\"\\F132\"}.fa-calendar-o:before{content:\"\\F133\"}.fa-fire-extinguisher:before{content:\"\\F134\"}.fa-rocket:before{content:\"\\F135\"}.fa-maxcdn:before{content:\"\\F136\"}.fa-chevron-circle-left:before{content:\"\\F137\"}.fa-chevron-circle-right:before{content:\"\\F138\"}.fa-chevron-circle-up:before{content:\"\\F139\"}.fa-chevron-circle-down:before{content:\"\\F13A\"}.fa-html5:before{content:\"\\F13B\"}.fa-css3:before{content:\"\\F13C\"}.fa-anchor:before{content:\"\\F13D\"}.fa-unlock-alt:before{content:\"\\F13E\"}.fa-bullseye:before{content:\"\\F140\"}.fa-ellipsis-h:before{content:\"\\F141\"}.fa-ellipsis-v:before{content:\"\\F142\"}.fa-rss-square:before{content:\"\\F143\"}.fa-play-circle:before{content:\"\\F144\"}.fa-ticket:before{content:\"\\F145\"}.fa-minus-square:before{content:\"\\F146\"}.fa-minus-square-o:before{content:\"\\F147\"}.fa-level-up:before{content:\"\\F148\"}.fa-level-down:before{content:\"\\F149\"}.fa-check-square:before{content:\"\\F14A\"}.fa-pencil-square:before{content:\"\\F14B\"}.fa-external-link-square:before{content:\"\\F14C\"}.fa-share-square:before{content:\"\\F14D\"}.fa-compass:before{content:\"\\F14E\"}.fa-caret-square-o-down:before,.fa-toggle-down:before{content:\"\\F150\"}.fa-caret-square-o-up:before,.fa-toggle-up:before{content:\"\\F151\"}.fa-caret-square-o-right:before,.fa-toggle-right:before{content:\"\\F152\"}.fa-eur:before,.fa-euro:before{content:\"\\F153\"}.fa-gbp:before{content:\"\\F154\"}.fa-dollar:before,.fa-usd:before{content:\"\\F155\"}.fa-inr:before,.fa-rupee:before{content:\"\\F156\"}.fa-cny:before,.fa-jpy:before,.fa-rmb:before,.fa-yen:before{content:\"\\F157\"}.fa-rouble:before,.fa-rub:before,.fa-ruble:before{content:\"\\F158\"}.fa-krw:before,.fa-won:before{content:\"\\F159\"}.fa-bitcoin:before,.fa-btc:before{content:\"\\F15A\"}.fa-file:before{content:\"\\F15B\"}.fa-file-text:before{content:\"\\F15C\"}.fa-sort-alpha-asc:before{content:\"\\F15D\"}.fa-sort-alpha-desc:before{content:\"\\F15E\"}.fa-sort-amount-asc:before{content:\"\\F160\"}.fa-sort-amount-desc:before{content:\"\\F161\"}.fa-sort-numeric-asc:before{content:\"\\F162\"}.fa-sort-numeric-desc:before{content:\"\\F163\"}.fa-thumbs-up:before{content:\"\\F164\"}.fa-thumbs-down:before{content:\"\\F165\"}.fa-youtube-square:before{content:\"\\F166\"}.fa-youtube:before{content:\"\\F167\"}.fa-xing:before{content:\"\\F168\"}.fa-xing-square:before{content:\"\\F169\"}.fa-youtube-play:before{content:\"\\F16A\"}.fa-dropbox:before{content:\"\\F16B\"}.fa-stack-overflow:before{content:\"\\F16C\"}.fa-instagram:before{content:\"\\F16D\"}.fa-flickr:before{content:\"\\F16E\"}.fa-adn:before{content:\"\\F170\"}.fa-bitbucket:before{content:\"\\F171\"}.fa-bitbucket-square:before{content:\"\\F172\"}.fa-tumblr:before{content:\"\\F173\"}.fa-tumblr-square:before{content:\"\\F174\"}.fa-long-arrow-down:before{content:\"\\F175\"}.fa-long-arrow-up:before{content:\"\\F176\"}.fa-long-arrow-left:before{content:\"\\F177\"}.fa-long-arrow-right:before{content:\"\\F178\"}.fa-apple:before{content:\"\\F179\"}.fa-windows:before{content:\"\\F17A\"}.fa-android:before{content:\"\\F17B\"}.fa-linux:before{content:\"\\F17C\"}.fa-dribbble:before{content:\"\\F17D\"}.fa-skype:before{content:\"\\F17E\"}.fa-foursquare:before{content:\"\\F180\"}.fa-trello:before{content:\"\\F181\"}.fa-female:before{content:\"\\F182\"}.fa-male:before{content:\"\\F183\"}.fa-gittip:before,.fa-gratipay:before{content:\"\\F184\"}.fa-sun-o:before{content:\"\\F185\"}.fa-moon-o:before{content:\"\\F186\"}.fa-archive:before{content:\"\\F187\"}.fa-bug:before{content:\"\\F188\"}.fa-vk:before{content:\"\\F189\"}.fa-weibo:before{content:\"\\F18A\"}.fa-renren:before{content:\"\\F18B\"}.fa-pagelines:before{content:\"\\F18C\"}.fa-stack-exchange:before{content:\"\\F18D\"}.fa-arrow-circle-o-right:before{content:\"\\F18E\"}.fa-arrow-circle-o-left:before{content:\"\\F190\"}.fa-caret-square-o-left:before,.fa-toggle-left:before{content:\"\\F191\"}.fa-dot-circle-o:before{content:\"\\F192\"}.fa-wheelchair:before{content:\"\\F193\"}.fa-vimeo-square:before{content:\"\\F194\"}.fa-try:before,.fa-turkish-lira:before{content:\"\\F195\"}.fa-plus-square-o:before{content:\"\\F196\"}.fa-space-shuttle:before{content:\"\\F197\"}.fa-slack:before{content:\"\\F198\"}.fa-envelope-square:before{content:\"\\F199\"}.fa-wordpress:before{content:\"\\F19A\"}.fa-openid:before{content:\"\\F19B\"}.fa-bank:before,.fa-institution:before,.fa-university:before{content:\"\\F19C\"}.fa-graduation-cap:before,.fa-mortar-board:before{content:\"\\F19D\"}.fa-yahoo:before{content:\"\\F19E\"}.fa-google:before{content:\"\\F1A0\"}.fa-reddit:before{content:\"\\F1A1\"}.fa-reddit-square:before{content:\"\\F1A2\"}.fa-stumbleupon-circle:before{content:\"\\F1A3\"}.fa-stumbleupon:before{content:\"\\F1A4\"}.fa-delicious:before{content:\"\\F1A5\"}.fa-digg:before{content:\"\\F1A6\"}.fa-pied-piper-pp:before{content:\"\\F1A7\"}.fa-pied-piper-alt:before{content:\"\\F1A8\"}.fa-drupal:before{content:\"\\F1A9\"}.fa-joomla:before{content:\"\\F1AA\"}.fa-language:before{content:\"\\F1AB\"}.fa-fax:before{content:\"\\F1AC\"}.fa-building:before{content:\"\\F1AD\"}.fa-child:before{content:\"\\F1AE\"}.fa-paw:before{content:\"\\F1B0\"}.fa-spoon:before{content:\"\\F1B1\"}.fa-cube:before{content:\"\\F1B2\"}.fa-cubes:before{content:\"\\F1B3\"}.fa-behance:before{content:\"\\F1B4\"}.fa-behance-square:before{content:\"\\F1B5\"}.fa-steam:before{content:\"\\F1B6\"}.fa-steam-square:before{content:\"\\F1B7\"}.fa-recycle:before{content:\"\\F1B8\"}.fa-automobile:before,.fa-car:before{content:\"\\F1B9\"}.fa-cab:before,.fa-taxi:before{content:\"\\F1BA\"}.fa-tree:before{content:\"\\F1BB\"}.fa-spotify:before{content:\"\\F1BC\"}.fa-deviantart:before{content:\"\\F1BD\"}.fa-soundcloud:before{content:\"\\F1BE\"}.fa-database:before{content:\"\\F1C0\"}.fa-file-pdf-o:before{content:\"\\F1C1\"}.fa-file-word-o:before{content:\"\\F1C2\"}.fa-file-excel-o:before{content:\"\\F1C3\"}.fa-file-powerpoint-o:before{content:\"\\F1C4\"}.fa-file-image-o:before,.fa-file-photo-o:before,.fa-file-picture-o:before{content:\"\\F1C5\"}.fa-file-archive-o:before,.fa-file-zip-o:before{content:\"\\F1C6\"}.fa-file-audio-o:before,.fa-file-sound-o:before{content:\"\\F1C7\"}.fa-file-movie-o:before,.fa-file-video-o:before{content:\"\\F1C8\"}.fa-file-code-o:before{content:\"\\F1C9\"}.fa-vine:before{content:\"\\F1CA\"}.fa-codepen:before{content:\"\\F1CB\"}.fa-jsfiddle:before{content:\"\\F1CC\"}.fa-life-bouy:before,.fa-life-buoy:before,.fa-life-ring:before,.fa-life-saver:before,.fa-support:before{content:\"\\F1CD\"}.fa-circle-o-notch:before{content:\"\\F1CE\"}.fa-ra:before,.fa-rebel:before,.fa-resistance:before{content:\"\\F1D0\"}.fa-empire:before,.fa-ge:before{content:\"\\F1D1\"}.fa-git-square:before{content:\"\\F1D2\"}.fa-git:before{content:\"\\F1D3\"}.fa-hacker-news:before,.fa-y-combinator-square:before,.fa-yc-square:before{content:\"\\F1D4\"}.fa-tencent-weibo:before{content:\"\\F1D5\"}.fa-qq:before{content:\"\\F1D6\"}.fa-wechat:before,.fa-weixin:before{content:\"\\F1D7\"}.fa-paper-plane:before,.fa-send:before{content:\"\\F1D8\"}.fa-paper-plane-o:before,.fa-send-o:before{content:\"\\F1D9\"}.fa-history:before{content:\"\\F1DA\"}.fa-circle-thin:before{content:\"\\F1DB\"}.fa-header:before{content:\"\\F1DC\"}.fa-paragraph:before{content:\"\\F1DD\"}.fa-sliders:before{content:\"\\F1DE\"}.fa-share-alt:before{content:\"\\F1E0\"}.fa-share-alt-square:before{content:\"\\F1E1\"}.fa-bomb:before{content:\"\\F1E2\"}.fa-futbol-o:before,.fa-soccer-ball-o:before{content:\"\\F1E3\"}.fa-tty:before{content:\"\\F1E4\"}.fa-binoculars:before{content:\"\\F1E5\"}.fa-plug:before{content:\"\\F1E6\"}.fa-slideshare:before{content:\"\\F1E7\"}.fa-twitch:before{content:\"\\F1E8\"}.fa-yelp:before{content:\"\\F1E9\"}.fa-newspaper-o:before{content:\"\\F1EA\"}.fa-wifi:before{content:\"\\F1EB\"}.fa-calculator:before{content:\"\\F1EC\"}.fa-paypal:before{content:\"\\F1ED\"}.fa-google-wallet:before{content:\"\\F1EE\"}.fa-cc-visa:before{content:\"\\F1F0\"}.fa-cc-mastercard:before{content:\"\\F1F1\"}.fa-cc-discover:before{content:\"\\F1F2\"}.fa-cc-amex:before{content:\"\\F1F3\"}.fa-cc-paypal:before{content:\"\\F1F4\"}.fa-cc-stripe:before{content:\"\\F1F5\"}.fa-bell-slash:before{content:\"\\F1F6\"}.fa-bell-slash-o:before{content:\"\\F1F7\"}.fa-trash:before{content:\"\\F1F8\"}.fa-copyright:before{content:\"\\F1F9\"}.fa-at:before{content:\"\\F1FA\"}.fa-eyedropper:before{content:\"\\F1FB\"}.fa-paint-brush:before{content:\"\\F1FC\"}.fa-birthday-cake:before{content:\"\\F1FD\"}.fa-area-chart:before{content:\"\\F1FE\"}.fa-pie-chart:before{content:\"\\F200\"}.fa-line-chart:before{content:\"\\F201\"}.fa-lastfm:before{content:\"\\F202\"}.fa-lastfm-square:before{content:\"\\F203\"}.fa-toggle-off:before{content:\"\\F204\"}.fa-toggle-on:before{content:\"\\F205\"}.fa-bicycle:before{content:\"\\F206\"}.fa-bus:before{content:\"\\F207\"}.fa-ioxhost:before{content:\"\\F208\"}.fa-angellist:before{content:\"\\F209\"}.fa-cc:before{content:\"\\F20A\"}.fa-ils:before,.fa-shekel:before,.fa-sheqel:before{content:\"\\F20B\"}.fa-meanpath:before{content:\"\\F20C\"}.fa-buysellads:before{content:\"\\F20D\"}.fa-connectdevelop:before{content:\"\\F20E\"}.fa-dashcube:before{content:\"\\F210\"}.fa-forumbee:before{content:\"\\F211\"}.fa-leanpub:before{content:\"\\F212\"}.fa-sellsy:before{content:\"\\F213\"}.fa-shirtsinbulk:before{content:\"\\F214\"}.fa-simplybuilt:before{content:\"\\F215\"}.fa-skyatlas:before{content:\"\\F216\"}.fa-cart-plus:before{content:\"\\F217\"}.fa-cart-arrow-down:before{content:\"\\F218\"}.fa-diamond:before{content:\"\\F219\"}.fa-ship:before{content:\"\\F21A\"}.fa-user-secret:before{content:\"\\F21B\"}.fa-motorcycle:before{content:\"\\F21C\"}.fa-street-view:before{content:\"\\F21D\"}.fa-heartbeat:before{content:\"\\F21E\"}.fa-venus:before{content:\"\\F221\"}.fa-mars:before{content:\"\\F222\"}.fa-mercury:before{content:\"\\F223\"}.fa-intersex:before,.fa-transgender:before{content:\"\\F224\"}.fa-transgender-alt:before{content:\"\\F225\"}.fa-venus-double:before{content:\"\\F226\"}.fa-mars-double:before{content:\"\\F227\"}.fa-venus-mars:before{content:\"\\F228\"}.fa-mars-stroke:before{content:\"\\F229\"}.fa-mars-stroke-v:before{content:\"\\F22A\"}.fa-mars-stroke-h:before{content:\"\\F22B\"}.fa-neuter:before{content:\"\\F22C\"}.fa-genderless:before{content:\"\\F22D\"}.fa-facebook-official:before{content:\"\\F230\"}.fa-pinterest-p:before{content:\"\\F231\"}.fa-whatsapp:before{content:\"\\F232\"}.fa-server:before{content:\"\\F233\"}.fa-user-plus:before{content:\"\\F234\"}.fa-user-times:before{content:\"\\F235\"}.fa-bed:before,.fa-hotel:before{content:\"\\F236\"}.fa-viacoin:before{content:\"\\F237\"}.fa-train:before{content:\"\\F238\"}.fa-subway:before{content:\"\\F239\"}.fa-medium:before{content:\"\\F23A\"}.fa-y-combinator:before,.fa-yc:before{content:\"\\F23B\"}.fa-optin-monster:before{content:\"\\F23C\"}.fa-opencart:before{content:\"\\F23D\"}.fa-expeditedssl:before{content:\"\\F23E\"}.fa-battery-4:before,.fa-battery-full:before,.fa-battery:before{content:\"\\F240\"}.fa-battery-3:before,.fa-battery-three-quarters:before{content:\"\\F241\"}.fa-battery-2:before,.fa-battery-half:before{content:\"\\F242\"}.fa-battery-1:before,.fa-battery-quarter:before{content:\"\\F243\"}.fa-battery-0:before,.fa-battery-empty:before{content:\"\\F244\"}.fa-mouse-pointer:before{content:\"\\F245\"}.fa-i-cursor:before{content:\"\\F246\"}.fa-object-group:before{content:\"\\F247\"}.fa-object-ungroup:before{content:\"\\F248\"}.fa-sticky-note:before{content:\"\\F249\"}.fa-sticky-note-o:before{content:\"\\F24A\"}.fa-cc-jcb:before{content:\"\\F24B\"}.fa-cc-diners-club:before{content:\"\\F24C\"}.fa-clone:before{content:\"\\F24D\"}.fa-balance-scale:before{content:\"\\F24E\"}.fa-hourglass-o:before{content:\"\\F250\"}.fa-hourglass-1:before,.fa-hourglass-start:before{content:\"\\F251\"}.fa-hourglass-2:before,.fa-hourglass-half:before{content:\"\\F252\"}.fa-hourglass-3:before,.fa-hourglass-end:before{content:\"\\F253\"}.fa-hourglass:before{content:\"\\F254\"}.fa-hand-grab-o:before,.fa-hand-rock-o:before{content:\"\\F255\"}.fa-hand-paper-o:before,.fa-hand-stop-o:before{content:\"\\F256\"}.fa-hand-scissors-o:before{content:\"\\F257\"}.fa-hand-lizard-o:before{content:\"\\F258\"}.fa-hand-spock-o:before{content:\"\\F259\"}.fa-hand-pointer-o:before{content:\"\\F25A\"}.fa-hand-peace-o:before{content:\"\\F25B\"}.fa-trademark:before{content:\"\\F25C\"}.fa-registered:before{content:\"\\F25D\"}.fa-creative-commons:before{content:\"\\F25E\"}.fa-gg:before{content:\"\\F260\"}.fa-gg-circle:before{content:\"\\F261\"}.fa-tripadvisor:before{content:\"\\F262\"}.fa-odnoklassniki:before{content:\"\\F263\"}.fa-odnoklassniki-square:before{content:\"\\F264\"}.fa-get-pocket:before{content:\"\\F265\"}.fa-wikipedia-w:before{content:\"\\F266\"}.fa-safari:before{content:\"\\F267\"}.fa-chrome:before{content:\"\\F268\"}.fa-firefox:before{content:\"\\F269\"}.fa-opera:before{content:\"\\F26A\"}.fa-internet-explorer:before{content:\"\\F26B\"}.fa-television:before,.fa-tv:before{content:\"\\F26C\"}.fa-contao:before{content:\"\\F26D\"}.fa-500px:before{content:\"\\F26E\"}.fa-amazon:before{content:\"\\F270\"}.fa-calendar-plus-o:before{content:\"\\F271\"}.fa-calendar-minus-o:before{content:\"\\F272\"}.fa-calendar-times-o:before{content:\"\\F273\"}.fa-calendar-check-o:before{content:\"\\F274\"}.fa-industry:before{content:\"\\F275\"}.fa-map-pin:before{content:\"\\F276\"}.fa-map-signs:before{content:\"\\F277\"}.fa-map-o:before{content:\"\\F278\"}.fa-map:before{content:\"\\F279\"}.fa-commenting:before{content:\"\\F27A\"}.fa-commenting-o:before{content:\"\\F27B\"}.fa-houzz:before{content:\"\\F27C\"}.fa-vimeo:before{content:\"\\F27D\"}.fa-black-tie:before{content:\"\\F27E\"}.fa-fonticons:before{content:\"\\F280\"}.fa-reddit-alien:before{content:\"\\F281\"}.fa-edge:before{content:\"\\F282\"}.fa-credit-card-alt:before{content:\"\\F283\"}.fa-codiepie:before{content:\"\\F284\"}.fa-modx:before{content:\"\\F285\"}.fa-fort-awesome:before{content:\"\\F286\"}.fa-usb:before{content:\"\\F287\"}.fa-product-hunt:before{content:\"\\F288\"}.fa-mixcloud:before{content:\"\\F289\"}.fa-scribd:before{content:\"\\F28A\"}.fa-pause-circle:before{content:\"\\F28B\"}.fa-pause-circle-o:before{content:\"\\F28C\"}.fa-stop-circle:before{content:\"\\F28D\"}.fa-stop-circle-o:before{content:\"\\F28E\"}.fa-shopping-bag:before{content:\"\\F290\"}.fa-shopping-basket:before{content:\"\\F291\"}.fa-hashtag:before{content:\"\\F292\"}.fa-bluetooth:before{content:\"\\F293\"}.fa-bluetooth-b:before{content:\"\\F294\"}.fa-percent:before{content:\"\\F295\"}.fa-gitlab:before{content:\"\\F296\"}.fa-wpbeginner:before{content:\"\\F297\"}.fa-wpforms:before{content:\"\\F298\"}.fa-envira:before{content:\"\\F299\"}.fa-universal-access:before{content:\"\\F29A\"}.fa-wheelchair-alt:before{content:\"\\F29B\"}.fa-question-circle-o:before{content:\"\\F29C\"}.fa-blind:before{content:\"\\F29D\"}.fa-audio-description:before{content:\"\\F29E\"}.fa-volume-control-phone:before{content:\"\\F2A0\"}.fa-braille:before{content:\"\\F2A1\"}.fa-assistive-listening-systems:before{content:\"\\F2A2\"}.fa-american-sign-language-interpreting:before,.fa-asl-interpreting:before{content:\"\\F2A3\"}.fa-deaf:before,.fa-deafness:before,.fa-hard-of-hearing:before{content:\"\\F2A4\"}.fa-glide:before{content:\"\\F2A5\"}.fa-glide-g:before{content:\"\\F2A6\"}.fa-sign-language:before,.fa-signing:before{content:\"\\F2A7\"}.fa-low-vision:before{content:\"\\F2A8\"}.fa-viadeo:before{content:\"\\F2A9\"}.fa-viadeo-square:before{content:\"\\F2AA\"}.fa-snapchat:before{content:\"\\F2AB\"}.fa-snapchat-ghost:before{content:\"\\F2AC\"}.fa-snapchat-square:before{content:\"\\F2AD\"}.fa-pied-piper:before{content:\"\\F2AE\"}.fa-first-order:before{content:\"\\F2B0\"}.fa-yoast:before{content:\"\\F2B1\"}.fa-themeisle:before{content:\"\\F2B2\"}.fa-google-plus-circle:before,.fa-google-plus-official:before{content:\"\\F2B3\"}.fa-fa:before,.fa-font-awesome:before{content:\"\\F2B4\"}.fa-handshake-o:before{content:\"\\F2B5\"}.fa-envelope-open:before{content:\"\\F2B6\"}.fa-envelope-open-o:before{content:\"\\F2B7\"}.fa-linode:before{content:\"\\F2B8\"}.fa-address-book:before{content:\"\\F2B9\"}.fa-address-book-o:before{content:\"\\F2BA\"}.fa-address-card:before,.fa-vcard:before{content:\"\\F2BB\"}.fa-address-card-o:before,.fa-vcard-o:before{content:\"\\F2BC\"}.fa-user-circle:before{content:\"\\F2BD\"}.fa-user-circle-o:before{content:\"\\F2BE\"}.fa-user-o:before{content:\"\\F2C0\"}.fa-id-badge:before{content:\"\\F2C1\"}.fa-drivers-license:before,.fa-id-card:before{content:\"\\F2C2\"}.fa-drivers-license-o:before,.fa-id-card-o:before{content:\"\\F2C3\"}.fa-quora:before{content:\"\\F2C4\"}.fa-free-code-camp:before{content:\"\\F2C5\"}.fa-telegram:before{content:\"\\F2C6\"}.fa-thermometer-4:before,.fa-thermometer-full:before,.fa-thermometer:before{content:\"\\F2C7\"}.fa-thermometer-3:before,.fa-thermometer-three-quarters:before{content:\"\\F2C8\"}.fa-thermometer-2:before,.fa-thermometer-half:before{content:\"\\F2C9\"}.fa-thermometer-1:before,.fa-thermometer-quarter:before{content:\"\\F2CA\"}.fa-thermometer-0:before,.fa-thermometer-empty:before{content:\"\\F2CB\"}.fa-shower:before{content:\"\\F2CC\"}.fa-bath:before,.fa-bathtub:before,.fa-s15:before{content:\"\\F2CD\"}.fa-podcast:before{content:\"\\F2CE\"}.fa-window-maximize:before{content:\"\\F2D0\"}.fa-window-minimize:before{content:\"\\F2D1\"}.fa-window-restore:before{content:\"\\F2D2\"}.fa-times-rectangle:before,.fa-window-close:before{content:\"\\F2D3\"}.fa-times-rectangle-o:before,.fa-window-close-o:before{content:\"\\F2D4\"}.fa-bandcamp:before{content:\"\\F2D5\"}.fa-grav:before{content:\"\\F2D6\"}.fa-etsy:before{content:\"\\F2D7\"}.fa-imdb:before{content:\"\\F2D8\"}.fa-ravelry:before{content:\"\\F2D9\"}.fa-eercast:before{content:\"\\F2DA\"}.fa-microchip:before{content:\"\\F2DB\"}.fa-snowflake-o:before{content:\"\\F2DC\"}.fa-superpowers:before{content:\"\\F2DD\"}.fa-wpexplorer:before{content:\"\\F2DE\"}.fa-meetup:before{content:\"\\F2E0\"}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}", ""]);

// exports


/***/ }),

/***/ "DgVG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderChildren = exports.cloneItemElement = undefined;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cloneItemElement = exports.cloneItemElement = function cloneItemElement(elem, extraProps) {
  return _react2.default.cloneElement(elem, (0, _extends3.default)({}, elem.props, extraProps));
};
var renderChildren = exports.renderChildren = function renderChildren(children, extraProps) {
  return _react2.default.Children.map(children, function (child) {
    return cloneItemElement(child, extraProps);
  });
};

/***/ }),

/***/ "E6IZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _weixin = __webpack_require__("mwPL");

var _weixin2 = _interopRequireDefault(_weixin);

var _weibo = __webpack_require__("CGNb");

var _weibo2 = _interopRequireDefault(_weibo);

var _qzone = __webpack_require__("CyHg");

var _qzone2 = _interopRequireDefault(_qzone);

var _douban = __webpack_require__("AW9g");

var _douban2 = _interopRequireDefault(_douban);

var _facebook = __webpack_require__("j7PK");

var _facebook2 = _interopRequireDefault(_facebook);

var _twitter = __webpack_require__("dHmQ");

var _twitter2 = _interopRequireDefault(_twitter);

var _google_plus = __webpack_require__("Z9ii");

var _google_plus2 = _interopRequireDefault(_google_plus);

var _GlobalAction = __webpack_require__("5Q8M");

var _reactIntlUniversal = __webpack_require__("cl+9");

var _reactIntlUniversal2 = _interopRequireDefault(_reactIntlUniversal);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = __webpack_require__("RH2O");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _ShareMenu = __webpack_require__("n2R4");

var _ShareMenu2 = _interopRequireDefault(_ShareMenu);

var _Menu = __webpack_require__("l8jW");

var _share = __webpack_require__("PNPU");

var _share2 = _interopRequireDefault(_share);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShareMenu = (_dec = (0, _reactRedux.connect)(function (state) {
  return {};
}, function (dispatch) {
  return {
    setQrCodeModalData: function setQrCodeModalData(show, data) {
      return dispatch((0, _GlobalAction.setQrCodeModalData)(show, data));
    }
  };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(ShareMenu, _Component);

  function ShareMenu() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ShareMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ShareMenu.__proto__ || (0, _getPrototypeOf2.default)(ShareMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      sns: [{
        action: 'wechat',
        text: _reactIntlUniversal2.default.get('share.to-wechat'),
        icon: _weixin2.default
      }, {
        action: 'weibo',
        text: _reactIntlUniversal2.default.get('share.to-weibo'),
        icon: _weibo2.default
      }, {
        action: 'qzone',
        text: _reactIntlUniversal2.default.get('share.to-qzone'),
        icon: _qzone2.default
      }, {
        action: 'douban',
        text: _reactIntlUniversal2.default.get('share.to-douban'),
        icon: _douban2.default
      }, {
        action: 'facebook',
        text: _reactIntlUniversal2.default.get('share.to-facebook'),
        icon: _facebook2.default
      }, {
        action: 'twitter',
        text: _reactIntlUniversal2.default.get('share.to-twitter'),
        icon: _twitter2.default
      }, {
        action: 'google_plus',
        text: _reactIntlUniversal2.default.get('share.to-googleplus'),
        icon: _google_plus2.default
      }]
    }, _this.onClick = function (e, action) {
      var shareData = _this.props.shareData;

      if (action.index === 'wechat') {
        _this.props.setQrCodeModalData(true, { link: shareData.link });
        return;
      }
      (0, _share2.default)(action.index, shareData.link, shareData.title, shareData.text);
    }, _this.getSubMenuItems = function () {
      var filterItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var renderText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var sns = _this.state.sns;

      return sns.filter(function (v) {
        return filterItems.indexOf(v.action) < 0;
      }).map(function (v, index) {
        return _react2.default.createElement(
          _Menu.MenuItem,
          { key: index, index: v.action, className: _ShareMenu2.default['shareitem'] },
          _react2.default.createElement('img', { src: v.icon, alt: '' }),
          v.text
        );
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /* 支持过滤某些分享项
   * @filterItems 需要过滤掉的分享项
   */


  (0, _createClass3.default)(ShareMenu, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          text = _props.text,
          index = _props.index,
          className = _props.className,
          iconName = _props.iconName,
          direction = _props.direction,
          filterItems = _props.filterItems,
          renderText = _props.renderText;

      return _react2.default.createElement(
        _Menu.SubMenu,
        {
          text: text,
          iconName: iconName && 'share',
          index: index,
          onClick: this.onClick,
          direction: direction,
          className: (0, _classnames2.default)(_ShareMenu2.default['sharemenu'], className)
        },
        this.getSubMenuItems(filterItems, renderText)
      );
    }
  }]);
  return ShareMenu;
}(_react.Component), _class2.defaultProps = {
  direction: 'left'
}, _temp2)) || _class);
exports.default = ShareMenu;

/***/ }),

/***/ "EDcJ":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "*{-webkit-box-sizing:border-box;box-sizing:border-box}body{margin:0}body.reader-day-mode{background-color:#fff}body.reader-night-mode{background-color:#3d3d3d}body ol,body ul{padding-left:0}body b,body h1,body h2,body h3,body h4,body h5,body h6,body strong{font-weight:600}body a,body a:hover{color:#595959}body input{border:0}body input::-moz-placeholder{color:#999;opacity:1}body input:-moz-placeholder{color:#999}body input:-ms-input-placeholder{color:#999}body input::-webkit-input-placeholder{color:#999}body :focus{outline:0}img.math-block,img.math-inline{max-width:100%}body.reader-night-mode img.math-block,body.reader-night-mode img.math-inline{-webkit-filter:invert(.8);filter:invert(.8)}.task-list-item{list-style:none}.task-list-item-checkbox{margin-left:-20px;margin-right:.2em}.note-view{font-size:16px}.note-view .film-score{text-align:center;margin-top:10px}.note-view blockquote p{font-weight:400;line-height:1.7}.note-view .video-package .video-placeholder-area{position:relative;display:inline-block;min-height:110px;padding:10px 10px 10px 110px;-webkit-box-sizing:border-box;box-sizing:border-box;border:1px solid #d9d9d9;text-align:left;cursor:pointer}.note-view .video-package .video-placeholder-area .video-cover{position:absolute;top:9px;left:9px;display:block;width:90px;height:90px;opacity:.8;-webkit-transition:opacity .1s linear;-o-transition:opacity linear .1s;transition:opacity .1s linear}.note-view .video-package .video-description:empty{display:none}.note-view .video-package .video-close-button,.note-view .video-package .video-provider-button{float:left;font-size:14px;padding:0;line-height:14px;cursor:pointer;-webkit-transition:opacity .1s linear;-o-transition:opacity linear .1s;transition:opacity .1s linear}.note-view .video-package .video-close-button i.fa,.note-view .video-package .video-provider-button i.fa{position:relative;top:1px}body.reader-night-mode .note-view{color:#b3b3b3}.note-view a,.note-view a:hover{color:#3194d0}.note-view h1,.note-view h2,.note-view h3,.note-view h4,.note-view h5,.note-view h6{text-rendering:optimizelegibility;line-height:1.7;margin:0 0 15px}body.reader-night-mode .note-view h1,body.reader-night-mode .note-view h2,body.reader-night-mode .note-view h3,body.reader-night-mode .note-view h4,body.reader-night-mode .note-view h5,body.reader-night-mode .note-view h6{color:#b3b3b3}.note-view h1{font-size:26px}.note-view h2{font-size:24px}.note-view h3{font-size:22px}.note-view h4{font-size:20px}.note-view h5{font-size:18px}.note-view h6{font-size:16px}.note-view hr{margin:0 0 20px;border:0;border-top:1px solid #d9d9d9!important}.note-view blockquote{padding:20px;background-color:#f2f2f2;border-left:6px solid #b3b3b3;word-break:break-word;font-size:16px;font-weight:400;line-height:30px;margin:0 0 20px}body.reader-night-mode .note-view blockquote{background-color:#595959;border-color:#262626}.note-view blockquote h1:last-child,.note-view blockquote h2:last-child,.note-view blockquote h3:last-child,.note-view blockquote h4:last-child,.note-view blockquote h5:last-child,.note-view blockquote h6:last-child,.note-view blockquote li:last-child,.note-view blockquote ol:last-child,.note-view blockquote p:last-child,.note-view blockquote ul:last-child{margin-bottom:0}.note-view blockquote .image-package{width:100%;margin-left:0}.note-view li p{margin:16px 0;overflow:visible}.note-view p{margin:0 0 25px;word-break:break-word}.note-view ol,.note-view ul{word-break:break-word;margin:-5px 0 20px 20px}.note-view ol li,.note-view ul li{line-height:30px}.note-view ol li ol,.note-view ol li ul,.note-view ul li ol,.note-view ul li ul{margin-top:15px}.note-view ol{list-style-type:decimal}.note-view ul{list-style-type:disc}.note-view pre{word-wrap:normal;word-break:break-all;white-space:pre;overflow:auto;margin-bottom:20px;padding:10px;border:1px solid #d9d9d9;border-radius:0;line-height:20px;background-color:#282c34}body.reader-night-mode .note-view pre{background-color:#262626;border-color:#1a1a1a}.note-view pre code{padding:0;background-color:transparent;white-space:pre}.note-view code{padding:2px 4px;background-color:#f6f6f6;vertical-align:middle;border:none;color:#c7254e;font-size:12px;white-space:pre-wrap}body.reader-night-mode .note-view code{background-color:#262626}.note-view table{width:100%;margin-bottom:20px;border:1px solid #d9d9d9;border-collapse:collapse;border-left:none;word-break:normal}.note-view table td,.note-view table th{padding:8px;border:1px solid #d9d9d9;line-height:20px;vertical-align:middle}.note-view table th{font-weight:700}.note-view table thead th{vertical-align:middle;text-align:inherit}.note-view table tr:nth-of-type(2n){background-color:hsla(0,0%,71%,.1)}.note-view table .image-package{width:100%;margin-left:0}.note-view .image-package{margin:0 -40px 20px;width:calc(100% + 80px);text-align:center;font-size:0}.note-view .image-package img{max-width:100%;width:auto;height:auto;vertical-align:middle;border:0}body.reader-night-mode .note-view .image-package img{opacity:.85}.note-view .image-package .image-caption{min-width:20%;max-width:80%;min-height:43px;display:inline-block;padding:10px;margin:0 auto;border-bottom:1px solid #d9d9d9;font-size:13px;color:#999;line-height:1.7}.note-view .image-package .image-caption:empty{display:none}body.reader-night-mode .note-view .image-package .image-caption{border-color:#2e2e2e}.note-view .video-package{position:relative;margin:0 auto 20px;text-align:center}.note-view .video-package .video-description{display:inline-block;min-width:20%;max-width:80%;min-height:22px;padding:10px;margin:0 auto;border-bottom:1px solid #d9d9d9;font-size:13px;color:#999;line-height:1.7}body.reader-night-mode .note-view .video-package .video-description{border-color:#2e2e2e}.note-view .video-package .video-description p{margin:0}.kalamu-area{color:#333;font-size:16px;font-weight:400;line-height:1.7;bottom:0;outline:0;min-height:100%;-webkit-box-sizing:border-box;box-sizing:border-box;padding:40px 40px 80px}body.reader-night-mode .kalamu-area{color:#b3b3b3}.kalamu-area a,.kalamu-area a:hover{color:#3194d0}.kalamu-area h1,.kalamu-area h2,.kalamu-area h3,.kalamu-area h4,.kalamu-area h5,.kalamu-area h6{text-rendering:optimizelegibility;line-height:1.7;margin:0 0 15px}body.reader-night-mode .kalamu-area h1,body.reader-night-mode .kalamu-area h2,body.reader-night-mode .kalamu-area h3,body.reader-night-mode .kalamu-area h4,body.reader-night-mode .kalamu-area h5,body.reader-night-mode .kalamu-area h6{color:#b3b3b3}.kalamu-area h1{font-size:26px}.kalamu-area h2{font-size:24px}.kalamu-area h3{font-size:22px}.kalamu-area h4{font-size:20px}.kalamu-area h5{font-size:18px}.kalamu-area h6{font-size:16px}.kalamu-area hr{margin:0 0 20px;border:0;border-top:1px solid #d9d9d9!important}.kalamu-area blockquote{padding:20px;background-color:#f2f2f2;border-left:6px solid #b3b3b3;word-break:break-word;font-size:16px;font-weight:400;line-height:30px;margin:0 0 20px}body.reader-night-mode .kalamu-area blockquote{background-color:#595959;border-color:#262626}.kalamu-area blockquote h1:last-child,.kalamu-area blockquote h2:last-child,.kalamu-area blockquote h3:last-child,.kalamu-area blockquote h4:last-child,.kalamu-area blockquote h5:last-child,.kalamu-area blockquote h6:last-child,.kalamu-area blockquote li:last-child,.kalamu-area blockquote ol:last-child,.kalamu-area blockquote p:last-child,.kalamu-area blockquote ul:last-child{margin-bottom:0}.kalamu-area blockquote .image-package{width:100%;margin-left:0}.kalamu-area li p{margin:16px 0;overflow:visible}.kalamu-area p{margin:0 0 25px;word-break:break-word}.kalamu-area ol,.kalamu-area ul{word-break:break-word;margin:-5px 0 20px 20px}.kalamu-area ol li,.kalamu-area ul li{line-height:30px}.kalamu-area ol li ol,.kalamu-area ol li ul,.kalamu-area ul li ol,.kalamu-area ul li ul{margin-top:15px}.kalamu-area ol{list-style-type:decimal}.kalamu-area ul{list-style-type:disc}.kalamu-area pre{word-wrap:normal;word-break:break-all;white-space:pre;overflow:auto;margin-bottom:20px;padding:10px;border:1px solid #d9d9d9;border-radius:0;line-height:20px;background-color:#282c34}body.reader-night-mode .kalamu-area pre{background-color:#262626;border-color:#1a1a1a}.kalamu-area pre code{padding:0;background-color:transparent;white-space:pre}.kalamu-area code{padding:2px 4px;background-color:#f6f6f6;vertical-align:middle;border:none;color:#c7254e;font-size:12px;white-space:pre-wrap}body.reader-night-mode .kalamu-area code{background-color:#262626}.kalamu-area table{width:100%;margin-bottom:20px;border:1px solid #d9d9d9;border-collapse:collapse;border-left:none;word-break:normal}.kalamu-area table td,.kalamu-area table th{padding:8px;border:1px solid #d9d9d9;line-height:20px;vertical-align:middle}.kalamu-area table th{font-weight:700}.kalamu-area table thead th{vertical-align:middle;text-align:inherit}.kalamu-area table tr:nth-of-type(2n){background-color:hsla(0,0%,71%,.1)}.kalamu-area table .image-package{width:100%;margin-left:0}.kalamu-area .image-package{margin:0 -40px 20px;width:calc(100% + 80px);text-align:center;font-size:0}.kalamu-area .image-package img{max-width:100%;width:auto;height:auto;vertical-align:middle;border:0}body.reader-night-mode .kalamu-area .image-package img{opacity:.85}.kalamu-area .image-package .image-caption{min-width:20%;max-width:80%;min-height:43px;display:inline-block;padding:10px;margin:0 auto;border-bottom:1px solid #d9d9d9;font-size:13px;color:#999;line-height:1.7}.kalamu-area .image-package .image-caption:empty{display:none}body.reader-night-mode .kalamu-area .image-package .image-caption{border-color:#2e2e2e}.kalamu-area .video-package{position:relative;margin:0 auto 20px;text-align:center}.kalamu-area .video-package .video-description{display:inline-block;min-width:20%;max-width:80%;min-height:22px;padding:10px;margin:0 auto;border-bottom:1px solid #d9d9d9;font-size:13px;color:#999;line-height:1.7}body.reader-night-mode .kalamu-area .video-package .video-description{border-color:#2e2e2e}.kalamu-area .video-package .video-description p{margin:0}.kalamu-area .image-package .image-caption:empty{display:inline-block}.kalamu-area .film-score{text-align:center;margin-top:10px}", ""]);

// exports


/***/ }),

/***/ "FWRk":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "._3P4JX{font-size:16px;width:40px;text-align:center;position:relative;min-height:30px;max-height:50px}._3P4JX ul._2V8zt{display:none;position:absolute;z-index:99;right:0}._3P4JX ul._2V8zt:before{position:absolute;right:12px;content:\"\";display:inline-block}._3P4JX ul.NvfK4{display:block}._3P4JX ul._2AwQg{bottom:100%}._3P4JX ul._2AwQg:before{bottom:-9px;border-left:9px solid transparent;border-right:9px solid transparent;border-top:9px solid #fff}body.reader-night-mode ._3P4JX ul._2AwQg:before{border-top-color:#3d3d3d}._3P4JX ul._3FcHm{top:100%}._3P4JX ul._3FcHm:before{border-left:9px solid transparent;border-right:9px solid transparent;border-bottom:9px solid #fff;top:-9px}body.reader-night-mode ._3P4JX ul._3FcHm:before{border-bottom-color:#3d3d3d}", ""]);

// exports
exports.locals = {
	"dropdown": "_3P4JX",
	"menu": "_2V8zt",
	"show": "NvfK4",
	"menu-top": "_2AwQg",
	"menu-bottom": "_3FcHm"
};

/***/ }),

/***/ "Fqd/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fontawesome-webfont.912ec66.svg";

/***/ }),

/***/ "FrNA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _Icon = __webpack_require__("9JgI");

var _Icon2 = _interopRequireDefault(_Icon);

var _util = __webpack_require__("oFuF");

var _MenuUtil = __webpack_require__("DgVG");

var _Menu = __webpack_require__("l8jW");

var _Menu2 = _interopRequireDefault(_Menu);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _rcAnimate = __webpack_require__("8aSS");

var _rcAnimate2 = _interopRequireDefault(_rcAnimate);

var _SubMenu = __webpack_require__("91PG");

var _SubMenu2 = _interopRequireDefault(_SubMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var winSize = (0, _util.getWindowSize)();
var SubMenu = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(SubMenu, _Component);

  function SubMenu() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SubMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SubMenu.__proto__ || (0, _getPrototypeOf2.default)(SubMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showMenu: false
    }, _this.onMouseEnter = function (e) {
      clearTimeout(_this.hideTimer);
      _this.setState({ showMenu: true });
    }, _this.onMouseLeave = function (e) {
      _this.hideTimer = setTimeout(function () {
        _this.setState({ showMenu: false });
      }, 30);
    }, _this.onItemClick = function (e, itemdata) {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          index = _this$props.index;

      onClick(e, itemdata);
    }, _this.autoAlignMenu = function () {
      var autoAlign = _this.props.autoAlign;
      // 计算下显示的位置是否合理

      if (autoAlign && _this.menuRef) {
        var rect = _this.menuRef.getBoundingClientRect();
        if (rect.width && rect.height) {
          var className = _this.menuRef.className;

          if (rect.height + rect.top > winSize[1]) {
            className = className.replace(new RegExp(_SubMenu2.default['submenu-bottom']), '');
            _this.menuRef.className = className + ' ' + _SubMenu2.default['submenu-top'];
          }
        }
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SubMenu, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.autoAlignMenu();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.autoAlignMenu();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var showMenu = this.state.showMenu;
      var _props = this.props,
          children = _props.children,
          iconName = _props.iconName,
          text = _props.text,
          className = _props.className,
          index = _props.index,
          direction = _props.direction;

      var subMenuClass = (0, _classnames2.default)(_SubMenu2.default['submenu'], _SubMenu2.default['submenu-bottom'], (0, _defineProperty3.default)({}, _SubMenu2.default['hidden'], !showMenu));
      return _react2.default.createElement(
        _Menu.MenuItem,
        {
          iconName: iconName,
          className: (0, _classnames2.default)(className, _SubMenu2.default['menuitem'], _SubMenu2.default['menuitem-' + direction]),
          onClick: this.onItemClick,
          onMouseEnter: this.onMouseEnter,
          onMouseLeave: this.onMouseLeave,
          index: index
        },
        text,
        _react2.default.createElement(
          _rcAnimate2.default,
          { transitionName: 'fade', component: 'div', className: _SubMenu2.default['submenu-wrapper'] },
          _react2.default.createElement(
            _Menu2.default,
            {
              key: 'submenu-wrapper',
              className: subMenuClass,
              onClick: this.onItemClick,
              getMenuDom: function getMenuDom(v) {
                _this2.menuRef = v;
              }
            },
            children
          )
        )
      );
    }
  }]);
  return SubMenu;
}(_react.Component), _class.defaultProps = {
  autoAlign: true,
  onClick: _util.noop,
  direction: 'left'
}, _temp2);
exports.default = SubMenu;

/***/ }),

/***/ "FruA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _Message = __webpack_require__("A6CO");

var _Message2 = _interopRequireDefault(_Message);

var _Message3 = __webpack_require__("hGJ7");

var _Icon = __webpack_require__("9JgI");

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MessageItem = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(MessageItem, _Component);

  function MessageItem() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, MessageItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MessageItem.__proto__ || (0, _getPrototypeOf2.default)(MessageItem)).call.apply(_ref, [this].concat(args))), _this), _this.clearCloseTimer = function () {
      if (_this.closeTimer) {
        clearTimeout(_this.closeTimer);
        _this.closeTimer = null;
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(MessageItem, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          duration = _props.duration,
          onClose = _props.onClose;
      // 如果为0，则一直显示

      if (duration !== 0) {
        this.closeTimer = setTimeout(function () {
          onClose();
          _this2.clearCloseTimer();
        }, duration);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearCloseTimer();
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames2;

      // eslint-disable-next-line object-curly-newline
      var _props2 = this.props,
          itemClass = _props2.itemClass,
          itemStyle = _props2.itemStyle,
          content = _props2.content,
          type = _props2.type;

      var itemCls = (0, _classnames2.default)((0, _defineProperty3.default)({}, '' + _Message2.default[_Message3.messagePrefix + '-item'], true));
      var contentCls = (0, _classnames2.default)((_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, '' + _Message2.default[_Message3.messagePrefix + '-content'], true), (0, _defineProperty3.default)(_classNames2, '' + _Message2.default[_Message3.messagePrefix + '-content-' + type], true), (0, _defineProperty3.default)(_classNames2, itemClass, !!itemClass), _classNames2));
      var iconName = {
        info: 'info-circle',
        success: 'check-circle',
        error: 'times-circle',
        warning: 'exclamation-circle',
        loading: 'spinner'
      }[type];

      return _react2.default.createElement(
        'div',
        { className: itemCls },
        _react2.default.createElement(
          'div',
          { className: contentCls, style: itemStyle },
          _react2.default.createElement(_Icon2.default, { name: iconName, spin: type === 'loading' }),
          _react2.default.createElement(
            'span',
            null,
            content
          )
        )
      );
    }
  }]);
  return MessageItem;
}(_react.Component), _class.propTypes = {
  content: _propTypes2.default.string,
  type: _propTypes2.default.string,
  duration: _propTypes2.default.number,
  onClose: _propTypes2.default.func,
  itemClass: _propTypes2.default.string,
  itemStyle: _propTypes2.default.object
}, _class.defaultProps = {
  duration: 2000,
  onClose: function onClose() {
    return undefined;
  }
}, _temp2);
exports.default = MessageItem;

/***/ }),

/***/ "FufB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.watchGetNotes = watchGetNotes;
exports.watchSortNotes = watchSortNotes;
exports.watchNewNote = watchNewNote;
exports.watchPublishNote = watchPublishNote;
exports.watchUpdateNote = watchUpdateNote;
exports.watchPrivateNote = watchPrivateNote;
exports.watchDeleteNoteSoft = watchDeleteNoteSoft;
exports.watchMoveNote = watchMoveNote;
exports.watchPublishPaidNote = watchPublishPaidNote;
exports.watchGetCoverImg = watchGetCoverImg;
exports.watchPostCoverImg = watchPostCoverImg;
exports.watchPostSetNoteTop = watchPostSetNoteTop;
exports.watchPostUnsetNoteTop = watchPostUnsetNoteTop;
exports.watchSetNoteReprintAble = watchSetNoteReprintAble;
exports.watchSetNotePublishTime = watchSetNotePublishTime;

var _util = __webpack_require__("oFuF");

var _reactIntlUniversal = __webpack_require__("cl+9");

var _reactIntlUniversal2 = _interopRequireDefault(_reactIntlUniversal);

var _NoteContentReducer = __webpack_require__("THqP");

var _NotesReducer = __webpack_require__("R2Qq");

var _effects = __webpack_require__("egdi");

var _NotebooksReducer = __webpack_require__("gmmG");

var _Message = __webpack_require__("mzOA");

var _Message2 = _interopRequireDefault(_Message);

var _ajax = __webpack_require__("Z1y9");

var _ajax2 = _interopRequireDefault(_ajax);

var _actionTypes = __webpack_require__("4HHy");

var _variables = __webpack_require__("+AJo");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(getNotesAsync),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(sortNotesAsync),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(newNoteAsync),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(publishNoteAsync),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(updateNoteAsync),
    _marked6 = /*#__PURE__*/_regenerator2.default.mark(privateNoteAsync),
    _marked7 = /*#__PURE__*/_regenerator2.default.mark(deleteNoteSoftAsync),
    _marked8 = /*#__PURE__*/_regenerator2.default.mark(moveNoteAsync),
    _marked9 = /*#__PURE__*/_regenerator2.default.mark(publishPaidNoteAsync),
    _marked10 = /*#__PURE__*/_regenerator2.default.mark(getCoverImgAsync),
    _marked11 = /*#__PURE__*/_regenerator2.default.mark(postCoverImgAsync),
    _marked12 = /*#__PURE__*/_regenerator2.default.mark(postSetNoteTopAsync),
    _marked13 = /*#__PURE__*/_regenerator2.default.mark(postUnsetNoteTopAsync),
    _marked14 = /*#__PURE__*/_regenerator2.default.mark(setNoteReprintAbleAsync),
    _marked15 = /*#__PURE__*/_regenerator2.default.mark(setNotePublishTimeAsync),
    _marked16 = /*#__PURE__*/_regenerator2.default.mark(watchGetNotes),
    _marked17 = /*#__PURE__*/_regenerator2.default.mark(watchSortNotes),
    _marked18 = /*#__PURE__*/_regenerator2.default.mark(watchNewNote),
    _marked19 = /*#__PURE__*/_regenerator2.default.mark(watchPublishNote),
    _marked20 = /*#__PURE__*/_regenerator2.default.mark(watchUpdateNote),
    _marked21 = /*#__PURE__*/_regenerator2.default.mark(watchPrivateNote),
    _marked22 = /*#__PURE__*/_regenerator2.default.mark(watchDeleteNoteSoft),
    _marked23 = /*#__PURE__*/_regenerator2.default.mark(watchMoveNote),
    _marked24 = /*#__PURE__*/_regenerator2.default.mark(watchPublishPaidNote),
    _marked25 = /*#__PURE__*/_regenerator2.default.mark(watchGetCoverImg),
    _marked26 = /*#__PURE__*/_regenerator2.default.mark(watchPostCoverImg),
    _marked27 = /*#__PURE__*/_regenerator2.default.mark(watchPostSetNoteTop),
    _marked28 = /*#__PURE__*/_regenerator2.default.mark(watchPostUnsetNoteTop),
    _marked29 = /*#__PURE__*/_regenerator2.default.mark(watchSetNoteReprintAble),
    _marked30 = /*#__PURE__*/_regenerator2.default.mark(watchSetNotePublishTime); /* eslint-disable no-unused-expressions */
/**
 * Created by zad on 17/4/26.
 */


function getNotesAsync(action) {
  var nbId, isForce, _action$page, page, _action$count, count, _action$nid, nid, notebooks, notes, _ref, data;

  return _regenerator2.default.wrap(function getNotesAsync$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          nbId = action.nbId, isForce = action.isForce, _action$page = action.page, page = _action$page === undefined ? 1 : _action$page, _action$count = action.count, count = _action$count === undefined ? 10 : _action$count, _action$nid = action.nid, nid = _action$nid === undefined ? null : _action$nid;
          _context.next = 3;
          return (0, _effects.select)(_NotebooksReducer.getState);

        case 3:
          notebooks = _context.sent;
          notes = notebooks.getIn(['entities', nbId, 'notes'], _variables.NOTES_NOT_FOUND);
          _context.prev = 5;
          _context.next = 8;
          return (0, _effects.call)(_ajax2.default.getNotes, nbId, page, count, nid);

        case 8:
          _ref = _context.sent;
          data = _ref.data;
          _context.next = 12;
          return (0, _effects.put)({ type: _actionTypes.Notes.GET_NOTES_SUCCESS, data: data, nbId: nbId, page: page, count: count, isForce: isForce, nid: nid });

        case 12:
          _context.next = 18;
          break;

        case 14:
          _context.prev = 14;
          _context.t0 = _context['catch'](5);
          _context.next = 18;
          return (0, _effects.put)({ type: _actionTypes.Notes.GET_NOTES_FAIL });

        case 18:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[5, 14]]);
}

function sortNotesAsync(action) {
  var newSeq, oldSeq, nbId, _ref2, data;

  return _regenerator2.default.wrap(function sortNotesAsync$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          newSeq = action.newSeq, oldSeq = action.oldSeq, nbId = action.nbId;
          _context2.prev = 1;
          _context2.next = 4;
          return (0, _effects.call)(_ajax2.default.sortNotes, newSeq);

        case 4:
          _ref2 = _context2.sent;
          data = _ref2.data;
          _context2.next = 8;
          return (0, _effects.put)({ type: _actionTypes.Notes.SORT_NOTES_SUCCESS });

        case 8:
          _context2.next = 14;
          break;

        case 10:
          _context2.prev = 10;
          _context2.t0 = _context2['catch'](1);
          _context2.next = 14;
          return (0, _effects.put)({ type: _actionTypes.Notes.SORT_NOTES_FAIL, oldSeq: oldSeq, nbId: nbId });

        case 14:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[1, 10]]);
}

function newNoteAsync(action) {
  var nbId, title, resolve, reject, atBottom, hasTop, _ref3, data;

  return _regenerator2.default.wrap(function newNoteAsync$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          nbId = action.nbId, title = action.title, resolve = action.resolve, reject = action.reject, atBottom = action.atBottom, hasTop = action.hasTop;
          // 没有文集或者没有选中文集需要提示

          if (nbId) {
            _context3.next = 7;
            break;
          }

          _Message2.default.error(_reactIntlUniversal2.default.get('error.no-nb'));
          _context3.next = 5;
          return (0, _effects.put)({ type: _actionTypes.Notes.NEW_NOTE_FAIL, error: {} });

        case 5:
          reject({}, nbId);
          return _context3.abrupt('return');

        case 7:
          _context3.prev = 7;
          _context3.next = 10;
          return (0, _effects.call)(_ajax2.default.newNote, { nbId: nbId, title: title, atBottom: atBottom, hasTop: hasTop });

        case 10:
          _ref3 = _context3.sent;
          data = _ref3.data;
          _context3.next = 14;
          return (0, _effects.put)({ type: _actionTypes.Notes.NEW_NOTE_SUCCESS, data: data, nbId: nbId, atBottom: atBottom, hasTop: hasTop });

        case 14:
          resolve(data, nbId);
          _context3.next = 22;
          break;

        case 17:
          _context3.prev = 17;
          _context3.t0 = _context3['catch'](7);
          _context3.next = 21;
          return (0, _effects.put)({ type: _actionTypes.Notes.NEW_NOTE_FAIL, error: _context3.t0 });

        case 21:
          reject(_context3.t0, nbId);

        case 22:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this, [[7, 17]]);
}

// 这个是仅仅发布非付费文章的接口
function publishNoteAsync(action) {
  var forcedPublish, _action$noteId, noteId, noteContentState, content, notes, _notes$getIn$toJS, shared, title, slug, paid, _ref4, data, resError, _data;

  return _regenerator2.default.wrap(function publishNoteAsync$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          forcedPublish = action.forcedPublish;
          _action$noteId = action.noteId, noteId = _action$noteId === undefined ? '' : _action$noteId;

          noteId = noteId.toString();
          _context4.next = 5;
          return (0, _effects.select)(_NoteContentReducer.getState);

        case 5:
          noteContentState = _context4.sent;
          content = noteContentState.getIn(['entities', noteId, 'content'], '');
          // 提示文章内容为空

          if (content.trim()) {
            _context4.next = 12;
            break;
          }

          _Message2.default.error(_reactIntlUniversal2.default.get('error.content-no-empty'));
          _context4.next = 11;
          return (0, _effects.put)({ type: _actionTypes.Notes.PUBLISH_NOTE_FAIL, error: {}, noteId: noteId });

        case 11:
          return _context4.abrupt('return');

        case 12:
          _context4.next = 14;
          return (0, _effects.select)(_NotesReducer.getState);

        case 14:
          notes = _context4.sent;
          _notes$getIn$toJS = notes.getIn(['entities', noteId]).toJS(), shared = _notes$getIn$toJS.shared, title = _notes$getIn$toJS.title, slug = _notes$getIn$toJS.slug, paid = _notes$getIn$toJS.paid;
          _context4.prev = 16;
          _context4.next = 19;
          return (0, _effects.call)(_ajax2.default.publishNote, noteId, forcedPublish);

        case 19:
          _ref4 = _context4.sent;
          data = _ref4.data;

          if (shared) {
            _context4.next = 24;
            break;
          }

          _context4.next = 24;
          return (0, _effects.put)({
            type: _actionTypes.Global.SET_PUBLISH_SUCCESS_MODAL_DATA,
            show: true,
            data: { noteId: noteId, title: title, slug: slug, paid: paid }
          });

        case 24:
          _context4.next = 26;
          return (0, _effects.put)({ type: _actionTypes.Notes.PUBLISH_NOTE_SUCCESS, data: data, noteId: noteId });

        case 26:
          _context4.next = 41;
          break;

        case 28:
          _context4.prev = 28;
          _context4.t0 = _context4['catch'](16);
          _context4.next = 32;
          return (0, _effects.put)({ type: _actionTypes.Notes.PUBLISH_NOTE_FAIL, error: _context4.t0, noteId: noteId });

        case 32:
          // 如果是未绑定手机，则需要提示用户绑定手机
          resError = _context4.t0.error;

          if (!(resError && resError[0] && resError[0].code === 7)) {
            _context4.next = 36;
            break;
          }

          _context4.next = 36;
          return (0, _effects.put)({ type: _actionTypes.Global.SET_BIND_PHONE_STATUS, hasBind: false, noteId: noteId });

        case 36:
          if (!(resError && resError[0] && resError[0].code === 2030)) {
            _context4.next = 41;
            break;
          }

          _data = resError[0].data;

          _data = JSON.parse(_data || '{}');
          _context4.next = 41;
          return (0, _effects.put)({
            type: _actionTypes.Global.SET_BIND_STATUS,
            status: false,
            data: _data
          });

        case 41:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this, [[16, 28]]);
}

function updateNoteAsync(action) {
  var noteId, title, content, _action$resolve, resolve, _action$reject, reject, notes, autosaveControl, _ref5, data;

  return _regenerator2.default.wrap(function updateNoteAsync$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          noteId = action.noteId, title = action.title, content = action.content, _action$resolve = action.resolve, resolve = _action$resolve === undefined ? _util.noop : _action$resolve, _action$reject = action.reject, reject = _action$reject === undefined ? _util.noop : _action$reject;
          _context5.next = 3;
          return (0, _effects.select)(_NotesReducer.getState);

        case 3:
          notes = _context5.sent;
          autosaveControl = notes.getIn(['entities', noteId, 'autosave_control']);
          _context5.prev = 5;
          _context5.next = 8;
          return (0, _effects.call)(_ajax2.default.updateNote, noteId, autosaveControl, title, content);

        case 8:
          _ref5 = _context5.sent;
          data = _ref5.data;
          _context5.next = 12;
          return (0, _effects.put)({ type: _actionTypes.Notes.UPDATE_NOTE_SUCCESS, data: data, noteId: noteId });

        case 12:
          resolve(data);
          _context5.next = 20;
          break;

        case 15:
          _context5.prev = 15;
          _context5.t0 = _context5['catch'](5);
          _context5.next = 19;
          return (0, _effects.put)({ type: _actionTypes.Notes.UPDATE_NOTE_FAIL, error: _context5.t0, noteId: noteId });

        case 19:
          reject(_context5.t0);

        case 20:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this, [[5, 15]]);
}

function privateNoteAsync(action) {
  var noteId, _ref6, data;

  return _regenerator2.default.wrap(function privateNoteAsync$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          noteId = action.noteId;
          _context6.prev = 1;
          _context6.next = 4;
          return (0, _effects.call)(_ajax2.default.privateNote, noteId);

        case 4:
          _ref6 = _context6.sent;
          data = _ref6.data;
          _context6.next = 8;
          return (0, _effects.put)({ type: _actionTypes.Notes.PRIVATE_NOTE_SUCCESS, data: data, noteId: noteId });

        case 8:
          _context6.next = 14;
          break;

        case 10:
          _context6.prev = 10;
          _context6.t0 = _context6['catch'](1);
          _context6.next = 14;
          return (0, _effects.put)({ type: _actionTypes.Notes.PRIVATE_NOTE_FAIL, error: _context6.t0, noteId: noteId });

        case 14:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this, [[1, 10]]);
}

function deleteNoteSoftAsync(action) {
  var noteId, nbId, doneCallback, _ref7, data;

  return _regenerator2.default.wrap(function deleteNoteSoftAsync$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          noteId = action.noteId, nbId = action.nbId, doneCallback = action.doneCallback;
          _context7.prev = 1;
          _context7.next = 4;
          return (0, _effects.call)(_ajax2.default.deleteNoteSoft, noteId);

        case 4:
          _ref7 = _context7.sent;
          data = _ref7.data;
          _context7.next = 8;
          return (0, _effects.put)({ type: _actionTypes.Notes.DEL_NOTE_SOFT_SUCCESS, data: data, noteId: noteId, nbId: nbId });

        case 8:
          doneCallback(null, data);
          _context7.next = 16;
          break;

        case 11:
          _context7.prev = 11;
          _context7.t0 = _context7['catch'](1);
          _context7.next = 15;
          return (0, _effects.put)({ type: _actionTypes.Notes.DEL_NOTE_SOFT_FAIL, resError: _context7.t0, noteId: noteId, nbId: nbId });

        case 15:
          doneCallback(_context7.t0.error);

        case 16:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this, [[1, 11]]);
}

// 移动文章
function moveNoteAsync(action) {
  var nbId, noteId, newNbId, doneCallback, _ref8, data;

  return _regenerator2.default.wrap(function moveNoteAsync$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          nbId = action.nbId, noteId = action.noteId, newNbId = action.newNbId, doneCallback = action.doneCallback;
          _context8.prev = 1;
          _context8.next = 4;
          return (0, _effects.call)(_ajax2.default.moveNote, newNbId, noteId);

        case 4:
          _ref8 = _context8.sent;
          data = _ref8.data;
          _context8.next = 8;
          return (0, _effects.put)({ type: _actionTypes.Notes.MOVE_NOTE_SUCCESS, data: data, noteId: noteId, newNbId: newNbId, nbId: nbId });

        case 8:
          doneCallback(null, data);
          _context8.next = 16;
          break;

        case 11:
          _context8.prev = 11;
          _context8.t0 = _context8['catch'](1);
          _context8.next = 15;
          return (0, _effects.put)({ type: _actionTypes.Notes.MOVE_NOTE_FAIL, error: _context8.t0, noteId: noteId, newNbId: newNbId, nbId: nbId });

        case 15:
          doneCallback(_context8.t0);

        case 16:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this, [[1, 11]]);
}

// 发布付费文章
function publishPaidNoteAsync(action) {
  var nbId, noteId, amount, content, license, audioPaid, resolve, reject, _ref9, data;

  return _regenerator2.default.wrap(function publishPaidNoteAsync$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          nbId = action.nbId, noteId = action.noteId, amount = action.amount, content = action.content, license = action.license, audioPaid = action.audioPaid, resolve = action.resolve, reject = action.reject;
          _context9.prev = 1;
          _context9.next = 4;
          return (0, _effects.call)(_ajax2.default.updatePNSetting, {
            note_id: noteId,
            amount: amount,
            content: content,
            license: license,
            audio_paid: audioPaid
          });

        case 4:
          _ref9 = _context9.sent;
          data = _ref9.data;
          _context9.next = 8;
          return (0, _effects.put)({ type: _actionTypes.Notes.PUBLISH_PAID_NOTE_SUCCESS, data: data, noteId: noteId, nbId: nbId });

        case 8:
          resolve && resolve(data);
          _context9.next = 16;
          break;

        case 11:
          _context9.prev = 11;
          _context9.t0 = _context9['catch'](1);
          _context9.next = 15;
          return (0, _effects.put)({ type: _actionTypes.Notes.PUBLISH_PAID_NOTE_FAIL, error: _context9.t0, noteId: noteId, nbId: nbId });

        case 15:
          reject && reject(_context9.t0);

        case 16:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this, [[1, 11]]);
}

function getCoverImgAsync(action) {
  var noteId, resolve, reject, _ref10, data;

  return _regenerator2.default.wrap(function getCoverImgAsync$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          noteId = action.noteId, resolve = action.resolve, reject = action.reject;
          _context10.prev = 1;
          _context10.next = 4;
          return (0, _effects.call)(_ajax2.default.getCoverImg, noteId);

        case 4:
          _ref10 = _context10.sent;
          data = _ref10.data;
          _context10.next = 8;
          return (0, _effects.put)({ type: _actionTypes.Notes.GET_COVER_IMG_SUCCESS, data: data, noteId: noteId });

        case 8:
          resolve(data);
          _context10.next = 16;
          break;

        case 11:
          _context10.prev = 11;
          _context10.t0 = _context10['catch'](1);
          _context10.next = 15;
          return (0, _effects.put)({ type: _actionTypes.Notes.GET_COVER_IMG_FAIL, error: _context10.t0, noteId: noteId });

        case 15:
          reject(_context10.t0);

        case 16:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked10, this, [[1, 11]]);
}

function postCoverImgAsync(action) {
  var noteId, flowType, coverImgUrls, abbr, resolve, reject, _ref11, data;

  return _regenerator2.default.wrap(function postCoverImgAsync$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          noteId = action.noteId, flowType = action.flowType, coverImgUrls = action.coverImgUrls, abbr = action.abbr, resolve = action.resolve, reject = action.reject;
          _context11.prev = 1;
          _context11.next = 4;
          return (0, _effects.call)(_ajax2.default.postCoverImg, { noteId: noteId, flowType: flowType, coverImgUrls: coverImgUrls, abbr: abbr });

        case 4:
          _ref11 = _context11.sent;
          data = _ref11.data;
          _context11.next = 8;
          return (0, _effects.put)({ type: _actionTypes.Notes.POST_COVER_IMG_SUCCESS, data: data, noteId: noteId });

        case 8:
          resolve(data);
          _context11.next = 16;
          break;

        case 11:
          _context11.prev = 11;
          _context11.t0 = _context11['catch'](1);
          _context11.next = 15;
          return (0, _effects.put)({ type: _actionTypes.Notes.POST_COVER_IMG_FAIL, error: _context11.t0, noteId: noteId });

        case 15:
          reject(_context11.t0);

        case 16:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked11, this, [[1, 11]]);
}

function postSetNoteTopAsync(action) {
  var noteId, resolve, reject, _ref12, data;

  return _regenerator2.default.wrap(function postSetNoteTopAsync$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          noteId = action.noteId, resolve = action.resolve, reject = action.reject;
          _context12.prev = 1;
          _context12.next = 4;
          return (0, _effects.call)(_ajax2.default.postSetNoteTop, noteId);

        case 4:
          _ref12 = _context12.sent;
          data = _ref12.data;
          _context12.next = 8;
          return (0, _effects.put)({ type: _actionTypes.Notes.POST_SET_NOTE_TOP_SUCCESS, noteId: noteId });

        case 8:
          resolve(data);
          _context12.next = 16;
          break;

        case 11:
          _context12.prev = 11;
          _context12.t0 = _context12['catch'](1);
          _context12.next = 15;
          return (0, _effects.put)({ type: _actionTypes.Notes.POST_SET_NOTE_TOP_FAIL, noteId: noteId });

        case 15:
          reject(_context12.t0);

        case 16:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked12, this, [[1, 11]]);
}

function postUnsetNoteTopAsync(action) {
  var noteId, resolve, reject, _ref13, data;

  return _regenerator2.default.wrap(function postUnsetNoteTopAsync$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          noteId = action.noteId, resolve = action.resolve, reject = action.reject;
          _context13.prev = 1;
          _context13.next = 4;
          return (0, _effects.call)(_ajax2.default.postUnsetNoteTop, noteId);

        case 4:
          _ref13 = _context13.sent;
          data = _ref13.data;
          _context13.next = 8;
          return (0, _effects.put)({ type: _actionTypes.Notes.POST_UNSET_NOTE_TOP_SUCCESS, noteId: noteId });

        case 8:
          resolve(data);
          _context13.next = 16;
          break;

        case 11:
          _context13.prev = 11;
          _context13.t0 = _context13['catch'](1);
          _context13.next = 15;
          return (0, _effects.put)({ type: _actionTypes.Notes.POST_UNSET_NOTE_TOP_FAIL, noteId: noteId });

        case 15:
          reject(_context13.t0);

        case 16:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked13, this, [[1, 11]]);
}

function setNoteReprintAbleAsync(action) {
  var noteId;
  return _regenerator2.default.wrap(function setNoteReprintAbleAsync$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          noteId = action.noteId;
          _context14.prev = 1;
          _context14.next = 4;
          return (0, _effects.call)(_ajax2.default.setReprintAble, noteId);

        case 4:
          _context14.next = 6;
          return (0, _effects.put)({ type: _actionTypes.Notes.SET_NOTE_REPRINTABLE_SUCCESS, noteId: noteId });

        case 6:
          _Message2.default.success(_reactIntlUniversal2.default.get('tips.set-reprintable-success'));
          _context14.next = 14;
          break;

        case 9:
          _context14.prev = 9;
          _context14.t0 = _context14['catch'](1);
          _context14.next = 13;
          return (0, _effects.put)({ type: _actionTypes.Notes.SET_NOTE_REPRINTABLE_FAIL });

        case 13:
          _Message2.default.error(_reactIntlUniversal2.default.get('tips.set-reprintable-fail'));

        case 14:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked14, this, [[1, 9]]);
}

function setNotePublishTimeAsync(action) {
  var noteId, publishTime, resolve, reject;
  return _regenerator2.default.wrap(function setNotePublishTimeAsync$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          noteId = action.noteId, publishTime = action.publishTime, resolve = action.resolve, reject = action.reject;
          _context15.prev = 1;
          _context15.next = 4;
          return (0, _effects.call)(_ajax2.default.setNotePublishTime, noteId, publishTime);

        case 4:
          _context15.next = 6;
          return (0, _effects.put)({ type: _actionTypes.Notes.SET_NOTE_PUBLISH_TIME_SUCCESS, noteId: noteId, publishTime: publishTime });

        case 6:
          resolve();
          _context15.next = 12;
          break;

        case 9:
          _context15.prev = 9;
          _context15.t0 = _context15['catch'](1);

          reject();

        case 12:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked15, this, [[1, 9]]);
}

function watchGetNotes() {
  return _regenerator2.default.wrap(function watchGetNotes$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return (0, _effects.takeEvery)(_actionTypes.Notes.GET_NOTES, getNotesAsync);

        case 2:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked16, this);
}

function watchSortNotes() {
  return _regenerator2.default.wrap(function watchSortNotes$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return (0, _effects.takeLatest)(_actionTypes.Notes.SORT_NOTES, sortNotesAsync);

        case 2:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked17, this);
}

function watchNewNote() {
  return _regenerator2.default.wrap(function watchNewNote$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          _context18.next = 2;
          return (0, _effects.takeEvery)(_actionTypes.Notes.NEW_NOTE, newNoteAsync);

        case 2:
        case 'end':
          return _context18.stop();
      }
    }
  }, _marked18, this);
}

function watchPublishNote() {
  return _regenerator2.default.wrap(function watchPublishNote$(_context19) {
    while (1) {
      switch (_context19.prev = _context19.next) {
        case 0:
          _context19.next = 2;
          return (0, _effects.takeLatest)(_actionTypes.Notes.PUBLISH_NOTE, publishNoteAsync);

        case 2:
        case 'end':
          return _context19.stop();
      }
    }
  }, _marked19, this);
}

function watchUpdateNote() {
  return _regenerator2.default.wrap(function watchUpdateNote$(_context20) {
    while (1) {
      switch (_context20.prev = _context20.next) {
        case 0:
          _context20.next = 2;
          return (0, _effects.takeLatest)(_actionTypes.Notes.UPDATE_NOTE, updateNoteAsync);

        case 2:
        case 'end':
          return _context20.stop();
      }
    }
  }, _marked20, this);
}

function watchPrivateNote() {
  return _regenerator2.default.wrap(function watchPrivateNote$(_context21) {
    while (1) {
      switch (_context21.prev = _context21.next) {
        case 0:
          _context21.next = 2;
          return (0, _effects.takeLatest)(_actionTypes.Notes.PRIVATE_NOTE, privateNoteAsync);

        case 2:
        case 'end':
          return _context21.stop();
      }
    }
  }, _marked21, this);
}

function watchDeleteNoteSoft() {
  return _regenerator2.default.wrap(function watchDeleteNoteSoft$(_context22) {
    while (1) {
      switch (_context22.prev = _context22.next) {
        case 0:
          _context22.next = 2;
          return (0, _effects.takeLatest)(_actionTypes.Notes.DEL_NOTE_SOFT, deleteNoteSoftAsync);

        case 2:
        case 'end':
          return _context22.stop();
      }
    }
  }, _marked22, this);
}

function watchMoveNote() {
  return _regenerator2.default.wrap(function watchMoveNote$(_context23) {
    while (1) {
      switch (_context23.prev = _context23.next) {
        case 0:
          _context23.next = 2;
          return (0, _effects.takeLatest)(_actionTypes.Notes.MOVE_NOTE, moveNoteAsync);

        case 2:
        case 'end':
          return _context23.stop();
      }
    }
  }, _marked23, this);
}

function watchPublishPaidNote() {
  return _regenerator2.default.wrap(function watchPublishPaidNote$(_context24) {
    while (1) {
      switch (_context24.prev = _context24.next) {
        case 0:
          _context24.next = 2;
          return (0, _effects.takeLatest)(_actionTypes.Notes.PUBLISH_PAID_NOTE, publishPaidNoteAsync);

        case 2:
        case 'end':
          return _context24.stop();
      }
    }
  }, _marked24, this);
}

function watchGetCoverImg() {
  return _regenerator2.default.wrap(function watchGetCoverImg$(_context25) {
    while (1) {
      switch (_context25.prev = _context25.next) {
        case 0:
          _context25.next = 2;
          return (0, _effects.takeLatest)(_actionTypes.Notes.GET_COVER_IMG, getCoverImgAsync);

        case 2:
        case 'end':
          return _context25.stop();
      }
    }
  }, _marked25, this);
}

function watchPostCoverImg() {
  return _regenerator2.default.wrap(function watchPostCoverImg$(_context26) {
    while (1) {
      switch (_context26.prev = _context26.next) {
        case 0:
          _context26.next = 2;
          return (0, _effects.takeLatest)(_actionTypes.Notes.POST_COVER_IMG, postCoverImgAsync);

        case 2:
        case 'end':
          return _context26.stop();
      }
    }
  }, _marked26, this);
}

function watchPostSetNoteTop() {
  return _regenerator2.default.wrap(function watchPostSetNoteTop$(_context27) {
    while (1) {
      switch (_context27.prev = _context27.next) {
        case 0:
          _context27.next = 2;
          return (0, _effects.takeLatest)(_actionTypes.Notes.POST_SET_NOTE_TOP, postSetNoteTopAsync);

        case 2:
        case 'end':
          return _context27.stop();
      }
    }
  }, _marked27, this);
}

function watchPostUnsetNoteTop() {
  return _regenerator2.default.wrap(function watchPostUnsetNoteTop$(_context28) {
    while (1) {
      switch (_context28.prev = _context28.next) {
        case 0:
          _context28.next = 2;
          return (0, _effects.takeLatest)(_actionTypes.Notes.POST_UNSET_NOTE_TOP, postUnsetNoteTopAsync);

        case 2:
        case 'end':
          return _context28.stop();
      }
    }
  }, _marked28, this);
}

function watchSetNoteReprintAble() {
  return _regenerator2.default.wrap(function watchSetNoteReprintAble$(_context29) {
    while (1) {
      switch (_context29.prev = _context29.next) {
        case 0:
          _context29.next = 2;
          return (0, _effects.takeLatest)(_actionTypes.Notes.SET_NOTE_REPRINTABLE, setNoteReprintAbleAsync);

        case 2:
        case 'end':
          return _context29.stop();
      }
    }
  }, _marked29, this);
}

function watchSetNotePublishTime() {
  return _regenerator2.default.wrap(function watchSetNotePublishTime$(_context30) {
    while (1) {
      switch (_context30.prev = _context30.next) {
        case 0:
          _context30.next = 2;
          return (0, _effects.takeLatest)(_actionTypes.Notes.SET_NOTE_PUBLISH_TIME, setNotePublishTimeAsync);

        case 2:
        case 'end':
          return _context30.stop();
      }
    }
  }, _marked30, this);
}

/***/ }),

/***/ "G2a6":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "._3PLTX{position:fixed;top:0;left:0;width:100%;height:100%;background-color:#fff;z-index:1010;overflow-y:auto}body.reader-night-mode ._3PLTX{background-color:#3d3d3d}._3PLTX ._3Q2EW{position:fixed;top:50px;right:100px;font-size:30px;font-weight:700;padding:5px;cursor:pointer}body.reader-night-mode ._3PLTX ._3Q2EW{color:#b3b3b3}._3PLTX ._2Mx1k{background-color:#f2f2f2;padding-bottom:110px}body.reader-night-mode ._3PLTX ._2Mx1k{background-color:#595959}._3PLTX ._2Mx1k ._3CoyQ{padding:80px 0 40px;text-align:center}._3PLTX ._2Mx1k ._3CoyQ ._2-ZiM{display:inline-block;height:40px;font-size:28px;font-weight:500;color:#333;margin-bottom:24px}._3PLTX ._2Mx1k ._3CoyQ ._2-ZiM:hover{text-decoration:underline}body.reader-night-mode ._3PLTX ._2Mx1k ._3CoyQ ._2-ZiM{color:#b3b3b3}._3PLTX ._2Mx1k ._3CoyQ ._2ajaT{font-size:16px;font-weight:600;color:#42c02e}._3PLTX ._2Mx1k ._3CoyQ ._2ajaT:hover{color:#3bab29}._3PLTX ._2Mx1k ._3CoyQ ._2ajaT:hover:before{border-color:#3bab29}._3PLTX ._2Mx1k ._3CoyQ ._2ajaT:before{content:\"\";display:inline-block;width:18px;height:10px;border:3px solid #42c02e;border-width:0 0 4px 4px;-webkit-transform:rotate(-45deg);-ms-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-transition:0s;-o-transition:0s;transition:0s;position:relative;bottom:4px;right:8px}._3PLTX ._2Mx1k .zelSB{text-align:center;color:#fff;font-size:14px}._3PLTX ._2Mx1k .zelSB>li{display:inline-block;width:124px;line-height:38px;border-radius:100px;margin:0 15px;cursor:pointer;padding:0;text-align:center}._3PLTX ._2Mx1k .zelSB>li>img{width:21px;position:relative;top:5px;right:5px}._3PLTX ._2Mx1k .zelSB>li i{margin-right:5px}._3PLTX ._2Mx1k .zelSB li._35P4c{background-color:#e05244}._3PLTX ._2Mx1k .zelSB li._1c1Eo{background-color:#07b225}._3PLTX ._2Mx1k .zelSB li._1HWk1{background-color:#3194d0}._3PLTX ._2Mx1k .zelSB li._3Qjz6{background-color:#a7a7a7;position:relative}._3PLTX ._2Mx1k .zelSB li._3Qjz6 ul{width:124px;right:-124px;top:100%;z-index:2}._3PLTX ._2Mx1k .zelSB li._3Qjz6 ul li{padding:4px 12px;line-height:24px}._3PLTX ._2TBVX{position:absolute;top:40%;left:0;right:0;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);background-color:transparent}._3PLTX ._1s967{height:40px;border-radius:50% 50% 0 0/100% 100% 0 0;background-color:#fff;margin-top:-40px}body.reader-night-mode ._3PLTX ._1s967{background-color:#3d3d3d}._3PLTX ._2w_E5{margin:40px auto 0;width:700px;font-size:14px}._3PLTX ._2w_E5 a{color:#42c02e}._3PLTX ._2w_E5 ._23R_O{margin-bottom:36px}._3PLTX ._2w_E5 ._23R_O ._3dZoJ{font-size:16px;font-weight:500;line-height:38px}body.reader-night-mode ._3PLTX ._2w_E5 ._23R_O ._3dZoJ{color:#b3b3b3}._3PLTX ._2w_E5 ._23R_O ._1WCUC{float:right;border:1px solid #d9d9d9;position:relative;width:200px;height:34px;border-radius:17px;padding:5px 20px 5px 30px}body.reader-night-mode ._3PLTX ._2w_E5 ._23R_O ._1WCUC{border-color:#4d4d4d}._3PLTX ._2w_E5 ._23R_O ._1WCUC i{position:absolute;left:10px;top:50%;margin-top:-8px;font-size:16px;color:#ccc}._3PLTX ._2w_E5 ._23R_O ._1WCUC input{line-height:24px;height:24px;width:100%;font-size:14px;background-color:transparent}body.reader-night-mode ._3PLTX ._2w_E5 ._23R_O ._1WCUC input{color:#b3b3b3}._3PLTX ._2w_E5 ._2Yn_Z{position:relative}._3PLTX ._2w_E5 ._18jMg{position:relative;margin-bottom:50px}._3PLTX ._2w_E5 ._18jMg h3{margin-bottom:0;height:40px;line-height:40px;padding:0 6px 0 14px;background-color:#f2f2f2;font-size:14px}body.reader-night-mode ._3PLTX ._2w_E5 ._18jMg h3{color:#b3b3b3;background-color:#4d4d4d}._3PLTX ._2w_E5 ._18jMg h3 a{margin-left:15px}._3PLTX ._2w_E5 ._18jMg h3 .Vd0_D{float:right;color:#999}body.reader-night-mode ._3PLTX ._2w_E5 ._18jMg h3 .Vd0_D{color:#4d4d4d}._3PLTX ._2w_E5 ._18jMg h3 i{padding:0 10px;cursor:pointer;color:#b3b3b3}body.reader-night-mode ._3PLTX ._2w_E5 ._18jMg h3 i{color:#4d4d4d}._3PLTX ._2w_E5 ._18jMg h3 i:hover{color:gray}body.reader-night-mode ._3PLTX ._2w_E5 ._18jMg h3 i:hover{color:#666}._3PLTX ._2w_E5 ._18jMg ._1hEmG{position:relative;margin:1px 0 0 1px;zoom:1;min-height:72px}._3PLTX ._2w_E5 ._18jMg ._1hEmG:after,._3PLTX ._2w_E5 ._18jMg ._1hEmG:before{content:\" \";display:table}._3PLTX ._2w_E5 ._18jMg ._1hEmG:after{clear:both;visibility:hidden;font-size:0;height:0}._3PLTX ._2w_E5 ._18jMg ._1hEmG li{float:left;width:234px;border:1px solid #f2f2f2;position:relative;margin:-1px 0 0 -1px;list-style-type:none}body.reader-night-mode ._3PLTX ._2w_E5 ._18jMg ._1hEmG li{border-color:#4d4d4d}._3PLTX ._2w_E5 ._18jMg ._1hEmG li img{position:absolute;left:15px;height:40px;width:40px;top:15px;border-radius:10%}._3PLTX ._2w_E5 ._18jMg ._1hEmG li a{position:absolute;top:24px;right:15px}._3PLTX ._2w_E5 ._18jMg ._1hEmG li ._1CN24{display:block;font-weight:700;color:#595959;width:100%;padding:0 60px 0 75px;line-height:70px;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap}body.reader-night-mode ._3PLTX ._2w_E5 ._18jMg ._1hEmG li ._1CN24{color:#b3b3b3}._3PLTX ._2w_E5 ._18jMg ._1hEmG ._3q_Pr{width:100%;text-align:center;padding:24px 0;border:1px solid #f2f2f2;border-top:none}body.reader-night-mode ._3PLTX ._2w_E5 ._18jMg ._1hEmG ._3q_Pr{color:#b3b3b3;border-color:#4d4d4d}._3PLTX ._2w_E5 ._18jMg ._1hEmG ._3GDE6{width:50%}._3PLTX ._2w_E5 ._18jMg ._1hEmG ._3GDE6 ._1CN24{display:block;padding:18px 65px 16px;line-height:1}._3PLTX ._2w_E5 ._18jMg ._1hEmG ._3GDE6 ._1CN24 em{font-weight:400;font-style:normal;color:#999;display:block;margin-top:8px;font-size:12px}._3PLTX ._2w_E5 ._18jMg ._245JG{height:120px;position:relative}._3PLTX ._1NlOh{pointer-events:none;cursor:none}._3PLTX ._31Mmk{padding:30px 0 60px;text-align:center;cursor:pointer}._3PLTX ._31Mmk i{margin-left:5px}body.reader-night-mode ._3PLTX ._31Mmk{color:#b3b3b3}._3PLTX ._27pBl{padding:30px 0;text-align:center}body.reader-night-mode ._3PLTX ._27pBl{color:#b3b3b3}", ""]);

// exports
exports.locals = {
	"success-modal": "_3PLTX",
	"close-btn": "_3Q2EW",
	"modal--top": "_2Mx1k",
	"title-wrap": "_3CoyQ",
	"title": "_2-ZiM",
	"status-des": "_2ajaT",
	"share-items": "zelSB",
	"weibo": "_35P4c",
	"wechat": "_1c1Eo",
	"copy-link": "_1HWk1",
	"more-share": "_3Qjz6",
	"modal-top-middle": "_2TBVX",
	"modal--rec": "_1s967",
	"modal--bottom": "_2w_E5",
	"collection-des": "_23R_O",
	"des": "_3dZoJ",
	"search-input-wrap": "_1WCUC",
	"search-result-page": "_2Yn_Z",
	"collection-auto-page": "_18jMg",
	"page-control": "Vd0_D",
	"collection-items": "_1hEmG",
	"collection-title": "_1CN24",
	"empty": "_3q_Pr",
	"rec-collection-item": "_3GDE6",
	"rec-loading-wrap": "_245JG",
	"disabled": "_1NlOh",
	"get-more": "_31Mmk",
	"no-more": "_27pBl"
};

/***/ }),

/***/ "Gbmw":
/***/ (function(module, exports) {

module.exports = "data:application/vnd.ms-fontobject;base64,wBEAABgRAAABAAIAAAAAAAIABQMAAAAAAAABAJABAAAAAExQAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAA/ewx8wAAAAAAAAAAAAAAAAAAAAAAABAAaQBjAG8AbgBmAG8AbgB0AAAADgBSAGUAZwB1AGwAYQByAAAAFgBWAGUAcgBzAGkAbwBuACAAMQAuADAAAAAQAGkAYwBvAG4AZgBvAG4AdAAAAAAAAAEAAAALAIAAAwAwR1NVQrD+s+0AAAE4AAAAQk9TLzI8d0jtAAABfAAAAFZjbWFw/gPSewAAAhAAAAJ+Z2x5Zl+ynJoAAASwAAAJPGhlYWQU5b4mAAAA4AAAADZoaGVhCEUEHgAAALwAAAAkaG10eDyV//wAAAHUAAAAPGxvY2EQDBIyAAAEkAAAACBtYXhwASAAkAAAARgAAAAgbmFtZT5U/n0AAA3sAAACbXBvc3TBGtVvAAAQXAAAALkAAQAAA4D/gABcBJP//P/7BGoAAQAAAAAAAAAAAAAAAAAAAA8AAQAAAAEAAPMx7P1fDzz1AAsEAAAAAADYsD0UAAAAANiwPRT//P+ABGoDgQAAAAgAAgAAAAAAAAABAAAADwCEAAcAAAAAAAIAAAAKAAoAAAD/AAAAAAAAAAEAAAAKAB4ALAABREZMVAAIAAQAAAAAAAAAAQAAAAFsaWdhAAgAAAABAAAAAQAEAAQAAAABAAgAAQAGAAAAAQAAAAAAAQQKAZAABQAIAokCzAAAAI8CiQLMAAAB6wAyAQgAAAIABQMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUGZFZABA5gHm8AOA/4AAXAOBAIAAAAABAAAAAAAABAAAAAQAAAAEAAAABJMAAAQAAAAEAAAABAAAAAQAAAAEAAAABAL//AQAAAAEAAAABAAAAAQAAAAEAAAAAAAABQAAAAMAAAAsAAAABAAAAcYAAQAAAAAAwAADAAEAAAAsAAMACgAAAcYABACUAAAAGgAQAAMACuYC5gTmEOYS5hvmKOYz5lHmkeaZ5qHm8P//AADmAeYE5hDmEuYa5ijmM+ZR5pHmmeah5vD//wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABABoAHAAcABwAHAAeAB4AHgAeAB4AHgAeAAAADgABAAMACgALAAwADQAFAAIABAAGAAgABwAJAAABBgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAC4AAAAAAAAAA4AAOYBAADmAQAAAA4AAOYCAADmAgAAAAEAAOYEAADmBAAAAAMAAOYQAADmEAAAAAoAAOYSAADmEgAAAAsAAOYaAADmGgAAAAwAAOYbAADmGwAAAA0AAOYoAADmKAAAAAUAAOYzAADmMwAAAAIAAOZRAADmUQAAAAQAAOaRAADmkQAAAAYAAOaZAADmmQAAAAgAAOahAADmoQAAAAcAAObwAADm8AAAAAkAAAAAAAAASABqAOoBNgFcAZYB+gLKAyYDYgPwBDIEbgSeAAQAAP+AAx0DgAARABoAIAAsAAAFIisBLgEnET4BNyEeARcRDgEnMjY0JiIGFBYTIisBFTMXBiMhIicRNjchFhcCqxaVqzBAAQFAMAFWMEABAUDbGCAgMCAgbQpLVaqPBwj+VggHDRABjhANgAFAMQMcMUABAUAx/OQxQDghMCAgMCEDjhw3AgL9aAcBAQcAAAEAAAAAA5sCnQARAAAlIi8BJjQ2Mh8BATYyFhQHAQYBoRkU/RImMhTQAY0UMiYS/kYUYhL+FDInE9EBjxMmMxP+QxIABgAA/8EEagM/AAgAEwAcACcARABWAAABNCYiBhQWMjYFNCYjIgYUFjMyNgM0JiIGFBYyNgU0JiMiBhQWMzI2JyYjIg4BFRQXBiMiJi8BJi8BBzcmNTQ+ATMyHgEBFAYHFycGIyIuATQ+ATMyHgEBVxstIyMtGwGOHBUOGRkOFRx/Gi0jIy0aAVUcFQ8YGA8VHI8RFFuYVwwTEg4ZERgHFhuHJptos2lfp3EBTkk/HmtQJVqZV1eZWlaZWwJpFhscKhsa+g8YGB4YGAEfFhscKhsa+g8YGB4YGOQCUo1UKSgCAgMDAQUGRHRtmlqYWEd9/oc/ci9hOxRLgpmCS0uCAAMAAP+4A8gDSAAMABAAKwAAAQYABxYAFzYANyYAJxMjNTMTBw4BFSM1PgE/ATY0JiIGByM+ATceARcUBgcCAMH+/wUFAQHBwQEBBQX+/8EuXFxeKRkcXAEcGTgaM04zAVsCZ01NZwIXEwNHBf7/wcH+/wUFAQHBwQEBBfz6WwEGKhc4MhcmQhk5Gk00NCZNZwICZ00fNBQAAQAAAAAC3gK5ABIAAAE0MQEmIgYUFwkBBhQWMjcBNjQC0v7UCx4VCgET/u0KFR4LASwLAYEBASwKFR4L/u3+7gwdFgsBLQsdAAAAAAQAAP/eA8MDMgAGAAoAGwAfAAABIR4BFzM2NzUhFQEhNSEmJzcjESERIxcGByEVAyE1IQLM/nQgOxmiSlr+GgKs/IgBCjE1RXgCo35EMjIBBBb8tgNKARw1czxwy6mp/mxWbE0sAVv+pSxrTlYC/FcAAAAAAQAA/7sDkANAAEAAAAE0Jic+ASc2JicOARcGFhcOARUGFjcyPgI3Mh8BHgEXDgEVDgEXFjY3Mx4BNzYmJzQmJz4BPwE2Mx4DMxY2A4EmJAMKHghizMxiCB4KAyQmDyMJBRIJDAIDAgIQKAIeJAgCXGR1AhQCdWRcAggkHgIoEAICAwIMCRIFCSMBDQRoMAFAMxL/EhL/EjNAATBoBFY4ARIPGgMGCC44AQ0dAgRHDwgkAwMkCA9HBAIdDQE4LggGAxoPEgE4AAAHAAAAAAOWAssAJAAwAEoAZQBxAHoAgwAAAS4BNz4BJyYGBwYmNzYmJyYGBw4BFzMeARc+ATc1Njc+AScuAQEuASc+ATceARcOARMWMzY3NjUuASciBw4BHgE3NjMeARcUBwYWAyIHDgEeATc2Mx4BFxQHBhYXFjMyNjc2NS4BAQ4BBx4BFz4BNy4BByImNDYyFhQGNw4BLgE+AR4BAsQKDAYICBYYUyYhDAIFATdQoSYxDQMBCcGPebQgBwMEAgcQPP7fZocCAodmZYcDA4fgAwQMBggBNikTEggFBg4ICwsYIAEFAwY4IR8MCwcVDBcYRl4CBwQLDAQFCQ8ECQJ//oY2SAICSDY2SAEBSGATGRkmGRlBBQ0MAwgODAMBhwELCw00GBUGEA4KCw9NDAOCPFRjAU9oAgFPPwENDhEtGCkk/t8CWUNDWgEBWkNDWQFdAgELEhMpNgEIAw4QBgMFASAYCwsIDgEDCQQUGAsDBwJeRhkXDBUEAQsKHyJff/6gAT8wLz8BAT8vMD+3GSYaGiYZUAcFBw4PBQcPAAAAAAT//P+mBAcDPAAIACYALwAzAAABJzMWHwEWBgcXAQ4BLgE3EyMDDgEiJicDIxMWDgEmJwEmNjchHgElNzY3MwcjLgElMxchAu97oCMYoAwOESL+gwYTEggDrjmqAw4TDgOrOa8DCBITBv6DCQ8QA8wRD/wLoRgjn3rtEg0Bv3Z7/pQCTe8BGacNIAFw/fEIBQkSCgIj/bEJCgoJAk/93goSCQQJAg4OHQEBHZCnGQHvASDO7wAAAAACAAAAAAM6AukAEAAhAAABJy4BPgEXBRYGByEuATQ2MxMXHgEOASclJjY3ITIWFAYjApasDgQSHw0BDRYQHP3mEBYWEHetDQQSHw3+8xYQHAIaEBYWEAIegAsfGwUJyBMzAgEWIRf+xIALHxsFCcgTMwIXIRcAAAAEAAD/pAPbA1wAFwAiAFIAWwAAARYdASYGBwYWFyEiJicRPgEzITIzFRQXNxcWBisBJic1PgETDgEHJyYGDwEGIi8BLgEPAS4BJzc2NC8BPgE3FxY2PwE2Mh8BHgE/AR4BFwcGFBcHPgE0JiIGFBYDtgFh5VFNEln+VB8pAQEqHgIiAQIHKsIEBAXCBwEBCPYHJR0kCRADCCRMIggCEQkkHSUHGwcHGwclHSQJEAMIJEwiCAIRCSQdJQcbBwe+JTIySjIyAlsBAvRLF1xf5VMqHwMkHiv4BwH0wwMJAQbDBQP9BCU+GAsDCgkkDAwkCQoDCxg+JRgHEwYZJD8YCwMJCiQLCyQKCQMLGD8kGQYTB0YBMUkxMUkxAAAAAAIAAP+ABAEDgQANACMAAAE0LgIjBgAHFgAXNgAlJj8BPgEfARYyNwE2HwEWFAcBBiInBABNlL1o1f7hBgYBH9XeASP9CgYFEgIIBHoHEgYBPwgHDwMD/qIGEQYBemi9lE0F/t3e1f7hBgYBH7YHCBgDAgNdBQYBCQYGDwMJA/6oBgYAAAEAAP//A0oDAQAlAAAbARYUBwMhNjc2NxUUBiMhIiY9ARM2NCcDNTQ2MyEyFh0BJicmJ+b0Bgb0AYJJHjhCDwr9gwsO9AUF9A8KAn0KD0I4HkwCzf7DCBAI/sMDCxQ5dQoPDwsZAT0IEAgBPRkLDw8LdDkUCwMAAAIAAP+ABAADgAADABsAABEhNSEBJyYiDwEGBx4BFzMxMxEhETM1Fz4BNyYEAPwAAybsGEQY7BMBASwhAmoBAGcFISwBAQMJd/4V+BkZ+BUcICoB/mcBmQEBASogHQAAAAAAEgDeAAEAAAAAAAAAFQAAAAEAAAAAAAEACAAVAAEAAAAAAAIABwAdAAEAAAAAAAMACAAkAAEAAAAAAAQACAAsAAEAAAAAAAUACwA0AAEAAAAAAAYACAA/AAEAAAAAAAoAKwBHAAEAAAAAAAsAEwByAAMAAQQJAAAAKgCFAAMAAQQJAAEAEACvAAMAAQQJAAIADgC/AAMAAQQJAAMAEADNAAMAAQQJAAQAEADdAAMAAQQJAAUAFgDtAAMAAQQJAAYAEAEDAAMAAQQJAAoAVgETAAMAAQQJAAsAJgFpCkNyZWF0ZWQgYnkgaWNvbmZvbnQKaWNvbmZvbnRSZWd1bGFyaWNvbmZvbnRpY29uZm9udFZlcnNpb24gMS4waWNvbmZvbnRHZW5lcmF0ZWQgYnkgc3ZnMnR0ZiBmcm9tIEZvbnRlbGxvIHByb2plY3QuaHR0cDovL2ZvbnRlbGxvLmNvbQAKAEMAcgBlAGEAdABlAGQAIABiAHkAIABpAGMAbwBuAGYAbwBuAHQACgBpAGMAbwBuAGYAbwBuAHQAUgBlAGcAdQBsAGEAcgBpAGMAbwBuAGYAbwBuAHQAaQBjAG8AbgBmAG8AbgB0AFYAZQByAHMAaQBvAG4AIAAxAC4AMABpAGMAbwBuAGYAbwBuAHQARwBlAG4AZQByAGEAdABlAGQAIABiAHkAIABzAHYAZwAyAHQAdABmACAAZgByAG8AbQAgAEYAbwBuAHQAZQBsAGwAbwAgAHAAcgBvAGoAZQBjAHQALgBoAHQAdABwADoALwAvAGYAbwBuAHQAZQBsAGwAbwAuAGMAbwBtAAAAAAIAAAAAAAAACgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADwECAQMBBAEFAQYBBwEIAQkBCgELAQwBDQEOAQ8BEAAFcGhvbmUGZHVpaGFvBndlY2hhdA9uYXZpZ2F0aW9uLWhlbHALeW91amlhbnRvdTEGZG91YmFuAnFxBXdlaWJvBHBhaWQGY2hhbmdlA3NldBJpY29uX3Njcm9sbF9hY3RpdmUHZ29uZ3NoaQppY29uX3N0aWNrAAAAAAA="

/***/ }),

/***/ "H3Ok":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _Icon = __webpack_require__("9JgI");

var _Icon2 = _interopRequireDefault(_Icon);

var _Menu = __webpack_require__("l8jW");

var _Menu2 = _interopRequireDefault(_Menu);

var _NestLoading = __webpack_require__("66rn");

var _NestLoading2 = _interopRequireDefault(_NestLoading);

var _util = __webpack_require__("oFuF");

var _reactIntlUniversal = __webpack_require__("cl+9");

var _reactIntlUniversal2 = _interopRequireDefault(_reactIntlUniversal);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// page button tpl
var renderPageControl = function renderPageControl(curPage, totalPage, styles, onPreBtnClick, onNextBtnClick) {
  if (totalPage <= 1) {
    return null;
  }
  var preBtnClass = (0, _classnames2.default)((0, _defineProperty3.default)({}, styles['disabled'], curPage <= 1));
  var nextBtnClass = (0, _classnames2.default)((0, _defineProperty3.default)({}, styles['disabled'], curPage >= totalPage));
  return _react2.default.createElement(
    'span',
    { className: styles['page-control'] },
    _react2.default.createElement(_Icon2.default, {
      name: 'chevron-circle-left',
      size: 'm',
      onClick: onPreBtnClick,
      className: preBtnClass
    }),
    curPage,
    '/',
    totalPage,
    _react2.default.createElement(_Icon2.default, {
      name: 'chevron-circle-right',
      size: 'm',
      onClick: onNextBtnClick,
      className: nextBtnClass
    })
  );
};

// 管理专题/最近专题
var renderCollectionItems = function renderCollectionItems() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var isLoading = arguments[1];
  var styles = arguments[2];
  var text = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var onContributeBtnClick = arguments[4];

  return _react2.default.createElement(
    'ul',
    { className: styles['collection-items'] },
    isLoading && _react2.default.createElement(_NestLoading2.default, null),
    !isLoading && data.length < 1 && _react2.default.createElement(
      'div',
      { className: styles['empty'] },
      _reactIntlUniversal2.default.get('error.data-empty')
    ),
    !isLoading && data.map(function (v, k) {
      return _react2.default.createElement(
        'li',
        { key: k },
        _react2.default.createElement(
          'a',
          {
            className: styles['post-btn'],
            onClick: onContributeBtnClick,
            'data-collection-id': v.id,
            'data-post-text': text.postText,
            'data-posting-text': text.postingText,
            'data-posted-text': text.postedText
          },
          text.postText
        ),
        _react2.default.createElement('img', {
          alt: 'png',
          src: v.avatar,
          thumbnail: '180x180'
        }),
        _react2.default.createElement(
          'span',
          { className: styles['collection-title'], title: v.title },
          v.title
        )
      );
    })
  );
};

// 推荐专题/搜索专题, 底部点击加载更多的分页模式
var renderRecomendCollectionItems = function renderRecomendCollectionItems() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var isLoading = arguments[1];
  var styles = arguments[2];
  var text = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var onContributeBtnClick = arguments[4];
  var hasMore = arguments[5];
  var onMoreDataBtnClick = arguments[6];

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'ul',
      { className: styles['collection-items'] },
      data.map(function (v, k) {
        return _react2.default.createElement(
          'li',
          { key: k, className: styles['rec-collection-item'] },
          _react2.default.createElement('img', {
            alt: 'png',
            src: v.avatar,
            thumbnail: '180x180'
          }),
          _react2.default.createElement(
            'span',
            { className: styles['collection-title'] },
            v.title,
            _react2.default.createElement(
              'em',
              null,
              _reactIntlUniversal2.default.get('collections.note-num', { num: (0, _util.formatNumByK)(v.notes_count) }),
              '\uFF0C',
              _reactIntlUniversal2.default.get('collections.suber-num', { num: (0, _util.formatNumByK)(v.subscribers_count) })
            )
          ),
          _react2.default.createElement(
            'a',
            {
              className: styles['post-btn'],
              onClick: onContributeBtnClick,
              'data-collection-id': v.id,
              'data-post-text': text.postText,
              'data-posting-text': text.postingText,
              'data-posted-text': text.postedText
            },
            text.postText
          )
        );
      }),
      !isLoading && data.length < 1 && _react2.default.createElement(
        'div',
        { className: styles['empty'] },
        _reactIntlUniversal2.default.get('error.data-empty')
      )
    ),
    isLoading && _react2.default.createElement(
      'div',
      { className: styles['rec-loading-wrap'] },
      _react2.default.createElement(_NestLoading2.default, null)
    ),
    !isLoading && hasMore === true && _react2.default.createElement(
      'div',
      {
        className: styles['get-more'],
        onClick: onMoreDataBtnClick
      },
      _reactIntlUniversal2.default.get('publishSuccessModal.get-more-data'),
      _react2.default.createElement(_Icon2.default, { name: 'caret-down', size: 'm' })
    ),
    !isLoading && hasMore === false && data.length > 0 && _react2.default.createElement(
      'div',
      { className: styles['no-more'] },
      _reactIntlUniversal2.default.get('publishSuccessModal.no-more-data'),
      ' '
    )
  );
};
var renderShareItems = function renderShareItems(shareData, styles) {
  var icons = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var onWeiboShareBtnClick = arguments[3];
  var onWechatShareBtnClick = arguments[4];

  return _react2.default.createElement(
    'ul',
    { className: styles['share-items'] },
    _react2.default.createElement(
      'li',
      { className: styles['weibo'], onClick: onWeiboShareBtnClick },
      _react2.default.createElement(_Icon2.default, { name: 'weibo', className: styles['icon'] }),
      _reactIntlUniversal2.default.get('share.to-weibo')
    ),
    _react2.default.createElement(
      'li',
      { className: styles['wechat'], onClick: onWechatShareBtnClick },
      _react2.default.createElement(_Icon2.default, { name: 'wechat', className: styles['icon'] }),
      _reactIntlUniversal2.default.get('share.to-wechat')
    ),
    _react2.default.createElement(
      'li',
      { className: styles['copy-link'], 'data-clipboard-text': shareData.link },
      _react2.default.createElement(_Icon2.default, { name: 'link', className: styles['icon'] }),
      _reactIntlUniversal2.default.get('share.copy-link')
    ),
    _react2.default.createElement(_Menu.ShareMenu, {
      text: _reactIntlUniversal2.default.get('share.more'),
      className: styles['more-share'],
      direction: '' // 取消方向icon
      , filterItems: ['weibo'],
      renderText: true,
      shareData: shareData
    })
  );
};
// 渲染我管理的专题模块
var renderEditableCoPage = function renderEditableCoPage(cachData, isLoading, styles) {
  var text = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var onContributeBtnClick = arguments[4];
  var curEditableCoPageNum = arguments[5];
  var totalEditableCoPage = arguments[6];
  var onPreBtnClick = arguments[7];
  var onNextBtnClick = arguments[8];
  var newCollectionUrl = arguments[9];

  return _react2.default.createElement(
    'div',
    { className: styles['collection-auto-page'] },
    _react2.default.createElement(
      'h3',
      null,
      _reactIntlUniversal2.default.get('publishSuccessModal.my-collections'),
      _react2.default.createElement(
        'a',
        { href: newCollectionUrl },
        _reactIntlUniversal2.default.get('publishSuccessModal.new-collection')
      ),
      renderPageControl(curEditableCoPageNum, totalEditableCoPage, styles, onPreBtnClick, onNextBtnClick)
    ),
    renderCollectionItems(cachData, isLoading, styles, text, onContributeBtnClick)
  );
};
// 渲染最近投稿的模块
var renderLatestCoPage = function renderLatestCoPage(cachData, isLoading, styles) {
  var text = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var onContributeBtnClick = arguments[4];
  var curLatestCoPageNum = arguments[5];
  var totalLatestCoPage = arguments[6];
  var onPreBtnClick = arguments[7];
  var onNextBtnClick = arguments[8];

  // 如果一条数据都没有直接返回null
  if (cachData[1] && cachData[1].length < 1) {
    return null;
  }
  return _react2.default.createElement(
    'div',
    { className: styles['collection-auto-page'] },
    _react2.default.createElement(
      'h3',
      null,
      _reactIntlUniversal2.default.get('publishSuccessModal.lastest-collections'),
      renderPageControl(curLatestCoPageNum, totalLatestCoPage, styles, onPreBtnClick, onNextBtnClick)
    ),
    renderCollectionItems(cachData[curLatestCoPageNum], isLoading, styles, text, onContributeBtnClick)
  );
};
// 渲染推荐专题模块
var renderRecCoPage = function renderRecCoPage(cachData, isLoading, styles) {
  var text = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var onContributeBtnClick = arguments[4];
  var curRecCoPageNum = arguments[5];
  var totalRecCoPage = arguments[6];
  var onNextBtnClick = arguments[7];

  return _react2.default.createElement(
    'div',
    { className: styles['collection-auto-page'] },
    _react2.default.createElement(
      'h3',
      null,
      _reactIntlUniversal2.default.get('publishSuccessModal.recomend-collections')
    ),
    renderRecomendCollectionItems(cachData, isLoading, styles, text, onContributeBtnClick, curRecCoPageNum < totalRecCoPage, onNextBtnClick)
  );
};

exports.default = {
  renderPageControl: renderPageControl,
  renderCollectionItems: renderCollectionItems,
  renderRecomendCollectionItems: renderRecomendCollectionItems,
  renderShareItems: renderShareItems,
  renderLatestCoPage: renderLatestCoPage,
  renderRecCoPage: renderRecCoPage,
  renderEditableCoPage: renderEditableCoPage
};

/***/ }),

/***/ "I2I8":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("l0FP");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../node_modules/css-loader/index.js??ref--3-1!../node_modules/postcss-loader/lib/index.js!../node_modules/sass-loader/lib/loader.js!./App.scss", function() {
		var newContent = require("!!../node_modules/css-loader/index.js??ref--3-1!../node_modules/postcss-loader/lib/index.js!../node_modules/sass-loader/lib/loader.js!./App.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "IMLV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.b06871f.ttf";

/***/ }),

/***/ "ISlr":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".ant-select{-webkit-box-sizing:border-box;box-sizing:border-box;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;-webkit-font-feature-settings:\"tnum\";font-feature-settings:\"tnum\";position:relative;display:inline-block;outline:0}.ant-select,.ant-select ol,.ant-select ul{margin:0;padding:0;list-style:none}.ant-select>ul>li>a{padding:0;background-color:#fff}.ant-select-arrow{display:inline-block;color:inherit;font-style:normal;line-height:0;text-align:center;text-transform:none;vertical-align:-.125em;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;position:absolute;top:50%;right:11px;margin-top:-6px;color:rgba(0,0,0,.25);font-size:12px;line-height:1;-webkit-transform-origin:50% 50%;-ms-transform-origin:50% 50%;transform-origin:50% 50%}.ant-select-arrow>*{line-height:1}.ant-select-arrow svg{display:inline-block}.ant-select-arrow:before{display:none}.ant-select-arrow .ant-select-arrow-icon{display:block}.ant-select-arrow .ant-select-arrow-icon svg{-webkit-transition:-webkit-transform .3s;transition:-webkit-transform .3s;-o-transition:transform .3s;transition:transform .3s;transition:transform .3s,-webkit-transform .3s}.ant-select-selection{display:block;-webkit-box-sizing:border-box;box-sizing:border-box;background-color:#fff;border:1px solid #d9d9d9;border-top-width:1.02px;border-radius:4px;outline:none;-webkit-transition:all .3s cubic-bezier(.645,.045,.355,1);-o-transition:all .3s cubic-bezier(.645,.045,.355,1);transition:all .3s cubic-bezier(.645,.045,.355,1);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ant-select-selection:hover{border-color:#40a9ff;border-right-width:1px!important}.ant-select-focused .ant-select-selection,.ant-select-selection:active,.ant-select-selection:focus{border-color:#40a9ff;border-right-width:1px!important;outline:0;-webkit-box-shadow:0 0 0 2px rgba(24,144,255,.2);box-shadow:0 0 0 2px rgba(24,144,255,.2)}.ant-select-selection__clear{position:absolute;top:50%;right:11px;z-index:1;display:inline-block;width:12px;height:12px;margin-top:-6px;color:rgba(0,0,0,.25);font-size:12px;font-style:normal;line-height:12px;text-align:center;text-transform:none;background:#fff;cursor:pointer;opacity:0;-webkit-transition:color .3s ease,opacity .15s ease;-o-transition:color .3s ease,opacity .15s ease;transition:color .3s ease,opacity .15s ease;text-rendering:auto}.ant-select-selection__clear:before{display:block}.ant-select-selection__clear:hover{color:rgba(0,0,0,.45)}.ant-select-selection:hover .ant-select-selection__clear{opacity:1}.ant-select-selection-selected-value{float:left;max-width:100%;overflow:hidden;white-space:nowrap;-o-text-overflow:ellipsis;text-overflow:ellipsis}.ant-select-no-arrow .ant-select-selection-selected-value{padding-right:0}.ant-select-disabled{color:rgba(0,0,0,.25)}.ant-select-disabled .ant-select-selection{background:#f5f5f5;cursor:not-allowed}.ant-select-disabled .ant-select-selection:active,.ant-select-disabled .ant-select-selection:focus,.ant-select-disabled .ant-select-selection:hover{border-color:#d9d9d9;-webkit-box-shadow:none;box-shadow:none}.ant-select-disabled .ant-select-selection__clear{display:none;visibility:hidden;pointer-events:none}.ant-select-disabled .ant-select-selection--multiple .ant-select-selection__choice{padding-right:10px;color:rgba(0,0,0,.33);background:#f5f5f5}.ant-select-disabled .ant-select-selection--multiple .ant-select-selection__choice__remove{display:none}.ant-select-selection--single{position:relative;height:32px;cursor:pointer}.ant-select-selection--single .ant-select-selection__rendered{margin-right:24px}.ant-select-no-arrow .ant-select-selection__rendered{margin-right:11px}.ant-select-selection__rendered{position:relative;display:block;margin-right:11px;margin-left:11px;line-height:30px}.ant-select-selection__rendered:after{display:inline-block;width:0;visibility:hidden;content:\".\";pointer-events:none}.ant-select-lg{font-size:16px}.ant-select-lg .ant-select-selection--single{height:40px}.ant-select-lg .ant-select-selection__rendered{line-height:38px}.ant-select-lg .ant-select-selection--multiple{min-height:40px}.ant-select-lg .ant-select-selection--multiple .ant-select-selection__rendered li{height:32px;line-height:32px}.ant-select-lg .ant-select-selection--multiple .ant-select-arrow,.ant-select-lg .ant-select-selection--multiple .ant-select-selection__clear{top:20px}.ant-select-sm .ant-select-selection--single{height:24px}.ant-select-sm .ant-select-selection__rendered{margin-left:7px;line-height:22px}.ant-select-sm .ant-select-selection--multiple{min-height:24px}.ant-select-sm .ant-select-selection--multiple .ant-select-selection__rendered li{height:16px;line-height:14px}.ant-select-sm .ant-select-selection--multiple .ant-select-arrow,.ant-select-sm .ant-select-selection--multiple .ant-select-selection__clear{top:12px}.ant-select-sm .ant-select-arrow,.ant-select-sm .ant-select-selection__clear{right:8px}.ant-select-disabled .ant-select-selection__choice__remove{color:rgba(0,0,0,.25);cursor:default}.ant-select-disabled .ant-select-selection__choice__remove:hover{color:rgba(0,0,0,.25)}.ant-select-search__field__wrap{position:relative;display:inline-block}.ant-select-search__field__placeholder,.ant-select-selection__placeholder{position:absolute;top:50%;right:9px;left:0;max-width:100%;height:20px;margin-top:-10px;overflow:hidden;color:#bfbfbf;line-height:20px;white-space:nowrap;text-align:left;-o-text-overflow:ellipsis;text-overflow:ellipsis}.ant-select-search__field__placeholder{left:12px}.ant-select-search__field__mirror{position:absolute;top:0;left:0;white-space:pre;opacity:0;pointer-events:none}.ant-select-search--inline{position:absolute;width:100%;height:100%}.ant-select-search--inline .ant-select-search__field__wrap{width:100%;height:100%}.ant-select-search--inline .ant-select-search__field{width:100%;height:100%;font-size:100%;line-height:1;background:transparent;border-width:0;border-radius:4px;outline:0}.ant-select-search--inline>i{float:right}.ant-select-selection--multiple{min-height:32px;padding-bottom:3px;cursor:text;zoom:1}.ant-select-selection--multiple:after,.ant-select-selection--multiple:before{display:table;content:\"\"}.ant-select-selection--multiple:after{clear:both}.ant-select-selection--multiple .ant-select-search--inline{position:static;float:left;width:auto;max-width:100%;padding:0}.ant-select-selection--multiple .ant-select-search--inline .ant-select-search__field{width:.75em;max-width:100%}.ant-select-selection--multiple .ant-select-selection__rendered{height:auto;margin-bottom:-3px;margin-left:5px}.ant-select-selection--multiple .ant-select-selection__placeholder{margin-left:6px}.ant-select-selection--multiple .ant-select-selection__rendered>ul>li,.ant-select-selection--multiple>ul>li{height:24px;margin-top:3px;line-height:22px}.ant-select-selection--multiple .ant-select-selection__choice{position:relative;float:left;max-width:99%;margin-right:4px;padding:0 20px 0 10px;overflow:hidden;color:rgba(0,0,0,.65);background-color:#fafafa;border:1px solid #e8e8e8;border-radius:2px;cursor:default;-webkit-transition:padding .3s cubic-bezier(.645,.045,.355,1);-o-transition:padding .3s cubic-bezier(.645,.045,.355,1);transition:padding .3s cubic-bezier(.645,.045,.355,1)}.ant-select-selection--multiple .ant-select-selection__choice__disabled{padding:0 10px}.ant-select-selection--multiple .ant-select-selection__choice__content{display:inline-block;max-width:100%;overflow:hidden;white-space:nowrap;-o-text-overflow:ellipsis;text-overflow:ellipsis;-webkit-transition:margin .3s cubic-bezier(.645,.045,.355,1);-o-transition:margin .3s cubic-bezier(.645,.045,.355,1);transition:margin .3s cubic-bezier(.645,.045,.355,1)}.ant-select-selection--multiple .ant-select-selection__choice__remove{color:inherit;font-style:normal;line-height:0;text-align:center;text-transform:none;vertical-align:-.125em;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;position:absolute;right:4px;color:rgba(0,0,0,.45);font-weight:700;line-height:inherit;cursor:pointer;-webkit-transition:all .3s;-o-transition:all .3s;transition:all .3s;display:inline-block;font-size:12px;font-size:10px\\9;-webkit-transform:scale(.83333) rotate(0deg);-ms-transform:scale(.83333) rotate(0deg);transform:scale(.83333) rotate(0deg)}.ant-select-selection--multiple .ant-select-selection__choice__remove>*{line-height:1}.ant-select-selection--multiple .ant-select-selection__choice__remove svg{display:inline-block}.ant-select-selection--multiple .ant-select-selection__choice__remove:before{display:none}.ant-select-selection--multiple .ant-select-selection__choice__remove .ant-select-selection--multiple .ant-select-selection__choice__remove-icon{display:block}:root .ant-select-selection--multiple .ant-select-selection__choice__remove{font-size:12px}.ant-select-selection--multiple .ant-select-selection__choice__remove:hover{color:rgba(0,0,0,.75)}.ant-select-selection--multiple .ant-select-arrow,.ant-select-selection--multiple .ant-select-selection__clear{top:16px}.ant-select-allow-clear .ant-select-selection--multiple .ant-select-selection__rendered,.ant-select-show-arrow .ant-select-selection--multiple .ant-select-selection__rendered{margin-right:20px}.ant-select-open .ant-select-arrow-icon svg{-webkit-transform:rotate(180deg);-ms-transform:rotate(180deg);transform:rotate(180deg)}.ant-select-open .ant-select-selection{border-color:#40a9ff;border-right-width:1px!important;outline:0;-webkit-box-shadow:0 0 0 2px rgba(24,144,255,.2);box-shadow:0 0 0 2px rgba(24,144,255,.2)}.ant-select-combobox .ant-select-arrow{display:none}.ant-select-combobox .ant-select-search--inline{float:none;width:100%;height:100%}.ant-select-combobox .ant-select-search__field__wrap{width:100%;height:100%}.ant-select-combobox .ant-select-search__field{position:relative;z-index:1;width:100%;height:100%;-webkit-box-shadow:none;box-shadow:none;-webkit-transition:all .3s cubic-bezier(.645,.045,.355,1),height 0s;-o-transition:all .3s cubic-bezier(.645,.045,.355,1),height 0s;transition:all .3s cubic-bezier(.645,.045,.355,1),height 0s}.ant-select-combobox.ant-select-allow-clear .ant-select-selection:hover .ant-select-selection__rendered,.ant-select-combobox.ant-select-show-arrow .ant-select-selection:hover .ant-select-selection__rendered{margin-right:20px}.ant-select-dropdown{margin:0;padding:0;color:rgba(0,0,0,.65);font-variant:tabular-nums;line-height:1.5;list-style:none;-webkit-font-feature-settings:\"tnum\";font-feature-settings:\"tnum\";position:absolute;top:-9999px;left:-9999px;z-index:1050;-webkit-box-sizing:border-box;box-sizing:border-box;font-size:14px;font-variant:normal;background-color:#fff;border-radius:4px;outline:none;-webkit-box-shadow:0 2px 8px rgba(0,0,0,.15);box-shadow:0 2px 8px rgba(0,0,0,.15)}.ant-select-dropdown.slide-up-appear.slide-up-appear-active.ant-select-dropdown-placement-bottomLeft,.ant-select-dropdown.slide-up-enter.slide-up-enter-active.ant-select-dropdown-placement-bottomLeft{-webkit-animation-name:antSlideUpIn;animation-name:antSlideUpIn}.ant-select-dropdown.slide-up-appear.slide-up-appear-active.ant-select-dropdown-placement-topLeft,.ant-select-dropdown.slide-up-enter.slide-up-enter-active.ant-select-dropdown-placement-topLeft{-webkit-animation-name:antSlideDownIn;animation-name:antSlideDownIn}.ant-select-dropdown.slide-up-leave.slide-up-leave-active.ant-select-dropdown-placement-bottomLeft{-webkit-animation-name:antSlideUpOut;animation-name:antSlideUpOut}.ant-select-dropdown.slide-up-leave.slide-up-leave-active.ant-select-dropdown-placement-topLeft{-webkit-animation-name:antSlideDownOut;animation-name:antSlideDownOut}.ant-select-dropdown-hidden{display:none}.ant-select-dropdown-menu{max-height:250px;margin-bottom:0;padding-left:0;overflow:auto;list-style:none;outline:none}.ant-select-dropdown-menu-item-group-list{margin:0;padding:0}.ant-select-dropdown-menu-item-group-list>.ant-select-dropdown-menu-item{padding-left:20px}.ant-select-dropdown-menu-item-group-title{height:32px;padding:0 12px;color:rgba(0,0,0,.45);font-size:12px;line-height:32px}.ant-select-dropdown-menu-item-group-list .ant-select-dropdown-menu-item:first-child:not(:last-child),.ant-select-dropdown-menu-item-group:not(:last-child) .ant-select-dropdown-menu-item-group-list .ant-select-dropdown-menu-item:last-child{border-radius:0}.ant-select-dropdown-menu-item{position:relative;display:block;padding:5px 12px;overflow:hidden;color:rgba(0,0,0,.65);font-weight:400;line-height:22px;white-space:nowrap;-o-text-overflow:ellipsis;text-overflow:ellipsis;cursor:pointer;-webkit-transition:background .3s ease;-o-transition:background .3s ease;transition:background .3s ease}.ant-select-dropdown-menu-item:hover:not(.ant-select-dropdown-menu-item-disabled){background-color:#e6f7ff}.ant-select-dropdown-menu-item:first-child{border-radius:4px 4px 0 0}.ant-select-dropdown-menu-item:last-child{border-radius:0 0 4px 4px}.ant-select-dropdown-menu-item-selected{color:rgba(0,0,0,.65);font-weight:600;background-color:#fafafa}.ant-select-dropdown-menu-item-disabled,.ant-select-dropdown-menu-item-disabled:hover{color:rgba(0,0,0,.25);cursor:not-allowed}.ant-select-dropdown-menu-item-active:not(.ant-select-dropdown-menu-item-disabled){background-color:#e6f7ff}.ant-select-dropdown-menu-item-divider{height:1px;margin:1px 0;overflow:hidden;line-height:0;background-color:#e8e8e8}.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item{padding-right:32px}.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item .ant-select-selected-icon{position:absolute;top:50%;right:12px;color:transparent;font-weight:700;font-size:12px;text-shadow:0 .1px 0,.1px 0 0,0 -.1px 0,-.1px 0;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);-webkit-transition:all .2s;-o-transition:all .2s;transition:all .2s}.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item:hover .ant-select-selected-icon{color:rgba(0,0,0,.87)}.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item-disabled .ant-select-selected-icon{display:none}.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item-selected .ant-select-selected-icon,.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item-selected:hover .ant-select-selected-icon{display:inline-block;color:#1890ff}.ant-select-dropdown--empty.ant-select-dropdown--multiple .ant-select-dropdown-menu-item{padding-right:12px}.ant-select-dropdown-container-open .ant-select-dropdown,.ant-select-dropdown-open .ant-select-dropdown{display:block}", ""]);

// exports


/***/ }),

/***/ "IkM0":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "._2_WAp:after{width:0;height:0;border-top:5px solid transparent;border-bottom:5px solid transparent;margin:4px 0 0 -12px}._3df2u:after{float:left;content:\"\";border-right:5px solid #ccc}._1GURb:after{float:right;content:\"\";border-left:5px solid #ccc}._2_WAp ._3x4X_{height:100%;top:0}._2_WAp ._2KzJx,._2_WAp ._3x4X_{position:absolute;right:100%}._2_WAp .qhLFp{bottom:0}._2_WAp .oGKRI{top:0}._2_WAp ._3DXDE{display:none}", ""]);

// exports
exports.locals = {
	"menuitem": "_2_WAp",
	"menuitem-left": "_3df2u",
	"menuitem-right": "_1GURb",
	"submenu-wrapper": "_3x4X_",
	"submenu": "_2KzJx",
	"submenu-top": "qhLFp",
	"submenu-bottom": "oGKRI",
	"hidden": "_3DXDE"
};

/***/ }),

/***/ "Jl+A":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _Icon = __webpack_require__("9JgI");

var _Icon2 = _interopRequireDefault(_Icon);

var _util = __webpack_require__("oFuF");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _IconFont = __webpack_require__("z69G");

var _IconFont2 = _interopRequireDefault(_IconFont);

var _MenuItem = __webpack_require__("SX5p");

var _MenuItem2 = _interopRequireDefault(_MenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MenuItem = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(MenuItem, _Component);

  function MenuItem() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, MenuItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MenuItem.__proto__ || (0, _getPrototypeOf2.default)(MenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function (e) {
      var _this$props = _this.props,
          index = _this$props.index,
          onClick = _this$props.onClick;

      onClick(e, { index: index });
      (0, _util.stopEvent)(e);
      // console.log('MenuItem::onClick', index);
    }, _this.onMouseEnter = function (e) {
      var _this$props2 = _this.props,
          index = _this$props2.index,
          onMouseEnter = _this$props2.onMouseEnter;

      onMouseEnter(e, { index: index });
      // console.log('MenuItem::onMouseEnter', index);
    }, _this.onMouseLeave = function (e) {
      var _this$props3 = _this.props,
          index = _this$props3.index,
          onMouseLeave = _this$props3.onMouseLeave;

      onMouseLeave(e, { index: index });
      // console.log('MenuItem::onMouseLeave', index);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(MenuItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          iconName = _props.iconName,
          iconFontName = _props.iconFontName,
          className = _props.className,
          hasBorder = _props.hasBorder,
          title = _props.title,
          disabled = _props.disabled;

      var classes = (0, _classnames2.default)(className, _MenuItem2.default['item'], (0, _defineProperty3.default)({}, _MenuItem2.default['item-border'], hasBorder));
      var itemDisable = (0, _classnames2.default)((0, _defineProperty3.default)({}, _MenuItem2.default['item-disabled'], disabled));
      return _react2.default.createElement(
        'li',
        {
          className: classes,
          onClick: this.onClick,
          onMouseEnter: this.onMouseEnter,
          onMouseLeave: this.onMouseLeave,
          title: title
        },
        _react2.default.createElement(
          'span',
          { className: itemDisable },
          iconName && _react2.default.createElement(_Icon2.default, { name: iconName, className: _MenuItem2.default['icon'] }),
          iconFontName && _react2.default.createElement(_IconFont2.default, { name: iconFontName, className: _MenuItem2.default['icon'] }),
          children
        )
      );
    }
  }]);
  return MenuItem;
}(_react.Component), _class.defaultProps = {
  hasBorder: true,
  onClick: _util.noop,
  onMouseEnter: _util.noop,
  onMouseLeave: _util.noop,
  title: '',
  disabled: false
}, _temp2);
exports.default = MenuItem;

/***/ }),

/***/ "JxR3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.watchGetUser = watchGetUser;
exports.watchGetUserOtpChannel = watchGetUserOtpChannel;
exports.watchChangeEditorType = watchChangeEditorType;
exports.watchSwitchScrollAsync = watchSwitchScrollAsync;

var _reactIntlUniversal = __webpack_require__("cl+9");

var _reactIntlUniversal2 = _interopRequireDefault(_reactIntlUniversal);

var _effects = __webpack_require__("egdi");

var _UserReducer = __webpack_require__("i0Fb");

var _actionTypes = __webpack_require__("4HHy");

var _Message = __webpack_require__("mzOA");

var _Message2 = _interopRequireDefault(_Message);

var _ajax = __webpack_require__("Z1y9");

var _ajax2 = _interopRequireDefault(_ajax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(getUserAsync),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(getUserOtpChannelAsync),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(changeEditorType),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(switchScrollAsync),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(watchGetUser),
    _marked6 = /*#__PURE__*/_regenerator2.default.mark(watchGetUserOtpChannel),
    _marked7 = /*#__PURE__*/_regenerator2.default.mark(watchChangeEditorType),
    _marked8 = /*#__PURE__*/_regenerator2.default.mark(watchSwitchScrollAsync); /**
                                                                                 * Created by zad on 17/4/26.
                                                                                 */


function getUserAsync(action) {
  var _ref, data;

  return _regenerator2.default.wrap(function getUserAsync$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.call)(_ajax2.default.getUser);

        case 3:
          _ref = _context.sent;
          data = _ref.data;
          _context.next = 7;
          return (0, _effects.put)({
            type: _actionTypes.User.GET_USER_SUCCESS,
            data: (0, _extends3.default)({
              can_publish_paid_note: false
            }, data, {
              name: data.nickname,
              email: data.slug + '@jianshu.com'
            })
          });

        case 7:
          _context.next = 13;
          break;

        case 9:
          _context.prev = 9;
          _context.t0 = _context['catch'](0);
          _context.next = 13;
          return (0, _effects.put)({ type: _actionTypes.User.GET_USER_FAIL });

        case 13:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[0, 9]]);
}

function getUserOtpChannelAsync(action) {
  var isForce, optChanel, data, result;
  return _regenerator2.default.wrap(function getUserOtpChannelAsync$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          isForce = action.isForce;
          _context2.next = 3;
          return (0, _effects.select)(_UserReducer.getUserOtpChannelState);

        case 3:
          optChanel = _context2.sent;
          data = optChanel.get('data');
          _context2.prev = 5;

          if (!(!data || isForce)) {
            _context2.next = 11;
            break;
          }

          _context2.next = 9;
          return (0, _effects.call)(_ajax2.default.getOtpChannel);

        case 9:
          result = _context2.sent;

          data = result.data; // eslint-disable-line prefer-destructuring

        case 11:
          _context2.next = 13;
          return (0, _effects.put)({ type: _actionTypes.User.GET_USER_OTP_CHANNEL_SUCCESS, data: data });

        case 13:
          _context2.next = 19;
          break;

        case 15:
          _context2.prev = 15;
          _context2.t0 = _context2['catch'](5);
          _context2.next = 19;
          return (0, _effects.put)({ type: _actionTypes.User.GET_USER_OTP_CHANNEL_FAIL });

        case 19:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[5, 15]]);
}

function changeEditorType(action) {
  var editorType;
  return _regenerator2.default.wrap(function changeEditorType$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          editorType = action.editorType;
          _context3.prev = 1;
          _context3.next = 4;
          return (0, _effects.call)(_ajax2.default.changeEditorType, editorType);

        case 4:
          _context3.next = 6;
          return (0, _effects.put)({ type: _actionTypes.User.CHANGE_EDITOR_TYPE_SUCCESS, editorType: editorType });

        case 6:
          _Message2.default.info(_reactIntlUniversal2.default.get('settings.change-editor'));
          _context3.next = 13;
          break;

        case 9:
          _context3.prev = 9;
          _context3.t0 = _context3['catch'](1);
          _context3.next = 13;
          return (0, _effects.put)({ type: _actionTypes.User.CHANGE_EDITOR_TYPE_FAIL });

        case 13:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this, [[1, 9]]);
}

function switchScrollAsync(action) {
  var on;
  return _regenerator2.default.wrap(function switchScrollAsync$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          on = action.on;
          _context4.prev = 1;
          _context4.next = 4;
          return (0, _effects.call)(_ajax2.default.switchScroll, on);

        case 4:
          _Message2.default.success(_reactIntlUniversal2.default.get('settings.switch-sync-scroll'));
          _context4.next = 11;
          break;

        case 7:
          _context4.prev = 7;
          _context4.t0 = _context4['catch'](1);
          _context4.next = 11;
          return (0, _effects.put)({ type: _actionTypes.User.SWITCH_SYNC_SCROLL_FAIL, on: on });

        case 11:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this, [[1, 7]]);
}

function watchGetUser() {
  return _regenerator2.default.wrap(function watchGetUser$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.takeLatest)(_actionTypes.User.GET_USER, getUserAsync);

        case 2:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function watchGetUserOtpChannel() {
  return _regenerator2.default.wrap(function watchGetUserOtpChannel$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.takeLatest)(_actionTypes.User.GET_USER_OTP_CHANNEL, getUserOtpChannelAsync);

        case 2:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function watchChangeEditorType() {
  return _regenerator2.default.wrap(function watchChangeEditorType$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.takeLatest)(_actionTypes.User.CHANGE_EDITOR_TYPE, changeEditorType);

        case 2:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

function watchSwitchScrollAsync() {
  return _regenerator2.default.wrap(function watchSwitchScrollAsync$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.takeLatest)(_actionTypes.User.SWITCH_SYNC_SCROLL, switchScrollAsync);

        case 2:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

/***/ }),

/***/ "K3ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.watchGetNoteContent = watchGetNoteContent;
exports.watchPutAudioMessageAsync = watchPutAudioMessageAsync;
exports.watchDeleteAudio = watchDeleteAudio;
exports.watchGetAudioUrl = watchGetAudioUrl;

var _reactIntlUniversal = __webpack_require__("cl+9");

var _reactIntlUniversal2 = _interopRequireDefault(_reactIntlUniversal);

var _effects = __webpack_require__("egdi");

var _actionTypes = __webpack_require__("4HHy");

var _NoteContentReducer = __webpack_require__("THqP");

var _variables = __webpack_require__("+AJo");

var _ajax = __webpack_require__("Z1y9");

var _ajax2 = _interopRequireDefault(_ajax);

var _Message = __webpack_require__("mzOA");

var _Message2 = _interopRequireDefault(_Message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(getNoteContentAsync),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(putAudioMessageAsync),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(deleteAudioAsync),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(getAudioUrlAsync),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(watchGetNoteContent),
    _marked6 = /*#__PURE__*/_regenerator2.default.mark(watchPutAudioMessageAsync),
    _marked7 = /*#__PURE__*/_regenerator2.default.mark(watchDeleteAudio),
    _marked8 = /*#__PURE__*/_regenerator2.default.mark(watchGetAudioUrl); /**
                                                                           * Created by zad on 17/4/26.
                                                                           */


function getNoteContentAsync(action) {
  var state, noteId, isForce, content, _ref, data;

  return _regenerator2.default.wrap(function getNoteContentAsync$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(_NoteContentReducer.getState);

        case 2:
          state = _context.sent;
          noteId = action.noteId, isForce = action.isForce;
          content = state.getIn(['entities', noteId, 'content'], _variables.CONTENT_NOT_FOUND);
          _context.prev = 5;

          if (!(content === _variables.CONTENT_NOT_FOUND || isForce)) {
            _context.next = 15;
            break;
          }

          _context.next = 9;
          return (0, _effects.call)(_ajax2.default.getNoteContent, noteId);

        case 9:
          _ref = _context.sent;
          data = _ref.data;
          _context.next = 13;
          return (0, _effects.put)({ type: _actionTypes.NoteContent.GET_NOTE_CONTENT_SUCCESS, data: data, noteId: noteId });

        case 13:
          _context.next = 17;
          break;

        case 15:
          _context.next = 17;
          return (0, _effects.put)({ type: _actionTypes.NoteContent.GET_NOTE_CONTENT_SUCCESS, noteId: noteId, isCache: true });

        case 17:
          _context.next = 23;
          break;

        case 19:
          _context.prev = 19;
          _context.t0 = _context['catch'](5);
          _context.next = 23;
          return (0, _effects.put)({ type: _actionTypes.NoteContent.GET_NOTE_CONTENT_FAIL, noteId: noteId });

        case 23:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[5, 19]]);
}

function putAudioMessageAsync(action) {
  var noteId, params, _ref2, data;

  return _regenerator2.default.wrap(function putAudioMessageAsync$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          noteId = action.noteId, params = action.params;
          _context2.prev = 1;
          _context2.next = 4;
          return (0, _effects.call)(_ajax2.default.putAudioMessage, noteId, params);

        case 4:
          _ref2 = _context2.sent;
          data = _ref2.data;
          _context2.next = 8;
          return (0, _effects.put)({ type: _actionTypes.NoteContent.PUT_AUDIO_MESSAGE_SUCCESS, data: data, noteId: noteId, params: params });

        case 8:
          _context2.next = 14;
          break;

        case 10:
          _context2.prev = 10;
          _context2.t0 = _context2['catch'](1);
          _context2.next = 14;
          return (0, _effects.put)({ type: _actionTypes.NoteContent.PUT_AUDIO_MESSAGE_FAIL, error: _context2.t0, noteId: noteId });

        case 14:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[1, 10]]);
}

function deleteAudioAsync(action) {
  var noteId, _ref3, data;

  return _regenerator2.default.wrap(function deleteAudioAsync$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          noteId = action.noteId;
          _context3.prev = 1;
          _context3.next = 4;
          return (0, _effects.call)(_ajax2.default.deleteAudio, noteId);

        case 4:
          _ref3 = _context3.sent;
          data = _ref3.data;
          _context3.next = 8;
          return (0, _effects.put)({ type: _actionTypes.NoteContent.DELETE_AUDIO_SUCCESS, data: data, noteId: noteId });

        case 8:
          _context3.next = 14;
          break;

        case 10:
          _context3.prev = 10;
          _context3.t0 = _context3['catch'](1);
          _context3.next = 14;
          return (0, _effects.put)({ type: _actionTypes.NoteContent.DELETE_AUDIO_FAIL, error: _context3.t0, noteId: noteId });

        case 14:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this, [[1, 10]]);
}

function getAudioUrlAsync(action) {
  var noteId, _ref4, data;

  return _regenerator2.default.wrap(function getAudioUrlAsync$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          noteId = action.noteId;
          _context4.prev = 1;
          _context4.next = 4;
          return (0, _effects.call)(_ajax2.default.getAudioUrl, noteId);

        case 4:
          _ref4 = _context4.sent;
          data = _ref4.data;
          _context4.next = 8;
          return (0, _effects.put)({ type: _actionTypes.NoteContent.GET_AUDIO_URL_SUCCESS, data: data, noteId: noteId });

        case 8:
          _context4.next = 14;
          break;

        case 10:
          _context4.prev = 10;
          _context4.t0 = _context4['catch'](1);
          _context4.next = 14;
          return (0, _effects.put)({ type: _actionTypes.NoteContent.GET_AUDIO_URL_FAIL, error: _context4.t0, noteId: noteId });

        case 14:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this, [[1, 10]]);
}

// eslint-disable-next-line import/prefer-default-export
function watchGetNoteContent() {
  return _regenerator2.default.wrap(function watchGetNoteContent$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.takeLatest)(_actionTypes.NoteContent.GET_NOTE_CONTENT, getNoteContentAsync);

        case 2:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function watchPutAudioMessageAsync() {
  return _regenerator2.default.wrap(function watchPutAudioMessageAsync$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.takeLatest)(_actionTypes.NoteContent.PUT_AUDIO_MESSAGE, putAudioMessageAsync);

        case 2:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function watchDeleteAudio() {
  return _regenerator2.default.wrap(function watchDeleteAudio$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.takeLatest)(_actionTypes.NoteContent.DELETE_AUDIO, deleteAudioAsync);

        case 2:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

function watchGetAudioUrl() {
  return _regenerator2.default.wrap(function watchGetAudioUrl$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.takeLatest)(_actionTypes.NoteContent.GET_AUDIO_URL, getAudioUrlAsync);

        case 2:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

/***/ }),

/***/ "KluA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__("+6Bu");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _isFunction2 = __webpack_require__("gGqR");

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _isString2 = __webpack_require__("JDN0");

var _isString3 = _interopRequireDefault(_isString2);

var _class, _temp;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("O27J");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _Button = __webpack_require__("wyFM");

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line no-underscore-dangle
var _type = {
  type: ['primary', 'danger']
};
var regTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
var isTwoCNChar = regTwoCNChar.test.bind(regTwoCNChar);

var Button = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Button, _Component);

  function Button(props) {
    (0, _classCallCheck3.default)(this, Button);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Button.__proto__ || (0, _getPrototypeOf2.default)(Button)).call(this, props));

    _this.getChildren = function () {
      var children = _this.props.children;

      return _react2.default.Children.map(children, function (child) {
        // 如果是两个中文，则自动插入空格
        if ((0, _isString3.default)(child) && isTwoCNChar(child)) {
          return _react2.default.createElement(
            'span',
            null,
            child.split('').join(' ')
          );
        }
        if ((0, _isString3.default)(child)) {
          return _react2.default.createElement(
            'span',
            null,
            child
          );
        }
        return child;
      });
    };

    _this.clickBtn = function (e) {
      _this.setState({ clicked: false });
      // 先clear，再remove
      if (_this.removeClicked) {
        clearTimeout(_this.removeClicked);
      }

      _this.addClicked = setTimeout(function () {
        _this.setState({ clicked: true });
      }, 10);
      _this.removeClicked = setTimeout(function () {
        _this.setState({ clicked: false });
      }, 500);
      if ((0, _isFunction3.default)(_this.props.onClick)) {
        _this.props.onClick(e);
      }
    };

    _this.blurBtn = function () {
      // eslint-disable-next-line react/no-find-dom-node
      _reactDom2.default.findDOMNode(_this).blur();
    };

    _this.state = { clicked: false };
    return _this;
  }

  (0, _createClass3.default)(Button, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.addClicked) {
        clearTimeout(this.addClicked);
        this.addClicked = null;
      }
      if (this.removeClicked) {
        clearTimeout(this.removeClicked);
        this.removeClicked = null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          type = _props.type,
          strong = _props.strong,
          className = _props.className,
          htmlType = _props.htmlType,
          props = (0, _objectWithoutProperties3.default)(_props, ['type', 'strong', 'className', 'htmlType']);
      var clicked = this.state.clicked;


      var btnClass = (0, _classnames2.default)((_classNames = {}, (0, _defineProperty3.default)(_classNames, '' + className, !!className), (0, _defineProperty3.default)(_classNames, '' + _Button2.default['btn'], true), (0, _defineProperty3.default)(_classNames, '' + _Button2.default['btn-strong'], !!strong), (0, _defineProperty3.default)(_classNames, '' + _Button2.default['btn-clicked'], clicked), (0, _defineProperty3.default)(_classNames, '' + _Button2.default['btn-' + type], type && _type.type.includes(type)), _classNames));

      return _react2.default.createElement(
        'button',
        (0, _extends3.default)({}, props, {
          type: htmlType || 'button',
          className: btnClass,
          onClick: this.clickBtn,
          onMouseUp: this.blurBtn
        }),
        this.getChildren()
      );
    }
  }]);
  return Button;
}(_react.Component), _class.propTypes = {
  type: _propTypes2.default.oneOf(_type.type),
  htmlType: _propTypes2.default.string,
  className: _propTypes2.default.string,
  strong: _propTypes2.default.bool,
  onClick: _propTypes2.default.func
}, _class.defaultProps = {
  strong: false
}, _class.__Button__ = true, _temp);
exports.default = Button;

/***/ }),

/***/ "MAZe":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("G2a6");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./PublishSuccessModal.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./PublishSuccessModal.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "OPmc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.default = rootSaga;

var _effects = __webpack_require__("egdi");

var _GlobalSaga = __webpack_require__("3SFg");

var _UserSaga = __webpack_require__("JxR3");

var _NotebooksSaga = __webpack_require__("2PWF");

var _NotesSaga = __webpack_require__("FufB");

var _NoteContentSaga = __webpack_require__("K3ts");

var _NoteHistorySaga = __webpack_require__("Qs4s");

var _TrashSaga = __webpack_require__("3zmX");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(rootSaga); /**
                                                                  * Created by zad on 17/4/26.
                                                                  */


function rootSaga() {
  return _regenerator2.default.wrap(function rootSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.all)([
          // global
          (0, _GlobalSaga.watchChangeLocale)(), (0, _GlobalSaga.watchChangeReadMode)(), (0, _GlobalSaga.watchChangeFontType)(),
          // user
          (0, _UserSaga.watchGetUser)(), (0, _UserSaga.watchGetUserOtpChannel)(), (0, _UserSaga.watchChangeEditorType)(), (0, _UserSaga.watchSwitchScrollAsync)(),
          // notebooks
          (0, _NotebooksSaga.watchGetNotebooks)(), (0, _NotebooksSaga.watchSortNotebooks)(), (0, _NotebooksSaga.watchNewNoteBook)(), (0, _NotebooksSaga.watchDelNoteBookSoft)(), (0, _NotebooksSaga.watchRenameNoteBook)(),
          // notes
          (0, _NotesSaga.watchGetNotes)(), (0, _NotesSaga.watchSortNotes)(), (0, _NotesSaga.watchNewNote)(), (0, _NotesSaga.watchPublishNote)(), (0, _NotesSaga.watchUpdateNote)(), (0, _NotesSaga.watchPrivateNote)(), (0, _NotesSaga.watchDeleteNoteSoft)(), (0, _NotesSaga.watchMoveNote)(), (0, _NotesSaga.watchPublishPaidNote)(), (0, _NotesSaga.watchGetCoverImg)(), (0, _NotesSaga.watchPostCoverImg)(), (0, _NotesSaga.watchPostSetNoteTop)(), (0, _NotesSaga.watchPostUnsetNoteTop)(), (0, _NotesSaga.watchSetNoteReprintAble)(), (0, _NotesSaga.watchSetNotePublishTime)(),
          // note-content
          (0, _NoteContentSaga.watchGetNoteContent)(), (0, _NoteContentSaga.watchPutAudioMessageAsync)(), (0, _NoteContentSaga.watchDeleteAudio)(), (0, _NoteContentSaga.watchGetAudioUrl)(),
          // note-histtory
          (0, _NoteHistorySaga.watchGetNoteHistoryList)(), (0, _NoteHistorySaga.watchGetNoteHistoryContent)(), (0, _NoteHistorySaga.watchRestoreNoteHistoryContent)(),
          // trash
          (0, _TrashSaga.watchGetTrashNotesList)(), (0, _TrashSaga.watchGetTrashNote)(), (0, _TrashSaga.watchDelTrashNote)(), (0, _TrashSaga.watchRecoveryTrashNote)()]);

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

/***/ }),

/***/ "Ohkn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _saSdkJavascript = __webpack_require__("uYVh");

var _saSdkJavascript2 = _interopRequireDefault(_saSdkJavascript);

var _events = __webpack_require__("aNgh");

var _events2 = _interopRequireDefault(_events);

var _util = __webpack_require__("oFuF");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.SAEVENTS = _events2.default; /* eslint-disable class-methods-use-this */

var EVENT_VALUES = [];
(0, _keys2.default)(_events2.default).forEach(function (k) {
  EVENT_VALUES.push(_events2.default[k]);
});

var SA_SERVER_URL = "https://events.jianshu.io:4006/sa?project=production"; // 默认走测试
var isProduction = "production" === 'production';

var JsSensor = function () {
  function JsSensor() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, JsSensor);

    var showLog = isProduction ? false : !!options.debug;
    // URL参数sensor_debug为true即可进入debug模式，方便线上调试
    if ((0, _util.getParameterByName)('sensor_debug') === 'true') {
      showLog = true;
    }
    _saSdkJavascript2.default.init({
      server_url: options.server_url || SA_SERVER_URL,
      show_log: showLog,
      debug_mode: isProduction ? false : !!options.debug_mode,
      is_single_page: options.is_single_page || false
    });

    this.initUser(options.user);

    _saSdkJavascript2.default.registerPage({
      platform: 'web', // 标识是web平台,以区别android和ios
      site: 'martin' // 标识web站点
    });
    // 自动收集$pageview事件
    _saSdkJavascript2.default.quick('autoTrack');
  }

  (0, _createClass3.default)(JsSensor, [{
    key: 'initUser',
    value: function initUser(user) {
      // init the user
      if (user) {
        this.login(user.id);
      } else {
        this.logout();
      }
    }
  }, {
    key: 'login',
    value: function login(userId) {
      // sensors目前仅支持一个userId
      _saSdkJavascript2.default.login(userId);
    }
    /*
     * 取消当前 login 的 id，改成最初自动生成的 cookie_id，A -> 真A -> A
     * 如果设置isNew 为true，则会重新生成一个新的 cookie_id，A -> 真A -> B
     */

  }, {
    key: 'logout',
    value: function logout(isNew) {
      _saSdkJavascript2.default.logout(isNew);
    }
    // 设置pagename

  }, {
    key: 'setPageName',
    value: function setPageName(pagename) {
      _saSdkJavascript2.default.registerPage({
        pagename: pagename
      });
    }
  }, {
    key: 'sendPV',
    value: function sendPV(cp) {
      _saSdkJavascript2.default.quick('autoTrack', cp);
    }
  }, {
    key: 'trackEvent',
    value: function trackEvent(eventId, cp, callback) {
      if (EVENT_VALUES.indexOf(eventId) >= 0) {
        _saSdkJavascript2.default.track(eventId, cp, callback);
      } else if (!isProduction && window.console) {
        console.warn('when you see this warning, the track data is failure, because %s is not listed in events.js', eventId); // eslint-disable-line no-console
      }
    }
  }]);
  return JsSensor;
}();

exports.default = JsSensor;

/***/ }),

/***/ "PNPU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = shareToSNS;

var _reactIntlUniversal = __webpack_require__("cl+9");

var _reactIntlUniversal2 = _interopRequireDefault(_reactIntlUniversal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function openShareWindow(url, title) {
  var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 600;
  var height = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 600;

  if (!url) {
    return;
  }
  function x() {
    if (!window.open(url, title, 'toolbar=0,resizable=1,scrollbars=yes,status=1,width=' + width + ',height=' + height)) {
      window.location.href = url;
    }
  }
  if (/Firefox/.test(navigator.userAgent)) {
    setTimeout(x, 0);
  } else {
    x();
  }
} /* 分享工具类 */
/* eslint-disable no-param-reassign,no-nested-ternary,no-useless-escape,quotes,space-infix-ops */
function shareToSNS(sns, link, title) {
  var text = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var images = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

  var e = encodeURIComponent;

  link = e(link + '?utm_campaign=maleskine&utm_content=note&utm_medium=writer_share&utm_source=' + sns);

  if (title && title.length > 0) {
    title = title.replace(/\'|\"/g, "'");
  } else {
    title = '';
  }
  var shareUrl = '';
  title = e(title);
  var d = document;
  var s1 = window.getSelection;
  var s2 = d.getSelection;
  var s3 = d.selection;
  var s = s1 ? s1() : s2 ? s2() : s3 ? s3.createRange().text : '';
  switch (sns) {
    case 'weibo':
      shareUrl = 'http://service.weibo.com/share/share.php?appkey=' + 1881139527 + '&\n        title=' + title + '&url=' + link + '&searchPic=false&style=simple';
      if (images.length > 0) {
        shareUrl += '&pic=' + e(images[0]);
      }
      break;
    case 'douban':
      shareUrl = 'http://www.douban.com/recommend/?url=' + link + '&title=' + title + '\'&sel=' + e(s) + '&v=1&r=1';
      break;
    case 'tweibo':
      shareUrl = 'http://share.v.t.qq.com/index.php?c=share&a=index&url=' + link + '&title=' + title;
      break;
    case 'qzone':
      shareUrl = 'http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=\'' + link + '\'&title=' + title;
      break;
    case 'twitter':
      shareUrl = 'https://twitter.com/share?url=' + link + '&text=' + title + '&related=jianshuio';
      break;
    case 'facebook':
      shareUrl = 'http://www.facebook.com/sharer.php?s=100&p[url]=' + link + '&p[title]=' + title + ' ' + _reactIntlUniversal2.default.get("share.trailing-jianshushe") + '&p[summary]=' + (text || title);
      break;
    case 'google_plus':
      shareUrl = 'https://plus.google.com/share?url=' + link;
      break;
    default:
      break;
  }
  openShareWindow(shareUrl, title);
}

/***/ }),

/***/ "PREo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

exports.default = function (content, options) {
  return (0, _ModalConfirm2.default)(content, (0, _assign2.default)({}, options, { showCancelBtn: false }));
};

var _ModalConfirm = __webpack_require__("1nMn");

var _ModalConfirm2 = _interopRequireDefault(_ModalConfirm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "PayV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/iconfont.dd9aa51.svg";

/***/ }),

/***/ "Q9EA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _Icon = __webpack_require__("9JgI");

var _Icon2 = _interopRequireDefault(_Icon);

var _Menu = __webpack_require__("l8jW");

var _Menu2 = _interopRequireDefault(_Menu);

var _MenuUtil = __webpack_require__("DgVG");

var _util = __webpack_require__("oFuF");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__("O27J");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _rcAnimate = __webpack_require__("8aSS");

var _rcAnimate2 = _interopRequireDefault(_rcAnimate);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _Dropdown = __webpack_require__("8Pl5");

var _Dropdown2 = _interopRequireDefault(_Dropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MouseEvents = ['mousedown', 'mousemove', 'mouseup'];
var winSize = (0, _util.getWindowSize)();
var Dropdown = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Dropdown, _Component);

  function Dropdown(props) {
    (0, _classCallCheck3.default)(this, Dropdown);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Dropdown.__proto__ || (0, _getPrototypeOf2.default)(Dropdown)).call(this, props));

    _this.autoAlignMenu = function () {
      var autoAlign = _this.props.autoAlign;
      // 计算下显示的位置是否合理

      if (autoAlign && _this.menuRef) {
        var rect = _this.menuRef.getBoundingClientRect();
        if (rect.width && rect.height) {
          var className = _this.menuRef.className;

          if (rect.height + rect.top > winSize[1]) {
            className = className.replace(new RegExp(_Dropdown2.default['menu-bottom']), '');
            _this.menuRef.className = className + ' ' + _Dropdown2.default['menu-top'];
          }
        }
      }
    };

    _this.stopPropagationEvent = function (e) {
      e.stopPropagation();
    };

    _this.stopEventsForSortableParent = function (on) {
      if (on) {
        MouseEvents.map(function (v) {
          _this.dropDown.addEventListener(v, _this.stopPropagationEvent, false);
          return null;
        });
      } else {
        MouseEvents.map(function (v) {
          _this.dropDown.removeEventListener(v, _this.stopPropagationEvent, false);
          return null;
        });
      }
    };

    _this.setShowMenu = function (visible, isMenuClick) {
      var onMenuVisibleChange = _this.props.onMenuVisibleChange;

      if (typeof visible === 'boolean') {
        // onMenuVisibleChange(visible);
        _this.setState({
          showMenu: visible
        });
      }
    };

    _this.iconClickHandler = function (e) {
      var showMenu = _this.state.showMenu;

      _this.setShowMenu(!showMenu);
    };

    _this.clickInside = function (e) {
      // 如果点击到外部，则进行switch
      var isClickInside = _this.dropDown.contains(e.target);
      if (!isClickInside) {
        _this.setShowMenu(false);
      }
    };

    _this.renderDropIcon = function () {
      var children = _this.props.children;

      if (children) {
        return (0, _MenuUtil.renderChildren)(children, {
          onClick: _this.iconClickHandler
        });
      }
      return _react2.default.createElement(_Icon2.default, { name: 'gear', className: _Dropdown2.default['icon-gear'], onClick: _this.iconClickHandler });
    };

    _this.onDropDownItemClick = function (e, data) {
      var onItemClick = _this.props.onItemClick;

      onItemClick(e, data);
    };

    _this.renderDropDownMenu = function () {
      var showMenu = _this.state.showMenu;
      var _this$props = _this.props,
          menuItems = _this$props.menuItems,
          menuCustomClass = _this$props.menuCustomClass,
          autoFix = _this$props.autoFix;

      var menuClass = [menuCustomClass, _Dropdown2.default['menu'], _Dropdown2.default['menu-bottom']];
      menuClass = (0, _classnames2.default)(menuClass, (0, _defineProperty3.default)({}, _Dropdown2.default['show'], showMenu));

      return _react2.default.createElement(
        _Menu2.default,
        {
          getMenuDom: function getMenuDom(v) {
            _this.menuRef = v;
          },
          className: menuClass,
          onClick: _this.onDropDownItemClick
        },
        menuItems
      );
    };

    _this.setShowMenu(props.showMenu);
    _this.state = {
      showMenu: false
    };
    return _this;
  }

  (0, _createClass3.default)(Dropdown, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var sortable = this.props.sortable;

      if (sortable) {
        this.stopEventsForSortableParent(true);
      }
      this.autoAlignMenu();
      window.addEventListener('click', this.clickInside, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // 如果外侧设置了
      this.setShowMenu(nextProps.showMenu);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.autoAlignMenu();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('click', this.clickInside, false);
      this.stopEventsForSortableParent(false);
    }
    // 对于sortable元素需要取消一些事件，以保证排序动作流畅
    // 因为react的事件系统会导致事件最后触发，无法在父元素事件触发之前就阻止掉冒泡，所以用原生的监听方式

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var showMenu = this.state.showMenu;
      var _props = this.props,
          children = _props.children,
          className = _props.className;

      var cls = (0, _classnames2.default)(_Dropdown2.default['dropdown'], className);
      return _react2.default.createElement(
        'div',
        {
          className: cls,
          ref: function ref(el) {
            _this2.dropDown = el;
          }
        },
        this.renderDropIcon(),
        _react2.default.createElement(
          _rcAnimate2.default,
          { transitionName: 'fade', component: 'span' },
          this.renderDropDownMenu()
        )
      );
    }
  }]);
  return Dropdown;
}(_react.Component), _class.propTypes = {
  showMenu: _propTypes2.default.bool // 控制menu的显影
}, _class.defaultProps = {
  autoAlign: true,
  onItemClick: _util.noop,
  onMenuVisibleChange: _util.noop, // menu visible change,
  sortable: false // 如果父元素是sortable的，需要设置为true
}, _temp);
exports.default = Dropdown;

/***/ }),

/***/ "QgNW":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "._2bPLj{height:273px;display:-webkit-box;display:-ms-flexbox;display:flex}._2bPLj ._2O_i0{width:40%;margin-top:50px;height:170px;border-right:1px solid #d8d8d8;padding:0 16px 60px 30px;-webkit-box-sizing:border-box;box-sizing:border-box}._2bPLj ._2O_i0 img{width:100%;margin-bottom:16px}._2bPLj ._2O_i0 ._2bPLj{font-family:PingFang-SC;font-size:14px;font-weight:400;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:#999}._2bPLj ._22F9u{width:60%;margin-top:50px;padding-left:20px}._2bPLj ._22F9u ._2-GkG{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;width:263px;height:60px;padding:18px;border-radius:8px;background-color:#fafafa;border:1px solid #ddd;margin-bottom:30px;font-size:16px}._2bPLj ._22F9u .ZYxKq{color:#999}._2bPLj ._22F9u .ZYxKq ._2H-zz{margin-right:18px;color:#999;font-size:16px}._2bPLj ._22F9u .ZYxKq ._1B8hd{color:#49be38}._2bPLj ._22F9u ._2-GkG .fOJcl{width:90px;height:30px;border-radius:16px;font-size:14px;color:#3294d0;border:1px solid #3294d0;cursor:pointer}._2bPLj ._22F9u ._2-GkG .fOJcl a{color:#3294d0}._2bPLj ._22F9u ._2-GkG .fOJcl:hover{background-color:rgba(50,148,208,.05)}", ""]);

// exports
exports.locals = {
	"content": "_2bPLj",
	"left": "_2O_i0",
	"right": "_22F9u",
	"item": "_2-GkG",
	"item-left": "ZYxKq",
	"icon": "_2H-zz",
	"active": "_1B8hd",
	"btn": "fOJcl"
};

/***/ }),

/***/ "Qs4s":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.watchGetNoteHistoryList = watchGetNoteHistoryList;
exports.watchGetNoteHistoryContent = watchGetNoteHistoryContent;
exports.watchRestoreNoteHistoryContent = watchRestoreNoteHistoryContent;

var _reduxSaga = __webpack_require__("igqX");

var _effects = __webpack_require__("egdi");

var _actionTypes = __webpack_require__("4HHy");

var _NoteHistoryReducer = __webpack_require__("qiO7");

var _ajax = __webpack_require__("Z1y9");

var _ajax2 = _interopRequireDefault(_ajax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(getNoteHistoryListAsync),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(getNoteHistoryContentAsync),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(restoreNoteHistoryContentAsync),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(watchGetNoteHistoryList),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(watchGetNoteHistoryContent),
    _marked6 = /*#__PURE__*/_regenerator2.default.mark(watchRestoreNoteHistoryContent);

function getNoteHistoryListAsync(action) {
  var noteId, _ref, data;

  return _regenerator2.default.wrap(function getNoteHistoryListAsync$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          noteId = action.noteId;
          _context.prev = 1;
          _context.next = 4;
          return (0, _effects.call)(_ajax2.default.getNoteHistoryList, noteId);

        case 4:
          _ref = _context.sent;
          data = _ref.data;
          _context.next = 8;
          return (0, _effects.put)({ type: _actionTypes.NoteHistory.GET_NOTE_HISTORY_LIST_SUCCESS, data: data });

        case 8:
          _context.next = 14;
          break;

        case 10:
          _context.prev = 10;
          _context.t0 = _context['catch'](1);
          _context.next = 14;
          return (0, _effects.put)({ type: _actionTypes.NoteHistory.GET_NOTE_HISTORY_LIST_FAIL });

        case 14:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[1, 10]]);
}

function getNoteHistoryContentAsync(action) {
  var historyId, isForce, noteId, noteHistoryContents, content, _ref2, data;

  return _regenerator2.default.wrap(function getNoteHistoryContentAsync$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          historyId = action.historyId, isForce = action.isForce, noteId = action.noteId;
          _context2.next = 3;
          return (0, _effects.select)(_NoteHistoryReducer.getNoteHistoryContentsState);

        case 3:
          noteHistoryContents = _context2.sent;
          content = noteHistoryContents.getIn(['entities', historyId.toString()]);
          _context2.prev = 5;

          if (!(!content || isForce)) {
            _context2.next = 14;
            break;
          }

          _context2.next = 9;
          return (0, _effects.call)(_ajax2.default.getNoteHistoryContent, historyId, noteId);

        case 9:
          _ref2 = _context2.sent;
          data = _ref2.data;

          content = data;
          _context2.next = 16;
          break;

        case 14:
          _context2.next = 16;
          return (0, _reduxSaga.delay)(300);

        case 16:
          _context2.next = 18;
          return (0, _effects.put)({
            type: _actionTypes.NoteHistory.GET_NOTE_HISTORY_CONTENT_SUCCESS,
            data: content,
            historyId: historyId
          });

        case 18:
          _context2.next = 24;
          break;

        case 20:
          _context2.prev = 20;
          _context2.t0 = _context2['catch'](5);
          _context2.next = 24;
          return (0, _effects.put)({ type: _actionTypes.NoteHistory.GET_NOTE_HISTORY_CONTENT_FAIL });

        case 24:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[5, 20]]);
}

function restoreNoteHistoryContentAsync(action) {
  var historyId, noteId, nbId, noteHistoryContents, revertData, _ref3, data;

  return _regenerator2.default.wrap(function restoreNoteHistoryContentAsync$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          historyId = action.historyId, noteId = action.noteId, nbId = action.nbId;
          _context3.next = 3;
          return (0, _effects.select)(_NoteHistoryReducer.getNoteHistoryContentsState);

        case 3:
          noteHistoryContents = _context3.sent;

          // 此处的revertData包含了title和content字段
          revertData = noteHistoryContents.getIn(['entities', historyId.toString()]).toJS();
          _context3.prev = 5;
          _context3.next = 8;
          return (0, _effects.call)(_ajax2.default.restoreHistoryContent, historyId, noteId);

        case 8:
          _ref3 = _context3.sent;
          data = _ref3.data;
          _context3.next = 12;
          return (0, _effects.put)({
            type: _actionTypes.NoteHistory.RESTORE_NOTE_HISTORY_CONTENT_SUCCESS,
            data: data,
            nbId: nbId,
            noteId: noteId,
            revertData: revertData
          });

        case 12:
          _context3.next = 18;
          break;

        case 14:
          _context3.prev = 14;
          _context3.t0 = _context3['catch'](5);
          _context3.next = 18;
          return (0, _effects.put)({ type: _actionTypes.NoteHistory.RESTORE_NOTE_HISTORY_CONTENT_FAIL });

        case 18:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this, [[5, 14]]);
}

// eslint-disable-next-line import/prefer-default-export
function watchGetNoteHistoryList() {
  return _regenerator2.default.wrap(function watchGetNoteHistoryList$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.takeLatest)(_actionTypes.NoteHistory.GET_NOTE_HISTORY_LIST, getNoteHistoryListAsync);

        case 2:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function watchGetNoteHistoryContent() {
  return _regenerator2.default.wrap(function watchGetNoteHistoryContent$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.takeLatest)(_actionTypes.NoteHistory.GET_NOTE_HISTORY_CONTENT, getNoteHistoryContentAsync);

        case 2:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function watchRestoreNoteHistoryContent() {
  return _regenerator2.default.wrap(function watchRestoreNoteHistoryContent$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.takeLatest)(_actionTypes.NoteHistory.RESTORE_NOTE_HISTORY_CONTENT, restoreNoteHistoryContentAsync);

        case 2:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

/***/ }),

/***/ "R2Qq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getState = undefined;

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _immutable2.default.fromJS(initialState);
  var action = arguments[1];

  switch (action.type) {
    // get文章
    case _actionTypes.Notes.GET_NOTES:
      state = state.set('status', _actionTypes.Notes.GET_NOTES);
      return state;
    case _actionTypes.Notes.GET_NOTES_SUCCESS:
      {
        var data = action.data,
            isCache = action.isCache,
            nbId = action.nbId,
            page = action.page,
            count = action.count;

        if (!isCache) {
          var _normalize = (0, _normalize3.default)(data),
              entities = _normalize.entities;
          // 将获取到的文章，merge到已有的store中


          var newEntities = state.get('entities').mergeDeep(_immutable2.default.fromJS(entities));
          state = state.set('entities', newEntities);

          // data只有在未缓存的时候才会传进来
          data.forEach(function (item) {
            if (item.is_top) {
              state = state.set('topNoteId', item.id);
            }
          });

          // 更新文集中的文章序列
          if (nbId && page && count) {
            // 获取当前文集的文章序列
            var currentNotes = state.getIn(['notebooksState', nbId, 'notes'], _immutable2.default.List());

            // 创建新的序列
            var newSeq = currentNotes;

            // 如果是第一页，直接使用新数据
            if (page === 1) {
              newSeq = _immutable2.default.List(data.map(function (item) {
                return item.id;
              }));
            } else {
              // 如果不是第一页，将新数据追加到现有数据后面
              data.forEach(function (item) {
                newSeq = newSeq.push(item.id);
              });
            }

            // 更新文集状态
            state = state.setIn(['notebooksState', nbId, 'notes'], newSeq);
          }
        }
        state = state.set('status', _actionTypes.Notes.GET_NOTES_SUCCESS);
        return state;
      }
    case _actionTypes.Notes.GET_NOTES_FAIL:
      state = state.set('status', _actionTypes.Notes.GET_NOTES_FAIL);
      return state;
    // sort文章
    case _actionTypes.Notes.SORT_NOTES:
      {
        state = state.set('status', _actionTypes.Notes.SORT_NOTES);
        return state;
      }
    case _actionTypes.Notes.SORT_NOTES_SUCCESS:
      {
        state = state.set('status', _actionTypes.Notes.SORT_NOTES_SUCCESS);
        return state;
      }
    case _actionTypes.Notes.SORT_NOTES_FAIL:
      {
        state = state.set('status', _actionTypes.Notes.SORT_NOTES_FAIL);
        return state;
      }
    // 创建文章
    case _actionTypes.Notes.NEW_NOTE:
      {
        state = state.set('status', _actionTypes.Notes.NEW_NOTE);
        return state;
      }
    case _actionTypes.Notes.NEW_NOTE_SUCCESS:
      {
        var _data = action.data,
            _nbId = action.nbId,
            atBottom = action.atBottom,
            hasTop = action.hasTop;
        // 新建的文章需要添加到entities中

        state = state.setIn(['entities', _data.id.toString()], _immutable2.default.fromJS(_data).merge(
        // 默认新文章可以转载
        { reprintable: true }));
        // 如果是添加到顶部，需要判断是否已经有置顶文章
        if (!atBottom && !hasTop) {
          // 添加到文集的第一位
          var nbPath = ['notebooksState', _nbId.toString(), 'notes'];
          var seq = state.getIn(nbPath, _immutable2.default.fromJS([]));
          state = state.setIn(nbPath, seq.unshift(_data.id));
        } else if (!atBottom && hasTop) {
          // 如果有置顶文章，添加到置顶文章后面
          var _nbPath = ['notebooksState', _nbId.toString(), 'notes'];
          var _seq = state.getIn(_nbPath, _immutable2.default.fromJS([]));
          state = state.setIn(_nbPath, _seq.insert(1, _data.id));
        } else {
          // 添加到文集的末尾
          var _nbPath2 = ['notebooksState', _nbId.toString(), 'notes'];
          var _seq2 = state.getIn(_nbPath2, _immutable2.default.fromJS([]));
          state = state.setIn(_nbPath2, _seq2.push(_data.id));
        }
        state = state.set('status', _actionTypes.Notes.NEW_NOTE_SUCCESS);
        return state;
      }
    case _actionTypes.Notes.NEW_NOTE_FAIL:
      {
        state = state.set('status', _actionTypes.Notes.NEW_NOTE_FAIL);
        return state;
      }
    // 发布文章
    case _actionTypes.Notes.PUBLISH_NOTE:
      {
        var noteId = action.noteId,
            _data2 = action.data;

        state = state.setIn(['entities', noteId.toString(), 'status'], _actionTypes.Notes.PUBLISH_NOTE);
        return state;
      }
    case _actionTypes.Notes.PUBLISH_NOTE_SUCCESS:
      {
        var _noteId = action.noteId,
            _data3 = action.data;

        state = state.setIn(['entities', _noteId.toString(), 'shared'], true);
        state = state.setIn(['entities', _noteId.toString(), 'schedule_publish_at'], null);
        state = state.setIn(['entities', _noteId.toString(), 'last_compiled_at'], _data3.last_compiled_at);
        state = state.setIn(['entities', _noteId.toString(), 'status'], _actionTypes.Notes.PUBLISH_NOTE_SUCCESS);
        return state;
      }
    case _actionTypes.Notes.PUBLISH_NOTE_FAIL:
      {
        var _noteId2 = action.noteId,
            _data4 = action.data;

        state = state.setIn(['entities', _noteId2.toString(), 'status'], _actionTypes.Notes.PUBLISH_NOTE_FAIL);
        return state;
      }
    // 私密化文章
    case _actionTypes.Notes.PRIVATE_NOTE:
      {
        var _noteId3 = action.noteId,
            _data5 = action.data;

        state = state.setIn(['entities', _noteId3.toString(), 'status'], _actionTypes.Notes.PRIVATE_NOTE);
        return state;
      }
    case _actionTypes.Notes.PRIVATE_NOTE_SUCCESS:
      {
        var _noteId4 = action.noteId;

        state = state.setIn(['entities', _noteId4.toString(), 'shared'], false);
        state = state.setIn(['entities', _noteId4.toString(), 'status'], _actionTypes.Notes.PRIVATE_NOTE_SUCCESS);
        return state;
      }
    case _actionTypes.Notes.PRIVATE_NOTE_FAIL:
      {
        var _noteId5 = action.noteId,
            _data6 = action.data;

        state = state.setIn(['entities', _noteId5.toString(), 'status'], _actionTypes.Notes.PRIVATE_NOTE_FAIL);
        return state;
      }
    // 软性删除文章
    case _actionTypes.Notes.DEL_NOTE_SOFT:
      {
        var _nbId2 = action.nbId,
            _noteId6 = action.noteId;

        state = state.setIn(['entities', _noteId6.toString(), 'status'], _actionTypes.Notes.DEL_NOTE_SOFT);
        return state;
      }
    case _actionTypes.Notes.DEL_NOTE_SOFT_SUCCESS:
      {
        var _data7 = action.data,
            _noteId7 = action.noteId,
            _nbId3 = action.nbId;
        // 删除文章需要在entities中删除

        state = state.deleteIn(['entities', _noteId7.toString()]);
        // 同时需要在文集的seq中删除
        var notesPath = ['notebooksState', _nbId3.toString(), 'notes'];
        var notes = state.getIn(notesPath);
        var index = notes.findIndex(function (item) {
          return item === +_noteId7;
        });
        notes = notes.delete(index);
        state = state.setIn(notesPath, notes);
        return state;
      }
    case _actionTypes.Notes.DEL_NOTE_SOFT_FAIL:
      {
        var _noteId8 = action.noteId;

        state = state.setIn(['entities', _noteId8.toString(), 'status'], _actionTypes.Notes.DEL_NOTE_SOFT_FAIL);
        return state;
      }
    // 更新文章内容
    case _actionTypes.Notes.UPDATE_NOTE:
      {
        var _noteId9 = action.noteId,
            content = action.content,
            title = action.title;
        // 不管服务端，直接更新本地的数据，并autosave_control + 1

        state = state.setIn(['entities', _noteId9.toString(), 'title'], title);
        var autosaveControl = state.getIn(['entities', _noteId9.toString(), 'autosave_control']);
        state = state.setIn(['entities', _noteId9.toString(), 'autosave_control'], autosaveControl + 1);
        return state;
      }
    case _actionTypes.Notes.UPDATE_NOTE_SUCCESS:
      {
        var _noteId10 = action.noteId,
            _data8 = action.data;

        state = state.setIn(['entities', _noteId10, 'content_updated_at'], _data8.content_updated_at);
        state = state.setIn(['entities', _noteId10, 'status'], _actionTypes.Notes.UPDATE_NOTE_SUCCESS);
        return state;
      }
    // 恢复版本,更新标题
    case _actionTypes.NoteHistory.RESTORE_NOTE_HISTORY_CONTENT_SUCCESS:
      {
        var _action$revertData = action.revertData,
            _title = _action$revertData.title,
            _content = _action$revertData.content,
            _nbId4 = action.nbId,
            _noteId11 = action.noteId;

        state = state.setIn(['entities', _noteId11.toString(), 'title'], _title);
        return state;
      }
    // 移动文章成功，需要修改文章所属的notebook_id
    case _actionTypes.Notes.MOVE_NOTE_SUCCESS:
      {
        var _data9 = action.data,
            _nbId5 = action.nbId,
            newNbId = action.newNbId,
            _noteId12 = action.noteId;

        state = state.setIn(['entities', _noteId12.toString(), 'notebook_id'], newNbId);
        return state;
      }
    // 发表付费文章成功
    case _actionTypes.Notes.PUBLISH_PAID_NOTE_SUCCESS:
      {
        var _data10 = action.data,
            _noteId13 = action.noteId,
            _nbId6 = action.nbId;

        state = state.setIn(['entities', _noteId13.toString(), 'paid'], true);
        state = state.setIn(['entities', _noteId13.toString(), 'shared'], true);
        state = state.setIn(['entities', _noteId13.toString(), 'schedule_publish_at'], null);
        state = state.setIn(['entities', _noteId13.toString(), 'last_compiled_at'], _data10.last_compiled_at);
        return state;
      }
    // 置顶文章
    case _actionTypes.Notes.POST_SET_NOTE_TOP_SUCCESS:
      {
        var _noteId14 = action.noteId;

        var topNoteId = state.get('topNoteId');
        if (topNoteId) {
          state = state.setIn(['entities', topNoteId.toString(), 'is_top'], false);
        }
        state = state.setIn(['entities', _noteId14.toString(), 'is_top'], true);
        state = state.set('topNoteId', _noteId14);
        return state;
      }
    // 取消置顶文章
    case _actionTypes.Notes.POST_UNSET_NOTE_TOP_SUCCESS:
      {
        var _noteId15 = action.noteId;

        state = state.setIn(['entities', _noteId15.toString(), 'is_top'], false);
        state = state.set('topNoteId', null);
        return state;
      }
    // 设置文章转载状态
    case _actionTypes.Notes.SET_NOTE_REPRINTABLE_SUCCESS:
      {
        var _noteId16 = action.noteId;

        state = state.updateIn(['entities', _noteId16.toString(), 'reprintable'], function (v) {
          return !v;
        });
        return state;
      }
    // 设置定时发文
    case _actionTypes.Notes.SET_NOTE_PUBLISH_TIME_SUCCESS:
      {
        var _noteId17 = action.noteId,
            publishTime = action.publishTime;

        state = state.setIn(['entities', _noteId17.toString(), 'schedule_publish_at'], publishTime);
        return state;
      }
    default:
      return state;
  }
};

var _immutable = __webpack_require__("BYKG");

var _immutable2 = _interopRequireDefault(_immutable);

var _normalize2 = __webpack_require__("w0tY");

var _normalize3 = _interopRequireDefault(_normalize2);

var _actionTypes = __webpack_require__("4HHy");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  entities: {},
  topNoteId: null,
  status: _actionTypes.Notes.NOTES_INIT
}; /* eslint-disable no-param-reassign */
/**
 * Created by zad on 17/10/18.
 */
var getState = exports.getState = function getState(state) {
  return state.Notes;
};

/***/ }),

/***/ "R2Yh":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".NVdZF{display:block}._20JYe{position:fixed;top:0;right:0;left:0;bottom:0;background-color:hsla(0,0%,100%,.7);height:100%;z-index:1000;filter:alpha(opacity=30)}body.reader-night-mode ._20JYe{background-color:hsla(0,0%,40%,.7)}._3WS2u{display:none}._23VW8{position:fixed;overflow:auto;top:0;right:0;bottom:0;left:0;z-index:1010;-webkit-overflow-scrolling:touch;outline:0}._3cgNz{position:relative;background-color:#fff;width:auto;border:0;border-radius:6px;margin:0 auto 24px;background-clip:padding-box;-webkit-box-shadow:0 2px 8px rgba(0,0,0,.2);box-shadow:0 2px 8px rgba(0,0,0,.2)}body.reader-night-mode ._3cgNz{background-color:#3d3d3d}.cjahm{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.cjahm.move-up-appear.move-up-appear-active,.cjahm.move-up-enter.move-up-enter-active{-webkit-animation-name:_2oyZp;animation-name:_2oyZp}.cjahm.move-up-leave.move-up-leave-active{-webkit-animation-name:_3g8pf;animation-name:_3g8pf}._2tIvb{position:relative;border-radius:6px}body.reader-night-mode ._2tIvb{background-color:#3d3d3d}.ZTNas{position:absolute;right:0;top:0;width:48px;height:48px;line-height:46px;text-align:center;font-size:16px;cursor:pointer;color:#999;-webkit-transition:color .3s ease;-o-transition:color .3s ease;transition:color .3s ease}.ZTNas:hover{color:#4d4d4d}._1KgC3{padding:13px 16px;border-radius:4px 4px 0 0;color:#595959;border-bottom:1px solid #d9d9d9}body.reader-night-mode ._1KgC3{border-color:#2e2e2e}.-K8Re{margin:0;font-size:16px;line-height:21px;font-weight:500;color:#4d4d4d}body.reader-night-mode .-K8Re{color:#b3b3b3}._3O4M2{font-size:13px;padding-left:10px;color:#999}._3O4M2 a{color:#3294d0}.PWCkH{padding:16px;font-size:12px;line-height:1.5;color:#595959}body.reader-night-mode .PWCkH{color:#b3b3b3}.pCffa{padding:0 16px 16px;text-align:right;border-radius:0 0 2px 2px}._26mjB{display:block}.HhIYk{zoom:1}.HhIYk:after,.HhIYk:before{content:\" \";display:table}.HhIYk:after{clear:both;visibility:hidden;font-size:0;height:0}._37SYn{font-size:13px;line-height:20px;padding:30px 30px 20px;color:#333}body.reader-night-mode ._37SYn{color:#b3b3b3}._2BmdS{padding:0 16px 16px;text-align:right;border-radius:0 0 2px 2px}._26mjB .PWCkH{padding:0;border-radius:2px}._26mjB .PWCkH a{color:#3194d0}._26mjB .PWCkH a:active,._26mjB .PWCkH a:hover{color:#2b86bc}._26mjB ._38pIX{padding:30px 16px;border:0}._26mjB ._38pIX input{display:block;border-radius:4px;width:100%;line-height:20px;padding:5px 10px;font-size:15px;background-color:transparent;border:1px solid #ccc}body.reader-night-mode ._26mjB ._38pIX input{border-color:#2e2e2e}._26mjB .ZTNas{width:32px;height:32px;line-height:32px}.HSpeJ .PWCkH{border:0}@-webkit-keyframes _2oyZp{0%{-webkit-transform-origin:-50% -50%;transform-origin:-50% -50%;-webkit-transform:translate(-50%,-150%);transform:translate(-50%,-150%);opacity:0}to{-webkit-transform-origin:-50% -50%;transform-origin:-50% -50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);opacity:1}}@keyframes _2oyZp{0%{-webkit-transform-origin:-50% -50%;transform-origin:-50% -50%;-webkit-transform:translate(-50%,-150%);transform:translate(-50%,-150%);opacity:0}to{-webkit-transform-origin:-50% -50%;transform-origin:-50% -50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);opacity:1}}@-webkit-keyframes _3g8pf{0%{-webkit-transform-origin:-50% -50%;transform-origin:-50% -50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);opacity:1}to{-webkit-transform-origin:-50% -50%;transform-origin:-50% -50%;-webkit-transform:translate(-50%,-150%);transform:translate(-50%,-150%);opacity:0}}@keyframes _3g8pf{0%{-webkit-transform-origin:-50% -50%;transform-origin:-50% -50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);opacity:1}to{-webkit-transform-origin:-50% -50%;transform-origin:-50% -50%;-webkit-transform:translate(-50%,-150%);transform:translate(-50%,-150%);opacity:0}}", ""]);

// exports
exports.locals = {
	"modal-container": "NVdZF",
	"modal-mask": "_20JYe",
	"modal-mask-hidden": "_3WS2u",
	"modal-wrap": "_23VW8",
	"modal-entity": "_3cgNz",
	"modal-entity-middle": "cjahm",
	"ModalMoveUpIn": "_2oyZp",
	"ModalMoveUpOut": "_3g8pf",
	"modal-content": "_2tIvb",
	"modal-closer": "ZTNas",
	"modal-header": "_1KgC3",
	"modal-header-title": "-K8Re",
	"modal-header-tip": "_3O4M2",
	"modal-body": "PWCkH",
	"modal-footer": "pCffa",
	"confirm": "_26mjB",
	"confirm-wrapper": "HhIYk",
	"confirm-body": "_37SYn",
	"confirm-footer": "_2BmdS",
	"prompt-body": "_38pIX",
	"prompt": "HSpeJ"
};

/***/ }),

/***/ "S+hs":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "SX5p":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("jrrN");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--3-1!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/lib/loader.js!./MenuItem.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--3-1!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/lib/loader.js!./MenuItem.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Su7A":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; /**
                   * Created by mac on 2018/8/23.
                   */
/**
 * Created by mac on 2018/8/14.
 */


var _Modal = __webpack_require__("/MvA");

var _Modal2 = _interopRequireDefault(_Modal);

var _img_binding_pic = __webpack_require__("S+hs");

var _img_binding_pic2 = _interopRequireDefault(_img_binding_pic);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _reactIntlUniversal = __webpack_require__("cl+9");

var _reactIntlUniversal2 = _interopRequireDefault(_reactIntlUniversal);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__("RH2O");

var _reactRouterDom = __webpack_require__("F8kA");

var _immutable = __webpack_require__("BYKG");

var _immutable2 = _interopRequireDefault(_immutable);

var _actionTypes = __webpack_require__("4HHy");

var _NoOtherAccount = __webpack_require__("kSF0");

var _NoOtherAccount2 = _interopRequireDefault(_NoOtherAccount);

var _StepOne = __webpack_require__("7XSB");

var _StepOne2 = _interopRequireDefault(_StepOne);

var _StepTwo = __webpack_require__("0BBt");

var _StepTwo2 = _interopRequireDefault(_StepTwo);

var _GlobalAction = __webpack_require__("5Q8M");

var _IconFont = __webpack_require__("z69G");

var _IconFont2 = _interopRequireDefault(_IconFont);

var _GlobalReducer = __webpack_require__("boom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoOtherAccount = (_dec = (0, _reactRedux.connect)(function (state) {
  var globalState = (0, _GlobalReducer.getState)(state);
  return {
    msg: globalState.get('noOtherAccount').msg,
    step: globalState.get('noOtherAccount').step,
    data: JSON.parse(globalState.get('noOtherAccount').data)
  };
}, function (dispatch) {
  return {
    setBindPhoneStatus: function setBindPhoneStatus(status) {
      return dispatch((0, _GlobalAction.setBindPhoneStatus)(status));
    }
  };
}), _dec(_class = function (_Component) {
  (0, _inherits3.default)(NoOtherAccount, _Component);

  function NoOtherAccount() {
    (0, _classCallCheck3.default)(this, NoOtherAccount);
    return (0, _possibleConstructorReturn3.default)(this, (NoOtherAccount.__proto__ || (0, _getPrototypeOf2.default)(NoOtherAccount)).apply(this, arguments));
  }

  (0, _createClass3.default)(NoOtherAccount, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onModalCancelClick = _props.onModalCancelClick,
          visible = _props.visible,
          data = _props.data;

      console.log('data', this.props);
      return _react2.default.createElement(
        _Modal2.default,
        {
          width: 520,
          visible: visible,
          showFooter: false,
          maskClassName: _NoOtherAccount2.default['mask'],
          modalClassName: _NoOtherAccount2.default['modal'],
          closable: true,
          isMiddle: true,
          title: _reactIntlUniversal2.default.get('phoneModal.wxoccupy'),
          onCancel: onModalCancelClick
        },
        _react2.default.createElement(
          'div',
          { className: _NoOtherAccount2.default['content'] },
          _react2.default.createElement(
            'p',
            null,
            this.props.msg
          )
        ),
        this.props.step === 1 && _react2.default.createElement(_StepOne2.default, {
          username: data.target_user_nickname,
          id: data.target_user_id,
          token: data.token
        }),
        this.props.step === 2 && _react2.default.createElement(_StepTwo2.default, {
          onModalCancelClick: onModalCancelClick,
          id: data.target_user_id,
          token: data.token,
          username: data.target_user_nickname
        })
      );
    }
  }]);
  return NoOtherAccount;
}(_react.Component)) || _class);
exports.default = NoOtherAccount;

/***/ }),

/***/ "THqP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getState = undefined;

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _immutable2.default.fromJS(initialState);
  var action = arguments[1];

  switch (action.type) {
    // 获取文章内容
    case _actionTypes.NoteContent.GET_NOTE_CONTENT:
      {
        var noteId = action.noteId;

        state = state.setIn(['entities', noteId.toString(), 'status'], _actionTypes.NoteContent.GET_NOTE_CONTENT);
        return state;
      }
    case _actionTypes.NoteContent.GET_NOTE_CONTENT_SUCCESS:
      {
        var _noteId = action.noteId,
            data = action.data,
            isCache = action.isCache;

        if (!isCache) {
          var content = data.content,
              audio = data.audio;

          state = state.setIn(['entities', _noteId, 'content'], content);
          state = state.setIn(['entities', _noteId, 'audio'], (0, _immutable.fromJS)(audio) || (0, _immutable.fromJS)({}));
          // 内容的保存对用户来说十分的重要，所以这里单独用一个字段保存状态
          state = state.setIn(['entities', _noteId.toString(), 'updateStatus'], _actionTypes.Notes.UPDATE_NOTE_SUCCESS);
        }
        state = state.setIn(['entities', _noteId.toString(), 'status'], _actionTypes.NoteContent.GET_NOTE_CONTENT_SUCCESS);
        return state;
      }
    case _actionTypes.NoteContent.GET_NOTE_CONTENT_FAIL:
      {
        var _noteId2 = action.noteId;

        state = state.setIn(['entities', _noteId2.toString(), 'status'], _actionTypes.NoteContent.GET_NOTE_CONTENT_FAIL);
        return state;
      }
    // 更新文章内容ABBR和word num
    case _actionTypes.NoteContent.UPDATE_NOTE_CONTENT_ABBR:
      {
        var abbr = action.abbr,
            wordNum = action.wordNum,
            _noteId3 = action.noteId;

        state = state.setIn(['entities', _noteId3.toString(), 'abbr'], abbr);
        state = state.setIn(['entities', _noteId3.toString(), 'wordNum'], wordNum);
        return state;
      }
    // 更新文章内容
    case _actionTypes.Notes.UPDATE_NOTE:
      {
        var _noteId4 = action.noteId,
            _content = action.content,
            title = action.title;
        // 不管服务端，直接更新本地的数据

        state = state.setIn(['entities', _noteId4.toString(), 'content'], _content);
        state = state.setIn(['entities', _noteId4.toString(), 'status'], _actionTypes.Notes.UPDATE_NOTE);
        state = state.setIn(['entities', _noteId4.toString(), 'updateStatus'], _actionTypes.Notes.UPDATE_NOTE);
        return state;
      }
    case _actionTypes.Notes.UPDATE_NOTE_SUCCESS:
      {
        var _noteId5 = action.noteId;

        state = state.setIn(['entities', _noteId5.toString(), 'status'], _actionTypes.Notes.UPDATE_NOTE_SUCCESS);
        state = state.setIn(['entities', _noteId5.toString(), 'updateStatus'], _actionTypes.Notes.UPDATE_NOTE_SUCCESS);
        return state;
      }
    case _actionTypes.Notes.UPDATE_NOTE_FAIL:
      {
        var _noteId6 = action.noteId;

        state = state.setIn(['entities', _noteId6.toString(), 'status'], _actionTypes.Notes.UPDATE_NOTE_FAIL);
        state = state.setIn(['entities', _noteId6.toString(), 'updateStatus'], _actionTypes.Notes.UPDATE_NOTE_FAIL);
        return state;
      }
    // 发布文章内容
    case _actionTypes.Notes.PUBLISH_NOTE:
      {
        var _noteId7 = action.noteId;

        state = state.setIn(['entities', _noteId7.toString(), 'status'], _actionTypes.Notes.PUBLISH_NOTE);
        return state;
      }
    case _actionTypes.Notes.PUBLISH_NOTE_SUCCESS:
      {
        var _noteId8 = action.noteId;

        state = state.setIn(['entities', _noteId8.toString(), 'status'], _actionTypes.Notes.PUBLISH_NOTE_SUCCESS);
        return state;
      }
    case _actionTypes.Notes.PUBLISH_NOTE_FAIL:
      {
        var _noteId9 = action.noteId;

        state = state.setIn(['entities', _noteId9.toString(), 'status'], _actionTypes.Notes.PUBLISH_NOTE_FAIL);
        return state;
      }
    // 恢复版本,更新内容
    case _actionTypes.NoteHistory.RESTORE_NOTE_HISTORY_CONTENT_SUCCESS:
      {
        var _action$revertData = action.revertData,
            _title = _action$revertData.title,
            _content2 = _action$revertData.content,
            nbId = action.nbId,
            _noteId10 = action.noteId;

        state = state.setIn(['entities', _noteId10.toString(), 'content'], _content2);
        return state;
      }
    // 上传文章音频
    case _actionTypes.NoteContent.POST_AUDIO:
      {
        var _noteId11 = action.noteId,
            _audio = action.audio;

        state = state.setIn(['entities', _noteId11.toString(), 'audio'], (0, _immutable.fromJS)(_audio));
        return state;
      }
    // 上传文章音频名称与作者
    case _actionTypes.NoteContent.PUT_AUDIO_MESSAGE:
      {
        var _noteId12 = action.noteId;

        state = state.setIn(['entities', _noteId12.toString(), 'audioStatus'], _actionTypes.NoteContent.PUT_AUDIO_MESSAGE);
        return state;
      }
    case _actionTypes.NoteContent.PUT_AUDIO_MESSAGE_SUCCESS:
      {
        var _noteId13 = action.noteId,
            _data = action.data,
            params = action.params;

        state = state.setIn(['entities', _noteId13.toString(), 'audioStatus'], _actionTypes.NoteContent.PUT_AUDIO_MESSAGE_SUCCESS);
        state = state.setIn(['entities', _noteId13.toString(), 'audio', 'title'], params.title);
        state = state.setIn(['entities', _noteId13.toString(), 'audio', 'dubber'], params.dubber);
        return state;
      }
    case _actionTypes.NoteContent.PUT_AUDIO_MESSAGE_FAIL:
      {
        var _noteId14 = action.noteId;

        state = state.setIn(['entities', _noteId14.toString(), 'audioStatus'], _actionTypes.NoteContent.PUT_AUDIO_MESSAGE_FAIL);
        return state;
      }
    // 删除音频
    case _actionTypes.NoteContent.DELETE_AUDIO:
      {
        var _noteId15 = action.noteId;

        state = state.setIn(['entities', _noteId15.toString(), 'audioStatus'], _actionTypes.NoteContent.DELETE_AUDIO);
        return state;
      }
    case _actionTypes.NoteContent.DELETE_AUDIO_SUCCESS:
      {
        var _noteId16 = action.noteId;

        state = state.setIn(['entities', _noteId16.toString(), 'audioStatus'], _actionTypes.NoteContent.DELETE_AUDIO_SUCCESS);
        state = state.setIn(['entities', _noteId16.toString(), 'audio'], (0, _immutable.fromJS)({}));
        return state;
      }
    case _actionTypes.NoteContent.DELETE_AUDIO_FAIL:
      {
        var _noteId17 = action.noteId;

        state = state.setIn(['entities', _noteId17.toString(), 'audioStatus'], _actionTypes.NoteContent.DELETE_AUDIO_FAIL);
        return state;
      }
    // 更新音频URL
    case _actionTypes.NoteContent.GET_AUDIO_URL:
      {
        var _noteId18 = action.noteId;

        state = state.setIn(['entities', _noteId18.toString(), 'audioStatus'], _actionTypes.NoteContent.GET_AUDIO_URL);
        return state;
      }
    case _actionTypes.NoteContent.GET_AUDIO_URL_SUCCESS:
      {
        var _noteId19 = action.noteId,
            _data2 = action.data;

        state = state.setIn(['entities', _noteId19.toString(), 'audioStatus'], _actionTypes.NoteContent.GET_AUDIO_URL_SUCCESS);
        state = state.setIn(['entities', _noteId19.toString(), 'audio', 'play_url'], _data2.play_url);
        return state;
      }
    case _actionTypes.NoteContent.GET_AUDIO_URL_FAIL:
      {
        var _noteId20 = action.noteId;

        state = state.setIn(['entities', _noteId20.toString(), 'audioStatus'], _actionTypes.NoteContent.GET_AUDIO_URL_FAIL);
        return state;
      }
    default:
      return state;
  }
};

var _immutable = __webpack_require__("BYKG");

var _immutable2 = _interopRequireDefault(_immutable);

var _actionTypes = __webpack_require__("4HHy");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-param-reassign */

var initialState = {
  entities: {}
};

var getState = exports.getState = function getState(state) {
  return state.NoteContent;
};

/***/ }),

/***/ "TRCE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _includes2 = __webpack_require__("q+Dy");

var _includes3 = _interopRequireDefault(_includes2);

exports.default = Loader;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _Loading = __webpack_require__("DUrC");

var _Loading2 = _interopRequireDefault(_Loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loaderPrefix = 'loader';
// eslint-disable-next-line no-underscore-dangle
/**
 * Created by zad on 17/1/13.
 */
var _type = {
  size: ['small', 'large']
};

function Loader(_ref) {
  var _classNames;

  var _ref$size = _ref.size,
      size = _ref$size === undefined ? undefined : _ref$size,
      _ref$tip = _ref.tip,
      tip = _ref$tip === undefined ? '' : _ref$tip,
      _ref$hasMask = _ref.hasMask,
      hasMask = _ref$hasMask === undefined ? false : _ref$hasMask,
      loading = _ref.loading,
      loaderClassName = _ref.loaderClassName;

  var sizeSuffix = {
    large: 'lg',
    small: 'sm'
  }[size];

  var loadingClass = (0, _classnames2.default)('' + _Loading2.default[loaderPrefix], loaderClassName, (_classNames = {}, (0, _defineProperty3.default)(_classNames, '' + _Loading2.default[loaderPrefix + '-' + sizeSuffix], size && (0, _includes3.default)(_type.size, size)), (0, _defineProperty3.default)(_classNames, '' + _Loading2.default[loaderPrefix + '-show-tip'], !!tip), (0, _defineProperty3.default)(_classNames, '' + _Loading2.default[loaderPrefix + '-is-loading'], loading), (0, _defineProperty3.default)(_classNames, '' + _Loading2.default[loaderPrefix + '-has-mask'], hasMask), _classNames));

  return _react2.default.createElement(
    'div',
    { className: loadingClass },
    _react2.default.createElement(
      'div',
      { className: '' + _Loading2.default[loaderPrefix + '-entity'] },
      _react2.default.createElement(
        'svg',
        { className: '' + _Loading2.default[loaderPrefix + '-svg'], viewBox: '25 25 50 50' },
        _react2.default.createElement('circle', { className: '' + _Loading2.default[loaderPrefix + '-circle'], cx: '50', cy: '50', r: '20', fill: 'none' })
      )
    ),
    !!tip && _react2.default.createElement(
      'div',
      { className: '' + _Loading2.default[loaderPrefix + '-tip'] },
      tip.toString()
    )
  );
}

/***/ }),

/***/ "UpxA":
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,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"

/***/ }),

/***/ "UsL9":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("R2Yh");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./Modal.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./Modal.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "V2Du":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; /**
                   * Created by mac on 2018/8/23.
                   */
/**
 * Created by mac on 2018/8/14.
 */


var _Modal = __webpack_require__("/MvA");

var _Modal2 = _interopRequireDefault(_Modal);

var _img_binding_pic = __webpack_require__("S+hs");

var _img_binding_pic2 = _interopRequireDefault(_img_binding_pic);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _reactIntlUniversal = __webpack_require__("cl+9");

var _reactIntlUniversal2 = _interopRequireDefault(_reactIntlUniversal);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__("RH2O");

var _reactRouterDom = __webpack_require__("F8kA");

var _immutable = __webpack_require__("BYKG");

var _immutable2 = _interopRequireDefault(_immutable);

var _actionTypes = __webpack_require__("4HHy");

var _GlobalAction = __webpack_require__("5Q8M");

var _IconFont = __webpack_require__("z69G");

var _IconFont2 = _interopRequireDefault(_IconFont);

var _GlobalReducer = __webpack_require__("boom");

var _HasOtherAccount = __webpack_require__("dzfs");

var _HasOtherAccount2 = _interopRequireDefault(_HasOtherAccount);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HasOtherAccount = (_dec = (0, _reactRedux.connect)(function (state) {
  var globalState = (0, _GlobalReducer.getState)(state);
  return {
    data: globalState.get('account'),
    content: globalState.get('occupyhasother').msg
  };
}, function (dispatch) {
  return {
    setBindPhoneStatus: function setBindPhoneStatus(status) {
      return dispatch((0, _GlobalAction.setBindPhoneStatus)(status));
    }
  };
}), _dec(_class = function (_Component) {
  (0, _inherits3.default)(HasOtherAccount, _Component);

  function HasOtherAccount() {
    (0, _classCallCheck3.default)(this, HasOtherAccount);
    return (0, _possibleConstructorReturn3.default)(this, (HasOtherAccount.__proto__ || (0, _getPrototypeOf2.default)(HasOtherAccount)).apply(this, arguments));
  }

  (0, _createClass3.default)(HasOtherAccount, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onModalCancelClick = _props.onModalCancelClick,
          visible = _props.visible,
          data = _props.data;

      return _react2.default.createElement(
        _Modal2.default,
        {
          width: 520,
          visible: visible,
          showFooter: false,
          closable: true,
          isMiddle: true,
          title: _reactIntlUniversal2.default.get('phoneModal.wxoccupy'),
          onCancel: onModalCancelClick
        },
        _react2.default.createElement(
          'div',
          { className: _HasOtherAccount2.default.content },
          _react2.default.createElement(
            'p',
            null,
            this.props.content
          ),
          _react2.default.createElement(
            'button',
            {
              className: _HasOtherAccount2.default['btn'],
              onClick: function onClick() {
                HasOtherAccount.goUrl();
              }
            },
            _reactIntlUniversal2.default.get('phoneModal.yjjb')
          ),
          _react2.default.createElement(
            'span',
            { className: _HasOtherAccount2.default['cancel'], onClick: onModalCancelClick },
            _reactIntlUniversal2.default.get('phoneModal.cancel')
          )
        )
      );
    }
  }], [{
    key: 'goUrl',
    value: function goUrl() {
      var url = window.location.href;
      window.location.href = '/users/auth/wechat?transfer=true&redirect_url=' + encodeURIComponent(url);
    }
  }]);
  return HasOtherAccount;
}(_react.Component)) || _class);
exports.default = HasOtherAccount;

/***/ }),

/***/ "Vpld":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "._5ulTv p{font-size:15px;color:#2f2f2f;line-height:normal;margin-bottom:30px}body.reader-night-mode ._5ulTv p{color:#b3b3b3}._5ulTv .zw-UG{font-size:14px;width:136px;border:none;height:42px;border-radius:24.5px;background-color:#00b61f;color:#fff;margin-right:30px}body.reader-night-mode ._5ulTv .zw-UG{border:none}._5ulTv ._1LsjJ{color:#929292;cursor:pointer}body.reader-night-mode ._5ulTv ._1LsjJ{color:#b3b3b3}._5ulTv ._1LsjJ:hover{color:#ccc}", ""]);

// exports
exports.locals = {
	"content": "_5ulTv",
	"btn": "zw-UG",
	"cancel": "_1LsjJ"
};

/***/ }),

/***/ "XB7B":
/***/ (function(module, exports) {

module.exports = "data:application/font-woff;base64,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"

/***/ }),

/***/ "XaZM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.switchSyncScroll = exports.setUser = exports.changeEditorType = exports.getUserOtpChannel = exports.getUser = undefined;

var _actionTypes = __webpack_require__("4HHy");

var _createAction = __webpack_require__("lTDY");

var _createAction2 = _interopRequireDefault(_createAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line import/prefer-default-export
/**
 * Created by zad on 17/10/25.
 */
var getUser = exports.getUser = (0, _createAction2.default)(_actionTypes.User.GET_USER);

var getUserOtpChannel = exports.getUserOtpChannel = (0, _createAction2.default)(_actionTypes.User.GET_USER_OTP_CHANNEL);

var changeEditorType = exports.changeEditorType = (0, _createAction2.default)(_actionTypes.User.CHANGE_EDITOR_TYPE, 'editorType');

var setUser = exports.setUser = (0, _createAction2.default)(_actionTypes.User.SET_USER, 'data');

var switchSyncScroll = exports.switchSyncScroll = (0, _createAction2.default)(_actionTypes.User.SWITCH_SYNC_SCROLL, 'on');

/***/ }),

/***/ "Xpbu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _isFunction2 = __webpack_require__("gGqR");

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _class, _temp;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rcAnimate = __webpack_require__("8aSS");

var _rcAnimate2 = _interopRequireDefault(_rcAnimate);

var _reactIntlUniversal = __webpack_require__("cl+9");

var _reactIntlUniversal2 = _interopRequireDefault(_reactIntlUniversal);

var _Modal = __webpack_require__("UsL9");

var _Modal2 = _interopRequireDefault(_Modal);

var _keyCode = __webpack_require__("r/Fa");

var _keyCode2 = _interopRequireDefault(_keyCode);

var _Icon = __webpack_require__("9JgI");

var _Icon2 = _interopRequireDefault(_Icon);

var _LazyRenderBox = __webpack_require__("gESm");

var _LazyRenderBox2 = _interopRequireDefault(_LazyRenderBox);

var _Portal = __webpack_require__("npO6");

var _Portal2 = _interopRequireDefault(_Portal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Modal = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Modal, _Component);

  function Modal(props) {
    (0, _classCallCheck3.default)(this, Modal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Modal.__proto__ || (0, _getPrototypeOf2.default)(Modal)).call(this, props));

    _this.saveRef = function (name) {
      return function (node) {
        _this[name] = node;
      };
    };

    _this.handleOk = function (e) {
      var onOk = _this.props.onOk;

      if ((0, _isFunction3.default)(onOk)) {
        onOk(e);
      }
    };

    _this.handleCancel = function (e) {
      var onCancel = _this.props.onCancel;

      if ((0, _isFunction3.default)(onCancel)) {
        onCancel(e);
      }
    };

    _this.onWrapClick = function (e) {
      var maskClosable = _this.props.maskClosable;

      if (e.target === e.currentTarget) {
        if (maskClosable) {
          _this.handleCancel(e);
        }
      }
    };

    _this.onWrapKeyDown = function (e) {
      if (e.keyCode === _keyCode2.default.ESC) {
        _this.handleCancel(e);
      }
    };

    _this.onModalLeave = function () {
      // 需要在动画结束时设定wrap的display，否则结束动画不触发
      var afterClose = _this.props.afterClose;

      if (_this.wrap) {
        _this.wrap.style.display = 'none';
      }
      if ((0, _isFunction3.default)(afterClose)) {
        afterClose();
      }
    };

    _this.getWrapStyle = function () {
      // 在modal打开时，设定display
      // 在modal关闭时，不去设定，而是等待动画结束后设定
      var visible = _this.props.visible;

      if (visible) {
        return {
          display: null
        };
      }
      return {};
    };

    _this.getModalStyle = function () {
      var _this$props = _this.props,
          isMiddle = _this$props.isMiddle,
          modalStyle = _this$props.modalStyle,
          width = _this$props.width,
          top = _this$props.top;

      if (isMiddle) {
        return (0, _assign2.default)({}, { width: width, top: top }, modalStyle);
      }
      return (0, _assign2.default)({}, { width: width, top: top || 120 }, modalStyle);
    };

    _this.getButtonText = function () {
      var _this$props2 = _this.props,
          okText = _this$props2.okText,
          cancelText = _this$props2.cancelText;

      return {
        ok: okText || _reactIntlUniversal2.default.get('modal.confirm'),
        cancel: cancelText || _reactIntlUniversal2.default.get('modal.cancel')
      };
    };

    _this.getContainer = function () {
      if ((0, _isFunction3.default)(_this.props.getContainer)) {
        return _this.props.getContainer();
      }
      var container = document.createElement('div');
      document.body.appendChild(container);
      return container;
    };

    _this.getMaskElement = function () {
      var _this$props3 = _this.props,
          visible = _this$props3.visible,
          showMask = _this$props3.showMask,
          maskClassName = _this$props3.maskClassName,
          maskStyle = _this$props3.maskStyle;

      if (!showMask) {
        return null;
      }
      var maskClass = (0, _classnames2.default)(maskClassName, (0, _defineProperty3.default)({}, '' + _Modal2.default['modal-mask'], true));

      return _react2.default.createElement(
        _rcAnimate2.default,
        {
          key: 'mask',
          showProp: 'visible',
          transitionAppear: true,
          component: '',
          transitionName: 'fade'
        },
        _react2.default.createElement(_LazyRenderBox2.default, {
          key: 'mask',
          className: maskClass,
          hiddenClassName: _Modal2.default['modal-mask-hidden'],
          visible: visible,
          style: maskStyle
        })
      );
    };

    _this.getModalElement = function () {
      var _classNames2;

      // eslint-disable-next-line max-len
      var _this$props4 = _this.props,
          visible = _this$props4.visible,
          closable = _this$props4.closable,
          title = _this$props4.title,
          showFooter = _this$props4.showFooter,
          isMiddle = _this$props4.isMiddle,
          modalClassName = _this$props4.modalClassName,
          bodyClass = _this$props4.bodyClass,
          footerClass = _this$props4.footerClass,
          bodyStyle = _this$props4.bodyStyle,
          headerStyle = _this$props4.headerStyle,
          footerStyle = _this$props4.footerStyle,
          tips = _this$props4.tips;

      var btnText = _this.getButtonText();
      var modalClass = (0, _classnames2.default)(modalClassName, (_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, '' + _Modal2.default['modal-entity'], true), (0, _defineProperty3.default)(_classNames2, '' + _Modal2.default['modal-entity-middle'], !!isMiddle), _classNames2));
      var tip = _react2.default.createElement(
        'span',
        { className: _Modal2.default['modal-header-tip'] },
        _reactIntlUniversal2.default.get('phoneModal.tip'),
        '\uFF1F',
        _react2.default.createElement(
          'a',
          { href: 'https://www.jianshu.com/p/794b92192f62', target: '_blank', rel: 'noopener noreferrer' },
          ' ',
          _reactIntlUniversal2.default.get('phoneModal.href')
        )
      );
      var header = title ? _react2.default.createElement(
        'div',
        { className: _Modal2.default['modal-header'], style: headerStyle },
        _react2.default.createElement(
          'div',
          { className: _Modal2.default['modal-header-title'] },
          title,
          ' ',
          tips && tip
        )
      ) : null;

      var footer = showFooter ? _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(footerClass, _Modal2.default['modal-footer']), style: footerStyle },
        _react2.default.createElement(
          Modal.Button,
          { onClick: _this.handleCancel },
          btnText.cancel
        ),
        _react2.default.createElement(
          Modal.Button,
          { onClick: _this.handleOk, type: 'primary' },
          btnText.ok
        )
      ) : null;

      var closer = closable ? _react2.default.createElement(
        'div',
        {
          className: _Modal2.default['modal-closer'],
          'aria-label': 'Close',
          onClick: _this.handleCancel
        },
        _react2.default.createElement(_Icon2.default, { name: 'close' })
      ) : null;

      var element = _react2.default.createElement(
        'div',
        { className: _Modal2.default['modal-content'] },
        closer,
        header,
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)(bodyClass, _Modal2.default['modal-body']), style: bodyStyle },
          _this.props.children
        ),
        footer
      );

      return _react2.default.createElement(
        _rcAnimate2.default,
        {
          key: 'modal-element',
          showProp: 'visible',
          onLeave: _this.onModalLeave,
          transitionName: 'move-up',
          component: '',
          transitionAppear: true
        },
        _react2.default.createElement(
          _LazyRenderBox2.default,
          {
            key: 'modal-element',
            role: 'document',
            ref: _this.saveRef('modal'),
            className: modalClass,
            style: _this.getModalStyle(),
            visible: visible
          },
          element
        )
      );
    };

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(Modal, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      var visible = this.props.visible;
      // 打开modal

      if (visible) {
        // 只有在切换modal的visible时，才去focus
        if (!prevProps.visible) {
          if (this.wrap) {
            this.wrap.focus();
          } else {
            // 第一次打开
            setTimeout(function () {
              _this2.wrap.focus();
            }, 0);
          }
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var visible = this.props.visible;


      if (visible || this.container) {
        return _react2.default.createElement(
          _Portal2.default,
          { getContainer: this.getContainer },
          _react2.default.createElement(
            'div',
            {
              className: _Modal2.default['modal-container'],
              ref: this.saveRef('container')
            },
            this.getMaskElement(),
            _react2.default.createElement(
              'div',
              {
                role: 'dialog',
                tabIndex: -1,
                className: _Modal2.default['modal-wrap'],
                style: this.getWrapStyle(),
                ref: this.saveRef('wrap'),
                onKeyDown: this.onWrapKeyDown,
                onClick: this.onWrapClick
              },
              this.getModalElement()
            )
          )
        );
      }
      return null;
    }
  }]);
  return Modal;
}(_react.Component), _class.propTypes = {
  getContainer: _propTypes2.default.func,
  visible: _propTypes2.default.bool,
  isMiddle: _propTypes2.default.bool, // 是否垂直居中
  showMask: _propTypes2.default.bool, // 是否显示蒙层
  maskClosable: _propTypes2.default.bool, // 点击蒙层是否关闭modal
  closable: _propTypes2.default.bool, // 是否显示右上角的关闭按钮
  showFooter: _propTypes2.default.bool, // 是否显示footer
  tips: _propTypes2.default.bool, // 是否显示title中的提示
  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  top: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  modalClassName: _propTypes2.default.string,
  maskClassName: _propTypes2.default.string,
  bodyClass: _propTypes2.default.string,
  footerClass: _propTypes2.default.string,
  modalStyle: _propTypes2.default.object,
  maskStyle: _propTypes2.default.object,
  bodyStyle: _propTypes2.default.object,
  headerStyle: _propTypes2.default.object,
  footerStyle: _propTypes2.default.object,
  okText: _propTypes2.default.string,
  cancelText: _propTypes2.default.string,
  onOk: _propTypes2.default.func,
  onCancel: _propTypes2.default.func,
  afterClose: _propTypes2.default.func
}, _class.defaultProps = {
  visible: false,
  isMiddle: false,
  showMask: true,
  maskClosable: true,
  closable: true,
  showFooter: true,
  tips: true,
  width: 520,
  onOk: function onOk() {
    return undefined;
  },
  onCancel: function onCancel() {
    return undefined;
  },
  afterClose: function afterClose() {
    return undefined;
  },
  maskStyle: {},
  modalStyle: {},
  bodyStyle: {},
  headerStyle: {},
  footerStyle: {}
}, _temp);
exports.default = Modal;

/***/ }),

/***/ "YCVJ":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "YrSj":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".ant-empty{margin:0 8px;font-size:14px;line-height:22px;text-align:center}.ant-empty-image{height:100px;margin-bottom:8px}.ant-empty-image img{height:100%}.ant-empty-image svg{height:100%;margin:auto}.ant-empty-description{margin:0}.ant-empty-footer{margin-top:16px}.ant-empty-normal{margin:32px 0;color:rgba(0,0,0,.25)}.ant-empty-normal .ant-empty-image{height:40px}.ant-empty-small{margin:8px 0;color:rgba(0,0,0,.25)}.ant-empty-small .ant-empty-image{height:35px}", ""]);

// exports


/***/ }),

/***/ "Z1y9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _isString2 = __webpack_require__("JDN0");

var _isString3 = _interopRequireDefault(_isString2);

var _isArray2 = __webpack_require__("NGEn");

var _isArray3 = _interopRequireDefault(_isArray2);

var _debounce2 = __webpack_require__("O4Lo");

var _debounce3 = _interopRequireDefault(_debounce2);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _reduxSaga = __webpack_require__("igqX");

var _Message = __webpack_require__("mzOA");

var _Message2 = _interopRequireDefault(_Message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var baseURL = ''; /* eslint-disable camelcase */

var timeout = 30000;

// A fix for window.location.origin in Internet Explorer
var origin =  false ? 'http://127.0.0.1:3000' : window.location.origin;
if (!origin) {
  // eslint-disable-next-line prefer-template
  origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
}
var showError = (0, _debounce3.default)(function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(errors) {
    var invalid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if ((0, _isArray3.default)(errors)) {
              _Message2.default.error(errors[0].message);
            }
            if ((0, _isString3.default)(errors)) {
              _Message2.default.error(errors);
            }

            if (!invalid) {
              _context.next = 6;
              break;
            }

            _context.next = 5;
            return (0, _reduxSaga.delay)(2500);

          case 5:
            window.location.href = origin + '/sign_in';

          case 6:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}(), 2500, { leading: true, trailing: false });

var Ajax = function Ajax() {
  var _this = this;

  (0, _classCallCheck3.default)(this, Ajax);

  this.getLinkInfo = function (url) {
    return _this.ajax.get('/external_pages/info', {
      params: {
        url: url
      }
    });
  };

  this.getVideoInfo = function (data) {
    return _this.ajax.post('/videos.json', data);
  };

  this.getAudioInfo = function (note_id) {
    return _this.ajax.get('/author/notes/' + note_id + '/audio/post_policy');
  };

  this.sendCaptcha = function (data) {
    return _this.ajax.post('/secure_sessions/send_code', data);
  };

  this.verifyCaptcha = function (data) {
    return _this.ajax.post('/secure_sessions/activate', data);
  };

  this.getCountyOtpInfo = function (data) {
    return _this.ajax.get('/countries');
  };

  this.sendCaptchaWhenBindPhone = function (data) {
    return _this.ajax.post('/mobile_phone/send_code', data);
  };

  this.bindPhone = function (data) {
    return _this.ajax.put('/mobile_phone/bind', data);
  };

  this.searchCollections = function (note_id, queryword) {
    return _this.ajax.get('/notes/' + note_id + '/submit_collections/search', {
      params: {
        q: queryword
      }
    });
  };

  this.searchFilms = function (keyword) {
    var url =  false ? '/film/api/film/films/search' : 'https://www.jianshu.com/film/api/film/films/search';
    console.log('[film] search request url:', url, 'keyword:', keyword, 'env:', "production", 'origin:', window.location.origin);
    return _this.ajax.post(url, { keyword: keyword });
  };

  this.getEditableCollections = function (note_id, page, per_page) {
    return _this.ajax.get('/notes/' + note_id + '/editable_collections', {
      params: {
        page: page,
        per_page: per_page
      }
    });
  };

  this.getLatestCollections = function (note_id, page, per_page) {
    var rest = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    return _this.ajax.get('/notes/' + note_id + '/submitted_collections', {
      params: {
        count: per_page,
        max_id: rest.maxId
      }
    });
  };

  this.getRecCollections = function (note_id, page, per_page) {
    return _this.ajax.get('/notes/' + note_id + '/recommended_collections', {
      params: {
        page: page,
        per_page: per_page
      }
    });
  };

  this.contributeToCollection = function (collection_id, note_id) {
    return _this.ajax.post('/notes/' + note_id + '/submit', {
      collection_id: collection_id
    });
  };

  this.getOtpChannel = function (data) {
    return _this.ajax.get('/otp_channels');
  };

  this.getUser = function () {
    return _this.ajax.get('/author/current_user');
  };

  this.switchScroll = function (on) {
    return _this.ajax.post('/author/current_user/set_md_auto_scroll', { on: +on });
  };

  this.getNotebooks = function () {
    return _this.ajax.get('/author/notebooks');
  };

  this.sortNotebooks = function (sequence) {
    return _this.ajax.put('/author/notebooks/sequence', {
      sequence: sequence
    });
  };

  this.updateBookName = function (nbId, name) {
    return _this.ajax.put('/author/notebooks/' + nbId, {
      name: name
    });
  };

  this.getNotes = function (nbId) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
    var nid = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    return _this.ajax.get('/author/notebooks/' + nbId + '/notes', {
      params: (0, _extends3.default)({
        page: page,
        count: count
      }, nid && { nid: nid })
    });
  };

  this.sortNotes = function (sequence) {
    return _this.ajax.put('/author/notes/sequence', {
      sequence: sequence
    });
  };

  this.getNoteContent = function (noteId) {
    return _this.ajax.get('/author/notes/' + noteId + '/content');
  };

  this.newNoteBook = function (name) {
    return _this.ajax.post('/author/notebooks', {
      name: name
    });
  };

  this.deleteNoteBookSoft = function (nbId) {
    return _this.ajax.post('/author/notebooks/' + nbId + '/soft_destroy');
  };

  this.newNote = function (data) {
    return _this.ajax.post('/author/notes', {
      notebook_id: data.nbId,
      title: data.title,
      at_bottom: data.atBottom
    });
  };

  this.publishNote = function (noteId, forcedPublish) {
    return _this.ajax.post('/author/notes/' + noteId + '/publicize', forcedPublish ? {
      // 强制发布
      schedule_publish_at: -1
    } : {});
  };

  this.updateNote = function (noteId, autosaveControl, title, content) {
    return _this.ajax.put('/author/notes/' + noteId, {
      id: noteId,
      autosave_control: autosaveControl, // eslint-disable-line camelcase
      title: title,
      content: content
    });
  };

  this.setReprintAble = function (noteId) {
    return _this.ajax.put('/author/notes/' + noteId + '/toggle_reprintable');
  };

  this.privateNote = function (noteId) {
    return _this.ajax.post('/author/notes/' + noteId + '/privatize');
  };

  this.moveNote = function (newNbId, noteId) {
    return _this.ajax.post('/author/notes/' + noteId + '/move', { notebook_id: newNbId });
  };

  this.recoveryNote = function (noteId) {
    return _this.ajax.post('/author/recycle/notes/' + noteId + '/restore');
  };

  this.deleteNoteSoft = function (noteId) {
    return _this.ajax.post('/author/notes/' + noteId + '/soft_destroy');
  };

  this.deleteNote = function (noteId) {
    return _this.ajax.delete('/author/recycle/notes/' + noteId);
  };

  this.getNoteHistoryList = function (noteId) {
    return _this.ajax.get('/author/notes/' + noteId + '/note_logs');
  };

  this.getNoteHistoryContent = function (historyId, note_id) {
    return _this.ajax.get('/author/note_logs/' + historyId, {
      params: {
        note_id: note_id
      }
    });
  };

  this.restoreHistoryContent = function (historyId, note_id) {
    return _this.ajax.post('/author/note_logs/' + historyId + '/restore', {
      note_id: note_id
    });
  };

  this.getTrashNotesList = function () {
    return _this.ajax.get('/author/recycle/notes');
  };

  this.changeReadMode = function (readMode) {
    return _this.ajax.put('/settings/view_mode', {
      read_mode: readMode
    });
  };

  this.changeFontType = function (fontType) {
    return _this.ajax.put('/settings/view_mode', {
      default_font: fontType
    });
  };

  this.changeLocale = function (locale) {
    return _this.ajax.put('/settings/view_mode', {
      locale: locale
    });
  };

  this.changeEditorType = function (editorType) {
    return _this.ajax.put('/author/settings', {
      preferred_note_type: editorType
    });
  };

  this.agreeThePNAgreement = function () {
    return _this.ajax.post('/paid_note_agreements/agree');
  };

  this.getPayNoteContent = function (note_id) {
    return _this.ajax.get('/author/paid_notes/notes/' + note_id + '/paid_setting');
  };

  this.updatePNSetting = function (data) {
    return _this.ajax.post('/author/paid_notes/notes/' + data.note_id + '/publicize', data);
  };

  this.getPayNoteAgreement = function () {
    return _this.ajax.get('/paid_note_agreement.html');
  };

  this.putAudioMessage = function (note_id, params) {
    return _this.ajax.put('/author/notes/' + note_id + '/audio', params);
  };

  this.deleteAudio = function (note_id) {
    return _this.ajax.delete('/author/notes/' + note_id + '/audio');
  };

  this.getAudioUrl = function (note_id) {
    return _this.ajax.get('/author/notes/' + note_id + '/audio/play_url');
  };

  this.getCoverImg = function (note_id) {
    return _this.ajax.get('/author/notes/' + note_id + '/cover_images');
  };

  this.postCoverImg = function (_ref2) {
    var noteId = _ref2.noteId,
        flowType = _ref2.flowType,
        abbr = _ref2.abbr,
        coverImgUrls = _ref2.coverImgUrls;
    return _this.ajax.post('/author/notes/' + noteId + '/update_cover_images', {
      flow_type: flowType,
      abbr: abbr,
      cover_image_urls: coverImgUrls
    });
  };

  this.getNoteMessage = function (noteId) {
    return _this.ajax.get('/author/notes/' + noteId);
  };

  this.postSetNoteTop = function (noteId) {
    return _this.ajax.post('/author/notes/' + noteId + '/set_top');
  };

  this.postUnsetNoteTop = function (noteId) {
    return _this.ajax.post('/author/notes/' + noteId + '/unset_top');
  };

  this.getTimePublishCount = function () {
    return _this.ajax.get('/user_function_cards/timing_publish/quantity');
  };

  this.getTimePublishCardInfo = function () {
    return _this.ajax.get('/function_cards/timing_publish');
  };

  this.setNotePublishTime = function (noteId, time) {
    return _this.ajax.post('/author/notes/' + noteId + '/publish_schedule/set_time', {
      schedule_time: time
    });
  };

  this.getTimePublishGuid = function () {
    return _this.ajax.post('/function_cards/timing_publish/buy', {
      quantity: 1
    });
  };

  this.payOrder = function (guid, channel) {
    return _this.ajax.post('/orders/' + guid + '/pay', { channel: channel });
  };

  this.getOrderStatus = function (guid) {
    return _this.ajax.get('/orders/' + guid + '/state');
  };

  this.getABtest = function () {
    return _this.ajax.get('/shakespeare/ab_settings');
  };

  this.getAuthorInfo = function () {
    return _this.ajax.get('/asimov/real_name_auth/auth_info');
  };

  this.ajax = _axios2.default.create({
    baseURL: baseURL,
    timeout: timeout,
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/json; charset=UTF-8'
    }
  });
  this.ajax.interceptors.response.use(function (res) {
    return res;
  }, function (error) {
    if (error.message === 'timeout of ' + timeout + 'ms exceeded') {
      // message.error(i18n.get('global.timeout'));
    }
    if (error.response) {
      var _error$response = error.response,
          data = _error$response.data,
          status = _error$response.status;
      var errors = data.error;

      if (errors) {
        // todo 目前401报错，error是string而不是数组
        showError(errors, status === 401);
      }
      data.status = status;
      return _promise2.default.reject(data);
    }
    return _promise2.default.reject(error);
  });
}

/* 与redux无关的api begin */

// 获取链接信息


// 获取视频信息


// 获取音频信息


// 身份验证时 请求发送验证码


// 身份验证时 验证验证码


// 获取国家手机区号


// 绑定手机请求发送 验证码


// 绑定手机请求验证 验证码


// 搜索专题的接口


// 搜索电影的接口：staging/线上直接请求电影服务全地址；
// 开发环境由 devServer 代理转发到同一全地址，避免本地跨域

// 获取用户管理的专题


// 获取用户最近投稿专题，分页有点奇怪

// 获取推荐的专题


// 投稿接口


/* 与redux无关的api end */

// 获取验证渠道信息


// 获取用户信息


// 切换同步滚动


// 获取文集列表


// 排序文集

// 修改文集名称


// 获取文章列表


// 排序文章


// 获取文章内容


// 创建文集


// 删除文集


// 创建文章


// 发布文章


// 更新文章内容（包含标题）


// 设置禁止转载


// 私密文章


// 移动文章


// 恢复文章


// 将文章移入回收站


// 彻底删除文章


// 获取历史版本的列表


// 获取某一个历史版本的内容  数据迁移需要临时加个note_id


// 恢复历史版本 数据迁移需要临时加个note_id


// 获取回收站文章列表


// 切换白天与黑夜模式


// 同意付费文章协议


// 获取付费文章内容


// 保存付费文章设置项


// 获取付费文章协议内容


// 上传音频标题与作者


// 删除音频


// 更新音频URL


// 获取自定义封面


// 上传自定义封面


// 获取文章信息


// 置顶文章


// 取消置顶文章


// 获取定时发文剩余次数


// 获取定时发文的详细信息


// 设置定时发文时间


// 获取定时发文guid


// 通过guid进行下单


// 查询订单状态


// 获取显示认证test


// 获取认证跳转
;

exports.default = new Ajax();

/***/ }),

/***/ "Z9ii":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAhFBMVEUAAAD6QC3/WEb/TDv5Py38QS//QDL7QC76Py36Py3/QjD6Py35Py36Py36Py36QC35Py37QC/6Qi/6QTD6Py36Py36Py36QC36Py76Py38QC76Py36Py75Py76QC75Py75Py37QC36QC38QC//RjH/SEj6QS/6Py36Py36QC3/STH5Py10Ms8sAAAAK3RSTlMAWgUJ2FAoesmqGvHgvaWaVj02L/n16cGel0zt0bKPhYF1YEkfA46NcWsV3NJT+wAAAOxJREFUOMvdkmkCgiAQhUcS1NTSzK193+b+92tAJAo7QH0/HPU9ecMg/BVsxrP88VWeRSVKwgMbkkcTNPiFq49XaDFxvw+VsKzrJZXIzdgiEavwol6/dNY0CxVQyuRx/9ZaGTGQ9YZEDgbHkJrGFp4mo3WFKBA3QghIyOCBxEfNHCDCHpibBGNAZhsquvB3Q0mj5TyjaM45yClcQbKbEvLRN032Y4hPoNA9N2+GAon0rPUjEllnSJI7Fd1wKLqdxnSfsI+zqtTW1rug7U7Nc36GGG1acBC+pV/Y0Nj3lZbTIwxzzvebNvBO8Js8AWRdJxV3vVB1AAAAAElFTkSuQmCC"

/***/ }),

/***/ "Z9oK":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".lRx6g{color:#999;text-align:center;vertical-align:middle;display:none;opacity:0}.qaqoV{background-color:#f2f2f2}body.reader-night-mode .qaqoV{background-color:#3d3d3d}._1jDx2{opacity:1;position:static}._1jDx2,._21yV1{display:inline-block}._21yV1{width:48px;height:48px}._1H33l ._21yV1{width:38.4px;height:38.4px}._1xE9Q ._21yV1{width:57.6px;height:57.6px}._3l2Da{-webkit-animation:_3kk3L 2s linear infinite;animation:_3kk3L 2s linear infinite;height:100%;-webkit-transform-origin:center center;-ms-transform-origin:center center;transform-origin:center center;width:100%;will-change:transfrom}._3sMBB{stroke-width:5;stroke-miterlimit:10;stroke-dasharray:1,151;stroke-dashoffset:0;stroke-linecap:round;stroke:#ec7259;-webkit-animation:pjsmG 1.5s cubic-bezier(.645,.045,.355,1) infinite;animation:pjsmG 1.5s cubic-bezier(.645,.045,.355,1) infinite;will-change:stroke-dasharray,stroke-dashoffset}._2mnPN{position:relative}._2mnPN .lRx6g{position:absolute;height:100%;width:100%;z-index:5}._2mnPN ._21yV1{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}._2mnPN ._2crc1 ._21yV1{-webkit-transform:translate(-50%,-50%) translateY(-10px);-ms-transform:translate(-50%,-50%) translateY(-10px);transform:translate(-50%,-50%) translateY(-10px)}._2mnPN .ZKQHD{position:absolute;top:50%;width:100%;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;color:#ec7259;-webkit-transform:translateY(18px);-ms-transform:translateY(18px);transform:translateY(18px)}._2mnPN ._1H33l .ZKQHD{-webkit-transform:translateY(13.2px);-ms-transform:translateY(13.2px);transform:translateY(13.2px)}._2mnPN ._1xE9Q .ZKQHD{-webkit-transform:translateY(22.8px);-ms-transform:translateY(22.8px);transform:translateY(22.8px)}._3br9T{position:relative;-webkit-transition:opacity .3s cubic-bezier(.645,.045,.355,1);-o-transition:opacity .3s cubic-bezier(.645,.045,.355,1);transition:opacity .3s cubic-bezier(.645,.045,.355,1);opacity:1}._3YqXw{pointer-events:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;opacity:.7}._3YqXw:after{content:\"\";position:absolute;left:0;right:0;top:0;bottom:0;background:transparent}@-webkit-keyframes _3kk3L{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes _3kk3L{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@-webkit-keyframes pjsmG{0%{stroke-dasharray:1,151;stroke-dashoffset:0}50%{stroke-dasharray:89,151;stroke-dashoffset:-35px}to{stroke-dasharray:89,151;stroke-dashoffset:-124px}}@keyframes pjsmG{0%{stroke-dasharray:1,151;stroke-dashoffset:0}50%{stroke-dasharray:89,151;stroke-dashoffset:-35px}to{stroke-dasharray:89,151;stroke-dashoffset:-124px}}", ""]);

// exports
exports.locals = {
	"loader": "lRx6g",
	"loader-has-mask": "qaqoV",
	"loader-is-loading": "_1jDx2",
	"loader-entity": "_21yV1",
	"loader-sm": "_1H33l",
	"loader-lg": "_1xE9Q",
	"loader-svg": "_3l2Da",
	"rotate": "_3kk3L",
	"loader-circle": "_3sMBB",
	"loader-dash": "pjsmG",
	"loading-has-children": "_2mnPN",
	"loader-show-tip": "_2crc1",
	"loader-tip": "ZKQHD",
	"loading-container": "_3br9T",
	"loading-blur": "_3YqXw"
};

/***/ }),

/***/ "aNgh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  PUBLISH_NOTE_BTN_CLICK: 'publish_note_btn_click', // 发布普通文章
  COMPILE_NOTE_BTN_CLICK: 'compile_note_btn_click', // 更新普通文章
  PUBLISH_PAID_NOTE_BTN_CLICK: 'publish_paid_note_btn_click', // 发布付费文章
  COMPILE_PAID_NOTE_BTN_CLICK: 'compile_paid_note_btn_click', // 更新付费文章
  PUBLIC_NOTE: 'public_note', // 公开文章
  PRIVATE_NOTE: 'private_note', // 私密文章
  ONE_IMG_CLICK: 'one_img_click', // '一图'按钮点击
  THREE_IMG_CLICK: 'three_img_click', // '三图'按钮点击
  UPLOAD_IMG_CLICK: 'upload_img_click', // '点击上传'按钮点击
  SAVE_BTN_CLICK: 'save_btn_click', // '保存'按钮点击
  PC_CLICK_STICK: 'pc_click_stick', // 点击'文章置顶'按钮
  PC_CLICK_UNSTICK: 'pc_click_unstick', // 点击'取消文章置顶'按钮
  PC_EDITOR_SIDEBAR_AD_EXPOSURE: 'pc_editor_sidebar_ad_exposure', // 侧边栏广告曝光
  PC_EDITOR_SIDEBAR_AD_CLICK: 'pc_editor_sidebar_ad_click' // 侧边栏广告点击
};

/***/ }),

/***/ "aQyQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _initialiseProps;

var _Message = __webpack_require__("mzOA");

var _Message2 = _interopRequireDefault(_Message);

var _Icon = __webpack_require__("9JgI");

var _Icon2 = _interopRequireDefault(_Icon);

var _urlHelper = __webpack_require__("kvZP");

var _util = __webpack_require__("oFuF");

var _ajax = __webpack_require__("Z1y9");

var _ajax2 = _interopRequireDefault(_ajax);

var _share = __webpack_require__("PNPU");

var _share2 = _interopRequireDefault(_share);

var _Menu = __webpack_require__("l8jW");

var _GlobalReducer = __webpack_require__("boom");

var _actionTypes = __webpack_require__("4HHy");

var _weibo = __webpack_require__("CGNb");

var _weibo2 = _interopRequireDefault(_weibo);

var _GlobalAction = __webpack_require__("5Q8M");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("RH2O");

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _clipboard = __webpack_require__("V33R");

var _clipboard2 = _interopRequireDefault(_clipboard);

var _reactIntlUniversal = __webpack_require__("cl+9");

var _reactIntlUniversal2 = _interopRequireDefault(_reactIntlUniversal);

var _PublishSuccessModal = __webpack_require__("MAZe");

var _PublishSuccessModal2 = _interopRequireDefault(_PublishSuccessModal);

var _tpl = __webpack_require__("H3Ok");

var _tpl2 = _interopRequireDefault(_tpl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var collectionIdAttr = 'data-collection-id';

var postNoteKey = 'publishSuccessModal.post-note';
var postingNoteKey = 'publishSuccessModal.posting-note';
var postedNoteKey = 'publishSuccessModal.posted-note';

var postNoteAttr = 'data-post-text';
var postingNoteAttr = 'data-posting-text';
var postedNoteAttr = 'data-posted-text';

// @withRouter
var PublishSuccessModal = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    globalState: (0, _GlobalReducer.getState)(state)
  };
}, function (dispatch) {
  return {
    setPublishSuccessData: function setPublishSuccessData(show, data) {
      return dispatch((0, _GlobalAction.setPublishSuccessData)(show, data));
    },
    setQrCodeModalData: function setQrCodeModalData(show, data) {
      return dispatch((0, _GlobalAction.setQrCodeModalData)(show, data));
    }
  };
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PublishSuccessModal, _Component);

  function PublishSuccessModal(props) {
    (0, _classCallCheck3.default)(this, PublishSuccessModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PublishSuccessModal.__proto__ || (0, _getPrototypeOf2.default)(PublishSuccessModal)).call(this, props));

    _initialiseProps.call(_this);

    var _this$props$data = _this.props.data,
        title = _this$props$data.title,
        slug = _this$props$data.slug;

    _this.noteSlug = slug;
    // 分享数据
    _this.shareData = {
      link: (0, _urlHelper.getNoteSharedUrl)(_this.noteSlug),
      title: title,
      text: title
    };
    // 按页存储
    _this.cachEditableCoData = {};
    _this.cachLatestCoData = {};
    _this.cachRecCoData = {};

    _this.state = {
      curEditableCoPageNum: 1, // 当前用户管理专题展示的页码
      totalEditableCoPage: -1,
      curLatestCoPageNum: 1, // 当前用户最近投稿专题展示的页码
      totalLatestCoPage: -1,
      curRecCoPageNum: 1, // 当前用户推荐专题展示的页码
      totalRecCoPage: -1,
      searchResultData: [], // 搜索的结果数据
      qrcdoeModalVisible: false,
      isLoadingRecCo: false, // 正在请求推荐文集
      isLoadingLatestCo: false, // 正在请求最近投稿文集
      isLoadingEditableCo: false, // 正在请求我的文集
      isSearching: false, // 正在请求搜索文集
      hasInputValue: false // 正在搜索
    };
    return _this;
  }

  (0, _createClass3.default)(PublishSuccessModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props$data = this.props.data,
          paid = _props$data.paid,
          noteId = _props$data.noteId,
          title = _props$data.title,
          slug = _props$data.slug;
      // 付费文章不需要显示这两个模块

      if (!paid) {
        this.getDataByPage('EditableCo', 1);
        this.getDataByPage('LatestCo', 1);
        this.getDataByPage('RecCo', 1);
      }
      var shareData = this.shareData;
      // clipboard 可以异步加载（TODO)

      if (!this.clipboard) {
        this.clipboard = new _clipboard2.default('.' + _PublishSuccessModal2.default['copy-link']);
        this.clipboard.on('success', function (e) {
          _Message2.default.success(_reactIntlUniversal2.default.get('publishSuccessModal.copy-success'));
          e.clearSelection();
        });
        this.clipboard.on('error', function (e) {
          _Message2.default.error(_reactIntlUniversal2.default.get('publishSuccessModal.copy-fail'));
        });
      }
    }

    // 分页请求数据，管理的专题、推荐的专题

    // 获取当前所有的RecCo data

  }, {
    key: 'render',
    value: function render() {
      var shareData = this.shareData,
          noteSlug = this.noteSlug;
      var paid = this.props.data.paid;
      var _state = this.state,
          qrcdoeModalVisible = _state.qrcdoeModalVisible,
          isSearching = _state.isSearching,
          hasInputValue = _state.hasInputValue;

      var modalTopClasses = (0, _classnames2.default)(_PublishSuccessModal2.default['modal--top'], (0, _defineProperty3.default)({}, _PublishSuccessModal2.default['modal-top-middle'], paid));
      return _react2.default.createElement(
        'div',
        { className: _PublishSuccessModal2.default['success-modal'] },
        _react2.default.createElement(
          'div',
          { className: modalTopClasses },
          _react2.default.createElement(
            'div',
            { className: _PublishSuccessModal2.default['title-wrap'] },
            _react2.default.createElement(
              'a',
              { href: shareData.link, className: _PublishSuccessModal2.default['title'] },
              shareData.title
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'a',
              { href: shareData.link, className: _PublishSuccessModal2.default['status-des'] },
              _reactIntlUniversal2.default.get('publishSuccessModal.success-des')
            )
          ),
          _tpl2.default.renderShareItems(shareData, _PublishSuccessModal2.default, { weiboIcon: _weibo2.default }, this.onWeiboShareBtnClick, this.onWechatShareBtnClick)
        ),
        _react2.default.createElement(
          'div',
          { className: _PublishSuccessModal2.default['close-btn'], onClick: this.onCloseClick },
          '\xD7'
        ),
        _react2.default.createElement('div', { className: _PublishSuccessModal2.default['modal--rec'] }),
        !paid && _react2.default.createElement(
          'div',
          { className: _PublishSuccessModal2.default['modal--bottom'] },
          _react2.default.createElement(
            'div',
            { className: _PublishSuccessModal2.default['collection-des'] },
            _react2.default.createElement(
              'div',
              { className: _PublishSuccessModal2.default['search-input-wrap'] },
              _react2.default.createElement(_Icon2.default, { name: 'search', size: '2x' }),
              _react2.default.createElement('input', {
                type: 'text',
                placeholder: _reactIntlUniversal2.default.get('publishSuccessModal.search-collection'),
                onChange: this.onSearchInputChange
              })
            ),
            _react2.default.createElement(
              'div',
              { className: _PublishSuccessModal2.default['des'] },
              _reactIntlUniversal2.default.get('publishSuccessModal.post-des')
            )
          ),
          hasInputValue && this.renderSearchResultPage(),
          !hasInputValue && this.renderNormalPage()
        )
      );
    }
  }]);
  return PublishSuccessModal;
}(_react.Component), _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.contributeToCollection = function (collectionId, noteId) {
    return _ajax2.default.contributeToCollection(collectionId, noteId);
  };

  this.showBigQrcodeModal = function () {
    var shareData = _this2.shareData;

    _this2.props.setQrCodeModalData(true, { link: shareData.link });
  };

  this.getDataByPage = function (name, page) {
    var perPageSize = name === 'RecCo' ? 30 : 6;
    if (page < 1) {
      return;
    }
    // 最近投稿的专题 需要一个max_id
    var maxId = void 0;
    if (name === 'LatestCo') {
      // 前一页数据还没有，是没法获取到后一页数据的，所以直接retrun
      if (page > 1 && !_this2.cachLatestCoData[page - 1]) {
        return;
      }
      var prePageData = _this2.cachLatestCoData[page - 1];
      if (prePageData) {
        // 取最后一个submitted_at
        maxId = (prePageData[prePageData.length - 1] || {}).submitted_at;
      }
    }
    var noteId = _this2.props.data.noteId;

    var data = _this2['cach' + name + 'Data'][page];

    _this2.setState((0, _defineProperty3.default)({}, 'cur' + name + 'PageNum', page));
    // 优先看缓存
    if (data) {
      _this2.setState((0, _defineProperty3.default)({}, 'isLoading' + name, false));
      return;
    }
    // ajax begin
    _this2.setState((0, _defineProperty3.default)({}, 'isLoading' + name, true));
    _ajax2.default['get' + name + 'llections'](noteId, page, perPageSize, { maxId: maxId }).then(function (res) {
      var resData = res.data;
      var totalPage = 0;
      if (resData.total_pages !== undefined) {
        totalPage = resData.total_pages;
      } else if (resData.total_count !== undefined) {
        totalPage = Math.ceil(resData.total_count / perPageSize);
      }
      // save data
      _this2.setState((0, _defineProperty3.default)({}, 'total' + name + 'Page', totalPage));
      _this2['cach' + name + 'Data'][page] = res.data.collections;
      // this[`cach${name}Data`][page] = [1, 2, 3, 4, 5, 6];

      // 如果当前展示页和返回的数据页一致，需要去掉loading
      // console.log(this.state[`cur${name}PageNum`], page);
      if (_this2.state['cur' + name + 'PageNum'] === page) {
        _this2.setState((0, _defineProperty3.default)({}, 'isLoading' + name, false));
      }
    }).catch(function (error) {
      // console.log('getDataByPage::', error);
      _this2.setState((0, _defineProperty3.default)({}, 'isLoading' + name, false));
      // Message.error(i18n.get('error.try-again'));
    });
  };

  this.onContributeBtnClick = function (e) {
    var noteId = _this2.props.data.noteId;
    var target = e.target;

    var collectionId = target.getAttribute(collectionIdAttr);
    var postNoteText = target.getAttribute(postNoteAttr);
    var postingNoteText = target.getAttribute(postingNoteAttr);
    var postedNoteText = target.getAttribute(postedNoteAttr);

    // 防止重复投稿
    if (!collectionId) {
      return;
    }
    target.removeAttribute(collectionIdAttr);
    var nextElem = target.nextElementSibling;
    target.innerHTML = postingNoteText;
    _this2.contributeToCollection(collectionId, noteId).then(function (data) {
      target.innerHTML = postedNoteText;
    }).catch(function (error) {
      target.innerHTML = postNoteText;
      target.setAttribute(collectionIdAttr, collectionId);
      _Message2.default.error(error.error);
    });
  };

  this.onCloseClick = function () {
    _this2.props.setPublishSuccessData(false); // 关闭弹窗
  };

  this.onWeiboShareBtnClick = function () {
    var shareData = _this2.shareData;

    (0, _share2.default)('weibo', shareData.link, shareData.title, shareData.text);
  };

  this.onWechatShareBtnClick = function () {
    _this2.showBigQrcodeModal();
  };

  this.searchCollections = function (noteId, queryword) {
    _this2.setState({
      isSearching: true,
      searchResultData: []
    });
    _ajax2.default.searchCollections(noteId, queryword).then(function (res) {
      var data = res.data;
      // console.log('searchCollections success::', data);

      _this2.setState({
        isSearching: false,
        searchResultData: data
      });
    }).catch(function (error) {
      // console.log('searchCollections error::', error);
      _this2.setState({
        isSearching: false,
        searchResultData: []
      });
    });
  };

  this.onSearchInputChange = function (e) {
    var noteId = _this2.props.data.noteId;

    var value = (e.target.value || '').trim();
    var isSearching = _this2.state.isSearching;

    clearTimeout(_this2.searchTimer);
    if (!value) {
      _this2.setState({
        hasInputValue: false,
        searchResultData: []
      });
      return;
    }
    if (isSearching) {
      return;
    }
    _this2.searchTimer = setTimeout(function () {
      _this2.setState({
        hasInputValue: true
      });
      _this2.searchCollections(noteId, value);
    }, 500);
  };

  this.getCurRecCoData = function () {
    var cachRecCoData = _this2.cachRecCoData;
    var curRecCoPageNum = _this2.state.curRecCoPageNum;

    var result = [];
    for (var i = 1; i <= curRecCoPageNum; i++) {
      result = result.concat(cachRecCoData[i] || []);
    }
    return result;
  };

  this.renderNormalPage = function () {
    var cachEditableCoData = _this2.cachEditableCoData,
        cachLatestCoData = _this2.cachLatestCoData,
        cachRecCoData = _this2.cachRecCoData;
    var _state2 = _this2.state,
        isLoadingEditableCo = _state2.isLoadingEditableCo,
        isLoadingLatestCo = _state2.isLoadingLatestCo,
        isLoadingRecCo = _state2.isLoadingRecCo,
        curEditableCoPageNum = _state2.curEditableCoPageNum,
        totalEditableCoPage = _state2.totalEditableCoPage,
        curLatestCoPageNum = _state2.curLatestCoPageNum,
        totalLatestCoPage = _state2.totalLatestCoPage,
        curRecCoPageNum = _state2.curRecCoPageNum,
        totalRecCoPage = _state2.totalRecCoPage;
    var _props$data2 = _this2.props.data,
        noteId = _props$data2.noteId,
        title = _props$data2.title,
        slug = _props$data2.slug;

    return _react2.default.createElement(
      'div',
      { className: _PublishSuccessModal2.default['normal-page'] },

      // 我管理的专题模块
      cachEditableCoData[curEditableCoPageNum] && _tpl2.default.renderEditableCoPage(cachEditableCoData[curEditableCoPageNum], isLoadingEditableCo, _PublishSuccessModal2.default, {
        postText: _reactIntlUniversal2.default.get('publishSuccessModal.include-note'),
        postingText: _reactIntlUniversal2.default.get('publishSuccessModal.including-note'),
        postedText: _reactIntlUniversal2.default.get('publishSuccessModal.included-note')
      }, _this2.onContributeBtnClick, curEditableCoPageNum, totalEditableCoPage, function () {
        _this2.getDataByPage('EditableCo', curEditableCoPageNum - 1);
      }, function () {
        _this2.getDataByPage('EditableCo', curEditableCoPageNum + 1);
      }, (0, _urlHelper.getNewCollectionPageUrl)()),

      // 最近投稿模块
      _tpl2.default.renderLatestCoPage(cachLatestCoData, isLoadingLatestCo, _PublishSuccessModal2.default, {
        postText: _reactIntlUniversal2.default.get(postNoteKey),
        postingText: _reactIntlUniversal2.default.get(postingNoteKey),
        postedText: _reactIntlUniversal2.default.get(postedNoteKey)
      }, _this2.onContributeBtnClick, curLatestCoPageNum, totalLatestCoPage, function () {
        _this2.getDataByPage('LatestCo', curLatestCoPageNum - 1);
      }, function () {
        _this2.getDataByPage('LatestCo', curLatestCoPageNum + 1);
      }),

      // 推荐专题模块
      _tpl2.default.renderRecCoPage(_this2.getCurRecCoData(), isLoadingRecCo, _PublishSuccessModal2.default, {
        postText: _reactIntlUniversal2.default.get(postNoteKey),
        postingText: _reactIntlUniversal2.default.get(postingNoteKey),
        postedText: _reactIntlUniversal2.default.get(postedNoteKey)
      }, _this2.onContributeBtnClick, curRecCoPageNum, totalRecCoPage, function () {
        _this2.getDataByPage('RecCo', curRecCoPageNum + 1);
      })
    );
  };

  this.renderSearchResultPage = function () {
    var _state3 = _this2.state,
        isSearching = _state3.isSearching,
        searchResultData = _state3.searchResultData;


    return _react2.default.createElement(
      'div',
      { className: _PublishSuccessModal2.default['search-result-page'] },
      _react2.default.createElement(
        'div',
        { className: _PublishSuccessModal2.default['collection-auto-page'] },
        _tpl2.default.renderRecomendCollectionItems(searchResultData, isSearching, _PublishSuccessModal2.default, {
          postText: _reactIntlUniversal2.default.get(postNoteKey),
          postingText: _reactIntlUniversal2.default.get(postingNoteKey),
          postedText: _reactIntlUniversal2.default.get(postedNoteKey)
        }, _this2.onContributeBtnClick)
      )
    );
  };
}, _temp)) || _class);
exports.default = PublishSuccessModal;

/***/ }),

/***/ "bByz":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "._3zXcJ{position:relative;display:inline-block;text-align:center;height:30px;line-height:20px;padding:4px 12px;border:1px solid transparent;border-radius:15px;font-size:14px;font-weight:500;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;background-image:none;white-space:nowrap;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-transition:all .2s cubic-bezier(.645,.045,.355,1);-o-transition:all .2s cubic-bezier(.645,.045,.355,1);transition:all .2s cubic-bezier(.645,.045,.355,1);color:#595959;background-color:#fff;border-color:transparent}._3zXcJ+._3zXcJ{margin-left:8px}._3zXcJ:focus,._3zXcJ:hover{color:#404040}._3zXcJ:active,._3zXcJ:focus,._3zXcJ:hover{background-color:#fff;border-color:transparent}._3zXcJ:active{color:#262626}body.reader-night-mode ._3zXcJ{color:#b3b3b3;background-color:#3d3d3d;border-color:transparent}body.reader-night-mode ._3zXcJ:focus,body.reader-night-mode ._3zXcJ:hover{color:#ccc;background-color:#3d3d3d;border-color:transparent}body.reader-night-mode ._3zXcJ:active{color:#e6e6e6;background-color:#3d3d3d;border-color:transparent}._3QfkW{color:#42c02e;background-color:#fff;border-color:#42c02e}._3QfkW:focus,._3QfkW:hover{color:#42c02e;background-color:#f7fcf7;border-color:#42c02e}._3QfkW:active{color:#42c02e;background-color:#f0faee;border-color:#42c02e}body.reader-night-mode ._3QfkW{color:#42c02e;background-color:#3d3d3d;border-color:#42c02e}body.reader-night-mode ._3QfkW:focus,body.reader-night-mode ._3QfkW:hover{color:#42c02e;background-color:#3d423d;border-color:#42c02e}body.reader-night-mode ._3QfkW:active{color:#42c02e;background-color:#3e483c;border-color:#42c02e}._3QfkW._3LBxu:before{content:\"\";position:absolute;border-radius:inherit;border:0 solid #42c02e;-webkit-animation:_12ABh .3s ease-out forwards;animation:_12ABh .3s ease-out forwards}._3QfkW._1M1e4{color:#fff;background-color:#42c02e;border-color:#42c02e}._3QfkW._1M1e4:focus,._3QfkW._1M1e4:hover{color:#fff;background-color:#4ac336;border-color:#42c02e}._3QfkW._1M1e4:active{color:#fff;background-color:#51c53f;border-color:#42c02e}body.reader-night-mode ._3QfkW._1M1e4{color:#3d3d3d;background-color:#42c02e;border-color:#42c02e}body.reader-night-mode ._3QfkW._1M1e4:focus,body.reader-night-mode ._3QfkW._1M1e4:hover{color:#3d3d3d;background-color:#42bb2f;border-color:#42c02e}body.reader-night-mode ._3QfkW._1M1e4:active{color:#3d3d3d;background-color:#42b62f;border-color:#42c02e}.JrecM{color:#f50;background-color:#fff;border-color:#f50}.JrecM:focus,.JrecM:hover{color:#f50;background-color:#fff8f5;border-color:#f50}.JrecM:active{color:#f50;background-color:#fff1eb;border-color:#f50}body.reader-night-mode .JrecM{color:#f50;background-color:#3d3d3d;border-color:#f50}body.reader-night-mode .JrecM:focus,body.reader-night-mode .JrecM:hover{color:#f50;background-color:#453e3b;border-color:#f50}body.reader-night-mode .JrecM:active{color:#f50;background-color:#4d3f38;border-color:#f50}.JrecM._3LBxu:before{content:\"\";position:absolute;border-radius:inherit;border:0 solid #f50;-webkit-animation:_12ABh .3s ease-out forwards;animation:_12ABh .3s ease-out forwards}.JrecM._1M1e4{color:#fff;background-color:#f50;border-color:#f50}.JrecM._1M1e4:focus,.JrecM._1M1e4:hover{color:#fff;background-color:#ff5c0a;border-color:#f50}.JrecM._1M1e4:active{color:#fff;background-color:#ff6314;border-color:#f50}body.reader-night-mode .JrecM._1M1e4{color:#3d3d3d;background-color:#f50;border-color:#f50}body.reader-night-mode .JrecM._1M1e4:focus,body.reader-night-mode .JrecM._1M1e4:hover{color:#3d3d3d;background-color:#f75402;border-color:#f50}body.reader-night-mode .JrecM._1M1e4:active{color:#3d3d3d;background-color:#ef5305;border-color:#f50}@-webkit-keyframes _12ABh{0%{opacity:.382;top:-1px;left:-1px;bottom:-1px;right:-1px;border-width:1px}to{opacity:0;top:-6px;left:-6px;bottom:-6px;right:-6px;border-width:6px}}@keyframes _12ABh{0%{opacity:.382;top:-1px;left:-1px;bottom:-1px;right:-1px;border-width:1px}to{opacity:0;top:-6px;left:-6px;bottom:-6px;right:-6px;border-width:6px}}", ""]);

// exports
exports.locals = {
	"btn": "_3zXcJ",
	"btn-primary": "_3QfkW",
	"btn-clicked": "_3LBxu",
	"buttonClick": "_12ABh",
	"btn-strong": "_1M1e4",
	"btn-danger": "JrecM"
};

/***/ }),

/***/ "boom":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getState = undefined;

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _immutable2.default.fromJS(initialState);
  var action = arguments[1];

  switch (action.type) {
    case _actionTypes.Global.CHANGE_LOCALE:
      {
        return state;
      }
    case _actionTypes.Global.CHANGE_LOCALE_SUCCESS:
      {
        state = state.setIn(['locale'], action.locale);
        return state;
      }
    case _actionTypes.Global.CHANGE_LOCALE_FAIL:
      {
        return state;
      }
    case _actionTypes.Global.CHANGE_READ_MODE:
      {
        return state;
      }
    case _actionTypes.Global.CHANGE_READ_MODE_SUCCESS:
      {
        state = state.setIn(['readMode'], action.readMode);
        return state;
      }
    case _actionTypes.Global.CHANGE_READ_MODE_FAIL:
      {
        return state;
      }
    case _actionTypes.Global.CHANGE_FONT_TYPE:
      {
        return state;
      }
    case _actionTypes.Global.CHANGE_FONT_TYPE_SUCCESS:
      {
        state = state.setIn(['fontType'], action.fontType);
        return state;
      }
    case _actionTypes.Global.CHANGE_FONT_TYPE_FAIL:
      {
        return state;
      }
    case _actionTypes.Global.SET_BIND_WX_STATUS:
      {
        var status = action.status;

        state = state.setIn(['bindWx'], status);
        return state;
      }
    case _actionTypes.Global.SET_BIND_PHONE_STATUS:
      {
        var hasBind = action.hasBind;

        state = state.setIn(['bindPhoneStatus'], hasBind);
        return state;
      }
    case _actionTypes.Global.SET_BIND_STATUS:
      {
        var data = action.data,
            _status = action.status;

        state = state.setIn(['bindStatus'], _status);
        if (data) {
          state = state.setIn(['account'], data);
        }
        return state;
      }
    case _actionTypes.Global.SET_PUBLISH_SUCCESS_MODAL_DATA:
      {
        var show = action.show,
            _action$data = action.data,
            _data = _action$data === undefined ? {} : _action$data;

        state = state.setIn(['publishSuccessModalData'], _immutable2.default.fromJS({ show: show, data: _data }));
        return state;
      }
    case _actionTypes.Global.SET_QRCODE_MODAL_DATA:
      {
        var _action$data2 = action.data,
            _data2 = _action$data2 === undefined ? {} : _action$data2,
            _show = action.show;

        state = state.setIn(['qrCodeModal'], _immutable2.default.fromJS({ show: _show, data: _data2 }));
        return state;
      }
    case _actionTypes.Global.SWITCH_DEV:
      {
        state = state.setIn(['isDev'], !state.get('isDev'));
        return state;
      }
    case _actionTypes.Global.SET_NOTE_DATA:
      {
        var _action$data3 = action.data,
            _data3 = _action$data3 === undefined ? {} : _action$data3;

        state = state.setIn(['noteData', 'isInit'], _data3.isInit);
        return state;
      }
    case _actionTypes.Global.SET_SORTED_NOTE_DATA:
      {
        var _action$data4 = action.data,
            _data4 = _action$data4 === undefined ? {} : _action$data4;

        state = state.setIn(['sortingNote'], _immutable2.default.fromJS(_data4));
        return state;
      }
    case _actionTypes.Global.SET_PNAGREE_MODAL_DATA:
      {
        var _show2 = action.show,
            _action$data5 = action.data,
            _data5 = _action$data5 === undefined ? {} : _action$data5;

        state = state.setIn(['pnAgreeModal'], _immutable2.default.fromJS({
          show: _show2,
          data: _data5
        }));
        return state;
      }
    case _actionTypes.Global.SET_OCCUPY_HASOTHER:
      {
        var msg = action.msg,
            _status2 = action.status;

        state = state.setIn(['occupyhasother'], {
          status: _status2,
          msg: msg
        });
        return state;
      }
    case _actionTypes.Global.SET_OCCUPY_NOOTHER:
      {
        var _msg = action.msg,
            _status3 = action.status,
            step = action.step,
            _data6 = action.data;

        state = state.setIn(['noOtherAccount'], {
          status: _status3,
          msg: _msg,
          step: step,
          data: _data6
        });
        return state;
      }
    case _actionTypes.Global.OPEN_TIME_PUBLISH_BUY_MODAL:
      {
        var _data7 = action.data;

        state = state.setIn(['timePublishBuyModal', 'data'], (0, _immutable.fromJS)(_data7));
        state = state.setIn(['timePublishBuyModal', 'visible'], true);
        return state;
      }
    case _actionTypes.Global.CLOSE_TIME_PUBLISH_BUY_MODAL:
      {
        state = state.setIn(['timePublishBuyModal', 'visible'], false);
        return state;
      }
    default:
      return state;
  }
};

var _immutable = __webpack_require__("BYKG");

var _immutable2 = _interopRequireDefault(_immutable);

var _jsCookie = __webpack_require__("lbHh");

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _actionTypes = __webpack_require__("4HHy");

var _util = __webpack_require__("oFuF");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-param-reassign */
/**
 * Created by zad on 17/10/18.
 */
var locale = _jsCookie2.default.get('locale') || 'zh-CN';
var readMode = _jsCookie2.default.get('read_mode') || 'day';
var fontType = _jsCookie2.default.get('default_font') || 'font2';

var initialState = {
  locale: locale, // 地区
  readMode: readMode, // 浏览模式
  fontType: fontType, // font1 -> 宋体 font2 -> 黑体
  isDev: _util.isDev,
  bindStatus: true,
  account: {},
  occupyhasother: {
    status: false,
    msg: ''
  },
  noOtherAccount: {
    status: false,
    msg: '',
    step: 1,
    data: '{}'
  },
  bindWx: true,
  bindPhoneStatus: true, // 是否已绑定手机，默认是true
  // 文章发布成功的全局控制数据
  publishSuccessModalData: {
    show: false, // 是否展示发布成功的modal
    data: {} // 存有noteId isPaid字段
  },
  // 显示微信二维码
  qrCodeModal: {
    show: false,
    data: {}
  },
  // 一些关于note的共享信息
  noteData: {
    isInit: false // 是否是新建文章
  },
  // 显示付费文章协议弹窗
  pnAgreeModal: {
    show: false,
    data: {}
  },
  // 正在移动文章的数据
  sortingNote: {
    isSorting: false,
    isCursorOnNbItem: false, // 鼠标是否在文集item上
    noteId: null,
    nbId: null,
    newNbId: null
  },
  // 购买定时发文的modal
  timePublishBuyModal: {
    visible: false,
    data: {}
  }
};

var getState = exports.getState = function getState(state) {
  return state.Global;
};

/***/ }),

/***/ "cBxc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = chainFunc;
/**
 * Created by zad on 17/9/29.
 */
function chainFunc() {
  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  var len = fns.length;
  return function chain() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    for (var i = 0; i < len; i++) {
      var fn = fns[i];
      if (fn && typeof fn === 'function') {
        fn.apply(this, args);
      }
    }
  };
}

/***/ }),

/***/ "cEaC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),

/***/ "cjYq":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".KinQ7{position:fixed;top:0;left:0;width:100%;height:100%;z-index:1011;background-color:hsla(0,0%,100%,.7)}body.reader-night-mode .KinQ7{background-color:hsla(0,0%,40%,.7)}.KinQ7 ._1ZqlG{position:absolute;padding:80px 60px 50px;border-radius:4px;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%);background-color:#fff;-webkit-box-shadow:0 5px 25px rgba(0,0,0,.1);box-shadow:0 5px 25px rgba(0,0,0,.1)}body.reader-night-mode .KinQ7 ._1ZqlG{background-color:#3d3d3d}.KinQ7 ._1ZqlG ._32hyk{width:240px;color:#4d4d4d;line-height:45px;font-size:14px;line-height:1.3;text-align:center;margin-bottom:30px;margin-top:-15px}body.reader-night-mode .KinQ7 ._1ZqlG ._32hyk{color:#b3b3b3}.KinQ7 ._1ZqlG img{margin:0 auto;padding:10px;width:200px;height:200px;background-color:#fff}.KinQ7 ._1ZqlG ._2vtX2{position:absolute;right:15px;top:6px;padding:5px;font-size:30px;font-weight:400;line-height:1;cursor:pointer}body.reader-night-mode .KinQ7 ._1ZqlG ._2vtX2{color:#b3b3b3}.u_qO5{display:none}", ""]);

// exports
exports.locals = {
	"qrcode-modal": "KinQ7",
	"qr-modal-body": "_1ZqlG",
	"qr-modal--title": "_32hyk",
	"close-btn": "_2vtX2",
	"hidden": "u_qO5"
};

/***/ }),

/***/ "cmUn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),

/***/ "dHmQ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABx0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzIENTNui8sowAAAKdSURBVFiF7ddNiFVlGAfw35WpSRG1XmchIm40ECNLVEwXlS4E3Si8gYoYUZouIjcSbmojCH4GEYQQIfgReBIZoYI26kIrZTYuoiSYBM2POYxOqGVyr4tzL565zp0753aHcdEfzuJ53ud5/n/e9zznfU6pUqkYS4wbU/anQUCprdWStAtbsAwV/IAvxNA/ROw4MZRLOcdkMdz5D+Rb8QFm4Zmq9wEu44AYvqzGTcHb6BPDkbyAHnwlhs9aID+EjU2ivsFDrMJ4dImhv1QtMBO91cD3xXCwAPmH+LSA3KtYjX8wrSbgdZzOBe1RqXzkranD92iSTsQfeGGE5GWcRycGsKXWBf/WBW5XKv0kSV9rUnBJAXKyrluKSYhiuFwT8JtsS/JYiHOS9JgkXdSg4KwC5DV8i/m1zsi/hCewZpjEn3ESZ/CLGPol6VocKyhgnRi+rhkduYV38SamNEhcVH1gQJJeKUhcQ2feyI4gSRdgJTahbwRFJuGl6lMUN/NGbQc6cbhK3lmf0Wb0DiWgB7fQNcrkf+L3vCM7ghjuY98ok8N5MTx4UgBUKrvx/SgLOF7veCwg++qtwm78NQrkfehuLOCxfQofo9U2a4TPxXCv3tlRZ5dxAAtk93m70If9Qy0M3oEYytiAv7V3WNkmhoHmAjIRv2IFrreJ/KgYjjRaHHomjOEsXsYuXMSNFskv4J3hAppvc5LOkF04SwuS92C5GG63JiBJ5+A9bMbEguTdWC+Gu80CS5J0ruxSeQ4TMAeLZfNAUdzDJ2LYO9KEDlm/v4gdmNcCKdzHUewUQ2+RxMFHkKSvyIaSZZiN5/FsXU65SngTl/AdusVwrQXhw74Dr+IN2Udpuuyavi0b337EWTFcbYV0kID/f07HWsAjK3ysMn3cJKAAAAAASUVORK5CYII="

/***/ }),

/***/ "dxin":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "._393FU p{font-size:15px;color:#2f2f2f;line-height:normal;margin-bottom:30px}body.reader-night-mode ._393FU p{color:#b3b3b3}", ""]);

// exports
exports.locals = {
	"content": "_393FU"
};

/***/ }),

/***/ "dzfs":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("Vpld");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./HasOtherAccount.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./HasOtherAccount.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "eQpn":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "._1YJL-{padding:40px 60px}._1YJL-,._3RuAN{text-align:center}._3RuAN{font-size:16px;font-weight:500;color:#000;margin-bottom:20px}body.reader-night-mode ._3RuAN{color:#d9d9d9}body.reader-night-mode .ant-select,body.reader-night-mode .ant-select-arrow{color:#b3b3b3}body.reader-night-mode .ant-select-selection{background-color:transparent;border-color:#2e2e2e;-webkit-box-shadow:none;box-shadow:none}.ant-select-open .ant-select-selection{border-color:#fa9e87;-webkit-box-shadow:0 0 0 2px rgba(236,114,89,.2);box-shadow:0 0 0 2px rgba(236,114,89,.2)}.ant-select-selection:hover{border-color:#fa9e87}.ant-select-selection:active,.ant-select-selection:focus{border-color:#fa9e87;-webkit-box-shadow:0 0 0 2px rgba(236,114,89,.2);box-shadow:0 0 0 2px rgba(236,114,89,.2)}.ant-select-dropdown-menu-item-active:not(.ant-select-dropdown-menu-item-disabled),.ant-select-dropdown-menu-item:hover:not(.ant-select-dropdown-menu-item-disabled){background-color:#fff5f0}body.reader-night-mode .ant-select-dropdown-menu-item{color:#b3b3b3;background-color:#3d3d3d}body.reader-night-mode .ant-select-dropdown-menu-item:hover:not(.ant-select-dropdown-menu-item-disabled){background-color:rgba(236,114,89,.7);color:#262626}body.reader-night-mode .ant-select-dropdown-menu-item-selected{background-color:#505050}body.reader-night-mode .ant-select-dropdown-menu-item-disabled,body.reader-night-mode .ant-select-dropdown-menu-item-disabled:hover{color:gray}body.reader-night-mode .ant-select-dropdown-menu-item-active:not(.ant-select-dropdown-menu-item-disabled){background-color:rgba(236,114,89,.7);color:#262626}._1RSIF{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;height:70px;border-top:1px solid rgba(0,0,0,.1)}body.reader-night-mode ._1RSIF{border-color:#595959}._2MpoI{color:#2f2f2f;font-size:14px}body.reader-night-mode ._2MpoI{color:#b3b3b3}.SOqpc{color:#ec7259;font-size:24px}._2xeAE,.SOqpc{font-weight:500}._2xeAE{display:inline-block;line-height:1;margin-top:24px;padding:12px 24px;font-size:14px;color:#fff;border-radius:24px;background-color:#ec7259;cursor:pointer}._1wLL2{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;text-align:left;margin-bottom:8px;padding-top:20px;border-top:1px solid rgba(0,0,0,.1)}body.reader-night-mode ._1wLL2{border-color:#595959}._1wLL2 ._1R60W{font-size:12px;color:#999}._1wLL2 ._2Pm6B{color:#ec7259}._1wLL2 ._2Pm6B,.pI4PI{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-size:12px}.pI4PI{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-top:30px;color:#999}.pI4PI>i{margin-right:4px}", ""]);

// exports
exports.locals = {
	"body": "_1YJL-",
	"title": "_3RuAN",
	"item": "_1RSIF",
	"item-name": "_2MpoI",
	"item-value": "SOqpc",
	"btn": "_2xeAE",
	"member-tips": "_1wLL2",
	"tip": "_1R60W",
	"buy": "_2Pm6B",
	"buy-tip": "pI4PI"
};

/***/ }),

/***/ "eTMa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _MenuUtil = __webpack_require__("DgVG");

var _util = __webpack_require__("oFuF");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _Menu = __webpack_require__("f0Ki");

var _Menu2 = _interopRequireDefault(_Menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Menu = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(Menu, _Component);

  function Menu() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Menu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Menu.__proto__ || (0, _getPrototypeOf2.default)(Menu)).call.apply(_ref, [this].concat(args))), _this), _this.onMouseLeave = function (e) {
      var onMouseLeave = _this.props.onMouseLeave;

      onMouseLeave(e);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Menu, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          show = _props.show,
          children = _props.children,
          className = _props.className,
          onClick = _props.onClick,
          getMenuDom = _props.getMenuDom;

      return _react2.default.createElement(
        'ul',
        { ref: getMenuDom, className: (0, _classnames2.default)(className, _Menu2.default['menu']), onMouseLeave: this.onMouseLeave },
        (0, _MenuUtil.renderChildren)(children, {
          onClick: onClick
        })
      );
    }
  }]);
  return Menu;
}(_react.Component), _class.defaultProps = {
  onClick: _util.noop,
  onMouseLeave: _util.noop
}, _temp2);
exports.default = Menu;

/***/ }),

/***/ "f0Ki":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("4/F/");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./Menu.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./Menu.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "gESm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _omit2 = __webpack_require__("Dc7M");

var _omit3 = _interopRequireDefault(_omit2);

var _class, _temp; /**
                    * Created by zad on 17/11/16.
                    */


var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("O27J");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LazyRenderBox = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(LazyRenderBox, _Component);

  function LazyRenderBox() {
    (0, _classCallCheck3.default)(this, LazyRenderBox);
    return (0, _possibleConstructorReturn3.default)(this, (LazyRenderBox.__proto__ || (0, _getPrototypeOf2.default)(LazyRenderBox)).apply(this, arguments));
  }

  (0, _createClass3.default)(LazyRenderBox, [{
    key: 'shouldComponentUpdate',


    // eslint-disable-next-line class-methods-use-this
    value: function shouldComponentUpdate(nextProps) {
      return !!nextProps.hiddenClassName || !!nextProps.visible;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          hiddenClassName = _props.hiddenClassName,
          visible = _props.visible;

      var boxClass = (0, _classnames2.default)(className, (0, _defineProperty3.default)({}, '' + hiddenClassName, !!hiddenClassName && !visible));
      var props = (0, _omit3.default)((0, _assign2.default)({}, this.props), ['hiddenClassName', 'visible']);
      return _react2.default.createElement('div', (0, _extends3.default)({}, props, { className: boxClass }));
    }
  }]);
  return LazyRenderBox;
}(_react.Component), _class.propTypes = {
  className: _propTypes2.default.string,
  visible: _propTypes2.default.bool,
  hiddenClassName: _propTypes2.default.string,
  role: _propTypes2.default.string,
  style: _propTypes2.default.object
}, _class.defaultProps = {
  style: {}
}, _temp);
exports.default = LazyRenderBox;

/***/ }),

/***/ "geoC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__("2KeS");

var _reduxSaga = __webpack_require__("igqX");

var _reduxSaga2 = _interopRequireDefault(_reduxSaga);

var _rootReducer = __webpack_require__("7ITh");

var _rootReducer2 = _interopRequireDefault(_rootReducer);

var _rootSaga = __webpack_require__("OPmc");

var _rootSaga2 = _interopRequireDefault(_rootSaga);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line import/no-mutable-exports
var store = void 0;
var sagaMiddleware = (0, _reduxSaga2.default)({
  onError: function onError(e) {
    // 上报saga 错误
    if (window.Raven) {
      window.Raven.captureException(e);
    }
  }
});

// set store
if (false) {
  store = (0, _redux.createStore)(_rootReducer2.default, (0, _redux.compose)((0, _redux.applyMiddleware)(sagaMiddleware),
  // eslint-disable-next-line no-underscore-dangle
  window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__({
    serialize: {
      options: true
    }
  }) : function (f) {
    return f;
  }));
} else {
  store = (0, _redux.createStore)(_rootReducer2.default, (0, _redux.applyMiddleware)(sagaMiddleware));
}

// run saga
sagaMiddleware.run(_rootSaga2.default);

// Enable Webpack hot module replacement for reducers
if (false) {
  module.hot.accept('../reducers/rootReducer', function () {
    var nextRootReducer = _rootReducer2.default;
    store.replaceReducer(nextRootReducer);
  });
}

exports.default = store;

/***/ }),

/***/ "gmmG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getState = undefined;

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _immutable2.default.fromJS(initialState);
  var action = arguments[1];

  switch (action.type) {
    case _actionTypes.Notebooks.GET_NOTEBOOKS:
      state = state.set('status', _actionTypes.Notebooks.GET_NOTEBOOKS);
      return state;
    case _actionTypes.Notebooks.GET_NOTEBOOKS_SUCCESS:
      {
        var data = action.data,
            isCache = action.isCache;

        if (!isCache) {
          var _normalize = (0, _normalize3.default)(data),
              entities = _normalize.entities,
              seq = _normalize.seq;

          state = state.set('entities', _immutable2.default.fromJS(entities).mergeDeep(state.get('entities')));
          state = state.set('seq', _immutable2.default.fromJS(seq));
        }
        state = state.set('status', _actionTypes.Notebooks.GET_NOTEBOOKS_SUCCESS);
        return state;
      }
    case _actionTypes.Notebooks.GET_NOTEBOOKS_FAIL:
      state = state.set('status', _actionTypes.Notebooks.GET_NOTEBOOKS_FAIL);
      return state;
    case _actionTypes.Notebooks.SORT_NOTEBOOKS:
      {
        var newSeq = action.newSeq;

        state = state.set('seq', _immutable2.default.fromJS(newSeq));
        state = state.set('status', _actionTypes.Notebooks.SORT_NOTEBOOKS);
        return state;
      }
    case _actionTypes.Notebooks.SORT_NOTEBOOKS_SUCCESS:
      {
        state = state.set('status', _actionTypes.Notebooks.SORT_NOTEBOOKS_SUCCESS);
        return state;
      }
    case _actionTypes.Notebooks.SORT_NOTEBOOKS_FAIL:
      {
        var oldSeq = action.oldSeq;

        state = state.set('seq', _immutable2.default.fromJS(oldSeq));
        state = state.set('status', _actionTypes.Notebooks.SORT_NOTEBOOKS_FAIL);
        return state;
      }
    // 新建文集
    case _actionTypes.Notebooks.NEW_NOTEBOOK:
      {
        state = state.set('status', _actionTypes.Notebooks.NEW_NOTEBOOK);
        return state;
      }
    case _actionTypes.Notebooks.NEW_NOTEBOOK_SUCCESS:
      {
        var _data = action.data;

        state = state.setIn(['entities', '' + _data.id], _immutable2.default.fromJS(_data));
        state = state.set('seq', state.get('seq').unshift(_data.id));
        state = state.set('status', _actionTypes.Notebooks.NEW_NOTEBOOK_SUCCESS);
        return state;
      }
    case _actionTypes.Notebooks.NEW_NOTEBOOK_FAIL:
      {
        state = state.set('status', _actionTypes.Notebooks.NEW_NOTEBOOK_FAIL);
        return state;
      }
    // 删除文集
    case _actionTypes.Notebooks.DEL_NOTEBOOK_SOFT:
      {
        var nbId = action.nbId;

        state = state.setIn(['entities', nbId.toString(), 'status'], _actionTypes.Notebooks.DEL_NOTEBOOK_SOFT);
        return state;
      }
    case _actionTypes.Notebooks.DEL_NOTEBOOK_SOFT_SUCCESS:
      {
        var _data2 = action.data,
            _nbId = action.nbId;

        var seqIndex = state.get('seq').findIndex(function (item) {
          return item === _nbId;
        });
        // entities中的key是string，seq中是数字，在Immutable中string和number有本质区别
        state = state.deleteIn(['entities', _nbId.toString()]);
        state = state.deleteIn(['seq', seqIndex]);
        return state;
      }
    case _actionTypes.Notebooks.DEL_NOTEBOOK_SOFT_FAIL:
      {
        var _data3 = action.data,
            _nbId2 = action.nbId;

        state = state.setIn(['entities', _nbId2.toString(), 'status'], _actionTypes.Notebooks.DEL_NOTEBOOK_SOFT_FAIL);
        return state;
      }

    // 重命名文集
    case _actionTypes.Notebooks.RENAME_NOTEBOOK:
      {
        var _data4 = action.data,
            _nbId3 = action.nbId,
            name = action.name;

        state = state.setIn(['entities', _nbId3.toString(), 'status'], _actionTypes.Notebooks.RENAME_NOTEBOOK);
        return state;
      }
    case _actionTypes.Notebooks.RENAME_NOTEBOOK_SUCCESS:
      {
        var _data5 = action.data,
            _nbId4 = action.nbId,
            _name = action.name;

        state = state.setIn(['entities', _nbId4.toString(), 'name'], _name);
        state = state.setIn(['entities', _nbId4.toString(), 'status'], _actionTypes.Notebooks.RENAME_NOTEBOOK_SUCCESS);
        return state;
      }
    case _actionTypes.Notebooks.RENAME_NOTEBOOK_FAIL:
      {
        var _data6 = action.data,
            _nbId5 = action.nbId,
            _name2 = action.name;

        state = state.setIn(['entities', _nbId5.toString(), 'status'], _actionTypes.Notebooks.RENAME_NOTEBOOK_FAIL);
        return state;
      }

    // 处理文章相关操作
    case _actionTypes.Notes.GET_NOTES_SUCCESS:
      {
        var _nbId6 = action.nbId,
            _data7 = action.data,
            page = action.page,
            count = action.count;
        // 更新文集中的文章列表

        if (_nbId6 && _data7) {
          var noteIds = _data7.map(function (note) {
            return note.id;
          });
          // 如果是第一页，直接使用新数据；否则将新数据追加到现有数据后面
          if (page === 1) {
            state = state.setIn(['entities', _nbId6.toString(), 'notes'], _immutable2.default.fromJS(noteIds));
          } else {
            // 获取当前文章列表
            var currentNotes = state.getIn(['entities', _nbId6.toString(), 'notes'], _immutable2.default.List());
            // 将新文章追加到现有列表后面
            var updatedNotes = currentNotes.concat(_immutable2.default.fromJS(noteIds));
            state = state.setIn(['entities', _nbId6.toString(), 'notes'], updatedNotes);
          }
        }
        return state;
      }
    // sort文章
    case _actionTypes.Notes.SORT_NOTES:
      {
        var _nbId7 = action.nbId,
            _newSeq = action.newSeq;

        state = state.setIn(['entities', _nbId7.toString(), 'notes'], _immutable2.default.fromJS(_newSeq));
        return state;
      }
    case _actionTypes.Notes.SORT_NOTES_FAIL:
      {
        var _nbId8 = action.nbId,
            _oldSeq = action.oldSeq;

        state = state.setIn(['entities', _nbId8.toString(), 'notes'], _immutable2.default.fromJS(_oldSeq));
        return state;
      }
    case _actionTypes.Notes.NEW_NOTE_SUCCESS:
      {
        var _data8 = action.data,
            _nbId9 = action.nbId,
            atBottom = action.atBottom,
            hasTop = action.hasTop;
        // 将新文章添加到文集的文章列表中
        //const notesPath = ['entities', nbId.toString(), 'notes'];
        //const notes = state.getIn(notesPath, Immutable.List());
        //state = state.setIn(notesPath, notes.push(data.id));

        var noteSeqPath = ['entities', _nbId9.toString(), 'notes'];
        var notesSeq = void 0;
        if (atBottom) {
          // 加在尾部
          notesSeq = state.getIn(noteSeqPath).push(_data8.id);
        } else if (hasTop) {
          // 加在头部 (存在置顶文章)
          notesSeq = state.getIn(noteSeqPath).insert(1, _data8.id);
        } else {
          // 加在头部 (不存在置顶文章)
          notesSeq = state.getIn(noteSeqPath).unshift(_data8.id);
        }
        state = state.setIn(noteSeqPath, notesSeq);
        return state;
      }
    // 软性删除文章
    case _actionTypes.Notes.DEL_NOTE_SOFT_SUCCESS:
      {
        var _nbId10 = action.nbId,
            noteId = action.noteId;

        var notesPath = ['entities', _nbId10.toString(), 'notes'];
        var notes = state.getIn(notesPath);
        notes = notes.filter(function (id) {
          return id !== +noteId;
        });
        state = state.setIn(notesPath, notes);
        return state;
      }
    // 移动文章
    case _actionTypes.Notes.MOVE_NOTE_SUCCESS:
      {
        var _data9 = action.data,
            _nbId11 = action.nbId,
            newNbId = action.newNbId,
            _noteId = action.noteId;
        // 从nbId中删除noteId

        var _notesPath = ['entities', _nbId11.toString(), 'notes'];
        var _notes = state.getIn(_notesPath);
        var index = _notes.findIndex(function (item) {
          return item === +_noteId;
        });
        _notes = _notes.delete(index);
        state = state.setIn(_notesPath, _notes);
        // push到newNbId中
        var newNotesPath = ['entities', newNbId.toString(), 'notes'];
        _notes = state.getIn(newNotesPath);
        // 有数据才push，没有数据，后面会重新ajax获取
        if (_notes) {
          _notes = _notes.unshift(+_noteId);
          state = state.setIn(newNotesPath, _notes);
        }
        return state;
      }
    default:
      return state;
  }
};

var _immutable = __webpack_require__("BYKG");

var _immutable2 = _interopRequireDefault(_immutable);

var _normalize2 = __webpack_require__("w0tY");

var _normalize3 = _interopRequireDefault(_normalize2);

var _actionTypes = __webpack_require__("4HHy");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  entities: {},
  seq: [],
  status: _actionTypes.Notebooks.NOTEBOOKS_INIT
}; /* eslint-disable no-param-reassign */
/**
 * Created by zad on 17/10/18.
 */
var getState = exports.getState = function getState(state) {
  return state.Notebooks;
};

/***/ }),

/***/ "gtn+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _icon = __webpack_require__("vgHw");

var _icon2 = _interopRequireDefault(_icon);

var _select = __webpack_require__("NJOH");

var _select2 = _interopRequireDefault(_select);

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

__webpack_require__("ODt/");

__webpack_require__("RWXa");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("RH2O");

var _qrcode = __webpack_require__("09s/");

var _qrcode2 = _interopRequireDefault(_qrcode);

var _GlobalReducer = __webpack_require__("boom");

var _GlobalAction = __webpack_require__("5Q8M");

var _Modal = __webpack_require__("/MvA");

var _Modal2 = _interopRequireDefault(_Modal);

var _Message = __webpack_require__("mzOA");

var _Message2 = _interopRequireDefault(_Message);

var _ajax = __webpack_require__("Z1y9");

var _ajax2 = _interopRequireDefault(_ajax);

var _TimePublishBuyModal = __webpack_require__("DM98");

var _TimePublishBuyModal2 = _interopRequireDefault(_TimePublishBuyModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Option = _select2.default.Option;
var TimePublishBuyModal = (_dec = (0, _reactRedux.connect)(function (state) {
  var globalState = (0, _GlobalReducer.getState)(state);
  var modalState = globalState.get('timePublishBuyModal');
  return {
    visible: modalState.get('visible'),
    modalData: modalState.get('data')
  };
}, function (dispatch) {
  return {
    $closeModal: function $closeModal() {
      return dispatch((0, _GlobalAction.closeTimePublishBuyModalAction)());
    }
  };
}), _dec(_class = function (_PureComponent) {
  (0, _inherits3.default)(TimePublishBuyModal, _PureComponent);

  function TimePublishBuyModal() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TimePublishBuyModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TimePublishBuyModal.__proto__ || (0, _getPrototypeOf2.default)(TimePublishBuyModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      channel: 'alipay',
      paying: false,
      codeUrl: ''
    }, _this.reset = function () {
      _this.clearTimer();
      _this.setState({
        channel: 'alipay',
        paying: false,
        codeUrl: ''
      });
    }, _this.clearTimer = function () {
      if (_this.timer) {
        clearTimeout(_this.timer);
        _this.timer = null;
      }
    }, _this.handleChannelChange = function (v) {
      _this.clearTimer();
      _this.setState({
        channel: v,
        codeUrl: ''
      });
    }, _this.checkPayStatus = function (guid) {
      var polling = function polling() {
        // 如果modal关闭了，则不再进行轮询
        var visible = _this.props.visible;

        if (!visible) {
          return;
        }
        _ajax2.default.getOrderStatus(guid).then(function (_ref2) {
          var data = _ref2.data;

          // 支付成功
          if (data.paid_state === 'paid') {
            _this.clearTimer();
            // 提示显示5秒
            _Message2.default.success('你已经获得1次定时发文功能，文章定时发布成功后会消耗1次权益', { duration: 5000 });
            _this.props.$closeModal();
          }
        });
        _this.timer = setTimeout(polling, 2000);
      };
      polling();
    }, _this.handlePay = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var _this$state, channel, paying, isWeChatPay, newWindow, _ref4, guid, _ref5, orderData;

      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$state = _this.state, channel = _this$state.channel, paying = _this$state.paying;

              if (!paying) {
                _context.next = 3;
                break;
              }

              return _context.abrupt('return');

            case 3:
              _this.clearTimer();
              _this.setState({
                paying: true
              });
              isWeChatPay = channel === 'wx_pub_qr';
              newWindow = void 0;

              if (!isWeChatPay) {
                newWindow = window.open();
              }
              _context.prev = 8;
              _context.next = 11;
              return _ajax2.default.getTimePublishGuid();

            case 11:
              _ref4 = _context.sent;
              guid = _ref4.data.guid;
              _context.next = 15;
              return _ajax2.default.payOrder(guid, channel);

            case 15:
              _ref5 = _context.sent;
              orderData = _ref5.data;

              // 微信支付
              if (isWeChatPay) {
                _this.setState({
                  codeUrl: orderData.wx_pub_qr
                });
              } else {
                // 支付宝支付，需要提前打开新窗口，否则会被拦截
                newWindow.location = orderData.payment_url;
              }
              _this.setState({
                paying: false
              });
              newWindow = null;
              _this.checkPayStatus(guid);
              _context.next = 27;
              break;

            case 23:
              _context.prev = 23;
              _context.t0 = _context['catch'](8);

              _this.setState({
                paying: false
              });
              if (!isWeChatPay && newWindow) {
                newWindow.close();
                newWindow = null;
              }

            case 27:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[8, 23]]);
    })), _this.handleCancel = function () {
      var $closeModal = _this.props.$closeModal;

      $closeModal();
    }, _this.getModalContent = function () {
      var modalData = _this.props.modalData;
      var _this$state2 = _this.state,
          channel = _this$state2.channel,
          codeUrl = _this$state2.codeUrl;

      var amount = modalData.get('amount', 0);
      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          'div',
          { className: _TimePublishBuyModal2.default.title },
          '\u5F00\u901A\u5B9A\u65F6\u53D1\u6587'
        ),
        _react2.default.createElement(
          'div',
          { className: _TimePublishBuyModal2.default.item },
          _react2.default.createElement(
            'div',
            { className: _TimePublishBuyModal2.default['item-name'] },
            '\u5355\u6B21\u5F00\u901A'
          ),
          _react2.default.createElement(
            'div',
            { className: _TimePublishBuyModal2.default['item-value'] },
            '\uFFE5',
            (amount / 100).toFixed(2)
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _TimePublishBuyModal2.default.item },
          _react2.default.createElement(
            'div',
            { className: _TimePublishBuyModal2.default['item-name'] },
            '\u652F\u4ED8\u65B9\u5F0F'
          ),
          _react2.default.createElement(
            _select2.default,
            { value: channel, onChange: _this.handleChannelChange },
            _react2.default.createElement(
              Option,
              { value: 'alipay' },
              '\u652F\u4ED8\u5B9D\u652F\u4ED8'
            ),
            _react2.default.createElement(
              Option,
              { value: 'wx_pub_qr' },
              '\u5FAE\u4FE1\u652F\u4ED8'
            )
          )
        ),
        codeUrl && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_qrcode2.default, { value: codeUrl, size: 200, level: 'M', includeMargin: true })
        ),
        _react2.default.createElement(
          'div',
          { className: _TimePublishBuyModal2.default['member-tips'] },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: _TimePublishBuyModal2.default.tip },
              '\u4F60\u53EF\u4EE5\u9009\u62E9\u5F00\u901A\u7B80\u4E66\u4F1A\u5458\uFF0C'
            ),
            _react2.default.createElement(
              'div',
              { className: _TimePublishBuyModal2.default.tip },
              '\u5F00\u901A\u540E\uFF0C\u5728\u4F1A\u5458\u6709\u6548\u671F\u5185\uFF0C\u53EF\u4EE5\u514D\u8D39\u8BD5\u7528\u8BE5\u529F\u80FD'
            )
          ),
          _react2.default.createElement(
            'a',
            { className: _TimePublishBuyModal2.default.buy, href: '/mobile/club', target: '_blank' },
            '\u5F00\u901A\u4F1A\u5458 ',
            _react2.default.createElement(_icon2.default, { type: 'right' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _TimePublishBuyModal2.default.btn, onClick: _this.handlePay, 'aria-label': '立即支付' },
          '\u7ACB\u5373\u652F\u4ED8'
        ),
        _react2.default.createElement(
          'div',
          { className: _TimePublishBuyModal2.default['buy-tip'] },
          _react2.default.createElement(_icon2.default, { type: 'info-circle' }),
          ' \u8BE5\u5546\u54C1\u4E3A\u865A\u62DF\u5546\u54C1\uFF0C\u652F\u4ED8\u540E\u4E0D\u652F\u6301\u9000\u6B3E\u54E6'
        )
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TimePublishBuyModal, [{
    key: 'render',
    value: function render() {
      var visible = this.props.visible;


      return _react2.default.createElement(
        _Modal2.default,
        {
          width: 480,
          bodyClass: _TimePublishBuyModal2.default.body,
          visible: visible,
          maskClosable: true,
          isMiddle: true,
          tips: false,
          showFooter: false,
          onCancel: this.handleCancel,
          afterClose: this.reset
        },
        this.getModalContent()
      );
    }
  }]);
  return TimePublishBuyModal;
}(_react.PureComponent)) || _class);
exports.default = TimePublishBuyModal;

/***/ }),

/***/ "hGJ7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messagePrefix = undefined;

var _objectWithoutProperties2 = __webpack_require__("+6Bu");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _isFunction2 = __webpack_require__("gGqR");

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _class, _temp;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__("O27J");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _rcAnimate = __webpack_require__("8aSS");

var _rcAnimate2 = _interopRequireDefault(_rcAnimate);

var _Message = __webpack_require__("A6CO");

var _Message2 = _interopRequireDefault(_Message);

var _chainFunc = __webpack_require__("cBxc");

var _chainFunc2 = _interopRequireDefault(_chainFunc);

var _MessageItem = __webpack_require__("FruA");

var _MessageItem2 = _interopRequireDefault(_MessageItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var messagePrefix = exports.messagePrefix = 'message';

function getKey() {
  var level = 1;
  return function () {
    var now = +new Date();
    return messagePrefix + '-' + now + '-' + level++;
  };
}

var Message = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Message, _Component);

  function Message(props) {
    (0, _classCallCheck3.default)(this, Message);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Message.__proto__ || (0, _getPrototypeOf2.default)(Message)).call(this, props));

    _this.addMessage = function () {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      // eslint-disable-next-line no-param-reassign,no-multi-assign
      var key = message.key = message.key || _this.getKey();
      _this.setState(function (prevState) {
        var messages = prevState.messages;
        // 如果key唯一，则添加

        if (messages.findIndex(function (msg) {
          return msg.key === key;
        }) === -1) {
          return {
            messages: messages.concat(message)
          };
        }
        return null;
      });
      return message;
    };

    _this.removeMessage = function (key) {
      _this.setState(function (prevState) {
        return {
          messages: prevState.messages.filter(function (msg) {
            return msg.key !== key;
          })
        };
      });
    };

    _this.getItems = function () {
      var messages = _this.state.messages;

      return messages.map(function (msg) {
        var onClose = msg.onClose,
            key = msg.key;

        var closeFunc = (0, _chainFunc2.default)(_this.removeMessage.bind(_this, msg.key), onClose);
        return _react2.default.createElement(_MessageItem2.default, (0, _extends3.default)({}, msg, { onClose: closeFunc, key: key }));
      });
    };

    _this.state = {
      messages: []
    };
    return _this;
  }

  (0, _createClass3.default)(Message, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getKey = getKey();
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          containerClass = _props.containerClass,
          containerStyle = _props.containerStyle;

      var containerCls = (0, _classnames2.default)((_classNames = {}, (0, _defineProperty3.default)(_classNames, '' + _Message2.default[messagePrefix + '-wrap'], true), (0, _defineProperty3.default)(_classNames, containerClass, !!containerClass), _classNames));

      return _react2.default.createElement(
        _rcAnimate2.default,
        { className: containerCls, style: containerStyle, transitionName: 'move-up' },
        this.getItems()
      );
    }
  }]);
  return Message;
}(_react.Component), _class.propTypes = {
  containerClass: _propTypes2.default.string,
  containerStyle: _propTypes2.default.object
}, _temp);


Message.createInstance = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var callback = arguments[1];
  var getContainer = options.getContainer,
      msgProps = (0, _objectWithoutProperties3.default)(options, ['getContainer']);

  var called = false;
  var target = void 0;
  if ((0, _isFunction3.default)(getContainer)) {
    target = getContainer();
  } else {
    target = document.createElement('div');
    document.body.appendChild(target);
  }

  function ref(instance) {
    if (called) {
      return;
    }
    called = true;
    var msgInstance = {
      add: function add(msg) {
        return instance.addMessage(msg);
      },
      remove: function remove(key) {
        return instance.removeMessage(key);
      },
      destroy: function destroy() {
        var _target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : target;

        _reactDom2.default.unmountComponentAtNode(_target); // _target是其他element
        document.body.removeChild(_target);
      },

      instance: instance,
      target: target
    };
    callback(msgInstance);
  }

  // 保证render的时候，可以准确获取到组件实例
  _reactDom2.default.render(_react2.default.createElement(Message, (0, _extends3.default)({}, msgProps, { ref: ref })), target);
};

exports.default = Message;

/***/ }),

/***/ "htM0":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "body,html{width:100%;height:100%}input::-ms-clear,input::-ms-reveal{display:none}*,:after,:before{-webkit-box-sizing:border-box;box-sizing:border-box}html{font-family:sans-serif;line-height:1.15;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;-ms-overflow-style:scrollbar;-webkit-tap-highlight-color:transparent}@-ms-viewport{width:device-width}article,aside,dialog,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}body{margin:0;color:rgba(0,0,0,.65);font-size:14px;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica Neue,Helvetica,Arial,sans-serif;font-variant:tabular-nums;line-height:1.5;background-color:#fff;-webkit-font-feature-settings:\"tnum\";font-feature-settings:\"tnum\"}[tabindex=\"-1\"]:focus{outline:none!important}hr{-webkit-box-sizing:content-box;box-sizing:content-box;height:0;overflow:visible}h1,h2,h3,h4,h5,h6{margin-top:0;margin-bottom:.5em;color:rgba(0,0,0,.85);font-weight:500}p{margin-top:0;margin-bottom:1em}abbr[data-original-title],abbr[title]{text-decoration:underline;-webkit-text-decoration:underline dotted;text-decoration:underline dotted;border-bottom:0;cursor:help}address{margin-bottom:1em;font-style:normal;line-height:inherit}input[type=number],input[type=password],input[type=text],textarea{-webkit-appearance:none}dl,ol,ul{margin-top:0;margin-bottom:1em}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}dt{font-weight:500}dd{margin-bottom:.5em;margin-left:0}blockquote{margin:0 0 1em}dfn{font-style:italic}b,strong{font-weight:bolder}small{font-size:80%}sub,sup{position:relative;font-size:75%;line-height:0;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}a{color:#1890ff;text-decoration:none;background-color:transparent;outline:none;cursor:pointer;-webkit-transition:color .3s;-o-transition:color .3s;transition:color .3s;-webkit-text-decoration-skip:objects}a:hover{color:#40a9ff}a:active{color:#096dd9}a:active,a:hover{text-decoration:none;outline:0}a[disabled]{color:rgba(0,0,0,.25);cursor:not-allowed;pointer-events:none}code,kbd,pre,samp{font-size:1em;font-family:SFMono-Regular,Consolas,Liberation Mono,Menlo,Courier,monospace}pre{margin-top:0;margin-bottom:1em;overflow:auto}figure{margin:0 0 1em}img{vertical-align:middle;border-style:none}svg:not(:root){overflow:hidden}[role=button],a,area,button,input:not([type=range]),label,select,summary,textarea{-ms-touch-action:manipulation;touch-action:manipulation}table{border-collapse:collapse}caption{padding-top:.75em;padding-bottom:.3em;color:rgba(0,0,0,.45);text-align:left;caption-side:bottom}th{text-align:inherit}button,input,optgroup,select,textarea{margin:0;color:inherit;font-size:inherit;font-family:inherit;line-height:inherit}button,input{overflow:visible}button,select{text-transform:none}[type=reset],[type=submit],button,html [type=button]{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{padding:0;border-style:none}input[type=checkbox],input[type=radio]{-webkit-box-sizing:border-box;box-sizing:border-box;padding:0}input[type=date],input[type=datetime-local],input[type=month],input[type=time]{-webkit-appearance:listbox}textarea{overflow:auto;resize:vertical}fieldset{min-width:0;margin:0;padding:0;border:0}legend{display:block;width:100%;max-width:100%;margin-bottom:.5em;padding:0;color:inherit;font-size:1.5em;line-height:inherit;white-space:normal}progress{vertical-align:baseline}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{outline-offset:-2px;-webkit-appearance:none}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{font:inherit;-webkit-appearance:button}output{display:inline-block}summary{display:list-item}template{display:none}[hidden]{display:none!important}mark{padding:.2em;background-color:#feffe6}::-moz-selection{color:#fff;background:#1890ff}::selection{color:#fff;background:#1890ff}.clearfix{zoom:1}.clearfix:after,.clearfix:before{display:table;content:\"\"}.clearfix:after{clear:both}.anticon{display:inline-block;color:inherit;font-style:normal;line-height:0;text-align:center;text-transform:none;vertical-align:-.125em;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.anticon>*{line-height:1}.anticon svg{display:inline-block}.anticon:before{display:none}.anticon .anticon-icon{display:block}.anticon[tabindex]{cursor:pointer}.anticon-spin,.anticon-spin:before{display:inline-block;-webkit-animation:loadingCircle 1s infinite linear;animation:loadingCircle 1s infinite linear}.fade-appear,.fade-enter,.fade-leave{-webkit-animation-duration:.2s;animation-duration:.2s;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-play-state:paused;animation-play-state:paused}.fade-appear.fade-appear-active,.fade-enter.fade-enter-active{-webkit-animation-name:antFadeIn;animation-name:antFadeIn;-webkit-animation-play-state:running;animation-play-state:running}.fade-leave.fade-leave-active{-webkit-animation-name:antFadeOut;animation-name:antFadeOut;-webkit-animation-play-state:running;animation-play-state:running;pointer-events:none}.fade-appear,.fade-enter{opacity:0}.fade-appear,.fade-enter,.fade-leave{-webkit-animation-timing-function:linear;animation-timing-function:linear}@-webkit-keyframes antFadeIn{0%{opacity:0}to{opacity:1}}@keyframes antFadeIn{0%{opacity:0}to{opacity:1}}@-webkit-keyframes antFadeOut{0%{opacity:1}to{opacity:0}}@keyframes antFadeOut{0%{opacity:1}to{opacity:0}}.move-up-appear,.move-up-enter,.move-up-leave{-webkit-animation-duration:.2s;animation-duration:.2s;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-play-state:paused;animation-play-state:paused}.move-up-appear.move-up-appear-active,.move-up-enter.move-up-enter-active{-webkit-animation-name:antMoveUpIn;animation-name:antMoveUpIn;-webkit-animation-play-state:running;animation-play-state:running}.move-up-leave.move-up-leave-active{-webkit-animation-name:antMoveUpOut;animation-name:antMoveUpOut;-webkit-animation-play-state:running;animation-play-state:running;pointer-events:none}.move-up-appear,.move-up-enter{opacity:0;-webkit-animation-timing-function:cubic-bezier(.08,.82,.17,1);animation-timing-function:cubic-bezier(.08,.82,.17,1)}.move-up-leave{-webkit-animation-timing-function:cubic-bezier(.6,.04,.98,.34);animation-timing-function:cubic-bezier(.6,.04,.98,.34)}.move-down-appear,.move-down-enter,.move-down-leave{-webkit-animation-duration:.2s;animation-duration:.2s;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-play-state:paused;animation-play-state:paused}.move-down-appear.move-down-appear-active,.move-down-enter.move-down-enter-active{-webkit-animation-name:antMoveDownIn;animation-name:antMoveDownIn;-webkit-animation-play-state:running;animation-play-state:running}.move-down-leave.move-down-leave-active{-webkit-animation-name:antMoveDownOut;animation-name:antMoveDownOut;-webkit-animation-play-state:running;animation-play-state:running;pointer-events:none}.move-down-appear,.move-down-enter{opacity:0;-webkit-animation-timing-function:cubic-bezier(.08,.82,.17,1);animation-timing-function:cubic-bezier(.08,.82,.17,1)}.move-down-leave{-webkit-animation-timing-function:cubic-bezier(.6,.04,.98,.34);animation-timing-function:cubic-bezier(.6,.04,.98,.34)}.move-left-appear,.move-left-enter,.move-left-leave{-webkit-animation-duration:.2s;animation-duration:.2s;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-play-state:paused;animation-play-state:paused}.move-left-appear.move-left-appear-active,.move-left-enter.move-left-enter-active{-webkit-animation-name:antMoveLeftIn;animation-name:antMoveLeftIn;-webkit-animation-play-state:running;animation-play-state:running}.move-left-leave.move-left-leave-active{-webkit-animation-name:antMoveLeftOut;animation-name:antMoveLeftOut;-webkit-animation-play-state:running;animation-play-state:running;pointer-events:none}.move-left-appear,.move-left-enter{opacity:0;-webkit-animation-timing-function:cubic-bezier(.08,.82,.17,1);animation-timing-function:cubic-bezier(.08,.82,.17,1)}.move-left-leave{-webkit-animation-timing-function:cubic-bezier(.6,.04,.98,.34);animation-timing-function:cubic-bezier(.6,.04,.98,.34)}.move-right-appear,.move-right-enter,.move-right-leave{-webkit-animation-duration:.2s;animation-duration:.2s;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-play-state:paused;animation-play-state:paused}.move-right-appear.move-right-appear-active,.move-right-enter.move-right-enter-active{-webkit-animation-name:antMoveRightIn;animation-name:antMoveRightIn;-webkit-animation-play-state:running;animation-play-state:running}.move-right-leave.move-right-leave-active{-webkit-animation-name:antMoveRightOut;animation-name:antMoveRightOut;-webkit-animation-play-state:running;animation-play-state:running;pointer-events:none}.move-right-appear,.move-right-enter{opacity:0;-webkit-animation-timing-function:cubic-bezier(.08,.82,.17,1);animation-timing-function:cubic-bezier(.08,.82,.17,1)}.move-right-leave{-webkit-animation-timing-function:cubic-bezier(.6,.04,.98,.34);animation-timing-function:cubic-bezier(.6,.04,.98,.34)}@-webkit-keyframes antMoveDownIn{0%{-webkit-transform:translateY(100%);transform:translateY(100%);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:0}to{-webkit-transform:translateY(0);transform:translateY(0);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:1}}@keyframes antMoveDownIn{0%{-webkit-transform:translateY(100%);transform:translateY(100%);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:0}to{-webkit-transform:translateY(0);transform:translateY(0);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:1}}@-webkit-keyframes antMoveDownOut{0%{-webkit-transform:translateY(0);transform:translateY(0);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:1}to{-webkit-transform:translateY(100%);transform:translateY(100%);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:0}}@keyframes antMoveDownOut{0%{-webkit-transform:translateY(0);transform:translateY(0);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:1}to{-webkit-transform:translateY(100%);transform:translateY(100%);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:0}}@-webkit-keyframes antMoveLeftIn{0%{-webkit-transform:translateX(-100%);transform:translateX(-100%);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:0}to{-webkit-transform:translateX(0);transform:translateX(0);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:1}}@keyframes antMoveLeftIn{0%{-webkit-transform:translateX(-100%);transform:translateX(-100%);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:0}to{-webkit-transform:translateX(0);transform:translateX(0);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:1}}@-webkit-keyframes antMoveLeftOut{0%{-webkit-transform:translateX(0);transform:translateX(0);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:1}to{-webkit-transform:translateX(-100%);transform:translateX(-100%);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:0}}@keyframes antMoveLeftOut{0%{-webkit-transform:translateX(0);transform:translateX(0);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:1}to{-webkit-transform:translateX(-100%);transform:translateX(-100%);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:0}}@-webkit-keyframes antMoveRightIn{0%{-webkit-transform:translateX(100%);transform:translateX(100%);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:0}to{-webkit-transform:translateX(0);transform:translateX(0);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:1}}@keyframes antMoveRightIn{0%{-webkit-transform:translateX(100%);transform:translateX(100%);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:0}to{-webkit-transform:translateX(0);transform:translateX(0);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:1}}@-webkit-keyframes antMoveRightOut{0%{-webkit-transform:translateX(0);transform:translateX(0);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:1}to{-webkit-transform:translateX(100%);transform:translateX(100%);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:0}}@keyframes antMoveRightOut{0%{-webkit-transform:translateX(0);transform:translateX(0);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:1}to{-webkit-transform:translateX(100%);transform:translateX(100%);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:0}}@-webkit-keyframes antMoveUpIn{0%{-webkit-transform:translateY(-100%);transform:translateY(-100%);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:0}to{-webkit-transform:translateY(0);transform:translateY(0);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:1}}@keyframes antMoveUpIn{0%{-webkit-transform:translateY(-100%);transform:translateY(-100%);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:0}to{-webkit-transform:translateY(0);transform:translateY(0);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:1}}@-webkit-keyframes antMoveUpOut{0%{-webkit-transform:translateY(0);transform:translateY(0);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:1}to{-webkit-transform:translateY(-100%);transform:translateY(-100%);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:0}}@keyframes antMoveUpOut{0%{-webkit-transform:translateY(0);transform:translateY(0);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:1}to{-webkit-transform:translateY(-100%);transform:translateY(-100%);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:0}}@-webkit-keyframes loadingCircle{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes loadingCircle{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}[ant-click-animating-without-extra-node=true],[ant-click-animating=true]{position:relative}html{--antd-wave-shadow-color:#1890ff}.ant-click-animating-node,[ant-click-animating-without-extra-node=true]:after{position:absolute;top:0;right:0;bottom:0;left:0;display:block;border-radius:inherit;-webkit-box-shadow:0 0 0 0 #1890ff;box-shadow:0 0 0 0 #1890ff;-webkit-box-shadow:0 0 0 0 var(--antd-wave-shadow-color);box-shadow:0 0 0 0 var(--antd-wave-shadow-color);opacity:.2;-webkit-animation:fadeEffect 2s cubic-bezier(.08,.82,.17,1),waveEffect .4s cubic-bezier(.08,.82,.17,1);animation:fadeEffect 2s cubic-bezier(.08,.82,.17,1),waveEffect .4s cubic-bezier(.08,.82,.17,1);-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards;content:\"\";pointer-events:none}@-webkit-keyframes waveEffect{to{-webkit-box-shadow:0 0 0 #1890ff;box-shadow:0 0 0 #1890ff;-webkit-box-shadow:0 0 0 6px var(--antd-wave-shadow-color);box-shadow:0 0 0 6px var(--antd-wave-shadow-color)}}@keyframes waveEffect{to{-webkit-box-shadow:0 0 0 #1890ff;box-shadow:0 0 0 #1890ff;-webkit-box-shadow:0 0 0 6px var(--antd-wave-shadow-color);box-shadow:0 0 0 6px var(--antd-wave-shadow-color)}}@-webkit-keyframes fadeEffect{to{opacity:0}}@keyframes fadeEffect{to{opacity:0}}.slide-up-appear,.slide-up-enter,.slide-up-leave{-webkit-animation-duration:.2s;animation-duration:.2s;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-play-state:paused;animation-play-state:paused}.slide-up-appear.slide-up-appear-active,.slide-up-enter.slide-up-enter-active{-webkit-animation-name:antSlideUpIn;animation-name:antSlideUpIn;-webkit-animation-play-state:running;animation-play-state:running}.slide-up-leave.slide-up-leave-active{-webkit-animation-name:antSlideUpOut;animation-name:antSlideUpOut;-webkit-animation-play-state:running;animation-play-state:running;pointer-events:none}.slide-up-appear,.slide-up-enter{opacity:0;-webkit-animation-timing-function:cubic-bezier(.23,1,.32,1);animation-timing-function:cubic-bezier(.23,1,.32,1)}.slide-up-leave{-webkit-animation-timing-function:cubic-bezier(.755,.05,.855,.06);animation-timing-function:cubic-bezier(.755,.05,.855,.06)}.slide-down-appear,.slide-down-enter,.slide-down-leave{-webkit-animation-duration:.2s;animation-duration:.2s;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-play-state:paused;animation-play-state:paused}.slide-down-appear.slide-down-appear-active,.slide-down-enter.slide-down-enter-active{-webkit-animation-name:antSlideDownIn;animation-name:antSlideDownIn;-webkit-animation-play-state:running;animation-play-state:running}.slide-down-leave.slide-down-leave-active{-webkit-animation-name:antSlideDownOut;animation-name:antSlideDownOut;-webkit-animation-play-state:running;animation-play-state:running;pointer-events:none}.slide-down-appear,.slide-down-enter{opacity:0;-webkit-animation-timing-function:cubic-bezier(.23,1,.32,1);animation-timing-function:cubic-bezier(.23,1,.32,1)}.slide-down-leave{-webkit-animation-timing-function:cubic-bezier(.755,.05,.855,.06);animation-timing-function:cubic-bezier(.755,.05,.855,.06)}.slide-left-appear,.slide-left-enter,.slide-left-leave{-webkit-animation-duration:.2s;animation-duration:.2s;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-play-state:paused;animation-play-state:paused}.slide-left-appear.slide-left-appear-active,.slide-left-enter.slide-left-enter-active{-webkit-animation-name:antSlideLeftIn;animation-name:antSlideLeftIn;-webkit-animation-play-state:running;animation-play-state:running}.slide-left-leave.slide-left-leave-active{-webkit-animation-name:antSlideLeftOut;animation-name:antSlideLeftOut;-webkit-animation-play-state:running;animation-play-state:running;pointer-events:none}.slide-left-appear,.slide-left-enter{opacity:0;-webkit-animation-timing-function:cubic-bezier(.23,1,.32,1);animation-timing-function:cubic-bezier(.23,1,.32,1)}.slide-left-leave{-webkit-animation-timing-function:cubic-bezier(.755,.05,.855,.06);animation-timing-function:cubic-bezier(.755,.05,.855,.06)}.slide-right-appear,.slide-right-enter,.slide-right-leave{-webkit-animation-duration:.2s;animation-duration:.2s;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-play-state:paused;animation-play-state:paused}.slide-right-appear.slide-right-appear-active,.slide-right-enter.slide-right-enter-active{-webkit-animation-name:antSlideRightIn;animation-name:antSlideRightIn;-webkit-animation-play-state:running;animation-play-state:running}.slide-right-leave.slide-right-leave-active{-webkit-animation-name:antSlideRightOut;animation-name:antSlideRightOut;-webkit-animation-play-state:running;animation-play-state:running;pointer-events:none}.slide-right-appear,.slide-right-enter{opacity:0;-webkit-animation-timing-function:cubic-bezier(.23,1,.32,1);animation-timing-function:cubic-bezier(.23,1,.32,1)}.slide-right-leave{-webkit-animation-timing-function:cubic-bezier(.755,.05,.855,.06);animation-timing-function:cubic-bezier(.755,.05,.855,.06)}@-webkit-keyframes antSlideUpIn{0%{-webkit-transform:scaleY(.8);transform:scaleY(.8);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:0}to{-webkit-transform:scaleY(1);transform:scaleY(1);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:1}}@keyframes antSlideUpIn{0%{-webkit-transform:scaleY(.8);transform:scaleY(.8);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:0}to{-webkit-transform:scaleY(1);transform:scaleY(1);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:1}}@-webkit-keyframes antSlideUpOut{0%{-webkit-transform:scaleY(1);transform:scaleY(1);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:1}to{-webkit-transform:scaleY(.8);transform:scaleY(.8);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:0}}@keyframes antSlideUpOut{0%{-webkit-transform:scaleY(1);transform:scaleY(1);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:1}to{-webkit-transform:scaleY(.8);transform:scaleY(.8);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:0}}@-webkit-keyframes antSlideDownIn{0%{-webkit-transform:scaleY(.8);transform:scaleY(.8);-webkit-transform-origin:100% 100%;transform-origin:100% 100%;opacity:0}to{-webkit-transform:scaleY(1);transform:scaleY(1);-webkit-transform-origin:100% 100%;transform-origin:100% 100%;opacity:1}}@keyframes antSlideDownIn{0%{-webkit-transform:scaleY(.8);transform:scaleY(.8);-webkit-transform-origin:100% 100%;transform-origin:100% 100%;opacity:0}to{-webkit-transform:scaleY(1);transform:scaleY(1);-webkit-transform-origin:100% 100%;transform-origin:100% 100%;opacity:1}}@-webkit-keyframes antSlideDownOut{0%{-webkit-transform:scaleY(1);transform:scaleY(1);-webkit-transform-origin:100% 100%;transform-origin:100% 100%;opacity:1}to{-webkit-transform:scaleY(.8);transform:scaleY(.8);-webkit-transform-origin:100% 100%;transform-origin:100% 100%;opacity:0}}@keyframes antSlideDownOut{0%{-webkit-transform:scaleY(1);transform:scaleY(1);-webkit-transform-origin:100% 100%;transform-origin:100% 100%;opacity:1}to{-webkit-transform:scaleY(.8);transform:scaleY(.8);-webkit-transform-origin:100% 100%;transform-origin:100% 100%;opacity:0}}@-webkit-keyframes antSlideLeftIn{0%{-webkit-transform:scaleX(.8);transform:scaleX(.8);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:0}to{-webkit-transform:scaleX(1);transform:scaleX(1);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:1}}@keyframes antSlideLeftIn{0%{-webkit-transform:scaleX(.8);transform:scaleX(.8);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:0}to{-webkit-transform:scaleX(1);transform:scaleX(1);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:1}}@-webkit-keyframes antSlideLeftOut{0%{-webkit-transform:scaleX(1);transform:scaleX(1);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:1}to{-webkit-transform:scaleX(.8);transform:scaleX(.8);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:0}}@keyframes antSlideLeftOut{0%{-webkit-transform:scaleX(1);transform:scaleX(1);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:1}to{-webkit-transform:scaleX(.8);transform:scaleX(.8);-webkit-transform-origin:0 0;transform-origin:0 0;opacity:0}}@-webkit-keyframes antSlideRightIn{0%{-webkit-transform:scaleX(.8);transform:scaleX(.8);-webkit-transform-origin:100% 0;transform-origin:100% 0;opacity:0}to{-webkit-transform:scaleX(1);transform:scaleX(1);-webkit-transform-origin:100% 0;transform-origin:100% 0;opacity:1}}@keyframes antSlideRightIn{0%{-webkit-transform:scaleX(.8);transform:scaleX(.8);-webkit-transform-origin:100% 0;transform-origin:100% 0;opacity:0}to{-webkit-transform:scaleX(1);transform:scaleX(1);-webkit-transform-origin:100% 0;transform-origin:100% 0;opacity:1}}@-webkit-keyframes antSlideRightOut{0%{-webkit-transform:scaleX(1);transform:scaleX(1);-webkit-transform-origin:100% 0;transform-origin:100% 0;opacity:1}to{-webkit-transform:scaleX(.8);transform:scaleX(.8);-webkit-transform-origin:100% 0;transform-origin:100% 0;opacity:0}}@keyframes antSlideRightOut{0%{-webkit-transform:scaleX(1);transform:scaleX(1);-webkit-transform-origin:100% 0;transform-origin:100% 0;opacity:1}to{-webkit-transform:scaleX(.8);transform:scaleX(.8);-webkit-transform-origin:100% 0;transform-origin:100% 0;opacity:0}}.swing-appear,.swing-enter{-webkit-animation-duration:.2s;animation-duration:.2s;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-play-state:paused;animation-play-state:paused}.swing-appear.swing-appear-active,.swing-enter.swing-enter-active{-webkit-animation-name:antSwingIn;animation-name:antSwingIn;-webkit-animation-play-state:running;animation-play-state:running}@-webkit-keyframes antSwingIn{0%,to{-webkit-transform:translateX(0);transform:translateX(0)}20%{-webkit-transform:translateX(-10px);transform:translateX(-10px)}40%{-webkit-transform:translateX(10px);transform:translateX(10px)}60%{-webkit-transform:translateX(-5px);transform:translateX(-5px)}80%{-webkit-transform:translateX(5px);transform:translateX(5px)}}@keyframes antSwingIn{0%,to{-webkit-transform:translateX(0);transform:translateX(0)}20%{-webkit-transform:translateX(-10px);transform:translateX(-10px)}40%{-webkit-transform:translateX(10px);transform:translateX(10px)}60%{-webkit-transform:translateX(-5px);transform:translateX(-5px)}80%{-webkit-transform:translateX(5px);transform:translateX(5px)}}.zoom-appear,.zoom-enter,.zoom-leave{-webkit-animation-duration:.2s;animation-duration:.2s;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-play-state:paused;animation-play-state:paused}.zoom-appear.zoom-appear-active,.zoom-enter.zoom-enter-active{-webkit-animation-name:antZoomIn;animation-name:antZoomIn;-webkit-animation-play-state:running;animation-play-state:running}.zoom-leave.zoom-leave-active{-webkit-animation-name:antZoomOut;animation-name:antZoomOut;-webkit-animation-play-state:running;animation-play-state:running;pointer-events:none}.zoom-appear,.zoom-enter{-webkit-transform:scale(0);-ms-transform:scale(0);transform:scale(0);opacity:0;-webkit-animation-timing-function:cubic-bezier(.08,.82,.17,1);animation-timing-function:cubic-bezier(.08,.82,.17,1)}.zoom-leave{-webkit-animation-timing-function:cubic-bezier(.78,.14,.15,.86);animation-timing-function:cubic-bezier(.78,.14,.15,.86)}.zoom-big-appear,.zoom-big-enter,.zoom-big-leave{-webkit-animation-duration:.2s;animation-duration:.2s;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-play-state:paused;animation-play-state:paused}.zoom-big-appear.zoom-big-appear-active,.zoom-big-enter.zoom-big-enter-active{-webkit-animation-name:antZoomBigIn;animation-name:antZoomBigIn;-webkit-animation-play-state:running;animation-play-state:running}.zoom-big-leave.zoom-big-leave-active{-webkit-animation-name:antZoomBigOut;animation-name:antZoomBigOut;-webkit-animation-play-state:running;animation-play-state:running;pointer-events:none}.zoom-big-appear,.zoom-big-enter{-webkit-transform:scale(0);-ms-transform:scale(0);transform:scale(0);opacity:0;-webkit-animation-timing-function:cubic-bezier(.08,.82,.17,1);animation-timing-function:cubic-bezier(.08,.82,.17,1)}.zoom-big-leave{-webkit-animation-timing-function:cubic-bezier(.78,.14,.15,.86);animation-timing-function:cubic-bezier(.78,.14,.15,.86)}.zoom-big-fast-appear,.zoom-big-fast-enter,.zoom-big-fast-leave{-webkit-animation-duration:.1s;animation-duration:.1s;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-play-state:paused;animation-play-state:paused}.zoom-big-fast-appear.zoom-big-fast-appear-active,.zoom-big-fast-enter.zoom-big-fast-enter-active{-webkit-animation-name:antZoomBigIn;animation-name:antZoomBigIn;-webkit-animation-play-state:running;animation-play-state:running}.zoom-big-fast-leave.zoom-big-fast-leave-active{-webkit-animation-name:antZoomBigOut;animation-name:antZoomBigOut;-webkit-animation-play-state:running;animation-play-state:running;pointer-events:none}.zoom-big-fast-appear,.zoom-big-fast-enter{-webkit-transform:scale(0);-ms-transform:scale(0);transform:scale(0);opacity:0;-webkit-animation-timing-function:cubic-bezier(.08,.82,.17,1);animation-timing-function:cubic-bezier(.08,.82,.17,1)}.zoom-big-fast-leave{-webkit-animation-timing-function:cubic-bezier(.78,.14,.15,.86);animation-timing-function:cubic-bezier(.78,.14,.15,.86)}.zoom-up-appear,.zoom-up-enter,.zoom-up-leave{-webkit-animation-duration:.2s;animation-duration:.2s;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-play-state:paused;animation-play-state:paused}.zoom-up-appear.zoom-up-appear-active,.zoom-up-enter.zoom-up-enter-active{-webkit-animation-name:antZoomUpIn;animation-name:antZoomUpIn;-webkit-animation-play-state:running;animation-play-state:running}.zoom-up-leave.zoom-up-leave-active{-webkit-animation-name:antZoomUpOut;animation-name:antZoomUpOut;-webkit-animation-play-state:running;animation-play-state:running;pointer-events:none}.zoom-up-appear,.zoom-up-enter{-webkit-transform:scale(0);-ms-transform:scale(0);transform:scale(0);opacity:0;-webkit-animation-timing-function:cubic-bezier(.08,.82,.17,1);animation-timing-function:cubic-bezier(.08,.82,.17,1)}.zoom-up-leave{-webkit-animation-timing-function:cubic-bezier(.78,.14,.15,.86);animation-timing-function:cubic-bezier(.78,.14,.15,.86)}.zoom-down-appear,.zoom-down-enter,.zoom-down-leave{-webkit-animation-duration:.2s;animation-duration:.2s;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-play-state:paused;animation-play-state:paused}.zoom-down-appear.zoom-down-appear-active,.zoom-down-enter.zoom-down-enter-active{-webkit-animation-name:antZoomDownIn;animation-name:antZoomDownIn;-webkit-animation-play-state:running;animation-play-state:running}.zoom-down-leave.zoom-down-leave-active{-webkit-animation-name:antZoomDownOut;animation-name:antZoomDownOut;-webkit-animation-play-state:running;animation-play-state:running;pointer-events:none}.zoom-down-appear,.zoom-down-enter{-webkit-transform:scale(0);-ms-transform:scale(0);transform:scale(0);opacity:0;-webkit-animation-timing-function:cubic-bezier(.08,.82,.17,1);animation-timing-function:cubic-bezier(.08,.82,.17,1)}.zoom-down-leave{-webkit-animation-timing-function:cubic-bezier(.78,.14,.15,.86);animation-timing-function:cubic-bezier(.78,.14,.15,.86)}.zoom-left-appear,.zoom-left-enter,.zoom-left-leave{-webkit-animation-duration:.2s;animation-duration:.2s;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-play-state:paused;animation-play-state:paused}.zoom-left-appear.zoom-left-appear-active,.zoom-left-enter.zoom-left-enter-active{-webkit-animation-name:antZoomLeftIn;animation-name:antZoomLeftIn;-webkit-animation-play-state:running;animation-play-state:running}.zoom-left-leave.zoom-left-leave-active{-webkit-animation-name:antZoomLeftOut;animation-name:antZoomLeftOut;-webkit-animation-play-state:running;animation-play-state:running;pointer-events:none}.zoom-left-appear,.zoom-left-enter{-webkit-transform:scale(0);-ms-transform:scale(0);transform:scale(0);opacity:0;-webkit-animation-timing-function:cubic-bezier(.08,.82,.17,1);animation-timing-function:cubic-bezier(.08,.82,.17,1)}.zoom-left-leave{-webkit-animation-timing-function:cubic-bezier(.78,.14,.15,.86);animation-timing-function:cubic-bezier(.78,.14,.15,.86)}.zoom-right-appear,.zoom-right-enter,.zoom-right-leave{-webkit-animation-duration:.2s;animation-duration:.2s;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-play-state:paused;animation-play-state:paused}.zoom-right-appear.zoom-right-appear-active,.zoom-right-enter.zoom-right-enter-active{-webkit-animation-name:antZoomRightIn;animation-name:antZoomRightIn;-webkit-animation-play-state:running;animation-play-state:running}.zoom-right-leave.zoom-right-leave-active{-webkit-animation-name:antZoomRightOut;animation-name:antZoomRightOut;-webkit-animation-play-state:running;animation-play-state:running;pointer-events:none}.zoom-right-appear,.zoom-right-enter{-webkit-transform:scale(0);-ms-transform:scale(0);transform:scale(0);opacity:0;-webkit-animation-timing-function:cubic-bezier(.08,.82,.17,1);animation-timing-function:cubic-bezier(.08,.82,.17,1)}.zoom-right-leave{-webkit-animation-timing-function:cubic-bezier(.78,.14,.15,.86);animation-timing-function:cubic-bezier(.78,.14,.15,.86)}@-webkit-keyframes antZoomIn{0%{-webkit-transform:scale(.2);transform:scale(.2);opacity:0}to{-webkit-transform:scale(1);transform:scale(1);opacity:1}}@keyframes antZoomIn{0%{-webkit-transform:scale(.2);transform:scale(.2);opacity:0}to{-webkit-transform:scale(1);transform:scale(1);opacity:1}}@-webkit-keyframes antZoomOut{0%{-webkit-transform:scale(1);transform:scale(1)}to{-webkit-transform:scale(.2);transform:scale(.2);opacity:0}}@keyframes antZoomOut{0%{-webkit-transform:scale(1);transform:scale(1)}to{-webkit-transform:scale(.2);transform:scale(.2);opacity:0}}@-webkit-keyframes antZoomBigIn{0%{-webkit-transform:scale(.8);transform:scale(.8);opacity:0}to{-webkit-transform:scale(1);transform:scale(1);opacity:1}}@keyframes antZoomBigIn{0%{-webkit-transform:scale(.8);transform:scale(.8);opacity:0}to{-webkit-transform:scale(1);transform:scale(1);opacity:1}}@-webkit-keyframes antZoomBigOut{0%{-webkit-transform:scale(1);transform:scale(1)}to{-webkit-transform:scale(.8);transform:scale(.8);opacity:0}}@keyframes antZoomBigOut{0%{-webkit-transform:scale(1);transform:scale(1)}to{-webkit-transform:scale(.8);transform:scale(.8);opacity:0}}@-webkit-keyframes antZoomUpIn{0%{-webkit-transform:scale(.8);transform:scale(.8);-webkit-transform-origin:50% 0;transform-origin:50% 0;opacity:0}to{-webkit-transform:scale(1);transform:scale(1);-webkit-transform-origin:50% 0;transform-origin:50% 0}}@keyframes antZoomUpIn{0%{-webkit-transform:scale(.8);transform:scale(.8);-webkit-transform-origin:50% 0;transform-origin:50% 0;opacity:0}to{-webkit-transform:scale(1);transform:scale(1);-webkit-transform-origin:50% 0;transform-origin:50% 0}}@-webkit-keyframes antZoomUpOut{0%{-webkit-transform:scale(1);transform:scale(1);-webkit-transform-origin:50% 0;transform-origin:50% 0}to{-webkit-transform:scale(.8);transform:scale(.8);-webkit-transform-origin:50% 0;transform-origin:50% 0;opacity:0}}@keyframes antZoomUpOut{0%{-webkit-transform:scale(1);transform:scale(1);-webkit-transform-origin:50% 0;transform-origin:50% 0}to{-webkit-transform:scale(.8);transform:scale(.8);-webkit-transform-origin:50% 0;transform-origin:50% 0;opacity:0}}@-webkit-keyframes antZoomLeftIn{0%{-webkit-transform:scale(.8);transform:scale(.8);-webkit-transform-origin:0 50%;transform-origin:0 50%;opacity:0}to{-webkit-transform:scale(1);transform:scale(1);-webkit-transform-origin:0 50%;transform-origin:0 50%}}@keyframes antZoomLeftIn{0%{-webkit-transform:scale(.8);transform:scale(.8);-webkit-transform-origin:0 50%;transform-origin:0 50%;opacity:0}to{-webkit-transform:scale(1);transform:scale(1);-webkit-transform-origin:0 50%;transform-origin:0 50%}}@-webkit-keyframes antZoomLeftOut{0%{-webkit-transform:scale(1);transform:scale(1);-webkit-transform-origin:0 50%;transform-origin:0 50%}to{-webkit-transform:scale(.8);transform:scale(.8);-webkit-transform-origin:0 50%;transform-origin:0 50%;opacity:0}}@keyframes antZoomLeftOut{0%{-webkit-transform:scale(1);transform:scale(1);-webkit-transform-origin:0 50%;transform-origin:0 50%}to{-webkit-transform:scale(.8);transform:scale(.8);-webkit-transform-origin:0 50%;transform-origin:0 50%;opacity:0}}@-webkit-keyframes antZoomRightIn{0%{-webkit-transform:scale(.8);transform:scale(.8);-webkit-transform-origin:100% 50%;transform-origin:100% 50%;opacity:0}to{-webkit-transform:scale(1);transform:scale(1);-webkit-transform-origin:100% 50%;transform-origin:100% 50%}}@keyframes antZoomRightIn{0%{-webkit-transform:scale(.8);transform:scale(.8);-webkit-transform-origin:100% 50%;transform-origin:100% 50%;opacity:0}to{-webkit-transform:scale(1);transform:scale(1);-webkit-transform-origin:100% 50%;transform-origin:100% 50%}}@-webkit-keyframes antZoomRightOut{0%{-webkit-transform:scale(1);transform:scale(1);-webkit-transform-origin:100% 50%;transform-origin:100% 50%}to{-webkit-transform:scale(.8);transform:scale(.8);-webkit-transform-origin:100% 50%;transform-origin:100% 50%;opacity:0}}@keyframes antZoomRightOut{0%{-webkit-transform:scale(1);transform:scale(1);-webkit-transform-origin:100% 50%;transform-origin:100% 50%}to{-webkit-transform:scale(.8);transform:scale(.8);-webkit-transform-origin:100% 50%;transform-origin:100% 50%;opacity:0}}@-webkit-keyframes antZoomDownIn{0%{-webkit-transform:scale(.8);transform:scale(.8);-webkit-transform-origin:50% 100%;transform-origin:50% 100%;opacity:0}to{-webkit-transform:scale(1);transform:scale(1);-webkit-transform-origin:50% 100%;transform-origin:50% 100%}}@keyframes antZoomDownIn{0%{-webkit-transform:scale(.8);transform:scale(.8);-webkit-transform-origin:50% 100%;transform-origin:50% 100%;opacity:0}to{-webkit-transform:scale(1);transform:scale(1);-webkit-transform-origin:50% 100%;transform-origin:50% 100%}}@-webkit-keyframes antZoomDownOut{0%{-webkit-transform:scale(1);transform:scale(1);-webkit-transform-origin:50% 100%;transform-origin:50% 100%}to{-webkit-transform:scale(.8);transform:scale(.8);-webkit-transform-origin:50% 100%;transform-origin:50% 100%;opacity:0}}@keyframes antZoomDownOut{0%{-webkit-transform:scale(1);transform:scale(1);-webkit-transform-origin:50% 100%;transform-origin:50% 100%}to{-webkit-transform:scale(.8);transform:scale(.8);-webkit-transform-origin:50% 100%;transform-origin:50% 100%;opacity:0}}.ant-motion-collapse-legacy{overflow:hidden}.ant-motion-collapse,.ant-motion-collapse-legacy-active{-webkit-transition:height .15s cubic-bezier(.645,.045,.355,1),opacity .15s cubic-bezier(.645,.045,.355,1)!important;-o-transition:height .15s cubic-bezier(.645,.045,.355,1),opacity .15s cubic-bezier(.645,.045,.355,1)!important;transition:height .15s cubic-bezier(.645,.045,.355,1),opacity .15s cubic-bezier(.645,.045,.355,1)!important}.ant-motion-collapse{overflow:hidden}", ""]);

// exports


/***/ }),

/***/ "i0Fb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserOtpChannelState = exports.getState = undefined;

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _immutable2.default.fromJS(initialState);
  var action = arguments[1];

  switch (action.type) {
    // get文章
    case _actionTypes.User.GET_USER:
      state = state.setIn(['status'], _actionTypes.User.GET_USER);
      return state;
    case _actionTypes.User.GET_USER_SUCCESS:
      {
        var data = action.data;

        state = state.setIn(['user'], _immutable2.default.fromJS(data));
        state = state.setIn(['status'], _actionTypes.User.GET_USER_SUCCESS);
        // try to set sentry user's context
        try {
          if (window.Raven) {
            window.Raven.setUserContext(data);
          } else {
            window.pageData = { user: data };
          }
          // eslint-disable-next-line no-empty
        } catch (e) {}
        return state;
      }
    case _actionTypes.User.GET_USER_FAIL:
      state = state.setIn(['status'], _actionTypes.User.GET_USER_FAIL);
      return state;
    case _actionTypes.User.SET_USER:
      {
        var _data = action.data;

        var user = state.get('user');
        state = state.setIn(['user'], user.mergeDeep(_immutable2.default.fromJS(_data)));
        return state;
      }
    case _actionTypes.User.CHANGE_EDITOR_TYPE_SUCCESS:
      {
        var editorType = action.editorType;

        state = state.setIn(['user', 'preferred_note_type'], editorType);
        return state;
      }
    // 获取用户的验证方式
    case _actionTypes.User.GET_USER_OTP_CHANNEL:
      state = state.setIn(['otpChannel', 'status'], _actionTypes.User.GET_USER_OTP_CHANNEL);
      return state;
    case _actionTypes.User.GET_USER_OTP_CHANNEL_SUCCESS:
      {
        var _data2 = action.data;

        state = state.setIn(['otpChannel', 'data'], _immutable2.default.fromJS(_data2));
        state = state.setIn(['otpChannel', 'status'], _actionTypes.User.GET_USER_OTP_CHANNEL_SUCCESS);
        return state;
      }
    case _actionTypes.User.GET_USER_OTP_CHANNEL_FAIL:
      state = state.setIn(['otpChannel', 'status'], _actionTypes.User.GET_USER_OTP_CHANNEL_FAIL);
      return state;
    case _actionTypes.User.SWITCH_SYNC_SCROLL:
      {
        var on = action.on;

        state = state.setIn(['user', 'md_auto_scroll'], on);
        return state;
      }
    case _actionTypes.User.SWITCH_SYNC_SCROLL_FAIL:
      {
        // 失败之后设置为之前的状态
        var _on = action.on;

        state = state.setIn(['user', 'md_auto_scroll'], !_on);
        return state;
      }
    default:
      return state;
  }
};

var _immutable = __webpack_require__("BYKG");

var _immutable2 = _interopRequireDefault(_immutable);

var _actionTypes = __webpack_require__("4HHy");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-param-reassign */
/**
 * Created by zad on 17/10/25.
 */
var initialState = {
  user: {
    md_auto_scroll: 0
  },
  status: _actionTypes.User.USER_INIT,
  otpChannel: {
    data: undefined,
    status: _actionTypes.User.USER_OTP_CHANNEL_INIT
  }
};

var getState = exports.getState = function getState(state) {
  return state.User;
};
var getUserOtpChannelState = exports.getUserOtpChannelState = function getUserOtpChannelState(state) {
  return state.User.getIn(['otpChannel']);
};

/***/ }),

/***/ "iiQK":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "._1Mly1{position:fixed;width:100%;left:0;top:0;font-size:12px;z-index:1020;pointer-events:none}._3IVL9{padding:6px;text-align:center}._3IVL9.move-up-leave.move-up-leave-active{overflow:hidden;-webkit-animation:_1YzhX .3s cubic-bezier(.19,.4,.17,.85);animation:_1YzhX .3s cubic-bezier(.19,.4,.17,.85)}._1rre_{display:inline-block;padding:8px 30px;min-width:200px;text-align:center;font-size:14px;background-color:#fff;-webkit-box-shadow:0 1px 6px rgba(0,0,0,.2);box-shadow:0 1px 6px rgba(0,0,0,.2);border-radius:4px;pointer-events:all}body.reader-night-mode ._1rre_{background-color:#3d3d3d}._1rre_ .fa{margin-right:4px;position:relative;top:1px;font-size:14px}._1woG-,.NJorz{color:#3194d0;border:1px solid #3194d0}._1woG- .fa,.NJorz .fa{color:#3194d0}._2d1w2{border:1px solid #42c02e}._2d1w2,._2d1w2 .fa{color:#42c02e}._2Yunk{border:1px solid #f50}._2Yunk,._2Yunk .fa{color:#f50}._lL-I{border:1px solid #fa0}._lL-I,._lL-I .fa{color:#fa0}@-webkit-keyframes _1YzhX{0%{opacity:1;max-height:150px;padding:6px}to{opacity:0;max-height:0;padding:0}}@keyframes _1YzhX{0%{opacity:1;max-height:150px;padding:6px}to{opacity:0;max-height:0;padding:0}}", ""]);

// exports
exports.locals = {
	"message-wrap": "_1Mly1",
	"message-item": "_3IVL9",
	"MessageMoveOut": "_1YzhX",
	"message-content": "_1rre_",
	"message-content-info": "_1woG-",
	"message-content-loading": "NJorz",
	"message-content-success": "_2d1w2",
	"message-content-error": "_2Yunk",
	"message-content-warning": "_lL-I"
};

/***/ }),

/***/ "j6uJ":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("ISlr");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../css-loader/index.js!../../../../postcss-loader/lib/index.js!../../../../sass-loader/lib/loader.js!./index.css", function() {
		var newContent = require("!!../../../../css-loader/index.js!../../../../postcss-loader/lib/index.js!../../../../sass-loader/lib/loader.js!./index.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "j7PK":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAM1BMVEUAAABGZqlEYaFFYaFFYaFEYaJVbqpFYaFGY6NFYKFFYaFEYaFGYaJFYqJGY6BJY6FEYKAtYy3MAAAAEHRSTlMAEPvjgI0KXCjx26VuaD4xlUjU4QAAAGxJREFUOMvlz0sKwCAMRdHk1aj9u//VNoh0ZAx04KR3IoSDJDQnQekGaQDFCA0UMxNgxQAg5EjEJsBdh9EEgRyQdcLpPCwA0rbBFUv93gH8HQR6uzyQPBC6QJiZNH12d8n/AVgADQj6AEJTegCRiCEBOZVvEgAAAABJRU5ErkJggg=="

/***/ }),

/***/ "jNsU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.fee66e7.woff";

/***/ }),

/***/ "jgCU":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("s3e1");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./PhoneModal.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./PhoneModal.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "jiq3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _Divider = __webpack_require__("lJyq");

var _Divider2 = _interopRequireDefault(_Divider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Divider = function (_Component) {
  (0, _inherits3.default)(Divider, _Component);

  function Divider() {
    (0, _classCallCheck3.default)(this, Divider);
    return (0, _possibleConstructorReturn3.default)(this, (Divider.__proto__ || (0, _getPrototypeOf2.default)(Divider)).apply(this, arguments));
  }

  (0, _createClass3.default)(Divider, [{
    key: 'render',

    // eslint-disable-next-line class-methods-use-this
    value: function render() {
      var childern = this.props.childern;

      return _react2.default.createElement('li', { className: _Divider2.default['divider'] });
    }
  }]);
  return Divider;
}(_react.Component);

exports.default = Divider;

/***/ }),

/***/ "jrrN":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "._2po2r{padding:10px 20px;line-height:20px;white-space:nowrap;text-align:left;position:relative;border-bottom:1px solid #d9d9d9}body.reader-night-mode ._2po2r{border-color:#2e2e2e}._2po2r:first-child{border-radius:4px 4px 0 0}._2po2r:last-child{border-radius:0 0 4px 4px;border-bottom:0}._2po2r:hover{background-color:#666;color:#fff}body.reader-night-mode ._2po2r:hover{background-color:#2e2e2e}._2po2r ._22XWG{margin-right:5px}.cRfUr{border-bottom:1px solid #d9d9d9}body.reader-night-mode .cRfUr{border-color:#2e2e2e}._20tIi{opacity:.3}", ""]);

// exports
exports.locals = {
	"item": "_2po2r",
	"icon": "_22XWG",
	"item-border": "cRfUr",
	"item-disabled": "_20tIi"
};

/***/ }),

/***/ "k0vs":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("YrSj");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../css-loader/index.js!../../../../postcss-loader/lib/index.js!../../../../sass-loader/lib/loader.js!./index.css", function() {
		var newContent = require("!!../../../../css-loader/index.js!../../../../postcss-loader/lib/index.js!../../../../sass-loader/lib/loader.js!./index.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "kSF0":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("dxin");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./NoOtherAccount.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./NoOtherAccount.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "kWOh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactIntlUniversal = __webpack_require__("cl+9");

var _reactIntlUniversal2 = _interopRequireDefault(_reactIntlUniversal);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _util = __webpack_require__("oFuF");

var _QrcodeModal = __webpack_require__("0Ze7");

var _QrcodeModal2 = _interopRequireDefault(_QrcodeModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultW = 200;
var defaultH = 200;

var QrcodeModal = function (_Component) {
  (0, _inherits3.default)(QrcodeModal, _Component);

  function QrcodeModal(props) {
    (0, _classCallCheck3.default)(this, QrcodeModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (QrcodeModal.__proto__ || (0, _getPrototypeOf2.default)(QrcodeModal)).call(this, props));

    _this.setTheQrcodeData = function (_ref) {
      var _ref$link = _ref.link,
          link = _ref$link === undefined ? '' : _ref$link,
          w = _ref.w,
          h = _ref.h;

      if (window.QRCode) {
        if (_this.bigQrcode) {
          _this.bigQrcode.clear();
          _this.bigQrcode.makeCode(link);
          return;
        }
        _this.bigQrcode = new QRCode(document.getElementById('big-qrcode'), {
          text: link,
          width: w || defaultW,
          height: h || defaultH,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        });
      }
    };

    _this.onQrcodeModalBodyClick = function (e) {
      (0, _util.stopEvent)(e);
    };

    _this.onQrcodeModalCancelClick = function (e) {
      var onModalCancel = _this.props.onModalCancel;

      onModalCancel(e);
    };

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(QrcodeModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var link = this.props.link;

      this.setTheQrcodeData({ link: link });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.visible !== this.props.visible) {
        this.setTheQrcodeData({ link: nextProps.link });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var visible = this.props.visible;

      var modalClass = (0, _classnames2.default)(_QrcodeModal2.default['qrcode-modal'], (0, _defineProperty3.default)({}, _QrcodeModal2.default['hidden'], !visible));
      return _react2.default.createElement(
        'div',
        {
          className: modalClass,
          onClick: this.onQrcodeModalCancelClick
        },
        _react2.default.createElement(
          'div',
          {
            className: _QrcodeModal2.default['qr-modal-body'],
            onClick: this.onQrcodeModalBodyClick
          },
          _react2.default.createElement(
            'span',
            {
              className: _QrcodeModal2.default['close-btn'],
              onClick: this.onQrcodeModalCancelClick
            },
            '\xD7'
          ),
          _react2.default.createElement(
            'div',
            { className: _QrcodeModal2.default['qr-modal--title'] },
            _reactIntlUniversal2.default.get('share.wechat-des')
          ),
          _react2.default.createElement('div', { id: 'big-qrcode' })
        )
      );
    }
  }]);
  return QrcodeModal;
}(_react.Component);

exports.default = QrcodeModal;

/***/ }),

/***/ "kvZP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNormalPageUrl = getNormalPageUrl;
exports.getWritingPageUrl = getWritingPageUrl;
exports.getRecyclePageUrl = getRecyclePageUrl;
exports.getHistoryPageUrl = getHistoryPageUrl;
exports.getPNSettingPageUrl = getPNSettingPageUrl;
exports.getNoteSharedUrl = getNoteSharedUrl;
exports.getNewCollectionPageUrl = getNewCollectionPageUrl;
/* create by dannyliu */
// import { BrowserRouter, history } from 'react-router-dom';


// 获取正常模式的路由地址
function getNormalPageUrl(nbId, noteId) {
  if (noteId) {
    return '/notebooks/' + nbId + '/notes/' + noteId;
  }
  if (nbId) {
    return '/notebooks/' + nbId;
  }
  return '/';
}

// 获取写作模式的路由地址
function getWritingPageUrl(nbId, noteId) {
  return '/notebooks/' + nbId + '/notes/' + noteId + '/writing';
}

// 获取回收站的路由地址
function getRecyclePageUrl(noteId) {
  if (noteId) {
    return '/recycle/' + noteId;
  }
  return '/recycle';
}

// 获取历史版本的路由地址
function getHistoryPageUrl(nbId, noteId) {
  return '/notebooks/' + nbId + '/notes/' + noteId + '/history';
}

// 获取付费文章设置页面路由
function getPNSettingPageUrl(nbId, noteId) {
  return '/notebooks/' + nbId + '/notes/' + noteId + '/pnsetting';
}

// 获取文章发布后的链接
function getNoteSharedUrl(slug) {
  var origin =  false ? 'http://localhost:3000' : window.location.origin;
  return origin + '/p/' + slug + '?v=' + new Date().getTime();
}

// 获取新建专题的页面url
function getNewCollectionPageUrl() {
  return window.location.origin + '/collections/new';
}

// const getAction = function (isReplace) {
//   return isReplace ? 'replace' : 'push';
// };
// // 跳转至三栏页面
// export function redirectToNormalPage(nbId, noteId, isReplace) {
//   history[getAction(isReplace)](getNormalPageUrl(nbId, noteId));
// }

// // 跳转至写作模式页面
// export function redirectToWritingPage(nbId, noteId, isReplace) {
//   history[getAction(isReplace)](this.getWritingPageUrl(nbId, noteId));
// }

// // 跳转至回收站页面
// export function redirectToRecyclePage(noteId, isReplace) {
//   history[getAction(isReplace)](getRecyclePageUrl(noteId));
// }

// // 跳转至历史版本页面
// export function redirectToHistoryPage(nbId, noteId, isReplace) {
//   history[getAction(isReplace)](getHistoryPageUrl(nbId, noteId));
// }

/***/ }),

/***/ "l0FP":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "body._2_Wea,body._2_Wea button,body._2_Wea input,body._2_Wea select,body._2_Wea textarea{font-family:-apple-system,SF UI Text,Arial,PingFang SC,Hiragino Sans GB,Microsoft YaHei,WenQuanYi Micro Hei,sans-serif}body._3fOHI,body._3fOHI button,body._3fOHI input,body._3fOHI select,body._3fOHI textarea{font-family:Georgia,Times New Roman,Times,Songti SC,serif}", ""]);

// exports
exports.locals = {
	"reader-black-font": "_2_Wea",
	"reader-song-font": "_3fOHI"
};

/***/ }),

/***/ "l8jW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShareMenu = exports.SubMenu = exports.Divider = exports.MenuItem = exports.Item = undefined;

var _Menu = __webpack_require__("eTMa");

var _Menu2 = _interopRequireDefault(_Menu);

var _SubMenu = __webpack_require__("FrNA");

var _SubMenu2 = _interopRequireDefault(_SubMenu);

var _ShareMenu = __webpack_require__("E6IZ");

var _ShareMenu2 = _interopRequireDefault(_ShareMenu);

var _MenuItem = __webpack_require__("Jl+A");

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _Divider = __webpack_require__("jiq3");

var _Divider2 = _interopRequireDefault(_Divider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Item = _MenuItem2.default;
exports.MenuItem = _MenuItem2.default;
exports.Divider = _Divider2.default;
exports.SubMenu = _SubMenu2.default;
exports.ShareMenu = _ShareMenu2.default;
// import MenuItemGroup from './MenuItemGroup';

exports.default = _Menu2.default;

/***/ }),

/***/ "lGVK":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("DYhM");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../css-loader/index.js!../../postcss-loader/lib/index.js!../../sass-loader/lib/loader.js!./font-awesome.scss", function() {
		var newContent = require("!!../../css-loader/index.js!../../postcss-loader/lib/index.js!../../sass-loader/lib/loader.js!./font-awesome.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "lIYd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable quote-props */
module.exports = {
  bind: {
    bindwb: '绑定微博',
    binddb: '绑定豆瓣',
    bindqq: '绑定qq',
    hasbind: '已绑定',
    yjbdwx: '一键绑定微信',
    bindway: '绑定以下任一种登录方式'
  },
  global: {
    'note-loading': '文章加载中',
    'content-loading': '内容加载中',
    quit: '按 Esc 退出',
    timeout: '请求超时',
    commit: '提交',
    cancel: '取消',
    setting: '设置',
    'to-home': '返回首页',
    'download': '下载简书App',
    'forbidden-desc': '很抱歉，网页版写文章功能暂不支持手机/平板电脑，你可以在简书 App 中使用',
    'load-more': '加载更多',
    'no-more-notes': '没有更多文章了',
    'loading': '加载中...'
  },
  'not-found': {
    'title': '您要找的页面不见了',
    'desc': '因为您的链接地址有误，链接地址为',
    'to-home': '返回「简书」首页'
  },
  'note-action': {
    'time-publish': '定时发布',
    'publicize': '直接发布',
    'publicized': '已发布',
    'compile-paid-note': '发布更新和设置',
    'publicize-paid-note': '发布为付费文章',
    'set-publicize-style': '设置发布样式',
    'topping-note': '置顶文章',
    'untopping-note': '取消置顶文章',
    'topping-success': '文章置顶成功',
    'untopping-success': '取消文章置顶成功',
    'share': '分享文章',
    'move-note': '移动文章',
    'open-in-new-window': '在新窗口打开',
    'private-note': '设为私密',
    'to-history': '历史版本',
    'del-note': '删除文章',
    'set-unreprintable': '设置禁止转载',
    'cancel-unreprintable': '取消禁止转载'
  },
  settings: {
    'change-read-mode': '阅读模式已切换成功',
    'change-locale': '显示语言已切换成功',
    'change-font': '显示字体已切换成功',
    'change-editor': '默认编辑器已切换成功',
    'display': '设置显示模式',
    'open-night-mode': '打开夜间模式',
    'close-night-mode': '关闭夜间模式',
    'change-to-song': '切换至宋体',
    'change-to-black': '切换至黑体',
    'change-to-simple': '切换至简体',
    'change-to-traditional': '切换至繁体',
    'editor': '默认编辑器',
    'md-editor': 'MarkDown编辑器',
    'rich-editor': '富文本编辑器',
    'recycle': '回收站',
    'feedback': '帮助与反馈',
    'need-help': '遇到问题',
    'common-issue': '常见问题',
    'on': '开',
    'off': '关',
    'sync-scroll': '同步滚动',
    'switch-sync-scroll': '同步滚动状态切换成功',
    'author-verfy': '简书作者实名认证'
  },
  grammar: {
    'grammar': 'Markdown语法参考',
    'h1': '# 一级标题',
    'h2': '## 二级标题',
    'h5': '##### 五级标题',
    'ul1': '- 列表第一项',
    'ul2': '- 列表第二项',
    'ol1': '1. 有序列表第一项',
    'ol2': '2. 有序列表第二项',
    'link': '[标题](链接地址)',
    'image': '![图片描述](图片链接地址)',
    'italic': '*斜体*',
    'bold': '**粗体**',
    'code-block': '> 引用段落',
    'blockquote': '```\n代码块\n```'
  },
  notebooks: {
    'to-homepage': '回首页',
    'new-notebook': '新建文集',
    'new-notebook-ing': '新建文集中...',
    'rename-notebook-tip': '请输入新文集名',
    'new-notebook-empty': '文集名不能为空',
    'del-notebook-tip': '确认删除文集《{name}》，文章将被移动到回收站。'
  },
  notes: {
    'audio': '音频',
    'new-note': '新建文章',
    'new-note-ing': '新建文章中...',
    'new-note-bottom': '在下方新建文章',
    'default-note-title': '无标题文章',
    'word-num': '字数:',
    'save-word': '{wordNum} 字',
    'move-note-success': '文章已移动至新文集',
    'del-note-confirm-tip': '确认删除文章《{title}》，文章将被移动到回收站，您可以在那里恢复它。60天后将被彻底删除。',
    'topping': '置顶'
  },
  'pay-note': {
    'i-agree': '我同意',
    'agree-title': '付费文章协议',
    'cancelbtn': '不同意',
    'okbtn': '同意',
    'step-title': '付费文章设置',
    'step-one': '设置试读范围',
    'step-one-des': '请你在右侧选择免费可读的部分',
    'step-two': '输入定价',
    'yuan': '元',
    'step-three': '设置音频',
    'pay-for-audio': '购买文章后才能播放',
    'free-for-audio': '免费播放',
    'confirming-btn': '发布中...',
    'confirm-btn': '确认并发布',
    'cancel-btn': '取消',
    'wrong-price': '请输入正确的金额({minnum}-{maxnum}元)',
    'price-tip': '您可自由设置文章定价，最低1元，最高2000元。',
    'mask-item-des': '该分割线以上免费可读',
    'publish-paid-notes': '发表付费文章',
    'publish-explain-1': '付费文章即读者付费后才可解锁阅读的文章，拥有付费文章发表权限的作者可以发表付费文章。',
    'publish-explain-2': '该功能仅针对「简书会员」或「简书钻大于 {minJSD}」或「被邀请」的用户开放，您可以通过购买简书会员快速获得该资格。',
    'about-jsd': '了解简书钻特权',
    'open-js-member': '开通简书会员'
  },
  'publish-setting': {
    'set-cover-img': '设置封面图，优化文章的显示效果',
    'set-note': '未设置则自动按默认样式显示',
    'choose-img-count': '选择图片数量',
    'one-img': '一图',
    'three-img': '三图（无摘要）',
    'upload-cover-img': '上传封面图',
    'click-to-upload': '点击上传',
    'upload-note1': '尺寸大于 360×360，格式 png/jpg',
    'upload-note2': '单张图片大于 440×320，格式 png/jpg',
    'change': '更换',
    'input-abstract': '输入摘要',
    'input-placeholder': '选填，30字内，如不填写会默认抓取首段内容',
    'confirm-btn': '保存',
    'confirming-btn': '保存中...',
    'cancel-btn': '取消',
    'preview': '效果预览',
    'preview-note': '仅供参考，具体效果会根据不同手机型号而变化',
    'save': '保存',
    'saving': '保存中...',
    'confirmed': '发布样式已更新',
    'notes-over-limit': '摘要字数超出限制！'
  },
  share: {
    'trailing-jianshushe': '- 简书社',
    'to-weibo': '微博',
    'to-qzone': 'QQ空间',
    'to-douban': '豆瓣',
    'to-wechat': '微信',
    'to-facebook': 'Facebook',
    'to-twitter': 'Twitter',
    'to-googleplus': 'Google+',
    'copy-link': '复制链接',
    'wechat-des': '打开微信“扫一扫”，打开网页后点击屏幕右上角分享按钮',
    more: '更多分享'
  },
  error: {
    'content-not-enough': '内容少于{num}段，不能发表为付费文章',
    'save-again-soft': '上一篇文章有内容未保存成功，需要手动保存',
    'save-again': '有内容未保存成功，确定要离开？',
    'data-empty': '暂无数据',
    'try-again': '操作失败，请再试一次',
    'content-no-empty': '内容不能为空',
    'link-no-empty': '链接不能为空',
    'text-no-empty': '文本不能为空',
    'file-not-exit': '文件不存在',
    'file-type-error': '图片格式错误，请使用jpg/jpeg/png/gif文件',
    'file-size-over': '文件大小超过{size}M',
    'need-bind-phone': '需要绑定手机号后才能发布文章哟~',
    'uploading-img': '正在上传图片，请稍等...',
    'video-max-over': '视频不能超过{num}个',
    'fail-refresh': '操作失败，可以刷新页面尝试',
    'upload-fail': '有图片未上传成功，请删除或重新上传图片。如需帮助，请',
    'click': '点击',
    'no-nb': '文集不存在'
  },
  tooltip: {
    bold: '粗体',
    italic: '斜体',
    strikethrough: '删除线',
    quote: '引用',
    picture: '插入图片',
    h1: '标题1',
    h2: '标题2',
    h3: '标题3',
    h4: '标题4',
    hr: '分割线',
    link: '插入链接',
    video: '插入视频',
    audio: '插入音频',
    audioExist: '已有音频',
    'math-formula': '数学公式',
    undo: '撤销',
    redo: '重做',
    history: '历史版本',
    save: '保存',
    expand: '全屏',
    compress: '退出全屏',
    preview: '切换到预览模式',
    'to-normal-mode': '返回',
    'grammar': 'Markdown语法参考',
    jianchuang: 'AI简创',
    film: '电影'
  },
  pubbtn: {
    publishing: '发布中...',
    saving: '保存中...',
    saved: '已保存',
    'save-fail': '保存失败,请手动保存',
    publicize: '发布文章',
    publicized: '已发布',
    'cancel-publish': '取消发布',
    'publish-update': '发布更新',
    'compile-paid-note': '发布更新和设置',
    'publicize-paid-note': '发布为付费文章',
    'audio-transcoding': '音频转码中，请稍后发布'
  },
  modal: {
    insertimg: '插入图片',
    insertlink: '插入链接',
    insertvideo: '插入视频',
    insertfilm: '插入电影',
    'film-placeholder': '请输入电影名称',
    'film-select-tip': '请先选择一部电影',
    'film-search-fail': '电影搜索失败',
    'film-score': '评分',
    'film-score-unit': '分',
    'film-score-bad': '很差',
    'film-score-poor': '较差',
    'film-score-ok': '还行',
    'film-score-good': '推荐',
    'film-score-great': '力荐',
    removeLink: '删除链接',
    confirm: '确认',
    cancel: '取消',
    urldes: '链接地址',
    'getting-linkinfo': '正在获取链接标题...',
    'getting-linkinfo-fail': '无法获取链接标题,请手动输入链接文本',
    linktxtdes: '链接文本',
    insertimgdes: '点击上传（可多张）',
    imgpolicy: '图片私密性',
    chooseurlimg: '或选择网络图片',
    imglinkdes: '请输入网络图片链接',
    choosesysimg: '或上传本地图片',
    'only-support': '目前只支持',
    tc: '腾讯',
    yk: '优酷',
    video: '视频',
    'video-url-des': '请输入视频地址',
    'wrong-video-source': '暂不支持此视频地址',
    'video-loading': '正在加载视频，请稍等...',
    'fetch-video-info-failed': '抱歉，您输入的地址无法识别！',
    'insert-audio': '插入音频',
    'upload-audio': '点击上传',
    'audio-support': '支持 {format} 格式，大小不超过 {size} M',
    'audio-cancle': '取消上传',
    'audio-upload-unfinished': '音频上传尚未完成',
    'reupload-audio': '重新上传',
    'retry': '重试',
    'audio-upload-failed': '上传失败',
    'audio-uploading-failed': '音频未上传成功',
    'audio-upload-complete': '上传完成',
    'audio-upload-error': '网络异常，请稍后再试',
    'audio-name': '音频名称',
    'audio-author': '音频作者',
    'insert-audio-name': '输入音频名称',
    'insert-audio-author': '输入音频的创作者',
    'delete-audio': '删除音频',
    'audio-confirm': ' 确定',
    'audio-overlarge': '文件大小超过限制！',
    'audio-delete': '确认删除音频吗？',
    'no-name': '佚名',
    'close-audio-warning': '确认关闭吗？',
    'close-audio-warning2': '关闭后，当前的更改或上传将丢失',
    'audio-transcoding': '音频正在转码，请稍候',
    'audio-edit': '编辑',
    'insert-math-formula': '插入数学公式',
    'common-expression': '常用表达式',
    'common-function': '常用函数',
    'common-symbol': '常用符号',
    'greek-alphabet': '希腊字母',
    'special-symbol': '特殊符号',
    'math-formula-grammar': '数学公式语法',
    'insert-empty': '输入内容为空，请重新输入！',
    'insert-audio-modal': '插入音频',
    'insert-audio-explain': '插入音频功能，仅对简书钻大于 {minJSD} 或被邀请的用户开放，你可以通过购买简书会员，或者积极参与简书社区互动（喜欢优质文章/喜欢自己的文章）等方式，增加你的简书钻'
  },
  history: {
    'auto-save': '自动保存',
    publicize: '公开发表文章',
    update: '发布更新',
    recovery: '版本恢复',
    web: '简书网站',
    ios: '简书 iPhone App',
    android: '简书 Android App',
    'ios-night': '简书 iPhone App 黑夜版',
    timeago: '刚刚_秒以前_分钟以前_小时以前_天以前_周以前_月以前_年以前',
    'total-items': '共{num}条历史版本',
    filter: '筛选',
    'recovery-to': '恢复到这个版本'
  },
  trash: {
    trash: '回收站({num})',
    recovery: '恢复文章',
    recovering: '恢复文章中...',
    delete: '彻底删除',
    deleting: '彻底删除中...',
    'del-time': '将于{time}清除',
    'del-time2': '{time}天后清除'
  },
  verifymodal: {
    'sending-captcha': '{num}秒后重新发送',
    'resend-captcha': '重新发送验证码',
    'send-captcha': '发送验证码',
    'empty-captcha': '验证码为空',
    'verify-captcha-error': '验证码错误，请重试',
    'send-captcha-error': '验证码发送失败，可刷新页面重试',
    loading: '正在加载验证信息...',
    confirm: '确认',
    confirming: '确认中...',
    captcha: '验证码',
    title: '安全验证',
    'email-prefix': '用邮箱',
    'sms-prefix': '用手机',
    verify: '验证',
    'by-email': '用邮箱验证',
    'by-phone': '用手机短信验证',
    des: '为了保证你的账号安全，请先验证身份，验证成功后进行下一步操作，验证码{minute}分钟内有效'
  },
  app: {
    name: '简 书'
  },
  phoneModal: {
    all: '全部',
    clickbind: '点击绑定',
    bindtitle: '绑定手机号和微信',
    wxoccupy: '微信被占用',
    bindwx: '綁定微信',
    bindwxtip: '请使用微信扫描二维码进行绑定',
    nobind: '未绑定',
    bindwxphone: '绑定手机号和微信',
    yjjb: '一键绑定',
    cancel: '取消',
    bindtip: '发布公开文章需要同时绑定手机号和微信',
    'tip': '绑定遇到问题',
    'href': '点击查看帮助',
    'hot-countries': '热门国家和地区',
    'captcha-regex-error': '验证码格式不对，请重新输入',
    captcha: '短信验证码',
    title: '绑定手机',
    'phone-num': '手机号',
    'phone-error': '输入的手机号码有误，请重新输入',
    'get-otp-info-error': '获取国家区号失败, 请刷新页面重试'
  },
  publishSuccessModal: {
    'post-des': '向专题投稿，让文章被更多人发现',
    'success-des': '发布成功，点击查看文章',
    'search-collection': '搜索专题',
    'new-collection': '新建',
    'my-collections': '我管理的专题',
    'lastest-collections': '最近投稿',
    'recomend-collections': '推荐专题',
    'include-note': '收录',
    'including-note': '收录中',
    'included-note': '已收录',
    'post-note': '投稿',
    'posting-note': '投稿中',
    'posted-note': '等待审核',
    'copy-success': '已复制到剪贴板中',
    'get-more-data': '点击加载更多',
    'no-more-data': '没有更多了',
    'copy-fail': '此浏览器不支持，复制失败，建议用Chrome'
  },
  collections: {
    'note-num': '{num}篇文章',
    'suber-num': '{num}人关注'
  },
  'upload-img': {
    'upload-success': '上传成功',
    'upload-fail': '上传失败',
    'upload-size-error': '上传图片尺寸错误',
    'upload-net-error': '网络错误，请重试'
  },
  tips: {
    'set-reprintable-success': '设置转载状态成功',
    'set-reprintable-fail': '设置转载状态失败'
  }
};

/***/ }),

/***/ "lJyq":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("63ug");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--3-1!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/lib/loader.js!./Divider.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--3-1!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/lib/loader.js!./Divider.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "lTDY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createAction;
/**
 * Created by zad on 17/10/19.
 */
function createAction(type) {
  for (var _len = arguments.length, names = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    names[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var action = { type: type };
    args.forEach(function (arg, index) {
      if (arg !== undefined) {
        action[names[index]] = arg;
      }
    });
    return action;
  };
}

/***/ }),

/***/ "lVK7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("4M2W");

__webpack_require__("d5DL");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("O27J");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__("RH2O");

__webpack_require__("tVgH");

__webpack_require__("+qiL");

__webpack_require__("lGVK");

var _App = __webpack_require__("pnOm");

var _App2 = _interopRequireDefault(_App);

var _ReduxRootStore = __webpack_require__("geoC");

var _ReduxRootStore2 = _interopRequireDefault(_ReduxRootStore);

var _index = __webpack_require__("Ohkn");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// styles
var version = 'v' + "1.4.2";

// init sensor begin


// start
/**
 * Created by zad on 17/9/27.
 */
// polyfill
window.JsSensor = new _index2.default({
  debug: false
});
// init sensor end

var render = function render(AppContainer) {
  _reactDom2.default.render(_react2.default.createElement(
    _reactRedux.Provider,
    { store: _ReduxRootStore2.default },
    _react2.default.createElement(AppContainer, null)
  ), document.getElementById('root'));
};

render(_App2.default);
window.__REACT__ = _react2.default; // eslint-disable-line no-underscore-dangle

// 模块热替换的 API
if (false) {
  module.hot.accept(function () {
    render(_App2.default);
  });
}

// console the release version
if (window.console && typeof window.console.log === 'function') {
  console.log('Release:: ' + ("release-20260921092946" || 'developing'));
  console.log('Environment:: ' + "production");
  console.log('Version:: ' + version);
}

/***/ }),

/***/ "m3yF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFirefox = isFirefox;
exports.isChrome = isChrome;
exports.isSafari = isSafari;
exports.isAndroid = isAndroid;
exports.isiPhone = isiPhone;
exports.isiPad = isiPad;
exports.isPC = isPC;
/**
 * Created by zad on 17/12/6.
 */
var fireFoxReg = /firefox/i;
var chromeReg = /chrome/i;
var safariReg = /safari/i;
var androidReg = /android/i;
var iPhoneReg = /iPhone/i;
var iPadReg = /iPad/i;

function isFirefox() {
  var _window = window,
      userAgent = _window.navigator.userAgent;

  return fireFoxReg.test(userAgent);
}

function isChrome() {
  var _window2 = window,
      userAgent = _window2.navigator.userAgent;

  return chromeReg.test(userAgent);
}

function isSafari() {
  var _window3 = window,
      userAgent = _window3.navigator.userAgent;

  return safariReg.test(userAgent) && !isChrome();
}

function isAndroid() {
  var _window4 = window,
      userAgent = _window4.navigator.userAgent;

  return androidReg.test(userAgent);
}

function isiPhone() {
  var _window5 = window,
      userAgent = _window5.navigator.userAgent;

  return iPhoneReg.test(userAgent);
}

function isiPad() {
  var _window6 = window,
      userAgent = _window6.navigator.userAgent;

  return iPadReg.test(userAgent);
}

function isPC() {
  return !(isAndroid() || isiPhone() || isiPad());
}

/***/ }),

/***/ "mIQu":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".math-block,.math-inline{max-width:100%}.math-block[mathimg=\"1\"]{display:block;margin:1em auto}.math-inline[mathimg=\"1\"]{display:inline;margin:0 3px;vertical-align:middle}body.reader-night-mode .math-block,body.reader-night-mode .math-inline{-webkit-filter:invert(.8);filter:invert(.8)}", ""]);

// exports


/***/ }),

/***/ "mXnL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTrashNotesState = exports.getTrashNotesListState = undefined;

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _immutable2.default.fromJS(initialState);
  var action = arguments[1];

  switch (action.type) {
    // 获取trash list
    case _actionTypes.Trash.GET_TRASH_NOTES_LIST:
      {
        var noteId = action.noteId;

        state = state.setIn(['list', 'status'], _actionTypes.Trash.GET_TRASH_NOTES_LIST);
        return state;
      }
    case _actionTypes.Trash.GET_TRASH_NOTES_LIST_SUCCESS:
      {
        var data = action.data;
        // 如果没有data则是取得缓存, 无需重新设置data

        if (data) {
          data.sort(function (a, b) {
            return a.deleted_at - b.deleted_at;
          });

          var _normalize = (0, _normalize3.default)(data),
              entities = _normalize.entities,
              seq = _normalize.seq;

          state = state.setIn(['list', 'entities'], _immutable2.default.fromJS(entities));
          state = state.setIn(['list', 'seq'], _immutable2.default.fromJS(seq));
        }
        state = state.setIn(['list', 'status'], _actionTypes.Trash.GET_TRASH_NOTES_LIST_SUCCESS);
        return state;
      }
    case _actionTypes.Trash.GET_TRASH_NOTES_LIST_FAIL:
      {
        state = state.setIn(['list', 'status'], _actionTypes.Trash.GET_TRASH_NOTES_LIST_FAIL);
        return state;
      }
    // 获取trash content
    case _actionTypes.Trash.GET_TRASH_NOTE_CONTENT:
      {
        var _noteId = action.noteId;

        state = state.setIn(['notes', _noteId.toString(), 'status'], _actionTypes.Trash.GET_TRASH_NOTE_CONTENT);
        return state;
      }
    case _actionTypes.Trash.GET_TRASH_NOTE_CONTENT_SUCCESS:
      {
        var _noteId2 = action.noteId,
            _data = action.data;
        // 如果没有data则是取得缓存, 无需重新设置data

        if (_data) {
          state = state.setIn(['notes', _noteId2.toString()], _immutable2.default.fromJS(_data));
        }
        state = state.setIn(['notes', _noteId2.toString(), 'status'], _actionTypes.Trash.GET_TRASH_NOTE_CONTENT_SUCCESS);
        return state;
      }
    case _actionTypes.Trash.GET_TRASH_NOTE_CONTENT_FAIL:
      {
        var _noteId3 = action.noteId;

        state = state.setIn(['notes', _noteId3.toString(), 'status'], _actionTypes.Trash.GET_TRASH_NOTE_CONTENT_FAIL);
        return state;
      }
    // 删除trash note
    case _actionTypes.Trash.DEL_TRASH_NOTE:
      {
        var _noteId4 = action.noteId;

        state = state.setIn(['notes', _noteId4.toString(), 'status'], _actionTypes.Trash.DEL_TRASH_NOTE);
        return state;
      }
    case _actionTypes.Trash.DEL_TRASH_NOTE_SUCCESS:
      {
        var _noteId5 = action.noteId,
            _data2 = action.data;

        state = state.deleteIn(['notes', _noteId5.toString()]);
        state = state.deleteIn(['list', 'entities', _noteId5.toString()]);
        var listSeqIndex = state.getIn(['list', 'seq']).indexOf(+_noteId5);
        state = state.deleteIn(['list', 'seq', listSeqIndex]);
        return state;
      }
    case _actionTypes.Trash.DEL_TRASH_NOTE_FAIL:
      {
        var _noteId6 = action.noteId;

        state = state.setIn(['notes', _noteId6.toString(), 'status'], _actionTypes.Trash.DEL_TRASH_NOTE_FAIL);
        return state;
      }
    //  恢复trash note
    case _actionTypes.Trash.RECOVERY_TRASH_NOTE:
      {
        var _noteId7 = action.noteId;

        state = state.setIn(['notes', _noteId7.toString(), 'status'], _actionTypes.Trash.RECOVERY_TRASH_NOTE);

        return state;
      }
    case _actionTypes.Trash.RECOVERY_TRASH_NOTE_SUCCESS:
      {
        var _noteId8 = action.noteId,
            _data3 = action.data;

        state = state.deleteIn(['notes', _noteId8.toString()]);
        var _listSeqIndex = state.getIn(['list', 'seq']).indexOf(+_noteId8);
        state = state.deleteIn(['list', 'seq', _listSeqIndex]);
        state = state.deleteIn(['list', 'entities', _noteId8.toString()]);
        return state;
      }
    case _actionTypes.Trash.RECOVERY_TRASH_NOTE_FAIL:
      {
        var _noteId9 = action.noteId;

        state = state.setIn(['notes', _noteId9.toString(), 'status'], _actionTypes.Trash.RECOVERY_TRASH_NOTE_FAIL);
        return state;
      }
    // 文章移入回收站
    case _actionTypes.Notes.DEL_NOTE_SOFT_SUCCESS:
      {
        var _data4 = action.data,
            _noteId10 = action.noteId,
            nbId = action.nbId;

        var _seq = state.getIn(['list', 'seq']);
        // 如果本来就没有数据就不需要手动增加，直接从后端一起啊获取
        if (_seq) {
          state = state.setIn(['list', 'entities', _noteId10], _immutable2.default.fromJS(_data4));
          state = state.setIn(['list', 'seq'], _seq.push(+_noteId10));
        }
        return state;
      }
    default:
      return state;
  }
};

var _normalize2 = __webpack_require__("w0tY");

var _normalize3 = _interopRequireDefault(_normalize2);

var _immutable = __webpack_require__("BYKG");

var _immutable2 = _interopRequireDefault(_immutable);

var _actionTypes = __webpack_require__("4HHy");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  list: {
    // entities: undefined, // 文章列表, Immutable中undefined也算是有数据，所以用注释的方法来标识数据结构
    // seq: undefined,
    status: _actionTypes.Trash.TRASH_NOTES_LIST_INIT
  },
  notes: {}
}; /* eslint-disable no-param-reassign */
/**
 * Created by zad on 17/10/18.
 */
var getTrashNotesListState = exports.getTrashNotesListState = function getTrashNotesListState(state) {
  return state.TrashNotes.get('list');
};

var getTrashNotesState = exports.getTrashNotesState = function getTrashNotesState(state) {
  return state.TrashNotes.get('notes');
};

/***/ }),

/***/ "mwPL":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAk1BMVEUAAAAAvCkAvCkAvCkAvCkAvCkAvCoA1UMAvCkAvCkAvCoAvCoAvCkAvy0Avy0AvCkAvCkAvCoAuyoAvCkAvCkAvCkAvCkAvSoAvCsAvSsAviwAwC0AwS8AvCoAvCoAvCoAvSoAvSwAv0AAvCoAvCkAuykAvCkAvCkAvCkAvSkAuykAvSsAxDAAxDEA/4AAvCkAuyl1qxS+AAAAMHRSTlMA9vvz5cSFB76ki3VoKSL47NzX0ZqAbmFLQDAcEe9dWU5FBN3azci4oJSPOBcNAq56ALHKAAABKUlEQVQ4y72S2ZKCQAxFwya7IsiObDruOvz/1w1XFpuGqnmZmvPQqc69IZ0K9G+okXGSHcnTg2xRNuVmQLisZ7rtNSyCxen3fcOxmuipg9x2g3OIAWvQkLHIljplvUcX5h1xAx5ECmLaF1w+hl3XtY5FREONBURJHQ3HrjfkPh70IA+fo0HiJlByS5PbV7i3ZMkg+v5mvGgpDF8TQ35ib07ZGgw248POIFZENtt/9Z6oxGbcEvPJT8w5UkioIoLPogwpkyhzB30Tdn2qbXt68e39USzj0BtkVHI41JJp/aKMuUEgoPcXc25woauSeE3C3VmJ5oYrDJE+bPfM66KN9Gdza/7nMomjEia6/iKe5MjoBi1Qh14/Exos84gKq7BfybdCv3Cv6Q/4AVCIWcoDQwrRAAAAAElFTkSuQmCC"

/***/ }),

/***/ "mzOA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

var _isNumber2 = __webpack_require__("J009");

var _isNumber3 = _interopRequireDefault(_isNumber2);

var _isFunction2 = __webpack_require__("gGqR");

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _isString2 = __webpack_require__("JDN0");

var _isString3 = _interopRequireDefault(_isString2);

var _isObject2 = __webpack_require__("yCNF");

var _isObject3 = _interopRequireDefault(_isObject2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _Message = __webpack_require__("hGJ7");

var _Message2 = _interopRequireDefault(_Message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var key = 1;
var instances = [];
var instance = null;

var defaultContainerStyle = {
  left: 0,
  top: 6
};
var defaultContainerClass = '';
var defaultItemStyle = {};
var defaultItemClass = '';
var defaultGetContainer = null;
var defaultDuration = 2000;

var usedContainerClass = defaultContainerClass;
var usedContainerStyle = (0, _assign2.default)({}, defaultContainerStyle);
var usedItemClass = defaultItemClass;
var usedItemStyle = (0, _assign2.default)({}, defaultItemStyle);
var usedGetContainer = defaultGetContainer;
var usedDuration = defaultDuration;

function getInstance(callback) {
  if (instance) {
    callback(instance);
    return;
  }
  _Message2.default.createInstance({
    containerClass: usedContainerClass,
    containerStyle: usedContainerStyle,
    getContainer: usedGetContainer
  }, function (msgInstance) {
    if (instance) {
      callback(instance);
      return;
    }
    instance = msgInstance;
    instances.push(msgInstance);
    callback(instance);
  });
}

function show() {
  var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$itemClass = _ref.itemClass,
      itemClass = _ref$itemClass === undefined ? usedItemClass : _ref$itemClass,
      _ref$itemStyle = _ref.itemStyle,
      itemStyle = _ref$itemStyle === undefined ? usedItemStyle : _ref$itemStyle,
      _ref$duration = _ref.duration,
      duration = _ref$duration === undefined ? usedDuration : _ref$duration,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === undefined ? function () {
    return undefined;
  } : _ref$onClose;

  var type = arguments[2];

  // eslint-disable-next-line no-underscore-dangle
  var _key = key++;
  var temp = null;
  getInstance(function (msg) {
    temp = msg; // 保持对多个instance的引用
    msg.add({
      key: _key,
      content: content,
      type: type,
      duration: duration,
      onClose: onClose,
      itemClass: itemClass,
      itemStyle: itemStyle
    });
  });
  return function () {
    if (temp) {
      temp.remove(_key);
    }
  };
}

var message = {
  info: function info(content, options) {
    return show(content, options, 'info');
  },
  success: function success(content, options) {
    return show(content, options, 'success');
  },
  error: function error(content, options) {
    return show(content, options, 'error');
  },
  warning: function warning(content, options) {
    return show(content, options, 'warning');
  },
  loading: function loading(content, options) {
    return show(content, options, 'loading');
  },
  resetOptions: function resetOptions() {
    usedContainerStyle = (0, _assign2.default)({}, defaultContainerStyle);
    usedItemStyle = (0, _assign2.default)({}, defaultItemStyle);
    usedContainerClass = defaultContainerClass;
    usedItemClass = defaultItemClass;
    usedGetContainer = defaultGetContainer;
    usedDuration = defaultDuration;
  },
  setOptions: function setOptions(options) {
    // eslint-disable-next-line object-curly-newline,max-len
    var containerStyle = options.containerStyle,
        containerClass = options.containerClass,
        getContainer = options.getContainer,
        itemStyle = options.itemStyle,
        itemClass = options.itemClass,
        duration = options.duration;

    var needClear = false;
    if ((0, _isObject3.default)(containerStyle)) {
      usedContainerStyle = (0, _assign2.default)({}, containerStyle);
      needClear = true;
    }
    if ((0, _isString3.default)(containerClass)) {
      usedContainerClass = containerClass;
      needClear = true;
    }
    if ((0, _isFunction3.default)(getContainer)) {
      usedGetContainer = getContainer;
      needClear = true;
    }
    if ((0, _isObject3.default)(itemStyle)) {
      usedItemStyle = (0, _assign2.default)({}, itemStyle);
    }
    if ((0, _isString3.default)(itemClass)) {
      usedItemClass = itemClass;
    }
    if ((0, _isNumber3.default)(duration)) {
      usedDuration = duration;
    }
    if (needClear) {
      instance = null;
    }
  },
  destroy: function destroy() {
    instances.forEach(function (inst) {
      inst.destroy();
      // eslint-disable-next-line no-param-reassign
      inst = null;
    });
    instances = [];
    if (instance) {
      message.resetOptions();
      // instance.destroy();
      instance = null;
    }
  }
};

exports.default = message;

/***/ }),

/***/ "n2R4":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("5Ara");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--3-1!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/lib/loader.js!./ShareMenu.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--3-1!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/lib/loader.js!./ShareMenu.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "npO6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by zad on 17/11/16.
                    */


var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__("O27J");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Portal = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Portal, _Component);

  function Portal() {
    (0, _classCallCheck3.default)(this, Portal);
    return (0, _possibleConstructorReturn3.default)(this, (Portal.__proto__ || (0, _getPrototypeOf2.default)(Portal)).apply(this, arguments));
  }

  (0, _createClass3.default)(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.createContainer();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeContainer();
    }
  }, {
    key: 'createContainer',
    value: function createContainer() {
      this.container = this.props.getContainer();
      this.forceUpdate();
    }
  }, {
    key: 'removeContainer',
    value: function removeContainer() {
      if (this.container) {
        this.container.parentNode.removeChild(this.container);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.container) {
        return (0, _reactDom.createPortal)(this.props.children, this.container);
      }
      return null;
    }
  }]);
  return Portal;
}(_react.Component), _class.propTypes = {
  getContainer: _propTypes2.default.func.isRequired,
  children: _propTypes2.default.node.isRequired
}, _temp);
exports.default = Portal;

/***/ }),

/***/ "oFuF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCookieByName = exports.countChinese = exports.countWords = exports.checkNoteIsInSeq = exports.stopEvent = exports.martinDispatch = exports.formatNumByK = exports.noop = exports.isDev = undefined;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

exports.getWindowSize = getWindowSize;
exports.checkNotes = checkNotes;
exports.checkContent = checkContent;
exports.keyDownResult = keyDownResult;
exports.calcAbbr = calcAbbr;
exports.formatTheVideoPackage = formatTheVideoPackage;
exports.captureException = captureException;
exports.getChildrenNum = getChildrenNum;
exports.formatPNHtml = formatPNHtml;
exports.cleanPNHtml = cleanPNHtml;
exports.getParameterByName = getParameterByName;
exports.cleanTheNoteHtml = cleanTheNoteHtml;

var _immutable = __webpack_require__("BYKG");

var _immutable2 = _interopRequireDefault(_immutable);

var _doyle = __webpack_require__("Gr4k");

var _doyle2 = _interopRequireDefault(_doyle);

var _variables = __webpack_require__("+AJo");

var _keyCode = __webpack_require__("r/Fa");

var _keyCode2 = _interopRequireDefault(_keyCode);

var _danteNo = __webpack_require__("9Q5t");

var _danteNo2 = _interopRequireDefault(_danteNo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $ = _danteNo2.default.$;
var isDev = exports.isDev = "production" === 'development';

var noop = exports.noop = function noop() {};

// 按K格式化数字
var formatNumByK = exports.formatNumByK = function formatNumByK(num) {
  if (num < 0) {
    return 0;
  }
  if (num < 100) {
    return num;
  }
  return (num / 1000).toFixed(1) + 'K';
};

// 用于需要知道每次的API调用状态的saga action，
var martinDispatch = exports.martinDispatch = function martinDispatch(dispatch, action) {
  return new _promise2.default(function () {
    var resolve = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;
    var reject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

    dispatch((0, _extends3.default)({}, action, {
      resolve: resolve,
      reject: reject
    }));
  });
};

var stopEvent = exports.stopEvent = function stopEvent(e) {
  e.stopPropagation();
  e.preventDefault();
};

function getWindowSize() {
  var d = document;
  var root = d.documentElement;
  var body = d.body; // eslint-disable-line prefer-destructuring
  var winW = window.innerWidth || root.clientWidth || body.clientWidth;
  var winH = window.innerHeight || root.clientHeight || body.clientHeight;
  return [winW, winH];
}

function checkNotes(props) {
  var notebooks = props.notebooks,
      match = props.match;
  var nbId = match.params.nbId;

  var notes = notebooks.getIn(['entities', nbId, 'notes']);
  return notes && notes.size > 0;
}

var checkNoteIsInSeq = exports.checkNoteIsInSeq = function checkNoteIsInSeq(props) {
  var notebooks = props.notebooks,
      match = props.match;
  var _match$params = match.params,
      nbId = _match$params.nbId,
      noteId = _match$params.noteId;

  var notesSeq = notebooks.getIn(['entities', nbId, 'notes'], _immutable2.default.fromJS([]));
  return notesSeq.includes(+noteId);
};

function checkContent(props) {
  var content = props.content,
      match = props.match;
  var noteId = match.params.noteId;

  return content.getIn(['entities', noteId, 'content'], _variables.CONTENT_NOT_FOUND) !== _variables.CONTENT_NOT_FOUND;
}

function keyDownResult(e) {
  return {
    esc: e.keyCode === _keyCode2.default.ESC,
    save: e.keyCode === 83 && (e.ctrlKey || e.metaKey)
  };
}

// /([\w\s]*)([^\w;x,\-.`'"{}\[\]+_)）（(*&\^@%$#!~\/?]*)/im
// const chineseSymbol = ['，', '。', '！', '？', '：', '；', '、', '《', '》'];
var chineseSymbolRegex = /[^\w\s;,\-.`'"{}[\]+_)）（(*&^@%$#!~/?]/;

// 计算单词个数
var countWords = exports.countWords = function countWords(text) {
  var words = text.replace(/[^\w]/g, ' ').match(/\S+/g);
  return words !== null ? words.length : 0;
};

// 计算中文个数
var countChinese = exports.countChinese = function countChinese(text) {
  var total = 0;
  for (var i = 0; i < text.length; i++) {
    var c = text.charAt(i);
    if (c.match(/[\u4e00-\u9fa5]/) || chineseSymbolRegex.test(c)) {
      total++;
    }
  }
  return total;
};

/**
 * 通过文章内容计算摘要和字数
 * @param text {String}
 * @param isMarkdown {Boolean}
 * @return {{abbr:String, wordNum:Number}}
 */
function calcAbbr(text) {
  var isMarkdown = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (isMarkdown) {
    var doyle = new _doyle2.default();
    var htmlString = doyle.parse(text);
    var div = document.createElement('div');
    div.style.display = 'none';
    div.innerHTML = htmlString;
    text = div.textContent; // eslint-disable-line no-param-reassign
    div = null;
  }
  return {
    abbr: text.slice(0, 61),
    wordNum: countWords(text) + countChinese(text)
  };
}

function videoMaker(_ref) {
  var url = _ref.url,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 400 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 400 : _ref$height,
      provider = _ref.provider,
      _ref$flash = _ref.flash,
      flash = _ref$flash === undefined ? '' : _ref$flash;

  var httpReg = /^http:/;
  var protocol = window.location.protocol;

  url = url.replace(/http:|https:/, ''); // eslint-disable-line
  flash = flash.trim().replace(httpReg, protocol); // eslint-disable-line
  var player = '';
  if (provider === 'bilibili') {
    player = '<div class="video-player player">';
    player += '<video width="' + width + '" height="' + height + '" preload="auto" controls="true">';
    player += '<source src="' + url + '" type="video/mp4">';
    player += '<object type="application/x-shockwave-flash" data="' + protocol + '//static.hdslb.com/play.swf" class="flash" style="width:' + width + 'px; height:' + height + 'px;">';
    player += '<param name="bgcolor" value="#ffffff">';
    player += '<param name="allowfullscreeninteractive" value="true">';
    player += '<param name="allowfullscreen" value="true">';
    player += '<param name="quality" value="high">';
    player += '<param name="allowscriptaccess" value="always">';
    player += '<param name="wmode" value="direct">';
    player += '<param name="flashvars" value="' + flash + '">';
    player += '</object>';
    player += '</video>';
    player += '</div>';
  } else {
    player = '<iframe class="player" src="' + url + '" height="' + height + '" width="' + width + '" frameborder=0 allowfullscreen style="width:' + width + 'px; height:' + height + 'px;"></iframe>';
  }

  return $(player);
}

function getVideoCoverImage(uuid, dimension) {
  if (dimension) {
    return "//upload.jianshu.io" + '/videos/cover_imgs/' + uuid + '?imageView2/1/w/' + dimension + '/h/' + dimension;
  }
  return "//upload.jianshu.io" + '/videos/cover_imgs/' + uuid;
}

// vedio元素显示的时候需要自己构造dom，这部分dom没有保存
function formatTheVideoPackage(dom) {
  [].map.call(dom.querySelectorAll('div.video-package'), function (v, index) {
    var elem = $(v);
    if (index > _variables.MAX_VIDEO_COUNT) {
      elem.remove();
      return;
    }
    // 已经fixed
    if (elem.find('.video-cover').length) {
      return;
    }
    var width = Math.round(v.offsetWidth);
    var height = Math.round(width / 6 * 5);
    var url = elem.attr('data-video-url');
    var provider = elem.attr('data-provider');
    var flash = elem.attr('data-flash-url');
    var videoPlayer = videoMaker({
      url: url,
      width: width,
      height: height,
      provider: provider,
      flash: flash
    });
    var caption = elem.find('.video-description');
    var uuid = elem.attr('data-cover-uuid');
    var placeholder = $('<div class="video-placeholder-area">' + caption.html() + '</div>');
    var videoCover = $('<img class="video-cover" src=' + getVideoCoverImage(uuid, 90) + '>');
    placeholder.append(videoCover);
    elem.prepend(placeholder);
    var closeBtn = $('<div class="video-close-button"><i class="fa fa-eject"></i> 收起视频</div>');
    closeBtn.hide();
    elem.append(closeBtn);
    caption.remove(); // 不需要显示标题
    var show = false; // 是否显示了player
    placeholder.on('click', function () {
      if (show) {
        return;
      }
      show = true;
      placeholder.after(videoPlayer);
      placeholder.hide();
      elem.css('margin-bottom', '50px');
      closeBtn.show();
    });
    closeBtn.on('click', function () {
      if (!show) {
        return;
      }
      show = false;
      videoPlayer.remove();
      placeholder.show();
      elem.css('margin-bottom', 'auto');
      closeBtn.hide();
    });
  });
}

function captureException(e, extra) {
  var _window = window,
      Raven = _window.Raven;

  if (Raven) {
    Raven.captureException(e, {
      extra: extra
    });
  }
}

// 获取html的children个数
function getChildrenNum() {
  var html = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var vDom = $('<div>').html(html);
  return vDom.children().length;
}

function getPNItemMask(index, isActive, isNoMask) {
  var maskElem = $('<span></span>').addClass(_variables.PN_ITEM_MASK_CLASSNAME).data('index', index);
  if (isActive) {
    maskElem.addClass('active');
  }
  if (isNoMask) {
    maskElem.addClass('no-mask');
  }
  maskElem.append($('<em>'));
  return maskElem;
}

// 初始化付费文章设置页的html（含mask）
function formatPNHtml(html) {
  var vDom = $('<div>').html(html);
  var initIndex = 0; // 文章初始时的分割线位置
  var children = vDom.children();
  // 查找初始位置
  // children.forEach((child, index) => {
  //   const childElem = $(child);
  //   const tag = childElem.getNodeName();
  //   if (tag === 'PAY-DIVIDE') {
  //     initIndex = index;
  //   }
  // });
  children.forEach(function (child, index) {
    var childElem = $(child);
    var tag = childElem.getNodeName();
    if (['HR', 'PAY-DIVIDE'].indexOf(tag) > -1) {
      return;
    }
    childElem.append(getPNItemMask(index, initIndex === index, index <= initIndex));
  });
  return [vDom.html(), initIndex];
}

function cleanPNHtml(html, index) {
  var vDom = $('<div>').html(html);
  vDom.find('pay-divide').forEach(function (item) {
    $(item).remove();
  });
  vDom.contents().get(index).after($('<pay-divide>'));
  // vDom.children().get(index).after($('<pay-divide>'));
  return vDom.html();
}

function getParameterByName(name, url) {
  if (!url) url = window.location.href; // eslint-disable-line no-param-reassign
  name = name.replace(/[\[\]]/g, '\\$&'); // eslint-disable-line no-useless-escape, no-param-reassign
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  var results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

// 后端保存富文本时不知道为啥会多出一些换行符
function cleanTheNoteHtml() {
  var html = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return html.replace(/\n|\r\n/g, '');
}
var getCookieByName = exports.getCookieByName = function getCookieByName(name) {
  var cookie = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.cookie;

  var target = cookie.split(';').map(function (item) {
    return { key: item.split('=')[0].trim(), value: item.split('=')[1].trim() };
  }).filter(function (item) {
    return item.key === name;
  })[0];
  return target && target.value || '{}';
};

/***/ }),

/***/ "of+2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.af7ae50.woff2";

/***/ }),

/***/ "pNOl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * Created by zad on 17/9/20.
 */
exports.default = function (c) {
  return c.displayName || c.name || 'Component';
};

/***/ }),

/***/ "pnOm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; /**
                   * Created by zad on 17/9/30.
                   */


var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__("F8kA");

var _reactRedux = __webpack_require__("RH2O");

var _reactIntlUniversal = __webpack_require__("cl+9");

var _reactIntlUniversal2 = _interopRequireDefault(_reactIntlUniversal);

var _zhCN = __webpack_require__("lIYd");

var _zhCN2 = _interopRequireDefault(_zhCN);

var _zhTW = __webpack_require__("+cSM");

var _zhTW2 = _interopRequireDefault(_zhTW);

var _App = __webpack_require__("I2I8");

var _App2 = _interopRequireDefault(_App);

var _util = __webpack_require__("oFuF");

var _GlobalAction = __webpack_require__("5Q8M");

var _UserAction = __webpack_require__("XaZM");

var _UserReducer = __webpack_require__("i0Fb");

var _GlobalReducer = __webpack_require__("boom");

var _Routes = __webpack_require__("vw9M");

var _Routes2 = _interopRequireDefault(_Routes);

var _PNAgreeModal = __webpack_require__("4J7M");

var _PNAgreeModal2 = _interopRequireDefault(_PNAgreeModal);

var _PhoneModal = __webpack_require__("4r03");

var _PhoneModal2 = _interopRequireDefault(_PhoneModal);

var _PublishSuccessModal = __webpack_require__("aQyQ");

var _PublishSuccessModal2 = _interopRequireDefault(_PublishSuccessModal);

var _NoAccount = __webpack_require__("CW2v");

var _NoAccount2 = _interopRequireDefault(_NoAccount);

var _QrcodeModal = __webpack_require__("kWOh");

var _QrcodeModal2 = _interopRequireDefault(_QrcodeModal);

var _TimePublishBuyModal = __webpack_require__("gtn+");

var _TimePublishBuyModal2 = _interopRequireDefault(_TimePublishBuyModal);

var _HasOtherAccount = __webpack_require__("V2Du");

var _HasOtherAccount2 = _interopRequireDefault(_HasOtherAccount);

var _NoOtherAccount = __webpack_require__("Su7A");

var _NoOtherAccount2 = _interopRequireDefault(_NoOtherAccount);

var _Message = __webpack_require__("mzOA");

var _Message2 = _interopRequireDefault(_Message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locales = {
  'zh-CN': _zhCN2.default,
  'zh-TW': _zhTW2.default
};

var fonts = {
  font1: 'song',
  font2: 'black'
};

var App = (_dec = (0, _reactRedux.connect)(function (state) {
  var globalState = (0, _GlobalReducer.getState)(state);
  return {
    user: (0, _UserReducer.getState)(state),
    locale: globalState.get('locale'),
    readMode: globalState.get('readMode'),
    fontType: globalState.get('fontType'),
    bindPhoneStatus: globalState.get('bindPhoneStatus'),
    bindStatus: globalState.get('bindStatus'),
    bindWx: globalState.get('bindWx'),
    publishSuccessModalData: globalState.get('publishSuccessModalData'),
    qrCodeModalData: globalState.get('qrCodeModal'),
    pnAgreeModalData: globalState.get('pnAgreeModal'),
    occupyhasother: globalState.get('occupyhasother'),
    occupynother: globalState.get('noOtherAccount')
  };
}, function (dispatch) {
  return {
    getUser: function getUser() {
      return dispatch((0, _UserAction.getUser)());
    },
    setBindWxStatus: function setBindWxStatus(status) {
      return dispatch((0, _GlobalAction.setBindWxStatus)(status));
    },
    setBindPhoneStatus: function setBindPhoneStatus(status) {
      return dispatch((0, _GlobalAction.setBindPhoneStatus)(status));
    },
    setBindStatus: function setBindStatus(status) {
      return dispatch((0, _GlobalAction.setBindStatus)(status));
    },
    setOccupy: function setOccupy(_ref) {
      var status = _ref.status,
          msg = _ref.msg;

      return dispatch((0, _GlobalAction.setOccupyHasOther)(status, msg));
    },
    setPublishSuccessData: function setPublishSuccessData(show, data) {
      return dispatch((0, _GlobalAction.setPublishSuccessData)(show, data));
    },
    setQrCodeModalData: function setQrCodeModalData(show, data) {
      return dispatch((0, _GlobalAction.setQrCodeModalData)(show, data));
    },
    setPnAgreeModalData: function setPnAgreeModalData(show, data) {
      return dispatch((0, _GlobalAction.setPnAgreeModalData)(show, data));
    },
    setNoOther: function setNoOther(_ref2) {
      var status = _ref2.status,
          msg = _ref2.msg,
          step = _ref2.step,
          data = _ref2.data;
      return dispatch((0, _GlobalAction.setOccupyNoother)(status, msg, step, data));
    }
  };
}), _dec(_class = function (_Component) {
  (0, _inherits3.default)(App, _Component);

  function App() {
    var _ref3;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, App);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref3 = App.__proto__ || (0, _getPrototypeOf2.default)(App)).call.apply(_ref3, [this].concat(args))), _this), _this.state = {
      initDone: false
    }, _this.onWxCancelClick = function () {
      _this.props.setBindWxStatus({ status: false });
    }, _this.onModalCancelClick = function () {
      _this.props.setBindStatus({ status: false });
    }, _this.onPhoneModalConfirmBtnClick = function () {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _this.onPhoneModalCancelClick();
    }, _this.onPhoneModalCancelClick = function () {
      _this.props.setBindPhoneStatus(true); // 关闭绑手机的modal时需要重置bindPhoneStatus
    }, _this.onQrcodeModalCancelClick = function () {
      _this.props.setQrCodeModalData(false);
    }, _this.onHasOtherCancelClick = function () {
      _this.props.setOccupy({
        status: false
      });
    }, _this.onNoOtherCancelClick = function () {
      _this.props.setNoOther({
        status: false
      });
    }, _this.onPNAgreeModalConcelBtnClick = function () {
      _this.props.setPnAgreeModalData(false, {});
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(App, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.getUser();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.loadLocales();
      this.setBodyClass();
      setTimeout(function () {
        _this2.getUserState();
      }, 0);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props = this.props,
          readMode = _props.readMode,
          fontType = _props.fontType;

      if (!(readMode === prevProps.readMode && fontType === prevProps.fontType)) {
        this.setBodyClass();
      }
    }

    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'componentDidCatch',
    value: function componentDidCatch(error, errorInfo) {
      // 上报react error
      if (window.Raven) {
        window.Raven.captureException(error, { extra: errorInfo });
      }
    }
  }, {
    key: 'getUserState',
    value: function getUserState() {
      if ((0, _util.getParameterByName)('callback')) {
        var bindSnsResult = (0, _util.getCookieByName)('bind_sns_result');
        try {
          var res = JSON.parse(decodeURIComponent(decodeURIComponent(bindSnsResult)));
          switch (res.code) {
            case 210:
              return this.props.setOccupy({ status: true, msg: res.message });
            case 211:
              return this.props.setNoOther({
                status: true, msg: res.message, step: 1, data: res.data || '{}'
              });
            case -1:
              return _Message2.default.success('一键绑定成功');
            case -2:
              return this.props.setNoOther({
                status: true, msg: res.message, step: 2, data: res.data || '{}'
              });
            default:
              return _Message2.default.error(res.message);
          }
        } catch (e) {
          // handle error
        }
      }
      return false;
    }
  }, {
    key: 'loadLocales',
    value: function loadLocales() {
      var _this3 = this;

      _reactIntlUniversal2.default.init({
        currentLocale: this.props.locale,
        locales: locales
      }).then(function () {
        _this3.setState({ initDone: true });
      });
    }
  }, {
    key: 'setBodyClass',
    value: function setBodyClass() {
      var _props2 = this.props,
          readMode = _props2.readMode,
          fontType = _props2.fontType;

      var font = fonts[fontType];
      document.body.className = 'reader-' + readMode + '-mode ' + _App2.default['reader-' + font + '-font'];
    }
  }, {
    key: 'render',
    value: function render() {
      // 是否显示绑定手机的弹层
      var phoneModalVisible = !this.props.bindPhoneStatus;
      var noAccount = !this.props.bindStatus;
      var occupyHasother = this.props.occupyhasother;
      var nowx = !this.props.bindWx;
      var occpyNoother = this.props.occupynother;
      // 是否显示发布文章成功的modal
      var publishSuccessModalData = this.props.publishSuccessModalData.toJS();
      var qrCodeModalData = this.props.qrCodeModalData.toJS();
      var pnAgreeModalData = this.props.pnAgreeModalData.toJS();
      if (this.state.initDone) {
        return _react2.default.createElement(
          _react.Fragment,
          null,
          _react2.default.createElement(
            _reactRouterDom.HashRouter,
            null,
            _react2.default.createElement(_Routes2.default, null)
          ),
          _react2.default.createElement(
            _react.Fragment,
            null,
            phoneModalVisible && _react2.default.createElement(_PhoneModal2.default, {
              visible: phoneModalVisible,
              onModalCancelClick: this.onPhoneModalCancelClick,
              onModalConfirmBtnClick: this.onPhoneModalConfirmBtnClick
            }),
            occupyHasother.status && _react2.default.createElement(_HasOtherAccount2.default, {
              visible: occupyHasother.status,
              onModalCancelClick: this.onHasOtherCancelClick
            }),
            occpyNoother.status && _react2.default.createElement(_NoOtherAccount2.default, {
              visible: occpyNoother.status,
              onModalCancelClick: this.onNoOtherCancelClick
            }),
            noAccount && _react2.default.createElement(_NoAccount2.default, {
              visible: noAccount,
              onModalCancelClick: this.onModalCancelClick,
              onModalConfirmBtnClick: this.onModalCancelClick
            }),
            publishSuccessModalData.show && _react2.default.createElement(_PublishSuccessModal2.default, {
              data: publishSuccessModalData.data
            }),
            qrCodeModalData.show && _react2.default.createElement(_QrcodeModal2.default, {
              visible: qrCodeModalData.show,
              link: qrCodeModalData.data.link,
              onModalCancel: this.onQrcodeModalCancelClick
            }),

            // 付费协议modal
            _react2.default.createElement(_PNAgreeModal2.default, {
              visible: pnAgreeModalData.show
              // onModalConfirmBtnClick={this.onPNAgreeModalConfirmBtnClick}
              , onModalCancelBtnClick: this.onPNAgreeModalConcelBtnClick
            }),
            _react2.default.createElement(_TimePublishBuyModal2.default, null)
          )
        );
      }

      return null;
    }
  }]);
  return App;
}(_react.Component)) || _class);
exports.default = App;

/***/ }),

/***/ "qiO7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNoteHistoryContentsState = exports.getNoteHistoryState = undefined;

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _immutable2.default.fromJS(initialState);
  var action = arguments[1];

  switch (action.type) {
    // 重置NoteHistory
    case _actionTypes.NoteHistory.NOTE_HISTORY_INIT:
      {
        // 清空list
        state = state.setIn(['status'], _actionTypes.NoteHistory.NOTE_HISTORY_INIT);
        state = state.setIn(['list'], _immutable2.default.fromJS([]));
        // 清空contens
        state = state.setIn(['contents', 'status'], _actionTypes.NoteHistory.NOTE_HISTORY_CONTENT_INIT);
        state = state.setIn(['contents', 'entities'], _immutable2.default.fromJS({}));
        // reset restore
        state = state.setIn(['restore', 'status'], _actionTypes.NoteHistory.NOTE_HISTORY_RESTORE_INIT);

        return state;
      }
    // 获取history list
    case _actionTypes.NoteHistory.GET_NOTE_HISTORY_LIST:
      {
        var noteId = action.noteId;

        state = state.setIn(['status'], _actionTypes.NoteHistory.GET_NOTE_HISTORY_LIST);
        return state;
      }
    case _actionTypes.NoteHistory.GET_NOTE_HISTORY_LIST_SUCCESS:
      {
        var data = action.data;

        window.itemdatas = data;
        // 存储之前先按修改时间排下顺序
        state = state.setIn(['list'], _immutable2.default.fromJS(data.sort(function (a, b) {
          return b.updated_at - a.updated_at;
        })));
        state = state.setIn(['status'], _actionTypes.NoteHistory.GET_NOTE_HISTORY_LIST_SUCCESS);
        return state;
      }
    case _actionTypes.NoteHistory.GET_NOTE_HISTORY_LIST_FAIL:
      {
        state = state.setIn(['status'], _actionTypes.NoteHistory.GET_NOTE_HISTORY_LIST_FAIL);
        return state;
      }
    // 获取history content
    case _actionTypes.NoteHistory.GET_NOTE_HISTORY_CONTENT:
      {
        var _noteId = action.noteId;

        state = state.setIn(['contents', 'status'], _actionTypes.NoteHistory.GET_NOTE_HISTORY_CONTENT);
        return state;
      }
    case _actionTypes.NoteHistory.GET_NOTE_HISTORY_CONTENT_SUCCESS:
      {
        var _data = action.data,
            historyId = action.historyId;

        state = state.setIn(['contents', 'entities', historyId.toString()], _immutable2.default.fromJS(_data));
        state = state.setIn(['contents', 'status'], _actionTypes.NoteHistory.GET_NOTE_HISTORY_CONTENT_SUCCESS);
        return state;
      }
    case _actionTypes.NoteHistory.GET_NOTE_HISTORY_CONTENT_FAIL:
      {
        state = state.setIn(['contents', 'status'], _actionTypes.NoteHistory.GET_NOTE_HISTORY_CONTENT_FAIL);
        return state;
      }
    // 恢复history content
    case _actionTypes.NoteHistory.RESTORE_NOTE_HISTORY_CONTENT:
      {
        state = state.setIn(['restore', 'status'], _actionTypes.NoteHistory.RESTORE_NOTE_HISTORY_CONTENT);
        return state;
      }
    case _actionTypes.NoteHistory.RESTORE_NOTE_HISTORY_CONTENT_SUCCESS:
      {
        state = state.setIn(['restore', 'status'], _actionTypes.NoteHistory.RESTORE_NOTE_HISTORY_CONTENT_SUCCESS);
        return state;
      }
    case _actionTypes.NoteHistory.RESTORE_NOTE_HISTORY_CONTENT_FAIL:
      {
        state = state.setIn(['restore', 'status'], _actionTypes.NoteHistory.RESTORE_NOTE_HISTORY_CONTENT_FAIL);
        return state;
      }
    default:
      return state;
  }
};

var _immutable = __webpack_require__("BYKG");

var _immutable2 = _interopRequireDefault(_immutable);

var _actionTypes = __webpack_require__("4HHy");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-param-reassign */
/**
 * Created by zad on 17/10/18.
 */
var initialState = {
  list: [],
  status: _actionTypes.NoteHistory.NOTE_HISTORY_INIT,
  contents: {
    status: _actionTypes.NoteHistory.NOTE_HISTORY_CONTENT_INIT,
    entities: {}
  },
  restore: {
    status: _actionTypes.NoteHistory.NOTE_HISTORY_RESTORE_INIT
  }
};

var getNoteHistoryState = exports.getNoteHistoryState = function getNoteHistoryState(state) {
  return state.NoteHistory;
};

var getNoteHistoryContentsState = exports.getNoteHistoryContentsState = function getNoteHistoryContentsState(state) {
  return state.NoteHistory.get('contents');
};

/***/ }),

/***/ "r/Fa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Created by zad on 17/11/16.
 */
exports.default = {
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,

  TAB: 9,
  CAP: 20,
  SHIFT: 16,
  CTRL: 17,

  ALT: 18,
  COMMAND: 91,
  WIN: 92,

  BACKSPACE: 8,
  DELETE: 46,
  SPACE: 32,
  ENTER: 13,
  ESC: 27,

  PAGE_UP: 33,
  PAGE_DOWN: 34
};

/***/ }),

/***/ "s3e1":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "._1m7Fq ._2A7wF{position:relative;width:100%;margin-bottom:20px;font-size:15px}._1m7Fq ._2A7wF input{border:1px solid #c8c8c8;display:block;width:100%;height:50px;line-height:50px;background-color:hsla(0,0%,71%,.1);padding:5px 10px;-webkit-box-sizing:border-box;box-sizing:border-box}body.reader-night-mode ._1m7Fq ._2A7wF input{border-color:#2e2e2e}._1m7Fq ._3gYdB{margin:0}._1m7Fq ._3gYdB input{border-radius:4px 4px 0 0;padding-left:35px}._1m7Fq ._3gYdB ._24MAM{position:absolute;left:0}._1m7Fq ._3gYdB ._24MAM ._2P4hw{position:absolute;width:110px;left:0;top:0;line-height:50px;border-right:1px solid #c8c8c8;text-align:center;cursor:pointer}body.reader-night-mode ._1m7Fq ._3gYdB ._24MAM ._2P4hw{border-color:#2e2e2e}._1m7Fq ._3gYdB ._24MAM ._2P4hw ._3brsZ{margin:16px 10px 0 0;float:right}._1m7Fq ._3gYdB ._24MAM ._2P4hw ._1DAKn{float:left;margin:10px 0 0 10px}._1m7Fq ._3gYdB ._24MAM .V_psv{position:absolute;top:50px;width:388px;left:0;padding-top:5px;font-size:14px;border-radius:0 0 4px 4px;max-height:300px;overflow-y:auto;background:#fff;z-index:3}._1m7Fq ._3gYdB ._24MAM .V_psv ._3borq{background-color:#efefef;color:#4a4a4a;height:28px;line-height:28px;padding-left:20px;font-size:12px}._1m7Fq ._3gYdB ._24MAM .V_psv li span{margin-right:20px;display:inline-block;width:65px}._1m7Fq .UIpaL input{padding:5px 110px 5px 35px;border-top:0;border-radius:0 0 4px 4px}._1m7Fq .UIpaL i{position:absolute;margin:18px 0 0 10px}._1m7Fq .UIpaL a{position:absolute;top:7px;right:7px;width:100px;height:36px;font-size:13px;text-align:center;color:#fff;background-color:#3194d0;border-radius:20px;line-height:36px}._1m7Fq .UIpaL a._2da27{opacity:.7;pointer-events:none}._1m7Fq ._2lEtB{width:100%;padding:9px 18px;font-size:18px;text-align:center;border:none;border-radius:25px;color:#fff;background:#3194d0;cursor:pointer}", ""]);

// exports
exports.locals = {
	"form": "_1m7Fq",
	"input-prepend": "_2A7wF",
	"phone-input-prepend": "_3gYdB",
	"country-dd": "_24MAM",
	"phone-icon-wrap": "_2P4hw",
	"arrow-icon": "_3brsZ",
	"mobile-icon": "_1DAKn",
	"menu": "V_psv",
	"divider": "_3borq",
	"captcha-input-prepend": "UIpaL",
	"disable": "_2da27",
	"confirm-btn": "_2lEtB"
};

/***/ }),

/***/ "sAuu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _isFunction2 = __webpack_require__("gGqR");

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _class, _temp; /**
                    * Created by zad on 17/11/17.
                    */


exports.default = prompt;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("O27J");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _reactIntlUniversal = __webpack_require__("cl+9");

var _reactIntlUniversal2 = _interopRequireDefault(_reactIntlUniversal);

var _Modal = __webpack_require__("Xpbu");

var _Modal2 = _interopRequireDefault(_Modal);

var _Modal3 = __webpack_require__("UsL9");

var _Modal4 = _interopRequireDefault(_Modal3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Prompt = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Prompt, _Component);

  function Prompt(props) {
    (0, _classCallCheck3.default)(this, Prompt);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Prompt.__proto__ || (0, _getPrototypeOf2.default)(Prompt)).call(this, props));

    _this.showModal = function () {
      _this.setState(function (prevState) {
        if (prevState.visible) {
          return null;
        }
        return {
          visible: true
        };
      });
    };

    _this.hideModal = function () {
      _this.setState({ visible: false });
    };

    _this.handleOk = function (e) {
      _this.hideModal();
      var _this$props = _this.props,
          onOk = _this$props.onOk,
          content = _this$props.content;

      if ((0, _isFunction3.default)(onOk)) {
        var value = (_this.vInput.value || '').trim();
        onOk(value, content);
      }
    };

    _this.handleCancel = function (e) {
      _this.hideModal();
      var onCancel = _this.props.onCancel;

      if ((0, _isFunction3.default)(onCancel)) {
        onCancel(e);
      }
    };

    _this.getButtonText = function () {
      var _this$props2 = _this.props,
          okText = _this$props2.okText,
          cancelText = _this$props2.cancelText;

      return {
        ok: okText || _reactIntlUniversal2.default.get('modal.confirm'),
        cancel: cancelText || _reactIntlUniversal2.default.get('modal.cancel')
      };
    };

    _this.state = {
      visible: false
    };
    return _this;
  }

  (0, _createClass3.default)(Prompt, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.destroy();
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames,
          _this2 = this;

      var _props = this.props,
          content = _props.content,
          modalClassName = _props.modalClassName,
          confirmBodyClassName = _props.confirmBodyClassName,
          confirmBodyStyle = _props.confirmBodyStyle,
          destroy = _props.destroy;

      var btnText = this.getButtonText();
      var modalClass = (0, _classnames2.default)(modalClassName, (_classNames = {}, (0, _defineProperty3.default)(_classNames, '' + _Modal4.default['confirm'], true), (0, _defineProperty3.default)(_classNames, '' + _Modal4.default['prompt'], true), _classNames));
      var bodyClass = (0, _classnames2.default)(confirmBodyClassName, (0, _defineProperty3.default)({}, '' + _Modal4.default['prompt-body'], true));

      var body = _react2.default.createElement(
        'div',
        { className: bodyClass, style: confirmBodyStyle },
        _react2.default.createElement('input', { type: 'text', ref: function ref(v) {
            _this2.vInput = v;
          }, defaultValue: content, className: _Modal4.default['vInput'] })
      );

      var footer = _react2.default.createElement(
        'div',
        { className: _Modal4.default['confirm-footer'] },
        _react2.default.createElement(
          _Modal2.default.Button,
          { onClick: this.handleCancel },
          btnText.cancel
        ),
        _react2.default.createElement(
          _Modal2.default.Button,
          { onClick: this.handleOk, type: 'primary' },
          btnText.ok
        )
      );

      return _react2.default.createElement(
        _Modal2.default,
        (0, _extends3.default)({}, this.props, {
          modalClassName: modalClass,
          visible: this.state.visible,
          onOk: function onOk() {
            return undefined;
          },
          onCancel: this.handleCancel,
          tips: false,
          afterClose: destroy
        }),
        _react2.default.createElement(
          'div',
          { className: _Modal4.default['confirm-wrapper'] },
          body,
          footer
        )
      );
    }
  }]);
  return Prompt;
}(_react.Component), _class.displayName = 'Modal.Prompt', _class.propTypes = {
  content: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  modalClassName: _propTypes2.default.string,
  confirmBodyClassName: _propTypes2.default.string,
  confirmBodyStyle: _propTypes2.default.object,
  destroy: _propTypes2.default.func
}, _temp);
function prompt(title, content, options) {
  var div = document.createElement('div');
  document.body.appendChild(div);

  // 在关闭动画结束时，触发destroy方法
  function destroy() {
    var isRemoved = _reactDom2.default.unmountComponentAtNode(div);
    if (isRemoved && div.parentNode) {
      div.parentNode.removeChild(div);
    }
  }

  var confirmProps = (0, _extends3.default)({
    title: title,
    isMiddle: true,
    showMask: true,
    maskClosable: true,
    width: 312,
    okText: '确认',
    cancelText: '取消',
    onOk: function onOk() {
      return undefined;
    },
    onCancel: function onCancel() {
      return undefined;
    },
    modalClassName: '',
    confirmBodyClassName: '',
    confirmBodyStyle: {}
  }, options, {
    showFooter: false,
    closable: false,
    content: content,
    destroy: destroy
  });

  // eslint-disable-next-line react/no-render-return-value
  var instance = _reactDom2.default.render(_react2.default.createElement(Prompt, confirmProps), div);
  instance.showModal();

  return {
    destroy: destroy,
    instance: instance,
    target: div
  };
}

/***/ }),

/***/ "tVgH":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("mIQu");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/lib/index.js!../../../sass-loader/lib/loader.js!./doyle.css", function() {
		var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/lib/index.js!../../../sass-loader/lib/loader.js!./doyle.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "uOmc":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("3vUK");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./iconfont.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./iconfont.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "v1l9":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "._29Rua ._6YQCF{overflow:hidden;margin-bottom:37px}._29Rua ._6YQCF .mCJ9d{float:left;width:24px;height:24px;text-align:center;border:1px solid #00b61f;border-radius:50%;font-size:14px;line-height:24px;color:#00b61f;margin-right:16px}body.reader-night-mode ._29Rua ._6YQCF .mCJ9d{border:1px solid #b3b3b3;color:#b3b3b3}._29Rua ._6YQCF p{float:left;color:#2f2f2f;font-size:16px;font-weight:500}body.reader-night-mode ._29Rua ._6YQCF p{color:#b3b3b3}._29Rua ._3kJx_{margin-left:45px;margin-right:30px;font-size:15px}._29Rua ._3kJx_ p{border-bottom:1px solid #f0f0f0;padding-bottom:16px;cursor:pointer}._29Rua ._3kJx_ p:hover{color:#c8c8c8}._29Rua ._3kJx_ .jISDs{margin-left:30px}._29Rua ._3kJx_ ._2vEDo{font-size:18px;color:#e05244}._29Rua ._3kJx_ .jWtG_{font-size:18px;color:#498ad5}._29Rua ._3kJx_ ._1-F4r{font-size:18px;color:#399626}._29Rua ._16g5j{font-size:14px;width:136px;height:42px;border-radius:24.5px;background-color:#00b61f;color:#fff;margin-right:30px;cursor:pointer;border:none}body.reader-night-mode ._29Rua ._16g5j{border:none}._29Rua .nN81a{cursor:pointer}._29Rua .nN81a:hover{color:#ccc}", ""]);

// exports
exports.locals = {
	"container": "_29Rua",
	"title": "_6YQCF",
	"index": "mCJ9d",
	"ways": "_3kJx_",
	"channel": "jISDs",
	"webo": "_2vEDo",
	"qq": "jWtG_",
	"douban": "_1-F4r",
	"btn": "_16g5j",
	"cancel": "nN81a"
};

/***/ }),

/***/ "vmjQ":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("htM0");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/lib/index.js!../../../sass-loader/lib/loader.js!./index.css", function() {
		var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/lib/index.js!../../../sass-loader/lib/loader.js!./index.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "vw9M":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__("+6Bu");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _class, _class2, _temp, _initialiseProps;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _path = __webpack_require__("o/zv");

var _reactRouterDom = __webpack_require__("F8kA");

var _AsyncRoute = __webpack_require__("2Jz7");

var _AsyncRoute2 = _interopRequireDefault(_AsyncRoute);

var _util = __webpack_require__("oFuF");

var _browserDetector = __webpack_require__("m3yF");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// pages
var HomePage = (0, _AsyncRoute2.default)(function () {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(__webpack_require__.bind(null, "/sEk"));
});
var HistoryPage = (0, _AsyncRoute2.default)(function () {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(5)]).then(__webpack_require__.bind(null, "7Gmt"));
});
var RecyclePage = (0, _AsyncRoute2.default)(function () {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(6)]).then(__webpack_require__.bind(null, "JtiA"));
});
var EditorWrapper = (0, _AsyncRoute2.default)(function () {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "t/fx"));
});
var PreviewPage = (0, _AsyncRoute2.default)(function () {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(__webpack_require__.bind(null, "RCBd"));
});
var ForbiddenPage = (0, _AsyncRoute2.default)(function () {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(__webpack_require__.bind(null, "+qiR"));
});
var NotFoundPage = (0, _AsyncRoute2.default)(function () {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(__webpack_require__.bind(null, "d6jq"));
});
var PayNoteSettingPage = (0, _AsyncRoute2.default)(function () {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, "QXtu"));
});
var PublishStyleSettingPage = (0, _AsyncRoute2.default)(function () {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, "OFS3"));
});

var PCRoute = function PCRoute(_ref) {
  var WrapperComponent = _ref.component,
      rest = (0, _objectWithoutProperties3.default)(_ref, ['component']);
  return _react2.default.createElement(_reactRouterDom.Route, (0, _extends3.default)({}, rest, {
    render: function render(props) {
      if ((0, _browserDetector.isPC)()) {
        return _react2.default.createElement(WrapperComponent, props);
      }
      return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/forbidden' });
    }
  }));
};

var Routes = (0, _reactRouterDom.withRouter)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Routes, _Component);

  function Routes(props) {
    (0, _classCallCheck3.default)(this, Routes);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Routes.__proto__ || (0, _getPrototypeOf2.default)(Routes)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(Routes, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.trackPage(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var locationChanged = nextProps.location !== this.props.location;
      if (locationChanged) {
        this.trackPage(nextProps);
      }
    }
  }, {
    key: 'render',


    // eslint-disable-next-line class-methods-use-this
    value: function render() {
      return _react2.default.createElement(
        _reactRouterDom.Switch,
        null,
        _react2.default.createElement(PCRoute, { exact: true, path: '/', component: HomePage }),
        _react2.default.createElement(PCRoute, { exact: true, path: '/notebooks/:nbId', component: HomePage }),
        _react2.default.createElement(PCRoute, { exact: true, path: '/notebooks/:nbId/notes/:noteId', component: HomePage }),
        _react2.default.createElement(PCRoute, { path: '/recycle/:noteId', component: RecyclePage }),
        _react2.default.createElement(PCRoute, { path: '/recycle', component: RecyclePage }),
        _react2.default.createElement(PCRoute, { path: '/notebooks/:nbId/notes/:noteId/history/:historyId', component: HistoryPage }),
        _react2.default.createElement(PCRoute, { path: '/notebooks/:nbId/notes/:noteId/history', component: HistoryPage }),
        _react2.default.createElement(PCRoute, { exact: true, path: '/notebooks/:nbId/notes/:noteId/writing', component: EditorWrapper }),
        _react2.default.createElement(PCRoute, { exact: true, path: '/notebooks/:nbId/notes/:noteId/preview', component: PreviewPage }),
        _react2.default.createElement(PCRoute, { exact: true, path: '/notebooks/:nbId/notes/:noteId/pnsetting', component: PayNoteSettingPage }),
        _react2.default.createElement(PCRoute, { exact: true, path: '/notebooks/:nbId/notes/:noteId/pssetting', component: PublishStyleSettingPage }),
        !(0, _browserDetector.isPC)() && _react2.default.createElement(_reactRouterDom.Route, { path: '/forbidden', component: ForbiddenPage }),
        _react2.default.createElement(PCRoute, { component: NotFoundPage })
      );
    }
  }]);
  return Routes;
}(_react.Component), _initialiseProps = function _initialiseProps() {
  this.trackPage = function (props) {
    if (!_util.isDev) {
      var pathname = props.location.pathname;

      var fullPath = (0, _path.normalize)('' + "/writer/" + pathname + '/');
      _hmt && _hmt.push(['_trackPageview', fullPath]); // eslint-disable-line no-undef,no-unused-expressions
    }
  };
}, _temp)) || _class;

exports.default = Routes;

/***/ }),

/***/ "w0tY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = normalize;
/**
 * Created by zad on 17/10/18.
 */
/**
 * get entity and seq from original data
 * @param data {Array} original list
 * @return {{entities: Object, seq: Array}}
 */
function normalize(data) {
  var entities = {};
  var seq = [];

  data.forEach(function (item) {
    var id = item.id;

    seq.push(id);
    entities[id] = item;
  });
  return {
    entities: entities,
    seq: seq
  };
}

// 没啥用
// export function antiNormalize(seq, entities) {
//   const data = [];
//   seq.forEach((v) => {
//     data.push({ [v]: entities[v] });
//   });
//   return data;
// }

/***/ }),

/***/ "wyFM":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("bByz");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("MTIv")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./Button.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/lib/loader.js!./Button.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "z69G":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__("+6Bu");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by zad on 17/10/11.
                    */


var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__("uOmc");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line no-underscore-dangle
var _type = {
  size: ['lg', '2x', '3x', '4x', '5x'],
  rotate: [90, 180, 270]
};

var IconFont = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(IconFont, _PureComponent);

  function IconFont() {
    (0, _classCallCheck3.default)(this, IconFont);
    return (0, _possibleConstructorReturn3.default)(this, (IconFont.__proto__ || (0, _getPrototypeOf2.default)(IconFont)).apply(this, arguments));
  }

  (0, _createClass3.default)(IconFont, [{
    key: 'render',
    value: function render() {
      // eslint-disable-next-line object-curly-newline
      var _props = this.props,
          name = _props.name,
          size = _props.size,
          fixedWidth = _props.fixedWidth,
          spin = _props.spin,
          pulse = _props.pulse,
          rotate = _props.rotate,
          className = _props.className,
          props = (0, _objectWithoutProperties3.default)(_props, ['name', 'size', 'fixedWidth', 'spin', 'pulse', 'rotate', 'className']);

      var iconClass = (0, _classnames2.default)('iconfont', 'ic-' + name, className);
      return _react2.default.createElement('i', (0, _extends3.default)({}, props, { className: iconClass }));
    }
  }]);
  return IconFont;
}(_react.PureComponent), _class.propTypes = {
  name: _propTypes2.default.string.isRequired,
  size: _propTypes2.default.string,
  fixedWidth: _propTypes2.default.bool,
  spin: _propTypes2.default.bool,
  pulse: _propTypes2.default.bool,
  rotate: _propTypes2.default.number
}, _temp);
exports.default = IconFont;

/***/ })

},["lVK7"]);


// WEBPACK FOOTER //
// static/js/app.3256f54613c65ab8c437.js